webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ViewedEvent: 'Viewed Event',

  LoggedIn: 'Logged In',
  LoggedOut: 'Logged Out',
  ForgotPassword: 'Forgot Password',
  SignedUp: 'Signed Up',
  AddedCreditCard: 'Added Credit Card',

  SubmittedReview: 'Submitted Review',

  RedeemedPromoCode: 'Redeemed Promo Code',

  ContactedConcierge: 'Contacted Concierge',

  EnteredJoinCode: 'Entered Join Code',
  JoinedOrder: 'Joined Order',

  RequestedSMSDownloadLink: 'Requested SMS Download Link',

  FavoritedVenue: 'Favorited Venue',
  FavoritedEvent: 'Favorited Event',
  UnfavoritedVenue: 'Unfavorited Venue',
  UnfavoritedEvent: 'Unfavorited Event',

  SearchedInventory: 'Searched Inventory',

  SearchResultSelected: 'SearchResultSelected',

  StartedOrder: 'Started Order',

  StartedCheckout: 'Started Checkout',
  CompletedOrder: 'Completed Order',
  BookingCompleted: 'Booking Completed',
  OrderCompleted: 'Order Completed',
  FollowedCuratedList: 'Followed Curated List',
  UnfollowedCuratedList: 'Un-followed Curated List',

  TappedFeaturedBanner: 'Tapped Featured Banner',
  ClickedHomepageMembershipAd: 'Clicked Homepage Membership Ad',
  CompletedMembershipOrder: 'Completed Membership Order',
  FilteredMembershipPerks: 'Filtered Membership Perks'
};
module.exports = exports['default'];

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  NODE_ENV: "" + "production",
  SDK_API_URL: "" + "https://api.tablelist.com",
  SIFT_KEY: "" + "a9359ff76b",
  DOMAIN: "" + "https://www.tablelist.com",
  DEFAULT_CITY_SLUG: "" + "nyc",
  DEFAULT_CITY_ID: "" + "aa211bf5d25100ac",
  ROLLBAR_ACCESS_TOKEN: "" + "9d71219a8e024ad39055361ff446c726",
  ROLLBAR_ENABLE: "" + true,
  GOOGLE_MAPS_API_URL: "" + "https://www.google.com/maps/embed/v1/place",
  GOOGLE_MAPS_API_KEY: "" + "AIzaSyDoQ3PHlmzM_BinF-XTmEAoMO-YBA-rJXQ",
  TL_API_KEY: "" + "49dac8e0-7743-11e9-8e3f-a5601eb2e936",
  SEGMENT_WRITE_KEY: "" + "7VRKp1x6N7OmiRbvM8LPx159cZosqjGn",
  SEGMENT_DEBUG: "" + true,
  TABLELIST_API_BASE_URL: "" + "https://api.tablelist.com",
  BRAZE_API_KEY: "" + "a79ec5e2-6ade-4e35-9b06-f6014985da8d",
  AUTH_TOKEN: "" + "tl_auth",
  PROSPECT_TOKEN: "" + "tl_prospect"
};
module.exports = exports["default"];

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _superagent = __webpack_require__(1023);

var _superagent2 = _interopRequireDefault(_superagent);

var _bluebird = __webpack_require__(555);

var _bluebird2 = _interopRequireDefault(_bluebird);

var _urlUtils = __webpack_require__(548);

var _urlUtils2 = _interopRequireDefault(_urlUtils);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _errorUtils = __webpack_require__(547);

var _errorUtils2 = _interopRequireDefault(_errorUtils);

var _helper = __webpack_require__(112);

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  patch: 'patch',
  delete: 'delete'
};

function get(path, query, options) {
  return makeRequest('get', path, query, null, options);
}

function post(path, body, options) {
  return makeRequest('post', path, null, body, options);
}

function put(path, body, options) {
  return makeRequest('put', path, null, body, options);
}

function patch(path, body, options) {
  return makeRequest('patch', path, null, body, options);
}

function del(path, body, options) {
  return makeRequest('delete', path, null, body, options);
}

function makeRequest(type, path, query, body, options) {
  if (!type) throw new Error('type');
  if (!path) throw new Error('path');
  if (!REQUEST_TYPES[type]) throw new Error(type + ' is not a valid request type');

  options = options || {};

  var fullUrl = _urlUtils2.default.combinePaths(_config2.default.TABLELIST_API_BASE_URL, path);

  var requestPromise = _superagent2.default[type](fullUrl).set('Accept', 'application/json').set('api-key', _config2.default.TL_API_KEY);

  if (query) requestPromise.query(query);
  if (body) requestPromise.send(body);
  if (options.headers) {
    (0, _keys2.default)(options.headers).forEach(function (key) {
      requestPromise.set(key, options.headers[key]);
    });
  }

  if (_helper2.default.getAuthToken()) {
    requestPromise.set('x-access-token', _helper2.default.getAuthToken());
  } else {
    requestPromise.set('x-prospect-token', _helper2.default.getProspectToken());
  }

  return requestPromise.then(function (response) {
    return response.body;
  }).catch(function (err) {
    return handleApiError(err);
  });
}

function handleApiError(err) {
  var response = err.response;

  if (!response) {
    return _bluebird2.default.reject(err);
  }

  var errorMessage = _errorUtils2.default.getErrorFromApiResponse(response.body);

  return _bluebird2.default.reject(new Error(errorMessage));
}

exports.default = {
  get: get,
  post: post,
  put: put,
  patch: patch,
  del: del
};
module.exports = exports['default'];

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _v = __webpack_require__(1029);

var _v2 = _interopRequireDefault(_v);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(503);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setAuthToken: function setAuthToken(token) {
    if (!token) throw new Error('token is required');

    _storage2.default.setItem(_config2.default.AUTH_TOKEN, token, {
      expires: 7
    });
  },
  setProspectToken: function setProspectToken(token) {
    if (!token) throw new Error('token is required');

    _storage2.default.setItem(_config2.default.PROSPECT_TOKEN, token, {
      expires: 7
    });
  },
  getAuthToken: function getAuthToken() {
    return _storage2.default.getItem(_config2.default.AUTH_TOKEN);
  },
  getProspectToken: function getProspectToken() {
    var prospectToken = _storage2.default.getItem(_config2.default.PROSPECT_TOKEN);

    if (!prospectToken) {
      prospectToken = (0, _v2.default)();

      _storage2.default.setItem(_config2.default.PROSPECT_TOKEN, prospectToken);
    }

    return prospectToken;
  },
  removeAuthToken: function removeAuthToken() {
    _storage2.default.removeItem(_config2.default.AUTH_TOKEN);
  }
};
module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCEL_PENDING: 'CANCEL_PENDING',
  CANCELLED: 'CANCELLED',
  PAST_DUE: 'PAST_DUE'
};
module.exports = exports['default'];

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _appboyWebSdk = __webpack_require__(341);

var _appboyWebSdk2 = _interopRequireDefault(_appboyWebSdk);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppBoyClient = function () {
  function AppBoyClient() {
    (0, _classCallCheck3.default)(this, AppBoyClient);
  }

  (0, _createClass3.default)(AppBoyClient, [{
    key: 'init',
    value: function init() {
      _appboyWebSdk2.default.initialize(_config2.default.BRAZE_API_KEY, {
        enableLogging: _config2.default.NODE_ENV !== 'production',
        baseUrl: 'https://customer.iad-03.braze.com/api/v3'
      });
      _appboyWebSdk2.default.display.automaticallyShowNewInAppMessages();
      _appboyWebSdk2.default.openSession();
    }
  }, {
    key: 'stopWebTracking',
    value: function stopWebTracking() {
      _appboyWebSdk2.default.stopWebTracking();
    }
  }, {
    key: 'resumeWebTracking',
    value: function resumeWebTracking() {
      _appboyWebSdk2.default.resumeWebTracking();
    }
  }, {
    key: 'identify',
    value: function identify(user) {
      _appboyWebSdk2.default.changeUser(user.id);
    }
  }, {
    key: 'track',
    value: function track(eventName, eventData) {
      _appboyWebSdk2.default.logCustomEvent(eventName, eventData);
    }
  }]);
  return AppBoyClient;
}();

exports.default = new AppBoyClient();
module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _isDate2 = __webpack_require__(999);

var _isDate3 = _interopRequireDefault(_isDate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  toDateWithDateOffset: function toDateWithDateOffset(date) {
    if (!date) throw new Error('dateUtilsService - createDateWithDateOffset() - date is required');
    if (!(0, _isDate3.default)(date)) throw new Error('dateUtilsService - createDateWithDateOffset() - date must be a Date object');

    return new Date(date.getTime() + 60000 * date.getTimezoneOffset());
  },
  toUTCMomentWithoutTime: function toUTCMomentWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required');
    if (!(0, _isDate3.default)(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object');

    return _moment2.default.isMoment(date) ? _moment2.default.utc([date.get('year'), date.get('month'), date.get('date'), 6]) : _moment2.default.utc([date.getFullYear(), date.getMonth(), date.getDate(), 6]);
  },
  toUTCDateWithoutTime: function toUTCDateWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required');
    if (!(0, _isDate3.default)(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object');

    return _moment2.default.isMoment(date) ? new Date(date.get('year'), date.get('month'), date.get('date'), 6) : new Date(date.getFullYear(), date.getMonth(), date.getDate(), 6);
  },
  toUTCTimestampWithoutTime: function toUTCTimestampWithoutTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date is required');
    if (!(0, _isDate3.default)(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date must be a Date object or a Moment object');

    return _moment2.default.isMoment(date) ? Date.UTC(date.get('year'), date.get('month'), date.get('date'), 6) : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 6);
  },
  toUTCTimestampWithTime: function toUTCTimestampWithTime(date) {
    if (!date) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date is required');
    if (!(0, _isDate3.default)(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date must be a Date object or a Moment object');

    return _moment2.default.isMoment(date) ? Date.UTC(date.get('year'), date.get('month'), date.get('date'), date.get('hour'), date.get('minute'), date.get('second'), date.get('millisecond')) : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  }
};
module.exports = exports['default'];

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(18);

__webpack_require__(556);

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(338);

__webpack_require__(329);

__webpack_require__(155);

__webpack_require__(334);

__webpack_require__(337);

__webpack_require__(326);

var _smoothscrollPolyfill = __webpack_require__(1020);

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

__webpack_require__(331);

__webpack_require__(333);

__webpack_require__(1018);

__webpack_require__(549);

__webpack_require__(550);

var _httpInterceptor = __webpack_require__(513);

var _httpInterceptor2 = _interopRequireDefault(_httpInterceptor);

var _services = __webpack_require__(515);

var _services2 = _interopRequireDefault(_services);

var _components = __webpack_require__(383);

var _components2 = _interopRequireDefault(_components);

var _constants = __webpack_require__(400);

var _constants2 = _interopRequireDefault(_constants);

var _directives = __webpack_require__(449);

var _directives2 = _interopRequireDefault(_directives);

var _filters = __webpack_require__(493);

var _filters2 = _interopRequireDefault(_filters);

var _rootScopeGlobals = __webpack_require__(504);

var _rootScopeGlobals2 = _interopRequireDefault(_rootScopeGlobals);

var _authentication = __webpack_require__(353);

var _authentication2 = _interopRequireDefault(_authentication);

var _stateChange = __webpack_require__(546);

var _stateChange2 = _interopRequireDefault(_stateChange);

var _appConfig = __webpack_require__(352);

var _appConfig2 = _interopRequireDefault(_appConfig);

var _routerConfig = __webpack_require__(505);

var _routerConfig2 = _interopRequireDefault(_routerConfig);

__webpack_require__(793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_smoothscrollPolyfill2.default.polyfill();

var app = _angular2.default.module('tablelistApp', ['jsSdk', 'ui.router', 'ngSegment', 'ui.bootstrap', 'ng-bs-animated-button', 'ngSanitize', 'duScroll', 'tl', 'ngclipboard']);

_services2.default.init(app);
_components2.default.init(app);
_constants2.default.init(app);
_directives2.default.init(app);
_filters2.default.init(app);

app.factory('npHttpInterceptor', _httpInterceptor2.default);

app.config(_appConfig2.default);
app.config(_routerConfig2.default);

app.run(_rootScopeGlobals2.default);
app.run(_authentication2.default);
app.run(_stateChange2.default);

app.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('npHttpInterceptor');
}]);

exports.default = app;
module.exports = exports['default'];

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = __webpack_require__(343);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service2.default;
module.exports = exports['default'];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tablelistApi = __webpack_require__(73);

var _tablelistApi2 = _interopRequireDefault(_tablelistApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  list: function list() {
    return _tablelistApi2.default.get('/v1/cities');
  }
};
module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = __webpack_require__(345);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service2.default;
module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tablelistApi = __webpack_require__(73);

var _tablelistApi2 = _interopRequireDefault(_tablelistApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  listByVenueId: function listByVenueId(venueId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!venueId) throw new Error('venueId is required');

    return _tablelistApi2.default.get('/v1/venues/' + venueId + '/events', options);
  }
};
module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = __webpack_require__(347);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service2.default;
module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tablelistApi = __webpack_require__(73);

var _tablelistApi2 = _interopRequireDefault(_tablelistApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  listByVenueId: function listByVenueId(venueId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!venueId) throw new Error('venueId is required');

    return _tablelistApi2.default.get('/v1/venues/' + venueId + '/active-inventory', options);
  },
  listByCityId: function listByCityId(cityId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!cityId) throw new Error('cityId is required');

    return _tablelistApi2.default.get('/v1/cities/' + cityId + '/active-inventory', options);
  },
  getById: function getById(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!id) throw new Error('id is required');

    return _tablelistApi2.default.get('/inventory/' + id, options);
  }
};
module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = __webpack_require__(349);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service2.default;
module.exports = exports['default'];

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tablelistApi = __webpack_require__(73);

var _tablelistApi2 = _interopRequireDefault(_tablelistApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  actionById: function actionById(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!id) throw new Error('id is required');
    if (!options) throw new Error('options is required');

    return _tablelistApi2.default.post('/membership/' + id + '/action', options);
  }
};
module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service = __webpack_require__(351);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _service2.default;
module.exports = exports['default'];

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tablelistApi = __webpack_require__(73);

var _tablelistApi2 = _interopRequireDefault(_tablelistApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  deleteByIdAndUserId: function deleteByIdAndUserId(id, userId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!id) throw new Error('id is required');
    if (!userId) throw new Error('userId is required');
    if (!options) throw new Error('options is required');

    return _tablelistApi2.default.del('/user/' + userId + '/payment-profile/' + id, options);
  }
};
module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _appboy = __webpack_require__(156);

var _appboy2 = _interopRequireDefault(_appboy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AppConfig($compileProvider, tablelistSdkProvider, sdkConfigProvider, cacheConfigProvider, segmentProvider) {
  $compileProvider.debugInfoEnabled(_config2.default.NODE_ENV !== 'production');

  tablelistSdkProvider.setApiKey(_config2.default.TL_API_KEY);
  tablelistSdkProvider.setEnv(_config2.default.NODE_ENV);
  tablelistSdkProvider.setUseAuthHeader(true);

  sdkConfigProvider.setApiKey(_config2.default.TL_API_KEY).setApiBaseUrl(_config2.default.SDK_API_URL).setEnableDebugMode(_config2.default.NODE_ENV !== 'production').setEnableSecureCookie(_config2.default.NODE_ENV === 'production').setEnableCookieDomain(_config2.default.NODE_ENV === 'production').setClient('web').setGetUserOnStartUp(true);

  if (_config2.default.NODE_ENV !== 'production') {
    sdkConfigProvider.setCookiePrefix('dev');
  }

  cacheConfigProvider.cacheResourceEndpoints('jsSdk.city.resource', ['list']);

  if (_config2.default.SEGMENT_WRITE_KEY) {
    segmentProvider.setKey(_config2.default.SEGMENT_WRITE_KEY).setDebug(_config2.default.SEGMENT_DEBUG);
  }

  _appboy2.default.init();

  _appboy2.default.stopWebTracking();
}

AppConfig.$inject = ['$compileProvider', 'TablelistSdkProvider', 'jsSdk.configProvider', 'jsSdk.cacheConfigProvider', 'segmentProvider'];

exports.default = AppConfig;
module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Authentication($rootScope, $state, authService) {
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    _handleAuthentication(event, toState, toParams);
  });

  function _handleAuthentication(event, toState, toParams) {
    if (toState.authenticate === true && !authService.isLoggedIn()) {
      event.preventDefault();

      var params = {
        redirectState: toState.name,
        redirectParams: _angular2.default.toJson(toParams)
      };

      $state.go('app.login', params);
    }
  }
}

Authentication.$inject = ['$rootScope', '$state', 'jsSdk.auth'];

exports.default = Authentication;
module.exports = exports['default'];

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, jsSdkCity, metaTagService) {
  metaTagService.set({
    title: 'About Us | Tablelist',
    description: 'We live for nightlife, and we are proud to deliver a seamless VIP experience to our users in a growing list of cities.'
  });

  $scope.cities = [];

  jsSdkCity.list().then(function success(resp) {

    $scope.cities = (0, _sortBy3.default)(resp, function (city) {
      return city.slugName;
    });
  }, function error() {});
}

Ctrl.$inject = ['$scope', 'jsSdk.city', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $q, bookingHelpers, loggerService, modalService, metaTagService, membershipService, jsSdkCuratedListFollow, jsSdkBooking, jsSdkUser, jsSdkReview) {
  metaTagService.set({
    title: 'Dashboard | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.loading = true;
  $scope.bookings = [];
  $scope.reviews = [];
  $scope.pendingReviews = [];
  $scope.finishedReviews = [];

  $scope.isSubscribed = function () {
    return membershipService.isUserSubscribed();
  };

  $scope.bookingsPromise = jsSdkBooking.listByUserId($rootScope.currentUser.id, {
    fields: 'event(), venue()'
  });

  $scope.bookingsPromise.then(function success(response) {
    $scope.bookings = (0, _sortBy3.default)(response, function (booking) {
      return booking.date;
    });

    $scope.tableCount = (0, _filter3.default)(response, function (booking) {
      return bookingHelpers.isTable(booking) && bookingHelpers.isUpcomingBooking(booking);
    }).length;

    $scope.ticketCount = (0, _filter3.default)(response, function (booking) {
      return bookingHelpers.isTicket(booking) && bookingHelpers.isUpcomingBooking(booking);
    }).length;
  }).catch(function (response) {
    loggerService.error(response);
  });

  $scope.reviewsPromise = jsSdkReview.listByUserId(jsSdkUser.getCurrentUser().id);

  $scope.reviewsPromise.then(function success(response) {
    $scope.reviews = response;

    $scope.pendingReviewCount = (0, _filter3.default)(response, function (review) {
      return review.pending === true;
    }).length;
  }).catch(function (response) {
    loggerService.error(response);
  });

  $scope.bookingReviewPromise = $q.all([$scope.bookingsPromise, $scope.reviewsPromise]).then(function (values) {
    $scope.loading = false;

    var bookings = values[0];
    var reviews = $scope.reviews.length > 0 ? $scope.reviews : values[1];

    return $q(function (resolve) {
      (0, _each3.default)(reviews, function (review) {
        var booking = (0, _find3.default)(bookings, {
          id: review.booking
        });

        if (!booking) return;

        if (review.pending) {
          $scope.pendingReviews.push({
            review: review,
            booking: booking
          });
        } else {
          $scope.finishedReviews.push({
            review: review,
            booking: booking
          });
        }
      });

      return resolve();
    });
  });

  $scope.followedLists = [];

  _loadFollowedCuratedLists();

  function _loadFollowedCuratedLists() {
    var user = jsSdkUser.getCurrentUser();

    if (!user) return;

    var options = {
      fields: 'curatedList()'
    };

    jsSdkCuratedListFollow.listByUserId(user.id, options).then(function (resp) {
      $scope.followedLists = resp;
    }, function () {});
  }

  $scope.contactSupport = function (msg) {
    modalService.contactSupport({
      message: msg
    });
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$q', 'bookingHelpersService', 'loggerService', 'modalService', 'metaTagService', 'membershipService', 'jsSdk.curatedListFollow', 'jsSdk.booking', 'jsSdk.user', 'jsSdk.review'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $location, utilsService, loggerService, bookingHelpers, metaTagService) {
  $scope.loading = true;

  metaTagService.set({
    title: 'Your Bookings | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.bookingsPromise.then(function (response) {
    $scope.loading = false;

    response = (0, _filter3.default)(response, bookingHelpers.isTable);

    $scope.sortedBookings = {
      all: response,
      upcoming: (0, _filter3.default)(response, bookingHelpers.isUpcomingBooking),
      past: (0, _filter3.default)(response, bookingHelpers.isPastBooking)
    };
  }).catch(function (response) {
    $scope.errorMsg = utilsService.errorMessage(response);

    loggerService.error(response);
  });

  $scope.scrollTo = function (id) {
    utilsService.scrollTo(id);
  };
}

Ctrl.$inject = ['$scope', '$rootScope', '$location', 'utilsService', 'loggerService', 'bookingHelpersService', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _min2 = __webpack_require__(1006);

var _min3 = _interopRequireDefault(_min2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _reject2 = __webpack_require__(111);

var _reject3 = _interopRequireDefault(_reject2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _membershipStatuses = __webpack_require__(113);

var _membershipStatuses2 = _interopRequireDefault(_membershipStatuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, utilsService, bookingHelpers, modalService, metaTagService, jsSdkUser, jsSdkMembership) {
  metaTagService.set({
    title: 'Dashboard | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.MEMBERSHIP_STATUSES = _membershipStatuses2.default;

  $scope.bookingsPromise.then(function success(response) {
    $scope.nextUpcomingBooking = nextUpcomingBooking(response);
  }).catch(function (response) {
    $scope.errorMsg = utilsService.errorMessage(response);
  });

  function nextUpcomingBooking(bookings) {
    bookings = (0, _filter3.default)(bookings, bookingHelpers.isUpcomingBooking);

    var upcoming = (0, _min3.default)(bookings, function (booking) {
      return booking.date;
    });

    $scope.loading = false;

    if (!upcoming || !upcoming.venue) return null;

    upcoming.mapURL = utilsService.getMapUrl(upcoming.venue.location.address, true);

    return upcoming;
  }

  $scope.editCities = function () {
    modalService.editCities();
  };

  $scope.enterPromo = function () {
    modalService.enterPromo();
  };

  $scope.editCreditCard = function () {
    modalService.editCreditCard();
  };

  loadMembership();

  function loadMembership() {
    $scope.loadingMembership = true;

    jsSdkMembership.listByUserId(jsSdkUser.getCurrentUser().id, {}).then(function (resp) {
      $scope.loadingMembership = false;

      var memberships = (0, _sortBy3.default)((0, _reject3.default)(resp, {
        status: _membershipStatuses2.default.CANCELLED
      }), 'created');

      if (memberships && memberships[0]) {
        $scope.membership = memberships[0];
      }
    }).catch(function () {
      $scope.loadingMembership = false;
    });
  }
}

Ctrl.$inject = ['$scope', '$rootScope', 'utilsService', 'bookingHelpersService', 'modalService', 'metaTagService', 'jsSdk.user', 'jsSdk.membership'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $timeout, favoritesService, modalService, metaTagService, loggerService) {
  $scope.loading = true;

  $scope.venues = [];
  $scope.events = [];
  $scope.lists = [];

  metaTagService.set({
    title: 'Your Favorites | Tablelist',
    description: 'Browse your favorite venues and events.'
  });

  favoritesService.listFavorites().then(function (response) {
    $scope.venues = (0, _filter3.default)(response, function (favorite) {
      return favorite.type === 'VENUE';
    });

    $scope.events = (0, _filter3.default)(response, function (favorite) {
      return favorite.type === 'EVENT';
    });

    $timeout(function () {
      $scope.loading = false;
    }, 300);

    $timeout(function () {
      $rootScope.$broadcast('eventsLoaded');
      $rootScope.$broadcast('venuesLoaded');
    });
  }).catch(function (err) {
    loggerService.error(err);
  });
}

Ctrl.$inject = ['$rootScope', '$scope', '$timeout', 'favoritesService', 'modalService', 'metaTagService', 'loggerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__(110);

var _extend3 = _interopRequireDefault(_extend2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _reject2 = __webpack_require__(111);

var _reject3 = _interopRequireDefault(_reject2);

var _membership = __webpack_require__(348);

var _membership2 = _interopRequireDefault(_membership);

var _membershipStatuses = __webpack_require__(113);

var _membershipStatuses2 = _interopRequireDefault(_membershipStatuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $q, $rootScope, $stateParams, $state, $timeout, $location, utilsService, modalService, metaTagService, jsSdkUser, jsSdkMembership) {
  metaTagService.set({
    title: 'Edit Profile | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.membership = null;
  $scope.MEMBERSHIP_STATUSES = _membershipStatuses2.default;

  loadMembership();

  $scope.editProfile = function () {
    modalService.editProfile();
  };

  $scope.editContactInformation = function () {
    modalService.editContactInformation();
  };

  $scope.editCreditCard = function () {
    modalService.editCreditCard();
  };

  $scope.editMembership = function () {
    modalService.editMembership({}, loadMembership);
  };

  $scope.cancelMembership = function () {
    $scope.errorMsg = null;

    modalService.confirmation({
      modalMessage: 'Are you sure you want to cancel your Diamond Membership?<br>\n          <p style="font-size: 14px; margin-top: 15px;">*Your membership will stop at the end of the month, at which point will no longer be able to redeem perks.</p>\n          <p style="font-size: 14px; margin-top: 15px;">*Any future purchases of Diamond perks will be cancelled.</p>',
      confirmBtnTxt: 'Yes',
      confirmingBtnTxt: 'Cancelling',
      cancelBtnTxt: 'No'
    }).then(function (result) {
      if (result && result.confirm) {
        $q.resolve(_membership2.default.actionById($scope.membership.id, {
          type: 'CANCEL'
        })).then(function (membership) {
          (0, _extend3.default)($scope.membership, membership);

          return jsSdkUser.me();
        }).then(function (currentUser) {
          (0, _extend3.default)($rootScope.currentUser, currentUser);

          result.modalInstance.close();
        }).catch(function (err) {
          $scope.errorMsg = err.message;

          result.modalInstance.close();

          utilsService.scrollTo('account-error');
        });
      }
    });
  };

  $scope.enterPromo = function () {
    modalService.enterPromo();
  };

  $scope.editCities = function () {
    modalService.editCities();
  };

  $scope.forgotPassword = function () {
    modalService.forgotPassword();
  };

  if ($stateParams.action === 'payment') {
    $scope.editCreditCard();
  }

  if ($state.params.section === 'membership-section') {
    utilsService.scrollTo('membership-section', 100, 0, 400);
  }

  function loadMembership() {
    $scope.loading = true;

    jsSdkMembership.listByUserId(jsSdkUser.getCurrentUser().id, {}).then(function (resp) {
      $scope.loading = false;

      var memberships = (0, _sortBy3.default)((0, _reject3.default)(resp, {
        status: _membershipStatuses2.default.CANCELLED
      }), 'created');

      if (memberships && memberships[0]) {
        $scope.membership = memberships[0];
      }

      if ($scope.membership.status === _membershipStatuses2.default.PAST_DUE && $state.params.pastDue) {
        $scope.editMembership();
      }
    }).catch(function () {
      $scope.loading = false;
    });
  }

  $scope.formatStatus = function (status) {
    if (!status) return '';

    return status.replace('_', ' ');
  };
}

Ctrl.$inject = ['$scope', '$q', '$rootScope', '$stateParams', '$state', '$timeout', '$location', 'utilsService', 'modalService', 'metaTagService', 'jsSdk.user', 'jsSdk.membership'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $stateParams, $timeout, jsSdkPromo, jsSdkUser, metaTagService, tracking) {
  metaTagService.set({
    title: 'Enter Promo Code | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.error = '';

  $scope.form = {
    promoCode: $stateParams.code
  };

  $scope.isRedeemingPromo = null;
  $scope.redeemPromoResult = null;
  $scope.redeemPromoBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Redeem Promo',
    buttonSubmittingText: 'Redeeming Promo...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Promo Redeemed',
    buttonSuccessClass: 'btn-success',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Invalid Promo Code',
    buttonErrorClass: 'btn-danger'
  };

  $scope.resetFormValidation = function () {
    $scope.form.promoCode = '';
    $scope.promoCodeForm.$setPristine();
    $scope.submitted = false;
  };

  $scope.redeemPromoCode = function (promoCodeForm) {

    $scope.submitted = true;

    if (!promoCodeForm.$valid) return;

    $scope.isRedeemingPromo = true;
    $scope.redeemPromoResult = null;

    jsSdkPromo.redeem($scope.form.promoCode).then(function success(response) {
      $scope.errorMsg = null;
      $scope.resetFormValidation();

      $scope.redeemPromoResult = 'success';
      $scope.isRedeemingPromo = false;

      $scope.successMsg = response.message;

      jsSdkUser.me();

      tracking.trackEvent(_segmentEvents2.default.RedeemedPromoCode, {});
    }, function error() {
      $scope.successMsg = null;
      $scope.errorMsg = 'Sorry that promo code is not valid';
      $scope.resetFormValidation();

      $scope.redeemPromoResult = 'error';
      $scope.isRedeemingPromo = false;
    });
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$stateParams', '$timeout', 'jsSdk.promo', 'jsSdk.user', 'metaTagService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _has2 = __webpack_require__(997);

var _has3 = _interopRequireDefault(_has2);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $q, $state, $stateParams, $timeout, metaTagService, jsSdkReview, utilsService, loggerService, tracking) {
  $scope.loading = true;
  $scope.valid = true;
  $scope.responses = ['I hated it', 'I didn\'t like it', 'It was ok', 'I liked it', 'I loved it!'];
  $scope.review = {};
  $scope.booking = {};

  metaTagService.set({
    title: 'Your Review | Tablelist',
    description: 'Review your night to help others learn about great nightlife venues.'
  });

  var reviewId = $stateParams.reviewId;

  $q.all([$scope.bookingsPromise, $scope.reviewsPromise]).then(function success(values) {
    var bookings = values[0];
    var reviews = $scope.reviews.length > 0 ? $scope.reviews : values[1];

    $scope.review = (0, _find3.default)(reviews, {
      id: reviewId
    });

    $scope.booking = (0, _find3.default)(bookings, {
      id: $scope.review.booking
    });

    (0, _each3.default)($scope.review.questions, function (question) {
      question.valid = true;
      question.disableResponses = false;
    });

    $scope.loading = false;
  }, error);

  $scope.respondToQuestion = function (key, rating) {
    var question = (0, _find3.default)($scope.review.questions, {
      key: key
    });

    if (question.disableResponses) return;

    question.disableResponses = true;
    question.rating = rating;
    question.spin = rating;

    $timeout(function () {
      question.spin = -1;
      question.disableResponses = false;
    }, 350);
  };

  $scope.validate = function () {
    var valid = true;

    (0, _each3.default)($scope.review.questions, function (question) {
      question.valid = (0, _has3.default)(question, 'rating') && typeof question.rating === 'number';
      if (!question.valid) valid = false;
    });

    $scope.valid = valid;

    return valid;
  };

  $scope.submitForm = function () {
    if (!$scope.validate()) return;

    var data = {};

    if ((0, _has3.default)($scope.review, 'comment')) {
      if (!$scope.review.comment) {
        delete $scope.review.comment;
      } else {
        data.comment = $scope.review.comment;
      }
    }

    var questions = [];

    (0, _each3.default)($scope.review.questions, function (question) {
      questions.push({
        key: (0, _has3.default)(question, 'key') && typeof question.key === 'number' ? question.key : -1,
        rating: (0, _has3.default)(question, 'rating') && typeof question.rating === 'number' ? question.rating : -1
      });
    });

    data.questions = questions;

    jsSdkReview.update($scope.review.id, data).then(function (resp) {
      $scope.review.pending = false;
      $scope.$parent.pendingReviewCount -= 1;

      var trackingData = {
        reviewId: resp.id,
        venueId: resp.venue,
        bookingId: resp.booking
      };

      tracking.trackEvent(_segmentEvents2.default.SubmittedReview, trackingData);

      $state.go('app.me.reviews');
    }, error);
  };

  function error(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    loggerService.error(response);
  }
}

Ctrl.$inject = ['$scope', '$q', '$state', '$stateParams', '$timeout', 'metaTagService', 'jsSdk.review', 'utilsService', 'loggerService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($rootScope, $scope, metaTagService) {
  $scope.loading = true;

  metaTagService.set({
    title: 'Your Reviews | Tablelist',
    description: 'Write a review for the venues you\'ve visited and view the reviews you\'ve made in the past.'
  });

  $scope.bookingReviewPromise.then(function () {
    $scope.loading = false;
  });
}

Ctrl.$inject = ['$rootScope', '$scope', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $state, $location, utilsService, loggerService, bookingHelpers, metaTagService) {
  metaTagService.set({
    title: 'Your Bookings | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.bookingsPromise.then(function success(response) {
    response = (0, _filter3.default)(response, bookingHelpers.isTicket);

    $scope.sortedBookings = {
      all: response,
      upcoming: (0, _filter3.default)(response, bookingHelpers.isUpcomingBooking),
      past: (0, _filter3.default)(response, bookingHelpers.isPastBooking)
    };
  }, error);

  $scope.scrollTo = function (id) {
    utilsService.scrollTo(id);
  };

  function error(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    loggerService.error(response);
  }
}

Ctrl.$inject = ['$scope', '$rootScope', '$state', '$location', 'utilsService', 'loggerService', 'bookingHelpersService', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helper = __webpack_require__(112);

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, currentUser, keychain, trackingService) {
  $rootScope.currentUser = currentUser;

  if ($rootScope.currentUser) {
    _helper2.default.setAuthToken(keychain.getConsumerAuthToken());
  }

  if ($rootScope.currentUser) {
    trackingService.identify($rootScope.currentUser);
  }

  $rootScope.$on('login', function () {
    if ($rootScope.currentUser) {
      _helper2.default.setAuthToken(keychain.getConsumerAuthToken());
    }
  });
}

Ctrl.$inject = ['$rootScope', 'currentUser', 'jsSdk.keychain', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BrowseCtrl($scope, $state, $q, $rootScope, $stateParams, $location, $document, jsSdkUser, utilsService, partnerService, metaTagService, tracking, modalService, iframeService, loggerService, jsSdkCity) {
  $scope.cities = [];
  $scope.city = null;
  $scope.partner = partnerService.partner ? partnerService.partner : null;
  $scope.showAffix = false;

  $document.bind('scroll', function () {
    var top = (0, _jquery2.default)(window).scrollTop();
    var bar = (0, _jquery2.default)('.nav-bar');

    if (!bar || !bar.offset()) return;

    var offset = bar.offset().top;

    $scope.$apply(function () {
      $scope.showAffix = top - offset > 0;
    });
  });

  $scope.citiesPromise = jsSdkCity.list();
  $scope.citiesPromise.then(function (cities) {
    cities = partnerService.filterCities(cities);

    cities.forEach(function (city) {
      city.primaryImage = _underscore2.default.find(city.images, function (image) {
        return image.primary === true;
      }) || city.images[0];
    });

    $scope.cities = _underscore2.default.sortBy(cities, function (city) {
      return city.name;
    });
  });

  $scope.setCity = function (citySlug, next) {
    $scope.city = _underscore2.default.find($scope.cities, {
      slugName: citySlug
    });

    if (!$scope.city || !$scope.city.id) {
      loggerService.error('Unknown city. Unable to transition to browse: ', citySlug);

      $state.transitionTo('app.browse.city', {
        city: utilsService.defaultCitySlug()
      });

      return;
    }

    $scope.city.primaryImage = _underscore2.default.find($scope.city.images, {
      primary: true
    });

    _setMetaTags();

    iframeService.postMessage({
      eventType: 'routeChange',
      url: $location.absUrl()
    });

    setPreferredCity($scope.city.id);

    if (next) next($scope.city);
  };

  function _setMetaTags() {
    var cityName = $scope.city && $scope.city.name ? $scope.city.name + ' ' : '';

    metaTagService.set({
      title: cityName + ', bottle service, tickets, tables and packages',
      description: 'Browse Events, Venues, VIP tables, bottle service and events in ' + cityName,
      facebookImage: $scope.featuredImage
    });
  }

  function setPreferredCity(cityId) {
    var user = jsSdkUser.getCurrentUser();

    if (!user || user.location && user.location.preferred && user.location.preferred.id === cityId) {
      return $q.resolve();
    }

    return jsSdkUser.updatePreferredCity(cityId, {
      city: cityId
    });
  }
}

BrowseCtrl.$inject = ['$scope', '$state', '$q', '$rootScope', '$stateParams', '$location', '$document', 'jsSdk.user', 'utilsService', 'partnerService', 'metaTagService', 'trackingService', 'modalService', 'iframeService', 'loggerService', 'jsSdk.city'];

exports.default = BrowseCtrl;
module.exports = exports['default'];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(69);

var _get3 = _interopRequireDefault(_get2);

var _includes2 = __webpack_require__(151);

var _includes3 = _interopRequireDefault(_includes2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BrowseCityCtrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService, modalService, metaTagService, eventService, venueService, utilsService, loggerService, membershipService, jsSdkCuratedList, imgix) {
  $scope.loading = {
    city: true,
    seasonal: true,
    featured: true,
    lists: true,
    venues: true,
    events: true
  };

  $scope.imgix = function (src) {
    var options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
  $scope.curatedLists = [];
  $scope.curatedListLimit = 6;

  metaTagService.set({
    title: 'Browse Tablelist venues and events',
    description: 'Browse Tablelist venues and events'
  });

  var seasonalLists = [];

  $scope.onlySeasonal = function (list) {
    return (0, _includes3.default)(seasonalLists, list.id);
  };

  $scope.noSeasonal = function (list) {
    return !(0, _includes3.default)(seasonalLists, list.id);
  };

  $scope.citiesPromise.then(function () {
    var city = $stateParams.city;

    if (!city) {
      $state.go('app.browse.city', {
        city: utilsService.defaultCitySlug()
      });

      return;
    }

    _loadFeatured(city);
    _loadLists(city);

    $scope.setCity(city, function () {
      $scope.loading.city = false;

      metaTagService.set({
        title: $scope.city.displayName + ' - Browse Tablelist lists, events and venues',
        description: 'Browse Tablelist lists, events and venues',
        facebookImage: (0, _get3.default)($scope, ['city', 'primaryImage', 'xlarge'])
      });

      _loadEvents();
      _loadVenues();
    });
  }).catch(function (err) {
    loggerService.error(err);
  });

  $scope.changeCity = function () {
    var city = $scope.selectedCity;

    console.log('changeCity', city);

    if (city.slugName === $stateParams.city) return;

    utilsService.link('/' + city.slugName + '/discover/');
  };

  function _loadFeatured(city) {

    $scope.featured = [];

    var options = {
      type: ['FEATURED'],
      maxMembershipLevel: membershipService.membershipLevel(),
      slug: true
    };

    var promise = jsSdkCuratedList.listByCityId(city, options);

    promise.then(function (resp) {
      if (!resp || !resp[0] || !resp[0].id) {
        $scope.loading.featured = false;
        return;
      }

      jsSdkCuratedList.readById(resp[0].id, {
        items: true
      }).then(function (resp2) {
        $scope.loading.featured = false;
        $scope.featured = resp2.items;
      }, error);
    }, error);
  }

  function _loadLists(city) {
    var options = {
      type: ['REGULAR'],
      slug: true
    };

    jsSdkCuratedList.listByCityId(city, options).then(function (resp) {
      resp = (0, _filter3.default)(resp, function (list) {
        return list.itemCount > 0;
      });

      $scope.curatedLists = resp;
      $scope.loading.lists = false;
      $scope.loading.seasonal = false;
    }, error);
  }

  function _loadEvents() {
    $scope.events = [];

    var options = {
      fields: 'date,seoPathname,favoriteCount,name,images,venue(name,seoPathname,location.address),special,tags',
      cityId: $scope.city.id,
      sort: 'date',
      limit: 3,
      start: (0, _moment2.default)().toDate().getTime(),
      end: (0, _moment2.default)().add(7, 'days').toDate().getTime()
    };

    eventService.listForCity(options).then(function _success(response) {
      $scope.events = response;
      $scope.loading.events = false;

      $timeout(function () {
        $rootScope.$broadcast('eventsLoaded');
      });
    }, error);
  }

  function _loadVenues() {
    var options = {
      cityId: $scope.city.id,
      fields: 'name, seoPathname, tags, images, featured, rating, favoriteCount',
      limit: 3
    };

    venueService.listForCity(options).then(function success(response) {
      $scope.venues = response;
      $scope.loading.venues = false;

      $timeout(function () {
        $rootScope.$broadcast('venuesLoaded');
      });
    }, error);
  }

  $scope.sortVenues = function (item) {
    return item.favoriteCount * -1;
  };

  function error(message) {
    loggerService.error(message);
  }

  $scope.scrollTo = function (id) {
    utilsService.scrollTo(id, 80);
  };
}

BrowseCityCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$location', '$timeout', 'partnerService', 'modalService', 'metaTagService', 'tl.event.service', 'tl.venue.service', 'utilsService', 'loggerService', 'membershipService', 'jsSdk.curatedList', 'jsSdk.imgix'];

exports.default = BrowseCityCtrl;
module.exports = exports['default'];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService, jsSdkEvent, utilsService, loggerService) {
  $scope.loading = true;
  $scope.events = [];

  $scope.citiesPromise.then(function () {
    var city = $stateParams.city;

    if (!city || city.length < 1) {
      $state.transitionTo('app.browse.events', {
        city: utilsService.defaultCitySlug()
      });
      return;
    }

    $scope.changeCity($stateParams.city);
  });

  $scope.changeCity = function (citySlug) {

    if (citySlug !== $stateParams.city) {
      $state.transitionTo('app.browse.events', {
        city: citySlug,
        tag: $stateParams.tag
      });
      return;
    }

    $scope.setCity(citySlug, function () {
      _getEvents();
    });
  };

  $scope.filters = [];

  function addFilter(tag) {
    if (!tag || !tag.key) return;

    tag.key = ('USER_DEFINED_' + tag.key).toUpperCase().replace(/ /g, '-');

    $scope.filters.push(tag);
  }

  _listTags();

  function _listTags() {
    var tags = [];

    if ($stateParams.tag) {
      tags.push($stateParams.tag);
    }

    if (partnerService.getTags()) {
      tags = tags.concat(partnerService.getTags());
    }

    if (tags && tags.length) {
      _underscore2.default.each(_underscore2.default.uniqBy(tags), function (tag) {
        addFilter({
          key: tag,
          name: tag,
          userDefined: true
        });
      });
    }
  }

  $scope.timeRanges = ['This Week', 'This Month', 'All Events'];

  var defaultTimeRange = $scope.filters && $scope.filters.length > 0 ? 'All Events' : $scope.timeRanges[0];

  $scope.currentTimeRange = $location.search() && $location.search().date ? $location.search().date : defaultTimeRange;

  $scope.changeEventTimeRange = function (timeRange) {
    $location.search('date', timeRange);
    $scope.currentTimeRange = timeRange;
    _getEvents();
  };

  function _getEvents() {

    $scope.events = [];
    $scope.loading = true;

    var options = {
      fields: 'date,seoPathname,favoriteCount,name,images,venue(name,seoPathname,location.address),special,tags',
      cityId: $scope.city.id,
      sort: 'date',
      limit: 200
    };

    if ($scope.filters && $scope.filters.length > 0) {
      options.tags = $scope.filters[0].key;
    }

    var list = {
      'This Week': 7,
      'This Month': 30,
      'All Events': 365
    };

    var daysOut = list[$scope.currentTimeRange] || 30;

    options.start = (0, _moment2.default)().toDate().getTime();
    options.end = (0, _moment2.default)().add(daysOut, 'days').toDate().getTime();

    jsSdkEvent.listByCityId($scope.city.id, options).then(function _success(response) {
      $scope.events = response;

      $scope.loading = false;

      $timeout(function () {
        $rootScope.$broadcast('eventsLoaded');
      });
    }, function _error(response) {
      loggerService.error(response);
      $scope.loading = false;
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$location', '$timeout', 'partnerService', 'jsSdk.event', 'utilsService', 'loggerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService, jsSdkVenue, utilsService, loggerService) {
  $scope.loading = true;
  $scope.venues = [];

  $scope.citiesPromise.then(function () {
    var city = $stateParams.city;

    if (!city || city.length < 1) {
      $state.transitionTo('browse.venues', {
        city: utilsService.defaultCitySlug()
      });
      return;
    }

    $scope.changeCity($stateParams.city);
  });

  $scope.changeCity = function (citySlug) {

    $scope.setCity(citySlug, function () {
      _getVenues();
    });
  };

  $scope.timeRanges = ['All Venues', 'Tonight', 'Tomorrow', 'This Weekend'];

  $scope.currentTimeRange = $location.search() && $location.search().date ? $location.search().date : 'All Venues';

  $scope.filterItemsByTime = function (venue) {
    var today = (0, _moment2.default)().day();

    if ($scope.currentTimeRange === 'All Venues') {
      return true;
    }

    if (!venue.schedule || venue.schedule.length === 0) {
      return false;
    } else if ($scope.currentTimeRange === 'Tonight') {
      return !venue.schedule[today].closed;
    } else if ($scope.currentTimeRange === 'Tomorrow') {
      return !venue.schedule[today + 1].closed;
    } else if ($scope.currentTimeRange === 'This Weekend') {
      return !venue.schedule[0].closed || !venue.schedule[5].closed || !venue.schedule[6].closed;
    }

    return false;
  };

  $scope.changeTimeRange = function (timeRange) {
    $location.search('date', timeRange);
    $scope.currentTimeRange = timeRange;
    $scope.updated();
  };

  $scope.filterItems = function (venue) {
    return $scope.filterItemsByTime(venue);
  };

  $scope.sorters = ['Featured', 'Alphabetical', 'Popular', 'Highest Rated'];

  $scope.sortBy = $location.search() && $location.search().sort ? $location.search().sort : 'Alphabetical';

  $scope.setSortBy = function (sorter) {
    $location.search('sort', sorter);
    $scope.sortBy = sorter;
    $scope.updated();
  };

  $scope.sortVenues = function (item) {
    if ($scope.sortBy === 'Featured') {
      return !item.featured;
    }

    if ($scope.sortBy === 'Popular') {
      return item.favoriteCount * -1;
    }

    if ($scope.sortBy === 'Alphabetical') {
      return item.name;
    }

    if ($scope.sortBy === 'Highest Rated') {
      return item.rating ? item.rating.ratingAverage * -1 : false;
    }

    return false;
  };

  function _getVenues() {
    $scope.loading = true;

    var options = {
      cityId: $scope.city.id,
      fields: 'name,seoPathname,tags,images,featured,rating,favoriteCount,schedule'
    };

    jsSdkVenue.listByCityId($scope.city.id, options).then(function success(response) {

      $scope.venues = response;

      $scope.loading = false;
      $scope.updated();
    }, function error(response) {
      loggerService.error(response);
      $scope.loading = false;
    });
  }

  $scope.updated = function () {
    $timeout(function () {
      $rootScope.$broadcast('venuesLoaded');
    });
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$location', '$timeout', 'partnerService', 'jsSdk.venue', 'utilsService', 'loggerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

var _tablelistTerms = __webpack_require__(401);

var _tablelistTerms2 = _interopRequireDefault(_tablelistTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BOOKING_PAYMENT_TYPES = {
  ADVANCE: 'ADVANCE',
  ADVANCE_DEPOSIT: 'ADVANCE_DEPOSIT',
  VENUE: 'VENUE',
  NONE: 'NONE'
};

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $uibModal, jsSdkUser, jsSdkBooking, jsSdkAuth, jsSdkLocalStorage, utilsService, jsSdkInventory, loggerService, resizeService, metaTagService, tracking, partnerService, $window, trackingService, modalService) {
  $scope.loading = true;
  $scope.BOOKING_PAYMENT_TYPES = BOOKING_PAYMENT_TYPES;
  $scope.errorMessage = null;

  $scope.submitted = false;
  $scope.completingPurchase = false;

  $scope.updateUserForm = {
    email: '',
    phone: ''
  };

  $rootScope.$on('userUpdated', _updateUserForm);

  $scope.bookingHasConfirmationRequestWithArrivalTime = function () {
    if (!$scope.booking) return false;

    return !!($scope.booking.confirmationRequest && $scope.booking.arrivalTime);
  };

  $scope.loginConfig = {
    startState: 'newUser',
    compactLayout: true,
    completeProfile: false,
    success: function success(response) {
      $scope.currentUser = response;
      $scope.updateUserForm.email = $scope.currentUser.email;
      $scope.updateUserForm.phone = $scope.currentUser.phone;

      _updateBooking({
        userId: response.id
      }, function (err, resp) {

        if (err) {
          $scope.errorMessage = utilsService.errorMessage(err);
          loggerService.error(err);
        } else {
          $scope.booking.primaryUser = resp.primaryUser;
          $scope.booking.users = resp.users;
        }
      });
    },
    error: function error(resp) {
      $scope.errorMessage = utilsService.errorMessage(resp);
      loggerService.error(resp);
    }
  };

  $scope.customerMarketingOptInChanged = function (newVal) {
    _updateBooking({
      customerMarketingOptIn: newVal
    });
  };

  $scope.arrivalTimes = [];

  $scope.changeArrivalTime = function (arrivalTime) {
    $scope.selectedArrivalTime = arrivalTime;

    if (!arrivalTime) return;

    if (arrivalTime === $scope.booking.arrivalTime) return;

    _updateBooking({
      arrivalTime: arrivalTime
    }, function (err, booking) {
      if (err) return;

      $scope.selectedArrivalTime = booking.arrivalTime;
      $scope.booking.arrivalTime = booking.arrivalTime;
    });
  };

  $scope.isUserValid = function () {
    return typeof $rootScope.isLoggedIn() !== 'undefined';
  };

  $scope.isPhoneValid = function () {
    return $scope.updateUserForm.phone && $scope.updateUserForm.phone.length > 9;
  };

  $scope.isEmailValid = function () {
    return $scope.updateUserForm.email && $scope.updateUserForm.email.length;
  };

  $scope.setPaymentProfile = function (paymentProfile) {
    $scope.paymentProfile = paymentProfile;
  };

  $scope.checkout = function (form) {
    if ($scope.submitted) {
      return null;
    }

    $scope.submitted = true;

    if (!form.email.$valid || !form.phone.$valid) {
      return null;
    }

    $scope.errorMessage = null;
    $scope.completingPurchase = true;

    if (!$scope.isPhoneValid()) {
      $scope.errorMessage = 'Please enter a valid phone number.';
      $scope.completingPurchase = false;
      return null;
    }

    if (!$scope.isEmailValid()) {
      $scope.errorMessage = 'Please enter a valid email address.';
      $scope.completingPurchase = false;
      return null;
    }

    if (!$scope.paymentProfile && this.booking.payment !== BOOKING_PAYMENT_TYPES.NONE && this.booking.payment !== BOOKING_PAYMENT_TYPES.VENUE) {
      $scope.errorMessage = 'Please enter your payment information.';
      $scope.completingPurchase = false;
      return null;
    }

    var userData = {};

    if ($scope.updateUserForm.email && $scope.updateUserForm.email !== $scope.currentUser.email) {
      userData.email = $scope.updateUserForm.email;
    }

    if ($scope.updateUserForm.phone && $scope.updateUserForm.phone !== $scope.currentUser.phone) {
      userData.phone = $scope.updateUserForm.phone;
    }

    return jsSdkUser.updateMe(userData).then(function () {
      return jsSdkBooking.complete($scope.booking.id, {
        paymentProfileId: $scope.paymentProfile ? $scope.paymentProfile.id : null
      });
    }).then(function (response) {
      if ($scope.currentUser) {
        $scope.currentUserBookings = $scope.currentUserBookings || [];
        $scope.currentUserBookings.push(response);
      }

      $scope.submitted = false;

      $state.go('app.receipt', {
        booking: response.id
      });
    }).catch(function (resp) {
      $scope.submitted = false;

      $scope.completingPurchase = false;
      $scope.checkoutResult = 'error';
      $scope.errorMessage = utilsService.errorMessage(resp);
    });
  };

  $scope.showArrivalTime = function () {
    if (!$scope.booking || $scope.booking.skipArrivalTime || $scope.booking.inventoryType === 'TICKET' || $scope.booking.inventoryType === 'COVER') return false;

    var start = _lodash2.default.get($scope.booking, 'arrivalStartTime');
    var end = _lodash2.default.get($scope.booking, 'arrivalEndTime');

    return start && end;
  };

  $scope.signOut = function ($event) {
    if ($event) $event.preventDefault();

    $rootScope.logout();

    $window.history.back();
  };

  $scope.showVenueTerms = function ($event) {
    if ($event) $event.preventDefault();

    modalService.terms({
      terms: $scope.inventory.termsAndConditions
    });
  };

  $scope.showTablelistTerms = function ($event) {
    if ($event) $event.preventDefault();

    modalService.terms({
      terms: _tablelistTerms2.default
    });
  };

  _getBooking();

  _updateUserForm();

  trackingService.trackEvent(_segmentEvents2.default.StartedCheckout);

  metaTagService.set({
    title: 'Checkout',
    description: 'Checkout'
  });

  function _defaultArrivalTime() {
    $scope.selectedArrivalTime = $scope.booking.arrivalTime;
  }

  function _updateFormWithUser(user) {
    $scope.updateUserForm.email = user.email;
    $scope.updateUserForm.phone = user.phone;
  }

  function _updateUserForm() {
    if (!jsSdkAuth.isLoggedIn()) return null;

    var user = jsSdkUser.getCurrentUser();

    if (user) return _updateFormWithUser(user);

    return jsSdkUser.me().then(_updateFormWithUser);
  }

  function _updateBooking(options) {
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    return jsSdkBooking.updateById($scope.booking.id, options).then(function (resp) {
      next(null, resp);
    });
  }

  function _getBooking() {
    jsSdkBooking.read($stateParams.bookingId).then(function (response) {
      $scope.booking = response;

      $scope.bookingDateSentence = utilsService.getBookingDateSentence($scope.booking);

      $scope.booking.itemCount = _lodash2.default.reduce(response.items, function (sum, item) {
        return sum + item.quantity;
      }, 0);

      var venueName = _lodash2.default.get(response, 'venue.name', 'this venue');

      $scope.venueMarketingOptInText = _lodash2.default.get(response, 'venue.marketingOptInText', 'Yes, I\'d like to get occasional marketing emails from ' + venueName);
      $scope.venueShowMarketingOptIn = _lodash2.default.get(response, 'venue.showMarketingOptIn', false);

      $scope.loading = false;

      if ($scope.booking.status !== 'OPEN') {
        $state.go('app.receipt', {
          booking: response.id
        });
        return;
      }

      _defaultArrivalTime();

      _getInventoryStartTime($scope.booking);

      if (_config2.default.NODE_ENV === 'production') {
        var fbqData = {
          content_type: 'product',
          value: $scope.booking.price,
          currency: 'USD',
          content_ids: [$scope.booking.venue.id],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'InitiateCheckout', fbqData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'InitiateCheckout', fbqData);

        if ($scope.booking.trackingFacebookPixelId && $scope.booking.trackingFacebookPixelId !== '1606722376242558' && $scope.booking.trackingFacebookPixelId !== '316401409092218') {
          $window.fbq('init', $scope.booking.trackingFacebookPixelId);
          $window.fbq('trackSingle', $scope.booking.trackingFacebookPixelId, 'InitiateCheckout', fbqData);
        }
      }
    }).catch(function (error) {
      loggerService.error(error);

      console.log('**ERROR GETTING BOOKING**', error);

      $state.go('app.404');
    });
  }

  function _getInventoryStartTime(booking) {
    jsSdkInventory.readById(booking.inventory).then(function (resp) {
      $scope.inventory = resp;

      if (booking.inventoryType === 'TICKET' || booking.inventoryType === 'COVER') return;

      var start = resp.start;
      var end = resp.end;

      createArrivalTimeOptions(start, end);
    });
  }

  function createArrivalTimeOptions(start, end) {
    if (!start || !end) return;

    for (var i = start; i <= end; i += 900000) {
      $scope.arrivalTimes.push(i);
    }
  }
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$stateParams', '$uibModal', 'jsSdk.user', 'jsSdk.booking', 'jsSdk.auth', 'jsSdk.localstorage', 'utilsService', 'jsSdk.inventory', 'loggerService', 'resizeService', 'metaTagService', 'trackingService', 'partnerService', '$window', 'trackingService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $location, metaTagService) {
  metaTagService.set({
    title: 'Concierge Service | Tablelist',
    description: 'Contact the Tablelist Concierge to help plan your night, or answer questions about your booking.'
  });

  var suggestedMessage = $location.search().message;

  var sampleMessage = 'Hello Tablelist Concierge, my friends and I would like to go out this weekend - can you help me find a great package for us?';

  $scope.message = suggestedMessage || sampleMessage;
}

Ctrl.$inject = ['$scope', '$location', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, metaTagService) {
  metaTagService.set({
    title: 'Tablelist Promo Codes | Tablelist',
    description: 'Coupons and Promo codoes for new users.'
  });
}

Ctrl.$inject = ['$scope', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shuffle2 = __webpack_require__(1011);

var _shuffle3 = _interopRequireDefault(_shuffle2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _uniqBy2 = __webpack_require__(154);

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $timeout, $stateParams, $document, $location, $q, metaTagService, utilsService, jsSdkUser, tlEE, jsSdkCuratedList, jsSdkCuratedListFollow, jsSdkCity, imgix, loggerService, tracking, modalService) {
  $scope.loading = true;
  $scope.saving = false;
  $scope.curatedList = null;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.followedLists = [];
  $scope.currentVenueFilter = null;

  _loadCuratedList($stateParams.id, function () {
    _loadCity($scope.curatedList.city);
  });

  _loadFollowedCuratedLists();

  tlEE.on(jsSdkUser.EVENTS.USER_UPDATED, function () {
    _loadFollowedCuratedLists();
  });

  $scope.imgix = function (src) {
    var options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.isFollowing = function () {
    var user = jsSdkUser.getCurrentUser();

    var isFollowing = false;

    if (user && $scope.curatedList && $scope.curatedList.follow && $scope.curatedList.follow[0]) {
      isFollowing = $scope.curatedList.follow[0].user === user.id;
    }

    return isFollowing;
  };

  $scope.toggleFollow = function (list) {
    if (!list || !list.id) return;

    var user = jsSdkUser.getCurrentUser();

    $scope.saving = true;

    if (user && $scope.isFollowing()) {
      _unfollow(list);
      return;
    }

    var options = {
      startState: 'existingUser'
    };

    modalService.authUser(function success() {
      _follow(list);
    }, function error() {
      $scope.saving = false;
    }, options);
  };

  $scope.toggleCurrentVenue = function (venue) {
    if ($scope.currentVenueFilter && $scope.currentVenueFilter.id === venue.id) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function (item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _follow(list) {
    jsSdkCuratedListFollow.createByCuratedListId(list.id).then(function () {
      tracking.trackEvent(_segmentEvents2.default.FollowedCuratedList, {
        id: list.id,
        title: list.title
      });

      _loadCuratedList(list.id);
    }, _error);
  }

  function _unfollow(list) {
    jsSdkCuratedListFollow.removeByCuratedListId(list.id).then(function () {
      tracking.trackEvent(_segmentEvents2.default.UnfollowedCuratedList, {
        id: list.id,
        title: list.title
      });

      _loadCuratedList(list.id);
    }, _error);
  }

  function _error(resp) {
    $scope.loading = false;
    $scope.saving = false;
    loggerService.error(resp);
  }

  function _loadFollowedCuratedLists() {
    var user = jsSdkUser.getCurrentUser();

    if (!user) {
      return;
    }

    $scope.followedLists = [];

    var options = {
      fields: 'curatedList()'
    };

    jsSdkCuratedListFollow.listByUserId(user.id, options).then(function (resp) {
      $scope.followedLists = (0, _shuffle3.default)(resp);
    });
  }

  function _loadCity(id) {
    jsSdkCity.readById(id).then(function (resp) {
      $scope.city = resp;
    });
  }

  function _loadCuratedList(id, next) {
    var options = {
      items: true,
      follow: true,
      fields: ['venue(id, name)', 'event(id, name, date, images, primaryImage, dateStart, dateEnd)'].join(',')
    };

    jsSdkCuratedList.readById(id, options).then(function (resp) {
      $scope.curatedList = resp;
      $scope.items = resp.items;

      var eventItems = (0, _filter3.default)($scope.items, {
        type: 'EVENT'
      });

      $scope.venues = (0, _uniqBy3.default)(eventItems.map(function (item) {
        return item.venue;
      }), function (venue) {
        return venue.id;
      });

      metaTagService.set({
        title: resp.title,
        description: resp.description,
        facebookImage: resp.imageUrl
      });

      $scope.shareBarConfig = {
        url: utilsService.createUrl('/list/' + $scope.curatedList.id),
        message: 'See Tablelist\'s - ' + $scope.curatedList.title
      };

      var url = utilsService.createUrl('/list/' + $scope.curatedList.id);
      var msg = 'See Tablelist\'s - ' + $scope.curatedList.title;

      $scope.facebookLink = utilsService.facebookLink(url);
      $scope.twitterLink = utilsService.twitterLink(url, msg);
      $scope.emailLink = utilsService.mailtoLink(url, msg);

      if (next) next();

      $scope.loading = false;
      $scope.saving = false;
    }, function () {

      $scope.loading = false;
      $scope.saving = false;

      utilsService.link('/404?target=' + $location.$$absUrl);
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$timeout', '$stateParams', '$document', '$location', '$q', 'metaTagService', 'utilsService', 'jsSdk.user', 'tl.ee', 'jsSdk.curatedList', 'jsSdk.curatedListFollow', 'jsSdk.city', 'jsSdk.imgix', 'loggerService', 'trackingService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(159);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _PROD_CURATED_LISTS_B;

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _uniqBy2 = __webpack_require__(154);

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NYC_CITY_ID = 'aa211bf5d25100ac';
var BOSTON_CITY_ID = '301072f4d252999a';
var CHICAGO_CITY_ID = '11abc446a23da51a';
var FOXWOODS_CITY_ID = '568778505711d1b2';
var FORT_LAUDERDALE = '386597775b2a72b6';
var LA_CITY_ID = 'f9fce97fa9132e52';
var MIAMI_CITY_ID = '62c929d5af07ce54';
var PHILLY_CITY_ID = '9ceeab229a24e62d';
var HOUSTON_CITY_ID = 'f571681b2ff72d5c';
var PROVIDENCE_CITY_ID = '791ea86155e28a75';
var SCOTTSDALE_CITY_ID = 'bcdfa9e13bbb3f46';
var SEATTLE_CITY_ID = 'ae509095e188297c';
var TAMPA_CITY_ID = '2f15e73a5e960cf9';

var SAN_ANTONIO_CITY_ID = 'cb453f5710bf9950';

var LAS_VEGAS_CITY_ID = 'cd2018d3f09c6ea9';
var ANAHEIM_CITY_ID = 'f0b90758fecbdbbf';
var MORGANTOWN_ID = '8b4957a1453b01c9';

var SAN_DIEGO_CITY_ID = 'b5ed38b8d630d9dc';
var SAN_FRANCISCO_CITY_ID = '5037331a71b485ee';

var WASHINGTON_DC_CITY_ID = '070ac346cd2d446f';

var PROD_CURATED_LISTS_BY_CITY_ID = (_PROD_CURATED_LISTS_B = {}, (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, NYC_CITY_ID, '27964c082f63edf6'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, BOSTON_CITY_ID, 'b698d874e188395b'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, CHICAGO_CITY_ID, '502c30150c54ccb1'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, FOXWOODS_CITY_ID, '5bbb6b3ce37a6270'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, FORT_LAUDERDALE, 'f8a96351f3182d1a'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, LA_CITY_ID, '33302c7aaee75be6'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, HOUSTON_CITY_ID, 'cecea942ec1cd83e'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, PHILLY_CITY_ID, '8a781784484defd8'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, PROVIDENCE_CITY_ID, '29b557cd3c22fa12'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SCOTTSDALE_CITY_ID, '72a3784565d62c87'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SEATTLE_CITY_ID, '44da9ab1ce4ec121'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, TAMPA_CITY_ID, 'f3c711777ed57c0b'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, MORGANTOWN_ID, '1ef4830869999a96'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, MIAMI_CITY_ID, 'd6365d210b4784dc'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_ANTONIO_CITY_ID, 'dcb5ace52a793d33'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, LAS_VEGAS_CITY_ID, '8b4fb520b01a6684'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, ANAHEIM_CITY_ID, 'efa86bc09fd775ea'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_DIEGO_CITY_ID, 'd60e332d10a61a98'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_FRANCISCO_CITY_ID, '81502583a1125aea'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, WASHINGTON_DC_CITY_ID, 'bc15909d9d9ef303'), _PROD_CURATED_LISTS_B);

var EVENT_ENABLED = true;
var TODAYS_DATE = (0, _moment2.default)();
var EVENT_DATE = (0, _moment2.default)().month(9).date(31).endOf('day');

function Ctrl($rootScope, $scope, $state, $timeout, $stateParams, $document, $location, $q, metaTagService, utilsService, jsSdkUser, tlEE, jsSdkCuratedList, jsSdkCuratedListFollow, jsSdkCity, imgix) {

  $scope.saving = false;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.currentVenueFilter = null;
  $scope.cityForm = {};

  var PROD_CITY_IDS = (0, _keys2.default)(PROD_CURATED_LISTS_BY_CITY_ID);

  var citySlug = $stateParams.city || utilsService.defaultCitySlug();

  $scope.showCountdown = !EVENT_ENABLED;

  var diff = TODAYS_DATE.diff(EVENT_DATE, 'days');

  if (diff > 0) {
    EVENT_DATE.add(1, 'year');

    $scope.eventPast = true;
  }

  $scope.eventDate = EVENT_DATE;


  jsSdkCity.list().then(function (cities) {
    $scope.cities = (0, _filter3.default)(cities, function (city) {
      return PROD_CITY_IDS.includes(city.id);
    });

    $scope.cityForm.city = (0, _find3.default)($scope.cities, {
      slugName: citySlug || 'nyc'
    }) || $scope.cities[0];

    $scope.selectCity();
  });

  $scope.selectCity = function () {
    if (PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]) {
      return _loadCuratedList(PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]);
    }

    return null;
  };

  $scope.imgix = function (src) {
    var options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.toggleCurrentVenue = function (venue) {
    if ($scope.currentVenueFilter && $scope.currentVenueFilter.id === venue.id) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function (item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _loadCuratedList(id, next) {
    $scope.loading = true;

    var options = {
      items: true,
      follow: true,
      fields: ['venue(id, name)', 'event(id, name, date, images, primaryImage, dateStart, dateEnd)'].join(',')
    };

    jsSdkCuratedList.readById(id, options).then(function (resp) {
      $scope.curatedList = resp;
      $scope.items = resp.items;

      var eventItems = (0, _filter3.default)($scope.items, {
        type: 'EVENT'
      });

      $scope.venues = (0, _uniqBy3.default)(eventItems.map(function (item) {
        return item.venue;
      }), function (venue) {
        return venue.id;
      });

      metaTagService.set({
        title: resp.title,
        description: resp.description,
        facebookImage: resp.imageUrl
      });

      $scope.shareBarConfig = {
        url: utilsService.createUrl('/list/' + $scope.curatedList.id),
        message: 'See Tablelist\'s - ' + $scope.curatedList.title
      };

      var url = utilsService.createUrl('/list/' + $scope.curatedList.id);
      var msg = 'See Tablelist\'s - ' + $scope.curatedList.title;

      $scope.facebookLink = utilsService.facebookLink(url);
      $scope.twitterLink = utilsService.twitterLink(url, msg);
      $scope.emailLink = utilsService.mailtoLink(url, msg);

      if (next) next();

      $scope.loading = false;
      $scope.saving = false;
    }).catch(function () {
      $scope.loading = false;
      $scope.saving = false;
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$stateParams', '$document', '$location', '$q', 'metaTagService', 'utilsService', 'jsSdk.user', 'tl.ee', 'jsSdk.curatedList', 'jsSdk.curatedListFollow', 'jsSdk.city', 'jsSdk.imgix', 'loggerService', 'trackingService', 'tl.config', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(159);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _PROD_CURATED_LISTS_B;

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _uniqBy2 = __webpack_require__(154);

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NYC_CITY_ID = 'aa211bf5d25100ac';
var BOSTON_CITY_ID = '301072f4d252999a';
var CHICAGO_CITY_ID = '11abc446a23da51a';
var FOXWOODS_CITY_ID = '568778505711d1b2';
var FORT_LAUDERDALE_CITY_ID = 'xxx';
var LA_CITY_ID = 'f9fce97fa9132e52';
var MIAMI_CITY_ID = '62c929d5af07ce54';
var PHILLY_CITY_ID = '9ceeab229a24e62d';
var DETROIT_CITY_ID = 'f552cfc2b2535d0e';
var SAN_ANTONIO_CITY_ID = 'cb453f5710bf9950';
var HONOLULU_CITY_ID = '6a38221d87f63fbd';
var HOUSTON_CITY_ID = 'f571681b2ff72d5c';
var LAS_VEGAS_CITY_ID = 'cd2018d3f09c6ea9';
var ANAHEIM_CITY_ID = '9ce1109aa47913bb';

var DALLAS_CITY_ID = '2a5304c583e1a75e';

var SAN_DIEGO_CITY_ID = 'b5ed38b8d630d9dc';
var SEATTLE_ID = 'ae509095e188297c';
var SAN_FRANCISCO_CITY_ID = '5037331a71b485ee';
var SCOTTSDALE_CITY_ID = 'bcdfa9e13bbb3f46';
var TAMPA_CITY_ID = '2f15e73a5e960cf9';
var AUSTIN_CITY_ID = 'abd97a4fd8b43635';
var ASPEN_CITY_ID = 'e908312b03c42d5b';
var WASHINGTON_DC_CITY_ID = '070ac346cd2d446f';

var PROD_CURATED_LISTS_BY_CITY_ID = (_PROD_CURATED_LISTS_B = {}, (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, NYC_CITY_ID, '270aac8a9eab2d68'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, BOSTON_CITY_ID, 'e9f8eb4b2b821e20'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, CHICAGO_CITY_ID, 'd303343d43ccc321'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, FOXWOODS_CITY_ID, '6fbf6cf3510fb223'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, FORT_LAUDERDALE_CITY_ID, 'fb4fc0762316dd0c'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, LA_CITY_ID, 'f8e216e4a0951aa5'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, MIAMI_CITY_ID, 'd680f3873b5475cb'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, PHILLY_CITY_ID, '4a5d0e43ad1722f5'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, DETROIT_CITY_ID, '65b5a0e1aded5c7c'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_ANTONIO_CITY_ID, '8ce2c846ecbb0db8'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, HONOLULU_CITY_ID, '562d0804f0b09b98'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, HOUSTON_CITY_ID, 'e57d1dea6b87868a'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, LAS_VEGAS_CITY_ID, 'ed6e43f2224ff19f'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, ANAHEIM_CITY_ID, 'ef2a5d67d434a0e4'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, DALLAS_CITY_ID, 'db6a96a4b058fb7c'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_DIEGO_CITY_ID, 'e40ee1a7e79e1c9a'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SEATTLE_ID, '1df7f70e1bc8cfbf'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SAN_FRANCISCO_CITY_ID, 'c650612af4d39c0a'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, SCOTTSDALE_CITY_ID, '847e6d07ecb0c3cb'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, TAMPA_CITY_ID, 'cabe83f05227ce72'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, AUSTIN_CITY_ID, '85586eaa6b8bfc85'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, ASPEN_CITY_ID, '5445b0bb031b4ebc'), (0, _defineProperty3.default)(_PROD_CURATED_LISTS_B, WASHINGTON_DC_CITY_ID, '48980046e68980c7'), _PROD_CURATED_LISTS_B);

var EVENT_ENABLED = true;
var TODAYS_DATE = (0, _moment2.default)();
var EVENT_DATE = (0, _moment2.default)().endOf('year');

function Ctrl($rootScope, $scope, $state, $timeout, $stateParams, $document, $location, $q, metaTagService, utilsService, jsSdkUser, tlEE, jsSdkCuratedList, jsSdkCuratedListFollow, jsSdkCity, imgix) {

  $scope.saving = false;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.currentVenueFilter = null;
  $scope.cityForm = {};
  $scope.currentYear = new Date().getFullYear();

  var PROD_CITY_IDS = (0, _keys2.default)(PROD_CURATED_LISTS_BY_CITY_ID);

  var citySlug = $stateParams.city || utilsService.defaultCitySlug();

  $scope.showCountdown = !EVENT_ENABLED;

  var diff = TODAYS_DATE.diff(EVENT_DATE, 'days');

  if (diff > 0) {
    EVENT_DATE.add(1, 'year');

    $scope.eventPast = true;
  }

  $scope.eventDate = EVENT_DATE;


  jsSdkCity.list().then(function (cities) {
    $scope.cities = (0, _filter3.default)(cities, function (city) {
      return PROD_CITY_IDS.includes(city.id);
    });

    $scope.cityForm.city = (0, _find3.default)($scope.cities, {
      slugName: citySlug || 'nyc'
    }) || $scope.cities[0];

    $scope.selectCity();
  });

  $scope.selectCity = function () {
    console.log('$scope.cityForm', $scope.cityForm);

    console.log('PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]', PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]);

    $state.go($state.current.name, {
      city: $scope.cityForm.city.slugName
    });

    if (PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]) {
      return _loadCuratedList(PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]);
    }

    return null;
  };

  $scope.imgix = function (src) {
    var options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.toggleCurrentVenue = function (venue) {
    if ($scope.currentVenueFilter && $scope.currentVenueFilter.id === venue.id) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function (item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _loadCuratedList(id) {
    $scope.loading = true;

    var options = {
      items: true,
      follow: true,
      fields: ['venue(id, name)', 'event(id, name, date, images, primaryImage, dateStart, dateEnd)'].join(',')
    };

    return jsSdkCuratedList.readById(id, options).then(function (resp) {
      $scope.curatedList = resp;
      $scope.items = resp.items;

      var eventItems = (0, _filter3.default)($scope.items, {
        type: 'EVENT'
      });

      $scope.venues = (0, _uniqBy3.default)(eventItems.map(function (item) {
        return item.venue;
      }), function (venue) {
        return venue.id;
      });

      metaTagService.set({
        title: resp.title,
        description: resp.description,
        facebookImage: resp.imageUrl
      });

      $scope.shareBarConfig = {
        url: utilsService.createUrl('/list/' + $scope.curatedList.id),
        message: 'See Tablelist\'s - ' + $scope.curatedList.title
      };

      var url = utilsService.createUrl('/list/' + $scope.curatedList.id);
      var msg = 'See Tablelist\'s - ' + $scope.curatedList.title;

      $scope.facebookLink = utilsService.facebookLink(url);
      $scope.twitterLink = utilsService.twitterLink(url, msg);
      $scope.emailLink = utilsService.mailtoLink(url, msg);

      $scope.loading = false;
      $scope.saving = false;
    }).catch(function () {
      $scope.loading = false;
      $scope.saving = false;
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$stateParams', '$document', '$location', '$q', 'metaTagService', 'utilsService', 'jsSdk.user', 'tl.ee', 'jsSdk.curatedList', 'jsSdk.curatedListFollow', 'jsSdk.city', 'jsSdk.imgix', 'loggerService', 'trackingService', 'tl.config', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $rootScope, utilsService, $uibModal, metaTagService) {
  $scope.showIos = true;

  metaTagService.set({
    title: 'Download Tablelist for iOS and Android',
    description: 'Download Tablelist for iOS and Android, the #1 app for access to VIP bottle service, private tables and exclusive events in a growing number of cities'
  });

  $scope.showDownloadLinks = function () {
    $uibModal.open({
      template: '<div id="download-links-modal" class="modal-body clearfix">' + '<div class="col-md-6">' + '<a class="apple" href="https://itunes.apple.com/app/tablelist/id634444177?mt=8" target="_blank" title="Download for iOS">' + '<img class="img-responsive" src="https://assets.tablelist.com/www-2/assets/download_apple.png">' + '</a>' + '</div>' + '<div class="col-md-6">' + '<a class="android" href="https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod" target="_blank" title="Download for Android">' + '<img class="img-responsive" src="https://assets.tablelist.com/www-2/assets/download_android.png">' + '</a>' + '</div>' + '</div>',
      controller: ['$scope', '$uibModalInstance', function ($scope2, $uibModalInstance) {
        $scope2.close = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }]
    });
  };
}

Ctrl.$inject = ['$scope', '$rootScope', 'utilsService', '$uibModal', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _earnCreditModal = __webpack_require__(874);

var _earnCreditModal2 = _interopRequireDefault(_earnCreditModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $uibModal, utilsService, metaTagService, jsSdkReferral, jsSdkSettings) {
  metaTagService.set({
    title: 'Earn Credit | Tablelist',
    description: 'Earn free credit by inviting your friends to join your VIP tables in Boston, New York City, Las Vegas, and San Francisco',
    facebookTitle: 'Get $25 for every friend you invite to Tablelist.',
    facebookDescription: 'Use Tablelist for a better night out. Life is a celebration, and finding the party has never been easier.'
  });

  if ($scope.currentUser && $scope.currentUser.id) {
    getReferrals();
  }

  $scope.learnMore = function () {
    $uibModal.open({
      template: _earnCreditModal2.default,
      windowClass: 'earnCreditModal',
      controller: 'earnCreditModalCtrl'
    });
  };

  $scope.scrollTo = function (target) {
    utilsService.scrollTo(target, 110, 500);
  };

  $scope.referralGetCredit = 25;
  $scope.referralGiveCredit = 25;

  var referralCode = $scope.currentUser && $scope.currentUser.referralCode ? $scope.currentUser.referralCode : '';

  $scope.shareURL = utilsService.createUrl('/invite/' + referralCode);

  jsSdkSettings.readConfig().then(function success(resp) {
    $scope.referralGetCredit = resp.referralGetCredit;
    $scope.referralGiveCredit = resp.referralGiveCredit;

    $scope.facebookLink = utilsService.facebookLink($scope.shareURL);
    $scope.twitterLink = utilsService.twitterLink($scope.shareURL, 'Join @Tablelist with my promo code to get $' + resp.referralGiveCredit + ' in credit at your favorite clubs and lounges.');
  });

  function getReferrals() {
    jsSdkReferral.listByUserId($scope.currentUser.id).then(function success(response) {
      $scope.referrals = response;
    });
  }
}

Ctrl.$inject = ['$scope', '$uibModal', 'utilsService', 'metaTagService', 'jsSdk.referral', 'jsSdk.settings'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $location, metaTagService) {
  metaTagService.set({
    title: '404 | Tablelist',
    description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',
    statusCode: 404
  });

  var params = $location.search();

  if (params && params.message) {
    $scope.message = params.message;
  }
}

Ctrl.$inject = ['$scope', '$location', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $location, metaTagService) {
  metaTagService.set({
    title: '400 | Tablelist',
    description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',
    statusCode: 400
  });

  var params = $location.search();

  if (params && params.message) {
    $scope.message = params.message;
  }
}

Ctrl.$inject = ['$scope', '$location', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

var _get2 = __webpack_require__(69);

var _get3 = _interopRequireDefault(_get2);

var _map2 = __webpack_require__(233);

var _map3 = _interopRequireDefault(_map2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $timeout, $window, $state, $stateParams, $sce, utilsService, jsSdkEvent, jsSdkVenue, jsSdkCuratedList, imgix, $http, $uibModal, $filter, fb, loggerService, favoritesService, eventHelpersService, metaTagService, trackingService, $location, jsSdkConfig) {

  var eventId = void 0;

  if ($stateParams.seoPathname) {
    eventId = $stateParams.seoPathname.split('-').pop();
  } else if ($stateParams.eventId) {
    eventId = $stateParams.eventId;
  } else {
    return $state.go('app.404');
  }

  $scope.showBackBtn = !!$stateParams.back;
  $scope.backId = $stateParams.back;
  $scope.backName = $stateParams.backName;

  var eventPromise = jsSdkEvent.readById(eventId, {
    fields: ['name', 'seoPathname', 'details', 'tags', 'images', 'active', 'date', 'dateStart', 'dateEnd', 'venue(name,location,seoPathname,marketingOptInText,showMarketingOptIn,details.minAge, trackingFacebookPixelId)', 'timezone', 'isMapWidgetEnabled', 'externalSellingLink', 'inventoryNote', 'trackingFacebookPixelId', 'performers'].join(',')
  });

  eventPromise.then(function (response) {
    $scope.initialize(response);

    trackingService.trackEvent(_segmentEvents2.default.ViewedEvent, {
      venueId: $scope.event.venue.id,
      venueName: $scope.event.venue.name,
      eventId: $scope.event.id,
      eventName: $scope.event.name
    });

    if (_config2.default.NODE_ENV === 'production') {
      var trackingData = {
        content_type: 'product',
        content_ids: [$scope.event.venue.id],
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        language: navigator.language
      };

      $window.fbq('init', '1606722376242558');
      $window.fbq('trackSingle', '1606722376242558', 'ViewContent', trackingData);
      $window.fbq('init', '316401409092218');
      $window.fbq('trackSingle', '316401409092218', 'ViewContent', trackingData);

      if ($scope.event.venue.trackingFacebookPixelId) {
        $window.fbq('init', $scope.event.venue.trackingFacebookPixelId);
        $window.fbq('init', $scope.event.venue.trackingFacebookPixelId);
        $window.fbq('trackSingle', $scope.event.venue.trackingFacebookPixelId, 'ViewContent', trackingData);
      }
    }

    $timeout(function () {
      var client = $location.search().client || 'web';

      if ($scope.event.isMapWidgetEnabled) {
        var inventoryListMapWidget = new window.TablelistWidgets.widgets.InventoryListMapWidget('#inventory-list-map-widget');

        inventoryListMapWidget.init({
          venueId: $scope.event.venue.id,
          eventId: $scope.event.id,
          date: $scope.event.date,
          client: client,
          theme: 'theme-light',
          attributionId: jsSdkConfig.attributionId || 'TABLELIST',
          affiliateId: $rootScope.affiliateId,
          trackingId: $rootScope.trackingId,
          disableInlineCheckout: true,
          checkoutUrl: _config2.default.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
          onInventoryAddedToCart: function onInventoryAddedToCart(inventory) {
            if (_config2.default.NODE_ENV === 'production') {
              var fbqData = {
                content_type: 'product',
                value: inventory.price,
                currency: 'USD',
                content_ids: [inventory.venue],
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                language: navigator.language
              };

              $window.fbq('init', '1606722376242558');
              $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
              $window.fbq('init', '316401409092218');
              $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);

              if ($scope.event.trackingFacebookPixelId) {
                $window.fbq('init', $scope.event.trackingFacebookPixelId);
                $window.fbq('trackSingle', $scope.event.trackingFacebookPixelId, 'AddToCart', fbqData);
              }
            }
          }
        });
      } else {
        var inventoryListWidget = void 0;

        if ((0, _jquery2.default)(window).width() < 992) {
          inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-xs');
        } else {
          inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-lg');
        }

        inventoryListWidget.init({
          venueId: $scope.event.venue.id,
          eventId: $scope.event.id,
          date: $scope.event.date,
          client: client,
          theme: 'theme-light',
          attributionId: jsSdkConfig.attributionId || 'TABLELIST',
          affiliateId: $rootScope.affiliateId,
          trackingId: $rootScope.trackingId,
          disableInlineCheckout: true,
          checkoutUrl: _config2.default.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
          onInventoryAddedToCart: function onInventoryAddedToCart(inventory) {
            if (_config2.default.NODE_ENV === 'production') {
              var fbqData = {
                content_type: 'product',
                value: inventory.price,
                currency: 'USD',
                content_ids: [inventory.venue],
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                language: navigator.language
              };

              $window.fbq('init', '1606722376242558');
              $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
              $window.fbq('init', '316401409092218');
              $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);

              if ($scope.event.trackingFacebookPixelId) {
                $window.fbq('init', $scope.event.trackingFacebookPixelId);
                $window.fbq('trackSingle', $scope.event.trackingFacebookPixelId, 'AddToCart', fbqData);
              }
            }
          }
        });
      }
    });
  }).catch(function () {
    $state.go('app.404', {
      message: 'Uh oh. The event you are looking for is no longer available.',
      target: '/e/' + eventId
    });
  });

  $scope.initialize = function (event) {
    $scope.event = event;

    setTags(event);
    setPlugins(event);
    setAddress(event);

    var venueId = (0, _get3.default)($scope, 'event.venue.id');

    _getEvents(venueId);
    _getCuratedLists(event.id);

    fb.logEvent(fb.events().VIEWED_CONTENT, $scope.event.id);

    var venue = (0, _get3.default)($scope, 'event.venue.name');

    var venueString = venue ? ' at ' + venue : "";

    var metaTitle = 'Buy Tickets and Tables to ' + event.name + venueString;
    var metaDesc = 'Buy tickets, tables and packages at  ' + event.name + venueString;

    metaTagService.set({
      title: metaTitle,
      description: metaDesc,
      facebookImage: (0, _get3.default)($scope, ['event', 'primaryImage', 'xlarge']),
      canonicalPath: '/e/' + $scope.event.seoPathname
    });

    $scope.shareBarConfig = {
      url: utilsService.createUrl('/e/' + $scope.event.seoPathname),
      message: 'Join me at ' + $scope.event.name
    };
  };

  $scope.imgix = function (src, w, h) {
    if (!src) return null;

    return imgix.url(src, {
      width: w,
      height: h
    });
  };

  $scope.isPast = function () {
    if (!$scope.event) return null;

    var start = (0, _moment2.default)($scope.event.date, 'x');
    var now = (0, _moment2.default)();
    var diff = now.diff(start, 'hours');

    return diff >= 24;
  };

  $scope.canBookNow = function () {
    if (!$scope.event) return null;

    return $scope.event.active;
  };

  $scope.getEventOpenSentence = function (event) {
    if (!event) return;

    var now = (0, _moment2.default)();
    var nowDate = now.get('date');

    var eventDate = (0, _moment2.default)($filter('localize')(event.date));

    var opensAt = '';

    if (nowDate === eventDate.get('date')) {
      opensAt = (eventDate.get('hours') >= 18 ? 'Tonight' : 'Today') + ' at ' + $scope.event.name;
    } else if (nowDate === eventDate.add(1, 'days').get('date')) {
      opensAt = 'Tomorrow at ' + $scope.event.name;
    } else {
      opensAt = eventDate.format('dddd MMMM DD') + ' ' + $scope.event.name;
    }

    event.opensAt = opensAt;
  };

  $scope.eventDateString = function (event) {
    if (!event || !event.date) return '';

    var eventDate = _moment2.default.utc(event.date).startOf('day');

    $scope.date = eventDate;

    var now = (0, _moment2.default)();
    var today = now.clone().startOf('day');
    var tomorrow = now.clone().add(1, 'days').startOf('day');

    if ($scope.isPast()) {
      return eventDate.format('M/D/YYYY') + ' at ';
    }

    if (eventDate.isSame(today, 'd')) {
      return 'Tonight, ' + eventDate.format('M/D') + ' at ';
    }

    if (eventDate.isSame(tomorrow, 'd')) {
      return 'Tomorrow, ' + eventDate.format('M/D') + ' at ';
    }

    return eventDate.format('dddd, M/D') + ' at ';
  };

  function setTags(event) {
    var musicTags = (0, _filter3.default)(event.tags, function (tag) {
      return tag.key === 'MUSIC';
    });

    var crowdTags = (0, _filter3.default)(event.tags, function (tag) {
      return tag.key === 'CROWD';
    });

    var okDressCodeTags = (0, _filter3.default)(event.tags, function (tag) {
      return tag.key === 'DRESS_CODE_OK';
    });

    var notOkDressCodeTags = (0, _filter3.default)(event.tags, function (tag) {
      return tag.key === 'DRESS_CODE_NOT_OK';
    });

    var userDefinedTags = (0, _filter3.default)(event.tags, function (tag) {
      return tag.key === 'USER_DEFINED';
    });

    if (musicTags && musicTags.length) {
      $scope.event.musicTags = musicTags;
    }
    if (crowdTags && crowdTags.length) {
      $scope.event.crowdTags = crowdTags;
    }
    if (okDressCodeTags && okDressCodeTags.length) {
      $scope.event.okDressCodeTags = okDressCodeTags;
    }
    if (notOkDressCodeTags && notOkDressCodeTags.length) {
      $scope.event.notOkDressCodeTags = notOkDressCodeTags;
    }
    if (userDefinedTags && userDefinedTags.length) {
      $scope.event.userDefinedTags = userDefinedTags;
    }
  }

  function setPlugins(event) {
    $scope.event.details = event.details || {
      social: {}
    };
    $scope.event.details.soundcloud = event.details.soundcloud ? $sce.trustAsResourceUrl(event.details.soundcloud) : '';
    $scope.event.details.youtube = event.details.youtube ? $sce.trustAsResourceUrl(getYoutubeUrl(event.details.youtube)) : '';
  }

  function setAddress(event) {
    var address = (0, _get3.default)(event, 'venue.location.address');

    if (!address) return;

    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(address));

    $scope.googleMapsDirectionsUrl = address.address ? 'http://www.google.com/maps/dir//' + address.address.replace(/ /g, '+') + '+' + address.city + '+' + address.state + '+' + address.zip : null;
  }

  function getYoutubeUrl(url) {
    if (url.indexOf('embed') >= 0) return url;
    var embedUrl = 'https://www.youtube.com/embed/';
    var query = urlQuery(url);

    embedUrl += query.v;

    return embedUrl;
  }

  function urlQuery(url) {
    var query = {};
    var queryString = url.split('?').pop();
    var queryParts = queryString.split('&');

    (0, _each3.default)(queryParts, function (part) {
      var parts = part.split('=');
      var key = parts[0];
      var val = parts[1];
      query[decodeURIComponent(key)] = decodeURIComponent(val);
    });

    return query;
  }

  function _getEvents(venueId) {
    if (!venueId) {
      $scope.loadingEvents = false;
      return;
    }

    var start = (0, _moment2.default)().toDate().getTime();
    var end = (0, _moment2.default)().add(4, 'month').toDate().getTime();

    jsSdkEvent.listByVenueId(venueId, {
      start: start,
      end: end,
      sort: 'date',
      limit: 6,
      fields: 'name,date,description,images,seoPathname'
    }).then(function success(response) {

      (0, _map3.default)(response, function (event) {
        event.image = (0, _get3.default)(event, 'primaryImage.filename', 'https://assets.tablelist.com/www/images/event-default-poster-v1.2.jpg');
        return event;
      });

      $scope.events = response;

      $scope.loadingEvents = false;
    });
  }

  function _getCuratedLists(eventId2) {
    if (!eventId2) return;

    jsSdkCuratedList.listByEventId(eventId2).then(function (resp) {
      $scope.curatedLists = resp;
    });
  }
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', '$window', '$state', '$stateParams', '$sce', 'utilsService', 'jsSdk.event', 'jsSdk.venue', 'jsSdk.curatedList', 'jsSdk.imgix', '$http', '$uibModal', '$filter', 'tl.facebook', 'loggerService', 'favoritesService', 'eventHelpersService', 'metaTagService', 'trackingService', '$location', 'jsSdk.config'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $location, $timeout, utilsService, metaTagService) {
  metaTagService.set({
    title: 'Frequently Asked Questions | Tablelist',
    description: 'Our concierges are available 24/7 to answer any questions you have, but here are a few they hear often. Go ahead and try to stump them!'
  });

  $scope.scrollTo = function (target, offset) {
    offset = offset || 100;
    utilsService.scrollTo(target, offset, 500);
  };

  $scope.selectedSlug = '';

  $scope.select = function (slug) {
    if ($scope.selectedSlug === slug) {
      $scope.selectedSlug = null;
    } else {
      $scope.selectedSlug = slug;
    }

    $location.search('q', $scope.selectedSlug);
  };

  var targetID = $location.search().q;

  if (targetID) {
    $timeout(function () {
      $scope.scrollTo(targetID, 210);
    }, 1000);

    $scope.selectedSlug = targetID;
  }

  $scope.faqGroups = [{
    slug: 'basics',
    header: 'Basics',
    questions: [{
      question: 'What is Tablelist?',
      answer: 'Tablelist makes it easy to plan a night out. Discover events, browse venues, book VIP tables, or buy event tickets all from the <a href="https://www.tablelist.com/dl/download" target="_blank">Tablelist app</a>. We develop and maintain relationships with our venue partners to provide VIP treatment for all of our users, whether it’s at an event, party, or private table on a night out. Learn more about who Tablelist is <a href="/about" target="_blank">here</a>.' }, {
      question: 'How can I use Tablelist?',
      answer: '<ul><li>Browse venues</li><li>Book VIP tables</li><li>Discover events</li><li>Buy tickets</li><li>Plan with a complimentary concierge</li></ul>Use Tablelist on <a href="/" target="_blank">Web</a>, <a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>, or <a href="https://bit.ly/tablelist-android" target="_blank">Android</a>.' }, {
      question: 'Where can I use Tablelist?',
      answer: 'Tablelist is in Boston, New York City, Las Vegas, San Francisco, Washington DC, Foxwoods Casino, Philadelphia, Miami and many more cities.' }, {
      question: 'Why should I use Tablelist?',
      answer: 'It comes down to three things: <ol><li><strong>Options</strong> - We connect you to the best venues in the city, and unlike a promoter, we don\'t have a preference for specific nights or venues. We get you the night that suits you best.</li><li><strong>Convenience</strong> - Your options are packaged into an easy-to-use platform, and we\'re on call 24/7 to answer any questions you may have.</li><li><strong>Trust</strong> - Transparent billing is always a priority, and the price you agree on is the price you pay. Additionally, you have a concierge waiting to answer questions, handle requests, or to go over the details of your night.</li></ol> ' }, {
      question: 'What is bottle service? ',
      answer: 'Everything you ever wanted to know about bottle service <a href="/bottleservice101" target="_blank">here</a>.' }]
  }, {
    slug: 'planning',
    header: 'Planning Your Night',
    questions: [{
      question: 'I’m looking for something different than the packages available through Tablelist, what should I do?',
      answer: 'This is where our relationships with venues really come in handy. If you have a custom request, get in touch with a concierge through the “Talk to us” widget anywhere on <a href="/" target="_blank">tablelist.com</a>, or text us at <strong>(617)-340-8791</strong>.' }, {
      question: 'I don’t know where to go, can I get help planning my night out? ',
      answer: 'Absolutely. Our concierges are available 24/7. Reach them from the “Talk to us” widget on <a href=' / ' target="_blank">tablelist.com</a>, or text us at <strong>(617)-340-8791</strong> to get started. They can help you find exactly what you are looking for, and they really shine when they are planning birthday, bachelor, or bachelorette parties.' }, {
      question: 'How do the concierges know about everything that’s going on in the city?',
      answer: 'The best answer here is that they love going out, and because it’s their job to know about everything going on. The concierges are in constant contact with venue hosts, and have an insider knowledge of events happening in each venue for their city. ' }, {
      question: 'I’m trying to go out on a specific budget, how do I find my best options?',
      answer: 'You have a range of options. Our table selection page gives you table minimums, which should help give you an idea of what you will be spending for the night. If you aren’t able to find anything that suits you, get in touch with a concierge and let them do the work. ' }]
  }, {
    slug: 'booking',
    header: 'Booking',
    questions: [{
      question: 'How far in advance can I book a table?',
      answer: 'Booking is available up to 7 days in advance, and remains open until night-of. Depending on capacity, you may be able to book a table or pay your cover charge from the line and skip the wait!' }, {
      question: 'What’s included with my table booking?',
      answer: 'Additional perks change from venue to venue, but all bottle service packages include:<br><ul><li>The bottles you ordered</li><li>Standard mixers (OJ, pineapple, etc.)</li><li>Express entry into the club for you and your guests </li><li>Waived cover charge</li><li>A private table for you and your guests</li><li>Private service from a personal waitress</li><li>On-call support from your personal Tablelist concierge</li></ul>' }, {
      question: 'I booked a table, do I still have to pay cover?',
      answer: 'Cover charge is included for the number of guests allowed at the table you selected. Any additional guests must pay cover and wait in line.' }, {
      question: 'How many people can I bring? Can I set up my own guest list?',
      answer: 'The table selection menu shows the maximum guests allowed for each option. Each person (up to the max) that accepts your invitation will be added to the guest list.' }, {
      question: 'What time should I arrive at the venue?',
      answer: 'Your table will be released as a “no-show” after 15 minutes, so be on time!' }, {
      question: 'Can my guests show up later than the arrival time?',
      answer: 'Yes, only one person needs to get there at arrival time to keep the table. Your friends will be on a list for your table.' }, {
      question: 'Can I transfer my reservation to a different venue?',
      answer: 'Transferring a reservation is not guaranteed, but feel free to get in touch with your concierge at <strong>(617)-340-8791</strong> and they will check for you.' }, {
      question: 'What if I have to cancel my table?',
      answer: 'Just text your concierge at <strong>(617)-340-8791</strong> and let them know. There is a 10% fee for cancellations within 24 hours of the reservation (same goes for no-shows).' }, {
      question: 'Once I book a table, when will my card be charged?',
      answer: '<ul><li><strong>Booking solo</strong> - A hold for the full amount will be placed on your card until 2 AM, the morning after your booking. </li></ul>' }]
  }, {
    slug: 'going-out',
    header: 'Going Out',
    questions: [{
      question: 'What time should I get to the venue?',
      answer: 'Your table will be released 15 minutes after your arrival time if you do not show up, so be on time! A 10% cancellation fee applies if your table is released due to a no-show.' }, {
      question: 'Will I have to show my ID if I book through Tablelist?',
      answer: 'Yes, you will be required to show ID to verify your table, age, and credit card.' }, {
      question: 'I booked a table solo, how do my friends get in if they don’t arrive with me?',
      answer: 'When your friends arrive, they will just tell the VIP host they are with you.' }, {
      question: 'We want to order more bottles while we are out, can we do it in the app?',
      answer: 'If you want to order more bottles once you are out, you will do this directly through the venue. ' }, {
      question: 'An issue came up, how do I get in touch with my concierge?',
      answer: 'Just text your concierge at <strong>(617)-340-8791</strong>. They’ll be available to handle anything that comes up for you. ' }, {
      question: 'What is the Early Arrival option?',
      answer: 'If you see the option for Early Arrival, it means that you will get a discount if you arrive before a certain time.' }, {
      question: 'Can I arrive early for my reservation?',
      answer: 'It likely won’t be a problem, but you may have to wait while the venue gets your table ready. Message your concierge at <strong>(617)-340-8791</strong> and let them know your new arrival time so they can ensure you get seated quickly.' }, {
      question: 'Am I guaranteed entry if we booked through Tablelist?',
      answer: 'No. Venues have complete discretion for entry. Info about the venue’s dress code and conduct guidelines can be found on the venue page at <a href=' / ' target="_blank">tablelist.com</a>.' }, {
      question: 'What’s the dress code at the venue I am attending? ',
      answer: 'Dress code varies, but each venue and event page on <a href=' / ' target="_blank">tablelist.com</a> gives the specific dress code.' }, {
      question: 'We decided we aren’t going out after all, can we cancel?',
      answer: 'You can cancel at any time, but cancellations within 24 hours of the booking are charged a 10% cancellation fee.' }]
  }, {
    slug: 'getting-in',
    header: 'Getting Into the Venue',
    questions: [{
      question: 'What type of ID should I bring to the venue?',
      answer: '<ul><li>Valid, unexpired, US driver\'s license (paper ID is not acceptable)</li><li>Out-of-state licenses often require a second form of ID, such as a credit card.</li><li>Official passport</li><li>U.S. Military ID</li></ul>' }, {
      question: 'Can the door staff refuse entry if I booked through Tablelist?',
      answer: 'Yes, entry is entirely the discretion of the door staff.' }, {
      question: 'What are some reasons that I could be denied entry to a venue?',
      answer: 'A venue can deny anybody entry from their private building, but some major reasons are:<ul><li>Arriving overly-intoxicated</li><li>Being aggressive or rowdy</li><li>Breaking dress code</li><li>Being underage</li><li>Invalid forms of ID</li><li>Failing to comply with other establishment policies (which vary from venue to venue.)</li></ul>' }, {
      question: 'My ID is expired, can I still get into a club?',
      answer: 'No. Expired IDs are not valid as a proof of age.' }, {
      question: 'I have a temporary paper ID, what should I do?',
      answer: 'Paper IDs are not honored as proper proof of age.' }]
  }, {
    slug: 'concierge',
    header: 'Your Tablelist Concierge',
    questions: [{
      question: 'How much does using a concierge cost?',
      answer: 'Nothing. Our concierge service is entirely free for Tablelist members, and always will be.' }, {
      question: 'What can I use my concierge for?',
      answer: 'Your concierge is available to help with nearly anything for your night out. They know our venues better than anyone, and can find you the exact type of night you are looking for. Ask your concierge something as simple as what music will be played, or let them plan an entire bachelorette party for you!' }, {
      question: 'Who is my concierge?',
      answer: 'Our concierges are fun-loving members of the Tablelist team, who spend a lot of time going out in their cities. They know the best nights for every one of our venues, and can make great suggestions for anyone’s interests. ' }, {
      question: 'How do I contact my concierge?',
      answer: 'Contact your concierge using the “Talk to Us” button at the bottom of every web page, or text them directly at <strong>(617)-340-8791</strong>.' }]
  }, {
    slug: 'events-and-tickets',
    header: 'Events and Tickets',
    questions: [{
      question: 'I bought a ticket, where do I find it?',
      answer: '<ul><li><strong><a href=' / ' target="_blank">Web</a>:</strong> Click your name in the top right corner of the page and it will be in your dashboard.</li><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under the “manage” tab, select “Admissions” to view all of your tickets.</li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Under the “Bookings” menu, your tickets are in the “Admissions” tab.</li></ul>' }, {
      question: 'Do I need to print anything to bring to the venue?',
      answer: 'You can either show your tickets using the mobile app, or print the .pdf from your email.' }, {
      question: 'Is my ticket transferrable?',
      answer: 'No, but you can buy a ticket for a friend and send it to them.' }, {
      question: 'I didn’t receive my ticket, what do I do?',
      answer: 'First, check your spam folder in case it ended up there. Otherwise, log into your Tablelist account from web or the app, and your ticket will be under your bookings.' }, {
      question: 'I bought a ticket for a friend, does it matter that it has my name on it?',
      answer: 'The name on the tickets is not an issue. As long as you send them their unique QR code, they will be admitted to the event. ' }, {
      question: 'Can I cancel my event ticket?',
      answer: 'Tickets are non-refundable, and all sales are final.' }]
  }, {
    slug: 'cancellations',
    header: 'Cancellation Policies',
    questions: [{
      question: 'I need to cancel my table, what should I do?',
      answer: 'To cancel your table reservation, contact your concierge at <strong>(617)-340-8791</strong>.<br><br><i>Tables are non-refundable for special events (Halloween, New Years Eve, etc).</i>' }, {
      question: 'What is the refund policy for a cancelled table?',
      answer: 'You can cancel your table at any time, but there is a 10% fee if you cancel less than 24 hours before your reservation.' }, {
      question: 'I didn’t show up to my reservation, what happens now?',
      answer: 'There is a 10% fee for no-shows on reservations.' }, {
      question: 'Can I transfer my reservation to a different venue?',
      answer: 'Transferring a reservation is not guaranteed, but feel free to get in touch with your concierge at <strong>(617)-340-8791</strong> so that they can check for you.' }, {
      question: 'Can I cancel my event ticket?',
      answer: 'Tickets are non-refundable.' }, {
      question: 'I’m on a guest list, but I’m not going to make it. What should I do?',
      answer: 'We really appreciate when people let us know they won’t be attending, but you don’t have to do anything. Shoot your concierge a text at <strong>(617)-340-8791</strong>.' }]
  }, {
    slug: 'credit-and-referrals',
    header: 'Credit & Referrals',
    questions: [{
      question: 'What is Tablelist credit?',
      answer: 'Tablelist credit acts as cash towards a table booking when you pay with Tablelist. If you select “Pay at Venue,” your Tablelist credit is non-applicable towards your bill. Credit can not be applied towards tickets.' }, {
      question: 'How can I earn Tablelist credit?',
      answer: 'Earn Tablelist credit by sharing your referral code with friends. Your friend will receive credit towards their first booking, and you’ll receive credit once they book for the first time. <br><br><i>Note: Publishing your referral code outside of your personal social media networks (coupon sites, search engines, etc.) is not allowed, and will result in your referral credits being revoked.</i>' }, {
      question: 'How can I use my Tablelist credit?',
      answer: 'Credit is automatically applied to tables over $200.' }, {
      question: 'Can my friends apply their credit to my table also?',
      answer: 'No, only the primary booker’s credit is applicable towards the table. ' }, {
      question: 'Can I purchase tickets or pay cover with my Tablelist credit?',
      answer: 'No, Tablelist credit only applies for table bookings. Credit will not apply towards reservations, skipping the line, event tickets, or cover charge. ' }, {
      question: 'The venue gave me a card receipt showing the full price, although I used credit. Am I being overcharged?',
      answer: 'No, the venue uses that total for their records, but your credit was applied and you are being charged correctly. ' }, {
      question: 'I have a code for Tablelist credit, where do I enter it?',
      answer: '<ul><li><strong><a href="/" target="_blank">Web</a>:</strong> click on your name in the top right corner, and select \'Enter Promo Code.\'</li><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under the “Account” tab, select “Enter Promo Code.</li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Select “Promo” in the navigation menu, enter code, and hit “Redeem.</li></ul>' }, {
      question: 'Can my friends and I combine credit?',
      answer: 'No, credit is non-transferrable and only applicable for the primary booker.' }, {
      question: 'How can I use my referral code?',
      answer: 'Share your referral code with friends, and on your personal social media. You may not share your referral code on coupon sites, search engines, or any other public forums. Doing so will result in all of your credit being revoked.' }, {
      question: 'I referred a friend, where’s my credit?',
      answer: 'Your friend receives credit immediately upon entering your referral code at signup. Once they book their first table, you’ll receive your referral credit. ' }]
  }, {
    slug: 'account-and-profile',
    header: 'Account & Profile',
    questions: [{
      question: 'How do I sign up with Tablelist?',
      answer: 'Sign up with your email, or link your Facebook account <a href="/dashboard" target="_blank">here</a>. Signing up for a Tablelist account is free.' }, {
      question: 'After you sign up, complete your profile to get the most out of Tablelist.',
      answer: 'What does a complete profile look like? <ul><li><strong>Your real name!</strong> - If not, you’ll have a reservation under a name that doesn’t match your ID, which makes the guest list problematic.</li><li><strong>Birthday</strong> - We require a verified age to use our app. You’ll be showing security your ID, so it won’t help to enter an incorrect age.</li><li><strong>Payment information </strong>- This makes it that much easier to book last minute, skip the line, or grab tickets right when they go on sale.</li><li><strong>Phone number </strong>- You’ll receive booking confirmation and any additional information via text message. </li><li><strong>Photo </strong>- Not required, but helps us identify you at the door.</li></ul>' }, {
      question: 'I have a fake name on Facebook and now my Tablelist account is wrong. How do I fix it?',
      answer: '<ul><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under “Account” tab, select your name and enter your real name</li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Under “Account,” tap your name and enter your real name</li><li><strong><a href=' / ' target="_blank">Web</a>:</strong> Select your name in the top right corner, select “Edit Profile” to enter your real name</li></ul>' }, {
      question: 'How do I change my payment method?',
      answer: '<ul><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under the “Account” tab, tap “Credit Card,” enter your new payment information, and hit “save.”</li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Under “Account,” tap the edit button in the bottom right, and update payment information</li><li><strong><a href=' / ' target="_blank">Web</a>:</strong> You will be able to change your card information on the checkout screen</li></ul>' }, {
      question: 'How do I change my password?',
      answer: 'To change you password, go to <a href="https://www.tablelist.com/forgot-password" target="_blank">tablelist.com/forgot-password</a>.' }, {
      question: 'How can I change my home city?',
      answer: 'In both <a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a> and <a href="https://bit.ly/tablelist-android" target="_blank">Android</a>, the dropdown is at the top of the home screen. <br><br> In web, simply change the city next to the venue dropdown list, or navigate to your <a href=' / ' target="_blank">Profile</a> and select “Edit Current City”' }, {
      question: 'How can I change my phone number?',
      answer: '<ul><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under “Account” tab, select your name and enter a new phone number</li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Under “Account,” tap the edit button in the bottom right, and update your phone number</li><li><strong><a href=' / ' target="_blank">Web</a>:</strong> Select your name in the top right corner, select “Edit Profile” to enter a new phone number</li></ul>' }, {
      question: 'How can I change my email address?',
      answer: '<ul><li><strong><a href="https://bit.ly/tablelist-ios" target="_blank">iOS</a>:</strong> Under “Account” tab, select your name and enter a new email address </li><li><strong><a href="https://bit.ly/tablelist-android" target="_blank">Android</a>:</strong> Under “Account,” tap the edit button in the bottom right, and update your email address</li><li><strong><a href=' / ' target="_blank">Web</a>:</strong> Select your name in the top right corner, select “Edit Profile” to enter a new email address</li></ul>' }]
  }];

  (0, _each3.default)($scope.faqGroups, function (group) {
    (0, _each3.default)(group.questions, function (question) {
      question.slug = utilsService.slugify(question.question);
    });
  });
}

Ctrl.$inject = ['$scope', '$location', '$timeout', 'utilsService', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, authService, tracking) {
  $scope.error = '';
  $scope.submitted = false;
  $scope.loading = false;
  $scope.emailSent = false;

  $scope.sendEmail = function (form) {
    $scope.submitted = true;

    if (form.$invalid) {
      $scope.error = 'Please enter a valid email';
      return;
    }

    authService.forgotPassword($scope.email, function () {
      $scope.submitted = false;
      $scope.emailSent = true;

      tracking.trackEvent(_segmentEvents2.default.ForgotPassword);
    }, function (resp) {
      $scope.error = resp.data.errors[0].message;
    });
  };
}

Ctrl.$inject = ['$scope', 'tl.auth.service', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $location, $anchorScroll, $document, $window, $timeout, loggerService, utilsService, metaTagService, membershipService, trackingService, modalService, partnerService) {
  $scope.partner = partnerService.partner;
  $scope.defaultCitySlug = utilsService.defaultCitySlug();

  metaTagService.set({
    title: 'Making Nightlife Simple - The #1 app for Bottle Service, Tickets, Guestlist',
    description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',
    facebookTitle: 'Making Nightlife Simple - The #1 app for Bottle Service, Tickets, Guestlist',
    facebookDescription: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.'
  });

  $scope.navigateTo = function (target) {
    if ($state.includes('app.home')) {
      utilsService.scrollTo(target, 30, 500);
    } else {
      utilsService.link('/?target=' + target);
    }
  };

  $scope.isSubscribed = function () {
    return membershipService.isUserSubscribed();
  };

  $scope.goToMembership = function () {
    trackingService.trackEvent(_segmentEvents2.default.ClickedHomepageMembershipAd, {});

    $state.go('app.membership.landing');
  };
}

Ctrl.$inject = ['$scope', '$state', '$location', '$anchorScroll', '$document', '$window', '$timeout', 'loggerService', 'utilsService', 'metaTagService', 'membershipService', 'trackingService', 'modalService', 'partnerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appCtrl = __webpack_require__(364);

var _appCtrl2 = _interopRequireDefault(_appCtrl);

var _homeCtrl = __webpack_require__(382);

var _homeCtrl2 = _interopRequireDefault(_homeCtrl);

var _aboutCtrl = __webpack_require__(354);

var _aboutCtrl2 = _interopRequireDefault(_aboutCtrl);

var _browseCtrl = __webpack_require__(365);

var _browseCtrl2 = _interopRequireDefault(_browseCtrl);

var _browseCityCtrl = __webpack_require__(366);

var _browseCityCtrl2 = _interopRequireDefault(_browseCityCtrl);

var _browseVenuesCtrl = __webpack_require__(368);

var _browseVenuesCtrl2 = _interopRequireDefault(_browseVenuesCtrl);

var _browseEventsCtrl = __webpack_require__(367);

var _browseEventsCtrl2 = _interopRequireDefault(_browseEventsCtrl);

var _eventCtrl = __webpack_require__(379);

var _eventCtrl2 = _interopRequireDefault(_eventCtrl);

var _faqCtrl = __webpack_require__(380);

var _faqCtrl2 = _interopRequireDefault(_faqCtrl);

var _tableserviceCtrl = __webpack_require__(393);

var _tableserviceCtrl2 = _interopRequireDefault(_tableserviceCtrl);

var _errorNotFoundCtrl = __webpack_require__(377);

var _errorNotFoundCtrl2 = _interopRequireDefault(_errorNotFoundCtrl);

var _errorServerCtrl = __webpack_require__(378);

var _errorServerCtrl2 = _interopRequireDefault(_errorServerCtrl);

var _checkoutCtrl = __webpack_require__(369);

var _checkoutCtrl2 = _interopRequireDefault(_checkoutCtrl);

var _receiptCtrl = __webpack_require__(389);

var _receiptCtrl2 = _interopRequireDefault(_receiptCtrl);

var _signupCtrl = __webpack_require__(392);

var _signupCtrl2 = _interopRequireDefault(_signupCtrl);

var _conciergeCtrl = __webpack_require__(370);

var _conciergeCtrl2 = _interopRequireDefault(_conciergeCtrl);

var _couponsCtrl = __webpack_require__(371);

var _couponsCtrl2 = _interopRequireDefault(_couponsCtrl);

var _downloadCtrl = __webpack_require__(375);

var _downloadCtrl2 = _interopRequireDefault(_downloadCtrl);

var _earnCreditCtrl = __webpack_require__(376);

var _earnCreditCtrl2 = _interopRequireDefault(_earnCreditCtrl);

var _forgotPasswordCtrl = __webpack_require__(381);

var _forgotPasswordCtrl2 = _interopRequireDefault(_forgotPasswordCtrl);

var _resetPasswordCtrl = __webpack_require__(390);

var _resetPasswordCtrl2 = _interopRequireDefault(_resetPasswordCtrl);

var _searchCtrl = __webpack_require__(391);

var _searchCtrl2 = _interopRequireDefault(_searchCtrl);

var _curatedListCtrl = __webpack_require__(372);

var _curatedListCtrl2 = _interopRequireDefault(_curatedListCtrl);

var _curatedListsHalloweenCtrl = __webpack_require__(373);

var _curatedListsHalloweenCtrl2 = _interopRequireDefault(_curatedListsHalloweenCtrl);

var _curatedListsNewYearsCtrl = __webpack_require__(374);

var _curatedListsNewYearsCtrl2 = _interopRequireDefault(_curatedListsNewYearsCtrl);

var _venueCtrl = __webpack_require__(394);

var _venueCtrl2 = _interopRequireDefault(_venueCtrl);

var _venueEventsCtrl = __webpack_require__(395);

var _venueEventsCtrl2 = _interopRequireDefault(_venueEventsCtrl);

var _venueInfoCtrl = __webpack_require__(396);

var _venueInfoCtrl2 = _interopRequireDefault(_venueInfoCtrl);

var _accountCtrl = __webpack_require__(355);

var _accountCtrl2 = _interopRequireDefault(_accountCtrl);

var _accountBookingCtrl = __webpack_require__(356);

var _accountBookingCtrl2 = _interopRequireDefault(_accountBookingCtrl);

var _accountDashboardCtrl = __webpack_require__(357);

var _accountDashboardCtrl2 = _interopRequireDefault(_accountDashboardCtrl);

var _accountFavoritesCtrl = __webpack_require__(358);

var _accountFavoritesCtrl2 = _interopRequireDefault(_accountFavoritesCtrl);

var _accountProfileCtrl = __webpack_require__(359);

var _accountProfileCtrl2 = _interopRequireDefault(_accountProfileCtrl);

var _accountPromoCtrl = __webpack_require__(360);

var _accountPromoCtrl2 = _interopRequireDefault(_accountPromoCtrl);

var _accountReviewCtrl = __webpack_require__(361);

var _accountReviewCtrl2 = _interopRequireDefault(_accountReviewCtrl);

var _accountReviewsCtrl = __webpack_require__(362);

var _accountReviewsCtrl2 = _interopRequireDefault(_accountReviewsCtrl);

var _accountTicketsCtrl = __webpack_require__(363);

var _accountTicketsCtrl2 = _interopRequireDefault(_accountTicketsCtrl);

var _membershipCtrl = __webpack_require__(384);

var _membershipCtrl2 = _interopRequireDefault(_membershipCtrl);

var _membershipStartCtrl = __webpack_require__(387);

var _membershipStartCtrl2 = _interopRequireDefault(_membershipStartCtrl);

var _membershipLandingCtrl = __webpack_require__(385);

var _membershipLandingCtrl2 = _interopRequireDefault(_membershipLandingCtrl);

var _membershipPerksCtrl = __webpack_require__(386);

var _membershipPerksCtrl2 = _interopRequireDefault(_membershipPerksCtrl);

var _membershipSuccessCtrl = __webpack_require__(388);

var _membershipSuccessCtrl2 = _interopRequireDefault(_membershipSuccessCtrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('appCtrl', _appCtrl2.default);
  app.controller('homeCtrl', _homeCtrl2.default);
  app.controller('aboutCtrl', _aboutCtrl2.default);
  app.controller('browseCtrl', _browseCtrl2.default);
  app.controller('browseCityCtrl', _browseCityCtrl2.default);
  app.controller('browseVenuesCtrl', _browseVenuesCtrl2.default);
  app.controller('browseEventsCtrl', _browseEventsCtrl2.default);
  app.controller('venueCtrl', _venueCtrl2.default);
  app.controller('venueEventsCtrl', _venueEventsCtrl2.default);
  app.controller('venueInfoCtrl', _venueInfoCtrl2.default);
  app.controller('eventCtrl', _eventCtrl2.default);
  app.controller('faqCtrl', _faqCtrl2.default);
  app.controller('tableserviceCtrl', _tableserviceCtrl2.default);
  app.controller('errorNotFoundCtrl', _errorNotFoundCtrl2.default);
  app.controller('errorServerCtrl', _errorServerCtrl2.default);
  app.controller('checkoutCtrl', _checkoutCtrl2.default);
  app.controller('receiptCtrl', _receiptCtrl2.default);
  app.controller('signupCtrl', _signupCtrl2.default);
  app.controller('conciergeCtrl', _conciergeCtrl2.default);
  app.controller('couponsCtrl', _couponsCtrl2.default);
  app.controller('downloadCtrl', _downloadCtrl2.default);
  app.controller('earnCreditCtrl', _earnCreditCtrl2.default);
  app.controller('forgotPasswordCtrl', _forgotPasswordCtrl2.default);
  app.controller('resetPasswordCtrl', _resetPasswordCtrl2.default);
  app.controller('searchCtrl', _searchCtrl2.default);

  app.controller('curatedListCtrl', _curatedListCtrl2.default);
  app.controller('curatedListHalloweenCtrl', _curatedListsHalloweenCtrl2.default);
  app.controller('curatedListsNewYearsCtrl', _curatedListsNewYearsCtrl2.default);

  app.controller('accountCtrl', _accountCtrl2.default);
  app.controller('accountBookingCtrl', _accountBookingCtrl2.default);
  app.controller('accountDashboardCtrl', _accountDashboardCtrl2.default);
  app.controller('accountFavoritesCtrl', _accountFavoritesCtrl2.default);
  app.controller('accountProfileCtrl', _accountProfileCtrl2.default);
  app.controller('accountPromoCtrl', _accountPromoCtrl2.default);
  app.controller('accountReviewCtrl', _accountReviewCtrl2.default);
  app.controller('accountReviewsCtrl', _accountReviewsCtrl2.default);
  app.controller('accountTicketsCtrl', _accountTicketsCtrl2.default);

  app.controller('membershipCtrl', _membershipCtrl2.default);
  app.controller('membershipStartCtrl', _membershipStartCtrl2.default);
  app.controller('membershipLandingCtrl', _membershipLandingCtrl2.default);
  app.controller('membershipPerksCtrl', _membershipPerksCtrl2.default);
  app.controller('membershipSuccessCtrl', _membershipSuccessCtrl2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $timeout, $stateParams, utilsService, loggerService, modalService, membershipService, jsSdkMembershipPlan) {
  $scope.plan = {
    billingPrice: 49
  };

  $scope.membershipListPromise = jsSdkMembershipPlan.list();

  $scope.membershipListPromise.then(function (resp) {
    resp = (0, _sortBy3.default)(resp, 'billingPrice');

    $scope.plan = resp[0];
  }, function () {
    loggerService.error('Failed to load membership plans.');
  });

  $scope.isSubscribed = function () {
    return membershipService.isUserSubscribed();
  };

  $scope.scrollTo = function (id, offset) {
    utilsService.scrollTo(id, offset);
  };

  $scope.concierge = function () {
    var msg = 'Hello Tablelist Concierge, I have a question about Tablelist Membership:';

    modalService.contactSupport({
      message: msg
    });
  };
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', '$stateParams', 'utilsService', 'loggerService', 'modalService', 'membershipService', 'jsSdk.membershipPlan'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $rootScope, $stateParams, $timeout, $location, metaTagService, tracking, membershipService, utilsService) {
  if (membershipService.isUserSubscribed()) {
    return $state.go('app.membership.perks');
  }

  $scope.typeformURL = 'https://tablelist-forms.typeform.com/to/gZr4xt';
  $scope.typeformPreviewURL = 'https://tablelist-forms.typeform.com/to/WhBCRZ';

  var query = $location.search();

  if (query) {
    if (!query.src) {
      query.src = 'www';
    }

    var params = utilsService.convertParamsToQueryString(query);

    $scope.typeformURL += params;
    $scope.typeformPreviewURL += params;
  }

  $scope.cities = membershipService.getCities();

  $scope.activeCity = $scope.cities[1];

  $scope.selectCity = function (slug) {
    $scope.activeCity = (0, _find3.default)($scope.cities, {
      slug: slug
    });
  };

  $scope.venues = membershipService.getVenues();

  $scope.filterVenues = function (city) {
    return city.city === $scope.activeCity.slug;
  };

  $scope.perkHTML = function (perks) {
    var perksList = {
      'drink deals': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-drink-v1.0.png" alt="Drink Deals">Drink Deals</span>',
      'table deals': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-TL-v1.0.png" alt="Table Deals">Table Deals</span>',
      'line jumpers': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-entry-v1.0.png" alt="VIP Line Jumpers">VIP Line Jumpers</span>',
      'preferred pricing': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-TL-v1.0.png">Preferred Pricing</span>',
      'free entry': '<span class="perk"><img src="https://assets.tablelist.com/www/images/membership/icons/circle-icon-ticket-v1.0.png" alt="Free Entry">Free Entry</span>'
    };

    var html = '';

    (0, _each3.default)(perks, function (perk) {
      html += perksList[perk];
    });

    return html;
  };

  $scope.shareBarConfig = {
    url: utilsService.createUrl('/membership'),
    message: 'Join @Tablelist Membership for exclusive members only experiences:'
  };

  metaTagService.set({
    title: 'Diamond Membership - The only nightlife membership program in the world.',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });
}

Ctrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', '$timeout', '$location', 'metaTagService', 'trackingService', 'membershipService', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _groupBy2 = __webpack_require__(996);

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _city = __webpack_require__(342);

var _city2 = _interopRequireDefault(_city);

var _inventory = __webpack_require__(346);

var _inventory2 = _interopRequireDefault(_inventory);

var _dateUtils = __webpack_require__(157);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $q, $timeout, inventorySearchService, membershipService, metaTagService, utilsService, loggerService, modalService, tracking, jsSdkCuratedList, imgix, jsSdkAuth) {

  metaTagService.set({
    title: 'Tablelist Diamond Membership Perks',
    description: 'Find perks in your city. Tablelist Diamond Tickets, Tables and Packages.'
  });

  if (!membershipService.isUserSubscribed()) {
    $state.go('app.membership.landing');

    return;
  }

  $scope.inventory = [];

  $scope.isLoggedIn = function () {
    return jsSdkAuth.isLoggedIn();
  };

  $scope.searchInventoryForm = {
    date: (0, _moment2.default)()
  };

  $scope.datePickerOptions = {
    startDate: (0, _moment2.default)(),
    minDate: (0, _moment2.default)(),
    parentEl: '.calendar-btn',
    locale: {
      format: 'MMM DD, YYYY'
    }
  };

  $scope.$watch('searchInventoryForm.date', function () {
    if (!$scope.pageInit) return;

    $scope.getInventoryByCityId($scope.currentCity.id);
  });

  $scope.getVenueImage = function (venue) {
    if (!venue || !venue.primaryImage) return '';

    return venue.primaryImage.filename;
  };

  $scope.changeCity = function () {
    if ($scope.currentUser) {
      utilsService.setPreferredCity($scope.currentCity.id).then(function () {
        return null;
      });
    }

    $scope.getInventoryByCityId($scope.currentCity.id);
  };

  $scope.getInventoryByCityId = function (cityId) {
    $scope.inventoryLoading = true;

    return $q.resolve(_inventory2.default.listByCityId(cityId, {
      dateStart: _dateUtils2.default.toUTCTimestampWithoutTime($scope.searchInventoryForm.date),
      dateEnd: _dateUtils2.default.toUTCTimestampWithoutTime($scope.searchInventoryForm.date),
      membershipLevelMin: 50,
      fields: 'venue(name, images, location, visibility)'
    })).then(function (result) {
      $scope.inventoryLoading = false;

      $scope.inventory = (0, _filter3.default)(result.data, function (inv) {
        return inv.venue.visibility >= 20;
      });

      var groups = (0, _groupBy3.default)($scope.inventory, 'venue._id');

      $scope.inventoryGroupedByVenue = (0, _keys2.default)(groups).map(function (key) {
        return {
          inventory: groups[key],
          venue: groups[key][0].venue
        };
      });
    });
  };

  $scope.currentCityImage = function () {
    if (!$scope.currentCity) return '';

    var image = $scope.currentCity && $scope.currentCity.images && $scope.currentCity.images.length ? (0, _find3.default)($scope.currentCity.images, {
      primary: true
    }) : {};

    return image.filename;
  };

  $scope.selectInventory = function (inventory) {
    $scope.selectedInventory = inventory;
  };

  $scope.deselectInventory = function () {
    $scope.selectedInventory = null;
  };

  $scope.loading = true;

  $q.resolve(_city2.default.list()).then(function (result) {
    $scope.cities = (0, _sortBy3.default)(result.data, 'name');

    $scope.currentCity = (0, _find3.default)($scope.cities, {
      id: utilsService.defaultCityId()
    }) || $scope.cities[0];

    $scope.loading = false;

    $scope.pageInit = true;

    return $scope.getInventoryByCityId($scope.currentCity.id);
  });
}

Ctrl.$inject = ['$scope', '$state', '$q', '$timeout', 'inventorySearchService', 'membershipService', 'metaTagService', 'utilsService', 'loggerService', 'modalService', 'trackingService', 'jsSdk.curatedList', 'jsSdk.imgix', 'jsSdk.auth'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _reduce2 = __webpack_require__(1010);

var _reduce3 = _interopRequireDefault(_reduce2);

var _map2 = __webpack_require__(233);

var _map3 = _interopRequireDefault(_map2);

var _filter2 = __webpack_require__(27);

var _filter3 = _interopRequireDefault(_filter2);

var _includes2 = __webpack_require__(151);

var _includes3 = _interopRequireDefault(_includes2);

var _extend2 = __webpack_require__(110);

var _extend3 = _interopRequireDefault(_extend2);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $location, utilsService, metaTagService, loggerService, tracking, membershipService, jsSdkMembership, jsSdkCity, jsSdkUser) {
  if ($scope.isSubscribed()) {
    $state.go('app.membership.perks');

    return;
  }

  metaTagService.set({
    title: 'Start Membership | Tablelist',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });

  $scope.paymentProfile = {};

  $scope.plans = [];
  $scope.plan = {};
  $scope.discountApplied = false;
  $scope.showDiscountForm = false;
  $scope.discountErrorMessage = null;
  $scope.membershipDiscountForm = {
    promoCode: null
  };

  $scope.toggleDiscountForm = function ($event) {
    if ($event) $event.preventDefault();

    $scope.showDiscountForm = !$scope.showDiscountForm;
  };

  if ($location.search && $location.search().promo) {
    $scope.showDiscountForm = true;
    $scope.membershipDiscountForm.promoCode = $location.search().promo;
  }

  $scope.selectPlan = function (plan, $event) {
    if ($event) $event.preventDefault();

    $scope.plan = plan;

    $scope.purchasingErrorMessage = null;
  };

  $scope.changePlan = function ($event) {
    if ($event) $event.preventDefault();

    $scope.plan = null;
  };

  $scope.loadingPlans = true;

  $scope.membershipListPromise.then(function (resp) {
    $scope.loadingPlans = false;

    (0, _each3.default)(resp, function (plan) {
      plan.terms = plan.terms.map(function (term) {
        return {
          title: term,
          accepted: false
        };
      });
    });

    $scope.plans = (0, _sortBy3.default)(resp, 'billingPrice');
  }).catch(function () {
    $scope.loadingPlans = false;
  });

  $scope.redeemDiscount = function (form, $event) {
    if ($event) $event.preventDefault();

    $scope.discountFormSubmitted = true;
    $scope.discountErrorMessage = null;
    $scope.discountApplied = false;

    if (!form.$valid) {
      return null;
    }

    var planId = $scope.plan.id;

    var options = {
      promoCode: $scope.membershipDiscountForm.promoCode
    };

    return jsSdkMembership.membershipCheckout(planId, options).then(function (result) {
      $scope.plan.promoCode = $scope.membershipDiscountForm.promoCode;
      $scope.plan.status = result.status;
      $scope.plan.statusDescription = result.statusDescription;
      $scope.plan.discounts = result.discounts;
      $scope.plan.billingIntervalPrice = result.price / result.billingInterval;
      $scope.plan.billingPrice = result.price;

      $scope.discountApplied = true;

      $scope.discountErrorMessage = null;

      $scope.discountFormSubmitted = false;
    }).catch(function (err) {
      $scope.discountErrorMessage = utilsService.errorMessage(err);
    });
  };

  $scope.loginConfig = {
    startState: 'newUser',
    completeProfile: false,
    compactLayout: true,
    success: function success() {
      if (membershipService.isUserSubscribed()) {
        $state.go('app.membership.perks');
      }
    },
    error: function error(resp) {
      $scope.loginErrorMessage = utilsService.errorMessage(resp);
    }
  };

  $scope.termsAccepted = function () {
    return (0, _reduce3.default)($scope.plan.terms, function (acc, term) {
      return acc && term.accepted;
    }, true);
  };

  $scope.paymentUpdated = function (profile) {
    $scope.paymentProfile = profile;
  };

  $scope.complete = function () {
    $scope.purchasingErrorMessage = null;

    var user = jsSdkUser.getCurrentUser();

    if (!user || !user.id) {
      $scope.purchasingErrorMessage = 'Unknown User. Please log out and try again.';
      return;
    }

    if (!$scope.paymentProfile || !$scope.paymentProfile.id) {
      $scope.purchasingErrorMessage = 'Invalid payment information. Please update your credit card.';
      return;
    }

    if (!$scope.termsAccepted()) {
      $scope.purchasingErrorMessage = 'Please accept the above terms and conditions';
      return;
    }

    var options = {
      userId: user.id,
      planId: $scope.plan.id,
      paymentProfileId: $scope.paymentProfile.id,
      promoCode: $scope.plan.promoCode,
      affiliateId: $rootScope.affiliateId,
      trackingId: $rootScope.trackingId
    };

    $scope.completing = true;

    jsSdkMembership.create(options).then(function (resp) {
      $scope.completing = false;

      var data = {
        plan: resp.planName,
        price: resp.price
      };

      tracking.trackEvent(_segmentEvents2.default.CompletedMembershipOrder, data);

      return jsSdkUser.me();
    }).then(function (currentUser) {
      (0, _extend3.default)($rootScope.currentUser, currentUser);

      $state.go('app.membership.success');
    }).catch(function (err) {
      $scope.completing = false;

      $scope.purchasingErrorMessage = err.message;

      loggerService.error(err);

      $scope.purchasingErrorMessage = utilsService.errorMessage(err);
    });
  };

  jsSdkCity.list().then(function (resp) {
    var limitTo = (0, _map3.default)(membershipService.getCities(), 'slug');

    $scope.cities = (0, _filter3.default)(resp, function (city) {
      return (0, _includes3.default)(limitTo, city.slugName);
    });
  }).catch(function (err) {
    loggerService.error(err);
  });
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$stateParams', '$location', 'utilsService', 'metaTagService', 'loggerService', 'trackingService', 'membershipService', 'jsSdk.membership', 'jsSdk.city', 'jsSdk.user'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _confettiJs = __webpack_require__(560);

var _confettiJs2 = _interopRequireDefault(_confettiJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, metaTagService, utilsService) {
  if (!$scope.isSubscribed()) {
    $state.go('app.membership.landing');

    return;
  }

  var url = utilsService.createUrl('/membership?promo=' + $scope.currentUser.referralCode);

  console.log('url', url);

  $scope.facebookLink = utilsService.facebookLink(url);

  console.log('$scope.facebookLink', $scope.facebookLink);

  var confettiSettings = {
    target: 'confetti-canvas',
    max: '100',
    animate: true,
    props: ['square', 'triangle', 'line'],
    colors: [[165, 104, 246], [230, 61, 135], [0, 199, 228], [253, 214, 126]],
    clock: '10',
    rotate: false
  };
  var confetti = new _confettiJs2.default(confettiSettings);

  confetti.render();

  metaTagService.set({
    title: 'Thank You | Tablelist',
    description: 'Receive exclusive member only perks and experiences at your favorite nightclubs, lounges, and events.'
  });

  $scope.onCopied = function () {
    document.getElementById('referral-code').select();
  };
}

Ctrl.$inject = ['$scope', '$state', 'metaTagService', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $state, $stateParams, $sce, $window, $http, bookingHelpers, bookingService, userService, paymentService, modalService, utilsService, loggerService, metaTagService, jsSdkBooking) {
  $scope.booking = null;
  $scope.status = {};
  $scope.tickets = [];
  $scope.errorMsg = null;
  $scope.facebookJoinMessageUrl = null;
  $scope.error = null;
  $scope.loading = true;

  var bookingId = $stateParams.booking;

  metaTagService.set({
    title: 'Your Booking Receipt',
    description: 'Your Booking Receipt',
    deeplink: 'booking/' + bookingId
  });

  $scope.shareBarConfig = {
    url: utilsService.createUrl('/'),
    message: 'I just booked on Tablelist!'
  };

  function initialize(bookingId2) {
    $scope.error = null;

    jsSdkBooking.read(bookingId2).then(function (resp) {

      $scope.loading = false;

      if (!resp || !resp.id) {
        $scope.error = 'Unable to find booking.';
        return;
      }

      var booking = resp;

      $scope.booking = booking;
      $scope.error = null;

      updatePage(booking);

      $scope.status = bookingHelpers.getStatus(booking);

      if (bookingHelpers.hasTickets(booking)) {
        getTickets(booking.id);
      }

      var paymentProfileID = void 0;

      if (booking.payment === 'PAYMENT_PLAN') {
        paymentProfileID = booking.paymentPlan.paymentProfile;
      } else {
        paymentProfileID = currentUsersPaymentProfileID(booking);
      }

      _loadPaymentProfile(paymentProfileID);
    }, function error(resp) {
      $scope.loading = false;
      $scope.error = utilsService.errorMessage(resp);
    });
  }

  function updatePage(booking) {
    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(booking.venue.location.address));
    $scope.directMapUrl = utilsService.getMapUrl(booking.venue.location.address, true);
    $scope.ticketPDF = bookingHelpers.downloadTicketLink(booking);
  }

  initialize($stateParams.booking);

  $scope.remove = function (user) {
    if (confirm('Are you sure you would like to remove ' + (user.id === $scope.currentUser.id ? 'yourself' : user.name) + ' from the table?')) {
      bookingService.decline($scope.booking.id, user.id).$promise.then(function success() {
        if (user.id === $scope.currentUser.id) {
          $state.go('app.home');
        } else {
          $state.go($state.currentState, {
            reload: true
          });
        }
      }, function error(response) {
        $scope.error = response.data;
      });
    }
  };

  bookingService.listBookingTickets({
    id: bookingId
  }).then(function (response) {
    $scope.tickets = response;
  }, function error(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
  });

  function getTickets(bookingId2) {
    $http.get('/booking/' + bookingId2 + '/ticket').then(function (resp) {
      $scope.packageTickets = resp.data;
    }, function (resp) {
      loggerService.error(resp);
    });
  }

  function currentUsersPaymentProfileID(booking) {
    if (!$rootScope.currentUser) return null;

    var paymentProfileID = null;

    (0, _each3.default)(booking.users, function (i) {
      if (i.user && i.user.id === $rootScope.currentUser.id) {

        paymentProfileID = i.paymentProfile;
      }
    });

    return paymentProfileID;
  }

  function _loadPaymentProfile(paymentProfileID) {
    if (!paymentProfileID) return;

    paymentService.read(paymentProfileID).$promise.then(function success(resp) {
      $scope.paymentProfile = resp;
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$sce', '$window', 'tl.http', 'bookingHelpersService', 'tl.booking.service', 'tl.user.service', 'tl.payment.service', 'modalService', 'utilsService', 'loggerService', 'metaTagService', 'jsSdk.booking'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $stateParams, authService) {
  $scope.reset = function () {
    $scope.infoMessage = null;
    $scope.successMessage = null;
    $scope.errorMessage = null;
    $scope.isReset = false;

    if ($scope.password1 !== $scope.password2) {
      $scope.errorMessage = 'Passwords must match';
    } else {
      $scope.infoMessage = 'Updating password...';
      $scope.buttonDisable = true;

      authService.resetPassword($stateParams.resetToken, $scope.password1, function () {
        $scope.infoMessage = null;
        $scope.buttonDisable = false;
        $scope.successMessage = 'Password updated successfully';
        $scope.isReset = true;
      }, function (data, status) {
        $scope.infoMessage = null;
        $scope.buttonDisable = false;
        if (status === 404) {
          $scope.errorMessage = 'Your password reset token is not valid';
        } else {
          $scope.errorMessage = 'There was an error reseting your password';
        }
      });
    }
  };
}

Ctrl.$inject = ['$scope', '$stateParams', 'tl.auth.service'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _includes2 = __webpack_require__(151);

var _includes3 = _interopRequireDefault(_includes2);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $stateParams, $rootScope, $state, $timeout, modalService, inventorySearch, metaTagService, utilsService, tracking) {
  metaTagService.set({
    title: 'Find your night | Tablelist',
    description: 'Search nightlife. Bottle Service, Tickets, Tables and Packages',
    facebookImage: $scope.featuredImage
  });

  $scope.loading = true;

  $scope.form = {
    cityId: $stateParams.cityId || utilsService.defaultCityId(),
    guestsMin: $stateParams.guestsMin,
    guestsMax: $stateParams.guestsMax,
    date: $stateParams.date || (0, _moment2.default)().valueOf()
  };

  $scope.limitTo = null;

  $scope.limitToOptions = {
    tickets: ['TICKET', 'COVER'],
    tables: ['TABLE', 'PACKAGE']
  };

  $scope.limitToType = function (type) {
    $scope.limitTo = $scope.limitTo === type ? null : type;
  };

  $scope.filterInventory = function (inventoryItem) {
    if (!$scope.limitTo) return true;

    var allowedInventory = $scope.limitToOptions[$scope.limitTo];

    return (0, _includes3.default)(allowedInventory, inventoryItem.type);
  };

  _getInventorySummaries();

  function _getInventorySummaries() {
    var date = (0, _moment2.default)($scope.form.date, 'x');

    var options = {
      cityId: $scope.form.cityId,
      guestMin: $scope.form.guestsMin,
      guestMax: $scope.form.guestsMax,
      start: date.startOf('day').valueOf(),
      end: date.endOf('day').valueOf()
    };

    tracking.trackEvent(_segmentEvents2.default.SearchedInventory, options);

    inventorySearch.getInventorySummaries(options, function success(resp) {

      $scope.inventorySummaries = resp;

      $timeout(function () {
        $scope.loading = false;
      }, 400);
    }, function () {});
  }

  $scope.concierge = function () {
    var msg = 'Hello Tablelist Concierge, I\'m browsing the tablelist website, and was wondering if you could help me with suggestions for my night out.';

    modalService.contactSupport({
      message: msg
    });
  };

  $scope.buyInventory = function (inventory, venue) {
    if (!inventory || !venue) return;

    if (inventory.quantity.quantity < 1) return;

    var options = {
      inventory: inventory.id,
      guests: inventory.guests,
      venue: venue,
      startDate: (0, _moment2.default)(Number($scope.form.date), 'x').hour(6).minute(0).utc().toDate().getTime()
    };

    var trackingData = {};
    trackingData.venue = venue.name;
    trackingData.type = inventory.type;

    tracking.trackEvent(_segmentEvents2.default.StartedOrder, trackingData);

    modalService.bookingWidget(options);
  };
}

Ctrl.$inject = ['$scope', '$stateParams', '$rootScope', '$state', '$timeout', 'modalService', 'inventorySearchService', 'metaTagService', 'utilsService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $state, $stateParams, $window, $http, utilsService, settingsService, loggerService, metaTagService, trackingService) {
  var isSignup = $state.current.name === 'app.signup';

  var title = isSignup ? 'Sign Up | Tablelist' : 'Login | Tablelist';

  $scope.titleText = isSignup ? 'Sign up for Tablelist' : 'Log in to Tablelist';

  metaTagService.set({
    title: title,
    description: 'Sign up for Tablelist and get instant access to exclusive nightlife, VIP bottle service, table service and members-only events in Boston, NYC, Las Vegas and San Francisco',
    facebookImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image.jpg'
  });

  $scope.scrollTo = function (target) {
    utilsService.scrollTo(target, 110, 500);
  };

  var promoCode = $stateParams.code;

  try {
    if ($stateParams.redirectParams) {
      var redirectParams = _angular2.default.fromJson($stateParams.redirectParams);

      if (redirectParams.code) {
        promoCode = redirectParams.code;
      }
    }
  } catch (e) {}

  if (promoCode) {
    checkPromo(promoCode, function (err, resp) {
      if (resp.referral) {

        $scope.promo = resp;

        metaTagService.set({
          title: 'Get credit towards your night out. Signup with my promo code.',
          description: 'Tablelist is the easiest way to book VIP tables at the best nightclubs and lounges. Sign up with my code (' + $scope.promo.code + ') and get free credit!',
          facebookTitle: 'Get credit towards your night out.',
          facebookDescription: 'Join ' + $scope.promo.name + ' on Tablelist and get access to best party and nightlife spots in your city.'
        });
      } else {
        $scope.promo = resp;
      }
    });
  }

  function checkPromo(promo, done) {
    if (!promo) {
      done('No Promo Provided', null);
    }

    var promise = $http.get('/promo/check/' + promo);

    promise.success(function (resp) {
      done(false, resp);
    });

    promise.error(function (resp) {
      done(resp, null);
    });
  }

  $scope.loginConfig = {
    title: title,
    promo: $scope.promo && $scope.promo.code ? $scope.promo.code : null,
    startState: isSignup ? 'newUser' : 'existingUser',
    success: function success() {
      if (isSignup) {
        trackingService.trackEvent(_segmentEvents2.default.SignedUp);
      }

      if ($stateParams.redirectUrl) {
        $window.location = $stateParams.redirectUrl;
        return;
      }

      var redirectState = $stateParams.redirectState;
      var redirectParams = null;

      try {
        redirectParams = _angular2.default.fromJson($stateParams.redirectParams);
      } catch (e) {}

      if (redirectState) {
        $state.transitionTo(redirectState, redirectParams);
      } else {
        $state.transitionTo('app.me.profile');
      }
    },
    error: function error(response) {
      loggerService.error(response);
      $scope.errorMsg = utilsService.errorMessage(response);
    }
  };

  $scope.referralGiveCredit = 25;

  settingsService.config(function success(resp) {
    $scope.referralGiveCredit = resp.referralGiveCredit;
  });
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$window', 'tl.http', 'utilsService', 'tl.settings.service', 'loggerService', 'metaTagService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, metaTagService) {
  metaTagService.set({
    title: 'What is Bottle Service? | Tablelist',
    description: 'Book VIP bottle service, private tables, and attend exclusive events through Tablelist'
  });
}

Ctrl.$inject = ['$scope', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _event = __webpack_require__(344);

var _event2 = _interopRequireDefault(_event);

var _dateUtils = __webpack_require__(157);

var _dateUtils2 = _interopRequireDefault(_dateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $location, $sce, utilsService, jsSdkVenue, jsSdkVenueInfo, jsSdkEvent, jsSdkCuratedList, imgix, $http, modalService, $filter, fb, loggerService, favoritesService, metaTagService, trackingService, jsSdkConfig, partnerService, $window) {
  $scope.venue = {};

  $scope.showBackBtn = !!$stateParams.back;
  $scope.backId = $stateParams.back;
  $scope.backName = $stateParams.backName;

  function _listInfo(venueId) {
    var options = {
      fields: 'key,title,enable'
    };

    jsSdkVenueInfo.listByVenueId(venueId, options).then(function _success(resp) {
      var infoPageOrder = {
        about: 1,
        'table-service': 2,
        'bottle-service': 3,
        'guest-list': 4,
        'vip-list': 5,
        tickets: 6,
        'cover-charge': 7
      };

      $scope.venueInfo = _lodash2.default.sortBy(resp, function (page) {
        return infoPageOrder[page.key] || 99;
      });
    }, function _error(err) {

      $scope.venueInfo = null;

      loggerService.error(err);
    });
  }

  var venueIdOrSlug = void 0;

  if ($stateParams.seoPathname) {
    venueIdOrSlug = $stateParams.seoPathname.split('-').pop();
  } else if ($stateParams.name) {
    venueIdOrSlug = $stateParams.name;
  }

  if (!venueIdOrSlug) {
    $state.go('app.404');
    return;
  }

  $scope.venueImage = function (src) {
    if (!src) return '';

    return imgix.url(src, {
      width: 700
    });
  };

  $scope.imgix = function (src, w, h) {
    if (!src) return '';

    return imgix.url(src, {
      width: w || 100,
      height: h || 100
    });
  };

  $scope.isVenueState = function () {
    return $state.is('app.venueOld') || $state.is('app.venue');
  };
  $scope.isInfoState = function () {
    return $state.is('app.venue.info') || $state.is('app.venueOld.info');
  };
  $scope.isEventsState = function () {
    return $state.is('app.venue.events') || $state.is('app.venueOld.events');
  };

  $scope.goToEvents = function () {
    $state.go('app.venue.events', {
      seoPathname: $scope.venue.seoPathname
    });
  };

  $scope.goToAbout = function () {
    if ($scope.isVenueState()) {
      utilsService.scrollTo('venue-about-section', 100, 500);
    } else {
      $state.go('app.venue', {
        seoPathname: $scope.venue.seoPathname
      });
    }
  };

  $scope.scrollTo = function (target, $event) {
    if ($event) $event.preventDefault();
    utilsService.scrollTo(target, 100, 500);
  };

  $scope.goToEvent = function (event) {
    $state.go('app.event', {
      seoPathname: event.seoPathname || event.id
    });
  };

  $scope.goToImage = function (index) {
    $scope.venue.primaryImage = $scope.venue.images[index];
  };

  $scope.slideIndex = 0;

  jsSdkVenue.readById(venueIdOrSlug, {
    fields: 'name,seoPathname,details,tags,rating,images,location,schedule,favorites,website,phone,favoriteCount,trackingFacebookPixelId'
  }).then(function success(response) {
    _listInfo(response.id);

    fb.logEvent(fb.events().VIEWED_CONTENT, response.id);

    $scope.venue = response;

    if (_config2.default.NODE_ENV === 'production') {
      var fbqData = {
        content_type: 'product',
        content_ids: [$scope.venue.id],
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        language: navigator.language
      };

      $window.fbq('init', '1606722376242558');
      $window.fbq('trackSingle', '1606722376242558', 'ViewContent', fbqData);

      if ($scope.venue.trackingFacebookPixelId) {
        $window.fbq('init', $scope.venue.trackingFacebookPixelId);
        $window.fbq('trackSingle', $scope.venue.trackingFacebookPixelId, 'ViewContent', fbqData);
      }
    }

    if (window.TablelistWidgets) {
      var inventoryListWidget = void 0;

      if ((0, _jquery2.default)(window).width() < 992) {
        inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-xs');
      } else {
        inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-lg');
      }

      inventoryListWidget.init({
        venueId: $scope.venue.id,
        theme: 'theme-light',
        client: $location.search().client || 'web',
        attributionId: jsSdkConfig.attributionId || 'TABLELIST',
        affiliateId: $rootScope.affiliateId,
        trackingId: $rootScope.trackingId,
        disableInlineCheckout: true,
        checkoutUrl: _config2.default.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
        onInventorySelected: function onInventorySelected() {
          utilsService.scrollTo('venue-about-section', 100, 500);
        },
        onInventoryAddedToCart: function onInventoryAddedToCart(inventory) {
          if (_config2.default.NODE_ENV === 'production') {
            var fbqData2 = {
              content_type: 'product',
              value: inventory.price,
              currency: 'USD',
              content_ids: [inventory.venue],
              referrer: document.referrer,
              userAgent: navigator.userAgent,
              language: navigator.language
            };

            $window.fbq('init', '1606722376242558');
            $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData2);
          }
        }
      });
    }

    $scope.shareBarConfig = {
      url: utilsService.createUrl('/v/' + $scope.venue.seoPathname),
      message: 'Join me at ' + $scope.venue.name
    };

    $scope.showBookingWidget = true;

    $scope.openSentence = venueOpenSentence(response);

    $scope.venueImages = $scope.venue.images.map(function (image) {
      return {
        image: image.xlarge
      };
    });

    var venueTypeTag = _lodash2.default.find($scope.venue.tags, function (tag) {
      return tag.key === 'VENUE_TYPE';
    });
    var venueSubTypeTag = _lodash2.default.find($scope.venue.tags, function (tag) {
      return tag.key === 'VENUE_SUB_TYPE';
    });

    var musicTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'MUSIC';
    });

    var crowdTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'CROWD';
    });

    var noiseLevelTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'NOISE_LEVELS';
    });

    var okDressCodeTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'DRESS_CODE_OK';
    });

    var notOkDressCodeTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'DRESS_CODE_NOT_OK';
    });

    var goodForTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'GOOD_FOR';
    });

    var busyNightTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'BUSY_NIGHTS';
    });

    if (venueTypeTag) $scope.venue.venueType = venueTypeTag.name;
    if (venueSubTypeTag) $scope.venue.venueSubType = venueSubTypeTag.name;

    $scope.generateLink = function (link) {
      if (!link) return null;

      if (link.indexOf('http://') < 0 && link.indexOf('https://') < 0) {
        return 'https://' + link;
      }

      return link;
    };

    $scope.generateTwitterLink = function (link) {
      if (!link) return null;

      if (link.indexOf('https://twitter.com/') < 0 && link.indexOf('https://twitter.com/') < 0) {
        return 'http://twitter.com/' + link;
      }

      return link;
    };

    function venueOpenSentence(venue) {
      var today = new Date().getDay();
      var isAfterMidnight = new Date().getHours() < 6;

      if (isAfterMidnight) {
        today -= 1;

        if (today < 0) {
          today = 6;
        }
      }

      var todaysSchedule = _lodash2.default.find(venue.schedule, function (scheduleDay) {
        return scheduleDay.day === today;
      });

      if (!todaysSchedule) return '';

      if (todaysSchedule.closed) return 'CLOSED';

      var start = todaysSchedule.hours[0].start;
      var end = todaysSchedule.hours[0].end;

      if (!start || !end) return '';

      start = _moment2.default.utc(start);
      end = _moment2.default.utc(end);

      return $scope.getDayName(today) + ' ' + start.format('h:mm a') + ' - ' + end.format('h:mm a');
    }

    if (musicTags && musicTags.length) {
      $scope.venue.musicTags = musicTags;
    }
    if (crowdTags && crowdTags.length) {
      $scope.venue.crowdTags = crowdTags;
    }
    if (noiseLevelTags && noiseLevelTags.length) {
      $scope.venue.noiseLevelTags = noiseLevelTags;
    }
    if (okDressCodeTags && okDressCodeTags.length) {
      $scope.venue.okDressCodeTags = okDressCodeTags;
    }
    if (notOkDressCodeTags && notOkDressCodeTags.length) {
      $scope.venue.notOkDressCodeTags = notOkDressCodeTags;
    }
    if (goodForTags && goodForTags.length) {
      $scope.venue.goodForTags = goodForTags;
    }
    if (busyNightTags && busyNightTags.length) {
      $scope.venue.busyNightTags = busyNightTags;
      _lodash2.default.each($scope.venue.busyNightTags, function (tag) {
        tag.name = $scope.getDayName(tag.name);
      });
    }
    $scope.venue.featuresTags = _lodash2.default.filter($scope.venue.tags, function (tag) {
      return tag.key === 'FEATURES';
    });

    $scope.venue.address = response.location.address;
    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(response.location.address));

    if (response.location && response.location.address && response.location.address.address) {
      $scope.googleMapsDirectionsUrl = 'http://www.google.com/maps/dir//' + response.location.address.address.replace(/ /g, '+') + '+' + response.location.address.city + '+' + response.location.address.state + '+' + response.location.address.zip;
    }

    $scope.getTimeFromCreation = function (creationDate) {
      return (0, _moment2.default)(creationDate).fromNow();
    };

    metaTagService.set({
      title: 'Buy Tickets and Tables at ' + $scope.venue.name,
      description: 'Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ' + $scope.venue.name + ' with Tablelist.',
      facebookImage: _lodash2.default.get($scope, ['venue', 'primaryImage', 'xlarge']),
      deeplink: 'venue/' + $scope.venue.id,
      canonicalPath: '/v/' + $scope.venue.seoPathname
    });

    _getEvents();
    _getCuratedLists($scope.venue.id);
  }, function error(response) {
    loggerService.error(response);

    $state.go('app.404', {
      message: 'Uh oh. The venue you are looking for is no longer available.'
    });
  });

  $scope.getDayName = utilsService.getDayName;
  $scope.getDayNameShort = utilsService.getDayNameShort;

  $scope.download = function () {
    utilsService.link('//www.deeplink.me/tablelist.com/venue/' + $scope.venueId);
  };

  function _getCuratedLists(venueId) {
    if (!venueId) return;

    jsSdkCuratedList.listByVenueId(venueId).then(function (resp) {
      $scope.curatedLists = resp;
    });
  }

  $scope.eventPageSize = 10;
  $scope.eventPageNumber = 1;

  $scope.previousEventPage = function () {
    $scope.eventPageNumber -= 1;

    _getEvents(true);
  };

  $scope.nextEventPage = function () {
    $scope.eventPageNumber += 1;

    _getEvents(true);
  };

  $scope.resetEventPaging = function () {
    $scope.eventPageNumber = 1;
  };

  function _getEvents(page) {
    if (!page) {
      $scope.resetEventPaging();
    }

    $scope.loadingEvents = true;

    _event2.default.listByVenueId($scope.venue.id, {
      dateStart: _dateUtils2.default.toUTCTimestampWithoutTime(new Date()),
      sort: 'date',
      skip: ($scope.eventPageNumber - 1) * $scope.eventPageSize,
      limit: $scope.eventPageSize
    }).then(function (response) {
      $scope.$apply(function () {
        $scope.events = response.data;
        $scope.totalEvents = response.count;

        $scope.events = $scope.events.map(function (event) {
          event.venue = $scope.venue;

          return event;
        });

        $scope.loadingEvents = false;

        if (page) {
          utilsService.scrollTo('venue-about-section', 100, 500);
        }
      });
    });
  }
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$stateParams', '$location', '$sce', 'utilsService', 'jsSdk.venue', 'jsSdk.venueInfo', 'jsSdk.event', 'jsSdk.curatedList', 'jsSdk.imgix', '$http', 'modalService', '$filter', 'tl.facebook', 'loggerService', 'favoritesService', 'metaTagService', 'trackingService', 'jsSdk.config', 'partnerService', '$window'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(69);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $stateParams, metaTagService) {
  $scope.loading = false;

  $scope.$watch('$parent.venue', function (venue) {
    if (!venue) return;

    metaTagService.set({
      title: 'Upcoming Events at ' + venue.name,
      description: 'Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ' + venue.name + ' with Tablelist.',
      facebookImage: (0, _get3.default)(venue, ['primaryImage', 'xlarge']),
      canonicalPath: '/v/' + venue.seoPathname + '/events'
    });
  });
}

Ctrl.$inject = ['$scope', '$state', '$stateParams', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(69);

var _get3 = _interopRequireDefault(_get2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $stateParams, utilsService, jsSdkVenueInfo, loggerService, metaTagService) {
  $scope.loading = true;

  $scope.$watch('$parent.venue', function (newValue) {
    if (newValue && newValue.id) {
      $scope.venue = $scope.$parent.venue;

      _readVenueInfo($scope.venue.id, $stateParams.page);

      utilsService.scrollTo('description', 200, 300);

      var title = void 0;

      switch ($stateParams.page) {
        case 'bottle-service':
          title = 'VIP Bottle Service at ' + $scope.venue.name;
          break;
        case 'tickets':
          title = 'Buy Tickets at ' + $scope.venue.name;
          break;
        case 'cover':
          title = 'Get on the Guest List at ' + $scope.venue.name;
          break;
        default:
          title = 'Learn More About ' + $scope.venue.name;
          break;
      }

      metaTagService.set({
        title: title,
        description: 'Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ' + $scope.venue.name + ' with Tablelist.',
        facebookImage: (0, _get3.default)($scope, ['venue', 'primaryImage', 'xlarge']),
        canonicalPath: '/v/' + $scope.venue.seoPathname + '/' + $stateParams.page
      });
    }
  });

  function _readVenueInfo(venueId, page) {

    if (!venueId) {
      loggerService.error('Unable to load venue information. Missing venueId');

      $scope.loading = false;

      return;
    }

    if (!page) {
      $scope.loading = false;

      $state.go('^');

      return;
    }

    jsSdkVenueInfo.read(venueId, {
      key: page
    }).then(function _success(resp) {
      $scope.page = resp;

      $scope.loading = false;
    }).catch(function () {
      $scope.page = {
        title: 'Requested Info not Found',
        text: 'The information you requested could not be found.'
      };

      $scope.loading = false;
    });
  }
}

Ctrl.$inject = ['$scope', '$state', '$stateParams', 'utilsService', 'jsSdk.venueInfo', 'loggerService', 'metaTagService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'tl_concierge_message_received';
module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SIGNUP: 'signup',
  CHAT: 'chat'
};
module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOST = '.tablelist.com';

exports.default = {
  domain: _config2.default.NODE_ENV === 'local' ? undefined : HOST,
  sameSite: _config2.default.NODE_ENV === 'local' ? undefined : 'none',
  secure: _config2.default.NODE_ENV !== 'local'
};
module.exports = exports['default'];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _conciergeStates = __webpack_require__(398);

var _conciergeStates2 = _interopRequireDefault(_conciergeStates);

var _conciergeMessageReceivedKey = __webpack_require__(397);

var _conciergeMessageReceivedKey2 = _interopRequireDefault(_conciergeMessageReceivedKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  app.constant('conciergeState', _conciergeStates2.default);
  app.constant('conciergeMessageReceivedKey', _conciergeMessageReceivedKey2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "\n<h2 class=\"main-h2\">Tablelist Terms &amp; Conditions</h2>\n<h2 class=\"sub-h2\">Terms &amp; Conditions</h2>\n<h4>PLEASE READ THESE TERMS OF SERVICE CAREFULLY. BY ACCESSING OR USING THE TABLELIST APPLICATION AND ANY SERVICES PROVIDED BY US, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS DESCRIBED HEREIN AND ALL TERMS INCORPORATED BY REFERENCE. IF YOU\n  DO NOT AGREE TO ALL OF THESE TERMS AND CONDITIONS, PLEASE IMMEDIATELY LEAVE THE TABLELIST APPLICATION AND DO NOT USE THE TABLELIST APPLICATION OR ANY SERVICES PROVIDED BY US.</h4>\n<p>These terms of service (the &ldquo;Terms&rdquo;) apply to your access and use of the iOS application, the Android application, the mobile web application and the website located at tablelist.com (collectively, the &ldquo;Application&rdquo;)\n  provided by Tablelist (&ldquo;Tablelist&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo; or &ldquo;us&rdquo;) and any feature, content, tools and services accessible by means of the Application. The Application and such services are collectively\n  referred to as the &ldquo;Service.&rdquo; The Terms do not alter in any way the terms or conditions of any other agreement you may have with Tablelist for the Service (or any part thereof). If you are using the Service on behalf of an entity,\n  you represent and warrant that you are authorized to accept the Terms on such entity&rsquo;s behalf, and that such entity agrees to indemnify you and Tablelist for violations of the Terms.</p>\n<p>We reserve the right to change or modify any of the terms and conditions contained in the Terms or any policy or guideline of the Service, at any time and in our sole discretion. Any changes or modifications will be effective immediately upon\n  the posting of such revisions on our website located at https://www.tablelist.com (the &ldquo;Site&rdquo;) or when such revisions are made available via the Service, and you waive any right you may have to receive specific notice of such\n  changes or modifications; provided, however, that to the extent such changes or modifications relate to our use, processing, storage, or disclosure of Personal Data (as defined in the Privacy Policy), we will obtain any consent required by\n  applicable law. Your continued use of the Service (or any portion thereof) following the posting of changes or modifications will confirm your acceptance of such changes or modifications. Therefore, you should frequently review the Terms and\n  applicable policies from time-to-time to understand the terms and conditions that apply to your use of the Service. If you do not agree to the amended Terms, you must leave the Application and stop using the Service.</p>\n<p>If you have any questions regarding the use of the Service, please email us at hello@tablelist.com.</p>\n<p>PRIVACY POLICY</p>\n<p>Please refer to our privacy policy for information on how we collect, use and disclose personally identifiable information from our users. Our Privacy Policy is available at https://www.tablelist.com/legal/privacy.</p>\n<p>DEVICE USAGE TERMS AND CONDITIONS</p>\n<p>You acknowledge and agree that your use of the Service must also be in accordance with the usage rules established by your mobile device platform or service provider.</p>\n<p>REGISTRATION DATA</p>\n<p>You agree to: (i) provide accurate, current and complete information about you as may be prompted by any signup, login and/or registration forms made available via the Service (\"Registration Data\"); (ii) maintain and promptly update the\n  Registration Data, and any other information you provide to Tablelist, in order to keep it accurate, current and complete; and (iii) accept all risk of unauthorized access to the Registration Data and any other information you provide to\n  Tablelist.</p>\n<p>You may not use the Service if you are less than 21 years of age and all of the members in your group are also 21 years of age. By using the Tablelist application you verify that you and all of the members in your group are at least 21 years\n  of age and that you are entering into this agreement with a clear/un-inebriated mind. If you or any member in your group is not at least 21 years of age, please leave the site and cease all use of the Application and Service.</p>\n<p>Tablelist will delete your account and any data or information that you may have stored as a result of your account or your use of the Application and Services (A) in accordance with Tablelist&rsquo;s standard document retention and deletion\n  schedules, and (B) upon receipt of your request that Tablelist delete your account information (such request may be made by emailing hello@tablelist.com). You are only authorized to create and use one account for the Service and are prohibited\n  from utilizing alter-egos or other disguised identities when utilizing the Application or Services. You are under no obligation to use or continue to use the Application or Services and may cease use of the Application or Services without\n  notice to Tablelist.</p>\n<p>GRANT AND RESTRICTIONS</p>\n<p>Subject to the terms, conditions and limitations set forth in the Terms, Tablelist grants you a non-exclusive, non-transferable and revocable license to use the Application on any mobile device that you own or control. The terms of the\n  license will also govern any upgrades provided by Tablelist that replace and/or supplement the original Application, unless such upgrade is accompanied by a separate license, in which case the terms of that license will govern.</p>\n<p>You agree not to do, or authorize or permit any third-party to do, any of the following: (i) distribute or make the Application available over a network where it could be used by multiple devices at the same time; (ii) rent, lease, lend,\n  sell, redistribute or sublicense the Application; (iii) copy, decompile, reverse engineer, disassemble, attempt to derive the source code of, modify, or create derivative works of the Application, any updates, or any part thereof (except as\n  and only to the extent any of the foregoing restrictions are prohibited by applicable law); or (iv) remove, alter or obscure any copyright, trademark or other proprietary rights notice on or in the Application. If you violate any of the\n  foregoing restrictions, your use of the Application will immediately cease and you will have infringed the copyright and other rights of Tablelist, which may subject you to prosecution and damages. Tablelist reserves all rights not expressly\n  granted to you in the Terms.</p>\n<p>CONSENT TO USE OF DATA AND MOBILE COMMUNICATIONS</p>\n<p>Tablelist will collect, use, process, and share certain of your technical data, Personal Data (as defined in the Privacy Policy), and related information in connection with the terms and conditions of the Tablelist&rsquo;s Privacy Policy,\n  which is hereby incorporated by reference into the Terms. You agree that Tablelist may collect and use such technical data, Personal Data, and related information in connection with your use of the Application including, but not limited to,\n  contact information and technical information about your device, system and application software, and peripherals, that are gathered periodically to facilitate the features and functionality of the Application and of software updates, product\n  support and other services. You also consent to our using such information to communicate with you about the Application or in connection with the features, functions and activities contained in the Application.</p>\n<p>COMPATIBILITY WITH MOBILE DEVICES</p>\n<p>Tablelist does not warrant that the Service will be compatible or interoperable with your mobile device or any other hardware, software or equipment installed on or used in connection with your mobile device.</p>\n<p>CARRIER CHARGES</p>\n<p>You acknowledge and understand that the Service requires and utilizes phone service, data access and text messaging capabilities. Carrier rates for phone, data and text messaging may apply and you are responsible for any such charges.</p>\n<p>PRODUCT DESCRIPTIONS</p>\n<p>Tablelist attempts to be as accurate as possible. However, Tablelist does not warrant that the Service is complete, reliable, current or error-free. If you have reason to believe that a VIP table you purchased through the Service does not\n  meet the claims advertised within the Service your sole remedy is to not accept the table and contact Tablelist immediately, and in any case no later than three business days following the date of purchase. Tablelist will make a determination\n  as to the merits of your claim in our sole discretion.</p>\n<p>ADVERTISED PRICES</p>\n<p>Tablelist makes no guarantee that the prices advertised through the Service represent (i) the lowest price for a VIP table in every area on any particular day or (ii) the published price for a VIP table on another website or publication not\n  affiliated with Tablelist in every area on any particular day.</p>\n<p>HONORING YOUR PAYMENT COMMITMENTS</p>\n<p>When you make a purchase via the Service you are representing to us that: (i) any credit information you supply is true and complete; (ii) charges incurred by you will be honored by your credit card company; and (iii) you will pay the charges incurred by you at the posted prices, including any applicable taxes. You are also acknowledging that: (a) the posted prices include the table rate negotiated by Tablelist with nightclub and lounges suppliers plus service fees and taxes, where applicable; (b) Tablelist pays its nightclub and lounge suppliers for the taxes due on the rental of the room but the nightclub and lounge suppliers calculate and remit applicable taxes to the applicable taxing jurisdictions; and (c) Tablelist retains a service fee or transaction fee from the posted price as compensation in servicing your purchase, regardless of whether you are able to consummate your purchase. Transactions fees, including and without limitations are non-refundable. </p>\n<p>Table OVERBOOKINGS; AGENT FEE</p>\n<p>If a nightclub or lounge has overbooked and is sold out, it is the nightclub or lounges responsibility to accommodate you with another VIP table. This is our agreement with each venue. We will endeavor to enforce our agreements with\n  nightclubs and lounges, and while we are not responsible to you if the nightclub or lounge does not, for whatever reason, find/create you a VIP table, we ask that you contact us immediately in the event that the nightclub or lounge is unable\n  to find/create you an available table so that we may assist in the process.</p>\n<p>TABLELIST CREDITS</p>\n<p>Tablelist booking credit is not redeemable for cash or cash equivalents, is non-transferable and may not be applied towards prior purchases. Other restrictions may apply. Unless you paid us in full for any booking credits, we reserve the\n  right to rescind any booking credits subject to reasonable notice to you. Sharing your referral code on coupon sites, search engines, or any other public forums is prohibited. Doing so may result in all credit being revoked.</p>\n<p>ELECTRONIC COMMUNICATIONS</p>\n<p>When you use the Service or send e-mails to us, you are communicating with us electronically, and you consent to receiving communications from us electronically regarding the Application, the Service, or other applications or services that we\n  may offer or provide from time to time. We may communicate with you by e-mail or by providing notices via the Service. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy\n  any legal requirement that such communications be in writing. Any such emails may include marketing and promotional content regarding the Application, the Service, or other applications or services that we may offer or provide from time to\n  time.</p>\n<p>THIRD-PARTY INTERACTIONS</p>\n<p>Your use of the Application and your contact, interaction, or dealings with any third-parties arising out of your use of the Service is solely at your own risk. You acknowledge and agree that Tablelist is not responsible or liable in any\n  manner for any loss, damage or harm of any sort incurred as the result of the Service, except as may be required by applicable law or regulation. The nightclubs and/or lounges and other suppliers providing accommodations through the Service\n  are independent contractors and not agents or employees of Tablelist. Tablelist is not responsible, and shall not be held liable for, the acts, errors, omissions, representations, warranties, breaches or negligence of any such suppliers for\n  any personal injuries, death, property damage, loss, theft or other damages or expenses resulting therefrom, except as may be required by applicable law or regulation.</p>\n<p>USER CONTENT AND YOUR CONDUCT</p>\n<p>The Service includes forums and other interactive areas or services (&ldquo;Interactive Areas&rdquo;) in which you or other users can create, post or share content, materials, data, information, text, photos and/or other materials\n  (&ldquo;User Content&rdquo;). You are solely responsible for your use of such Interactive Areas and the User Content you share.</p>\n<p>You agree not to post, upload to, transmit, distribute, store, create or otherwise publish through the Service any of the following:</p>\n<ul>\n  <li>User Content that is libelous, defamatory, profane, obscene, pornographic, sexually explicit, indecent, lewd, vulgar, suggestive, violent, harassing, hateful, threatening, offensive, discriminatory, bigoted, abusive, inflammatory,\n    fraudulent, deceptive or otherwise objectionable;</li>\n  <li>User Content that is illegal or unlawful, that would constitute, encourage or provide instructions for a criminal offense, or otherwise create liability or violate any local, state, national or international law;</li>\n  <li>User Content that may infringe or violate any patent, trademark, trade secret, copyright, right of privacy, right of publicity or other intellectual property right or other right of any party;</li>\n  <li>Unsolicited promotions, political campaigning, or commercial messages (SPAM) or any chain messages or User Content designed to deceive or trick the user of the Service;</li>\n  <li>Private information of any third-party including, but not limited to, addresses, phone numbers, email addresses, Social Security numbers and credit card numbers; and</li>\n  <li>Viruses, corrupted data or other harmful, disruptive or destructive files or code, script or other software designed to automate any functionality on the Service without Tablelist&rsquo;s express written consent.</li>\n</ul>\n<p>You further agree that you are solely responsible for your conduct while using the Service, and you agree that you will not do any of the following in connection with the Service or the users of the Service:</p>\n<ul>\n  <li>Use the Service in any manner that could interfere with, disrupt, negatively affect or inhibit other users from fully enjoying the Service or that could damage, disable, overburden or impair the functioning of the Service in any manner;</li>\n  <li>Collect any personally identifiable information about other users (except as specifically authorized by Tablelist), or intimidate, threaten, stalk, or otherwise harass or cause discomfort to other users of the Service;</li>\n  <li>Use the Service for any commercial purpose;</li>\n  <li>Use the Service for any illegal or unauthorized purpose or engage in, encourage, or promote any illegal activity, or any activity that violates the Terms or any other rules or polices established from time-to-time by Tablelist;</li>\n  <li>Create an account, post any content, or otherwise use the Service if you are not, at least, 21 years of age;</li>\n  <li>Modify, adapt, hack or emulate the Service;</li>\n  <li>Circumvent or attempt to circumvent any filtering, security measures or other features designed to protect the Service or users of the Service or third- parties; and Infringe upon or violate the rights of Tablelist, its users or any\n    third-party.</li>\n</ul>\n<p>Tablelist takes no responsibility and assumes no liability for any user conduct or for any User Content posted, stored or made available via the Service, nor is Tablelist liable for any mistakes, defamation, slander, libel, omissions,\n  falsehoods, obscenity, pornography or profanity you may encounter. Your use of Interactive Areas and the Service is at your own risk. Enforcement of the user content and conduct rules set forth in the Terms is solely at Tablelist&rsquo;s\n  discretion, and failure to enforce such rules in some instances does not constitute a waiver of our right to enforce such rules in other instances. In addition, these rules do not create any private right of action on the part of any\n  third-party or any reasonable expectation that the Service will not contain any content that is prohibited by such rules.</p>\n<p>THIRD-PARTY CONTENT</p>\n<p>Tablelist may provide third-party content via the Service and may provide links to Web pages and content of third-parties (collectively, the &ldquo;Third-Party Content&rdquo;) as a service to those interested in this information. Use of\n  Third-Party Content and access to Third-Party Content is subject to the terms of service, terms of use, and/or privacy policy of such Third-Party Content. Tablelist does not control, endorse or adopt any Third-Party Content and makes no\n  representation or warranties of any kind regarding the Third-Party Content including, but not limited to, its accuracy or completeness. You acknowledge and agree that Tablelist is not responsible or liable in any manner for any Third-Party\n  Content and undertakes no responsibility to update or review any Third-Party Content. Users use such Third-Party Content contained therein at their own risk.</p>\n<p>ADVERTISEMENTS AND PROMOTIONS; THIRD-PARTY PRODUCTS AND SERVICES</p>\n<p>Tablelist may run advertisements and promotions from third-parties via the Service or may otherwise provide information about or links to third-party products or services via the Service. Your business dealings or correspondence with, or\n  participation in promotions of, such third-parties, and any terms, conditions, warranties or representations associated with such dealings or promotions, are solely between you and such third-party. Tablelist is not responsible or liable for\n  any loss or damage of any sort incurred as the result of any such dealings or promotions or as the result of the presence of such non-Tablelist advertisers or third-party information accessible via the Service.</p>\n<p>TRADEMARKS</p>\n<p>The Tablelist and &ldquo;table&rdquo; logo are trademarks or registered trademarks of Tablelist LLC in the United States and in numerous international jurisdictions. These marks may not be reproduced or used without Tablelist LLC&rsquo;s\n  prior written permission. You may not use any metatags or any other &ldquo;hidden text&rdquo; utilizing &ldquo;Tablelist&rdquo; or any other name, trademark or product or service name of Tablelist without our prior written permission. In\n  addition, the look and feel of the Service, including all page headers, custom graphics, button icons and scripts, is the service mark, trademark and/or trade dress of Tablelist and may not be copied, imitated or used, in whole or in part,\n  without our prior written permission. All other trademarks, registered trademarks, product names and company names or logos made available via the Service are the property of their respective owners. Reference to any products, services,\n  processes or other information, by trade name, trademark, manufacturer, supplier or otherwise does not constitute or imply endorsement, sponsorship or recommendation thereof by us.</p>\n<p>OWNERSHIP</p>\n<p>The Service (including, but not limited to, the Application) contains the valuable proprietary content of Tablelist and its licensors and is protected by copyright and other intellectual property laws and treaties. You agree not to use the\n  Service (including, but not limited to, the Application) except in its intended manner in accordance with the terms and conditions of the Terms.</p>\n<p>TERMINATION OR MODIFICATION OF APPLICATION</p>\n<p>Tablelist reserves the right to change, suspend, remove, discontinue or disable access to the Service (including, but not limited to, the Application) at any time without notice. In no event will Tablelist be liable for the removal of or\n  disabling of access to any portion or feature of the Service (including, but not limited to, the Application).</p>\n<p>TERMINATION</p>\n<p>If you breach any of the terms or conditions of the Terms or Tablelist discontinues the Application, the Terms will automatically terminate. In the event of the termination of the Terms for any reason: (i) the license granted to you in the\n  Terms will immediately terminate; and (ii) you must immediately cease all use of the Application and destroy or erase all copies of the Application in your possession or control. All of the sections of the Terms will survive any termination of\n  the Terms except the License section and the Consent to Use of Data and Mobile Communications section. Any use of the Application after termination is unlicensed and is in violation of the copyright and other rights of Tablelist. Tablelist and\n  its affiliates reserve the right to refuse service, terminate accounts, remove or edit content or cancel orders in their sole discretion.</p>\n<p>UNLAWFUL ACTIVITY</p>\n<p>We reserve the right to investigate complaints or reported violations of the Terms and to take any action we deem appropriate including, but not limited to, reporting any suspected unlawful activity to law enforcement officials, regulators,\n  or other third-parties and disclosing any information necessary or appropriate to such persons or entities relating to your Registration Data, usage history, posted materials, IP addresses and traffic information.</p>\n<p>INFORMATION AND PRESS RELEASES</p>\n<p>The Site may contain information and press releases about us. We disclaim any duty or obligation to update this information. Information about companies other than ours contained in any press release or otherwise should not be relied upon as\n  being provided or endorsed by us.</p>\n<p>DISCLAIMERS</p>\n<p>YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE SERVICE (INCLUDING, BUT NOT LIMITED TO, THE APPLICATION) IS AT YOUR SOLE RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY, PERFORMANCE, SAFETY, ACCURACY AND EFFORT IS WITH YOU. TO\n  THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICE (INCLUDING, BUT NOT LIMITED TO, THE APPLICATION) IS PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS. TABLELIST DISCLAIMS ANY AND ALL WARRANTIES AND\n  REPRESENTATIONS (EXPRESS OR IMPLIED, ORAL OR WRITTEN) WITH RESPECT TO THE TERMS AND THE SERVICE (INCLUDING, BUT NOT LIMITED TO, THE APPLICATION) WHETHER ALLEGED TO ARISE BY OPERATION OF LAW, BY REASON OF CUSTOM OR USAGE IN THE TRADE, BY COURSE\n  OF DEALING OR OTHERWISE, INCLUDING ANY AND ALL: (I) WARRANTIES OF MERCHANTABILITY; (II) WARRANTIES OF FITNESS OR SUITABILITY FOR ANY PURPOSE (WHETHER OR NOT TABLELIST KNOWS, HAS REASON TO KNOW, HAS BEEN ADVISED OR IS OTHERWISE AWARE OF ANY\n  SUCH PURPOSE); AND (III) WARRANTIES OF NON-INFRINGEMENT OR CONDITION OF TITLE. TABLELIST DOES NOT WARRANT THAT THE FUNCTIONS CONTAINED IN THE APPLICATION WILL BE ACCURATE OR MEET YOUR REQUIREMENTS, THAT THE OPERATION OF THE APPLICATION WILL BE\n  UNINTERRUPTED OR ERROR-FREE, OR THAT DEFECTS IN THE APPLICATION WILL BE CORRECTED. NO ORAL OR WRITTEN INFORMATION, GUIDELINES OR ADVICE GIVEN BY TABLELIST OR ITS AUTHORIZED REPRESENTATIVE WILL CREATE A WARRANTY.</p>\n<p>INDEMNIFICATION</p>\n<p>You agree, at your sole expense, to defend, indemnify and hold us, our independent contractors, service providers and consultants, and their respective directors, employees and agents, harmless from and against any and all actual or\n  threatened suits, actions, proceedings (at law or in equity), claims, damages, payments, deficiencies, fines, judgments, settlements, liabilities, losses, costs and expenses (including, but not limited to, reasonable attorney fees, costs,\n  penalties, interest and disbursements) caused by, arising out of, resulting from, attributable to or in any way incidental to: (i) your conduct; (ii) your violation of the Terms or your violation of the rights of any third-party; or (iii) any\n  user content.</p>\n<p>LIMITATION OF LIABILITY</p>\n<p>TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT WILL TABLELIST BE LIABLE TO YOU OR ANY THIRD-PARTY FOR ANY DIRECT, INCIDENTAL, SPECIAL, INDIRECT, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES WHATSOEVER INCLUDING, BUT NOT LIMITED TO, DAMAGES\n  FOR LOSS OF PROFITS, LOSS OF DATA, BUSINESS INTERRUPTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, ARISING OUT OF OR RELATED TO YOUR USE OF OR INABILITY TO USE THE SERVICE (INCLUDING, BUT NOT LIMITED TO, THE APPLICATION), HOWEVER CAUSED,\n  REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY) AND EVEN IF TABLELIST HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH\n  DAMAGES. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION MAY NOT APPLY TO YOU. IN NO EVENT WILL TABLELIST&rsquo;S TOTAL LIABILITY, WHETHER IN CONTRACT, WARRANTY, TORT\n  (INCLUDING NEGLIGENCE, WHETHER ACTIVE, PASSIVE OR IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER THEORY, ARISING OUT OF OR RELATING TO THE USE OF OR INABILITY TO USE THE SERVICE (INCLUDING, BUT NOT LIMITED TO THE APPLICATION) EXCEED\n  $100.00 UNITED STATES DOLLARS.</p>\n<p>&nbsp;</p>\n<p>APPLICABLE LAW AND VENUE</p>\n<p>The Terms and your use of the Service including, but not limited to, the Application will be governed by and construed in accordance with the laws of the State of Massachusetts, applicable to agreements made and to be entirely performed\n  within the State of Massachusetts, without resort to its conflict of law provisions.</p>\n<p>The Terms and your use of the Service including, but not limited to, the Application will be governed by and construed in accordance with the laws of the State of Massachusetts applicable to agreements made and to be entirely performed within\n  the State of Massachusetts, without resort to its conflict of law provisions.</p>\n<p>EXPORT LIMITATIONS</p>\n<p>You may not use or otherwise export or re-export the Application except as authorized by United States law and the laws of the jurisdiction in which the Application was obtained. In particular, but without limitation, the Application may not\n  be exported or re-exported: (i) into any U.S. embargoed countries; or (ii) to anyone on the U.S. Treasury Department&rsquo;s list of Specially Designated Nationals or the U.S. Department of Commerce Denied Person&rsquo;s List or Entity List.\n  By using the Application, you represent and warrant that you are not located in any such country or on any such list. You also agree that you will not use the Application for any purposes prohibited by United States law including, but not\n  limited to, the development, design, manufacture or production of nuclear missiles, or chemical or biological weapons.</p>\n<p>US GOVERNMENT RIGHTS</p>\n<p>The Application and related documentation are &ldquo;Commercial Items,&rdquo; as that term is defined in 48 C.F.R. &sect;2.101, consisting of &ldquo;Commercial Computer Software&rdquo; and &ldquo;Commercial Computer Software\n  Documentation,&rdquo; as such terms are used in 48 C.F.R. &sect;12.212 or 48 C.F.R. &sect;227.7202, as applicable. Consistent with 48 C.F.R. &sect;12.212 or 48 C.F.R. &sect;227.7202-1 through 227.7202-4, as applicable, the Commercial Computer\n  Software and Commercial Computer Software Documentation are being licensed to U.S. Government end-users: (i) only as Commercial Items; and (ii) with only those rights as are granted to all other end-users pursuant to the terms and conditions\n  herein. Unpublished rights are reserved under the copyright laws of the United States.</p>\n<p>You may also contact our member support team at hello@tablelist.com</p>\n";
module.exports = exports["default"];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, partnerService, modalService) {
  $scope.partner = partnerService.partner;

  $scope.enterPromo = function () {
    modalService.enterPromo();
  };

  $scope.openSearchModal = function () {
    modalService.search();
  };
}

Ctrl.$inject = ['$scope', 'partnerService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(831);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: _template2.default,
    controller: 'appFooterCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


function Ctrl($scope, $state, $rootScope, $timeout, partnerService, membershipService, modalService, $window, utilsService) {
  $scope.partner = partnerService.partner;
  $scope.defaultCitySlug = utilsService.defaultCitySlug();

  $rootScope.showOverlayMenu = {
    hiding: true,
    hidden: true
  };

  $rootScope.isSubscribed = function () {
    return membershipService.isUserSubscribed();
  };

  $scope.isCheckoutPage = function () {
    return $state.current.name === 'app.checkout' || $state.current.name === 'app.checkout-widget' || $window.location.pathname.indexOf('/checkout') === 0 || $window.location.pathname.indexOf('/checkout-widget') === 0;
  };

  $scope.isHomePage = function () {
    return $state.current.name === 'app.home';
  };

  $scope.showNYEBanner = false;

  $scope.hideNYEBanner = function ($event) {
    if ($event) $event.preventDefault();

    $scope.showNYEBanner = false;
  };

  $scope.currentLogo = $scope.partner.logo;

  $scope.toggleOverlayMenu = function () {
    if ($rootScope.showOverlayMenu.hidden) {
      $rootScope.showOverlayMenu.hidden = false;
      $timeout(function () {
        $rootScope.showOverlayMenu.hiding = false;
      }, 100);
    } else {
      $rootScope.showOverlayMenu.hiding = true;
      $timeout(function () {
        $rootScope.showOverlayMenu.hidden = true;
      }, 400);
    }
  };

  $scope.openSearchModal = function () {
    modalService.search();
  };

  $rootScope.$on('$stateChangeSuccess', function () {
    if (!$rootScope.showOverlayMenu.hidden) {
      $scope.toggleOverlayMenu();
    }
  });
}

Ctrl.$inject = ['$scope', '$state', '$rootScope', '$timeout', 'partnerService', 'membershipService', 'modalService', '$window', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(832);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'appHeaderCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive($timeout) {
  return {
    restrict: 'AC',
    link: function link(_scope, _element) {
      $timeout(function () {
        _element[0].focus();
      }, 0);
    }
  };
}

Directive.$inject = ['$timeout'];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    link: function link(scope, element, attrs) {
      element.css({
        background: (attrs.bgColor ? attrs.bgColor : '') + ' url(' + attrs.bgImg + ') center center',
        'background-size': 'cover'
      });
      attrs.$observe('bgImg', function (img) {
        element.css({
          background: (attrs.bgColor ? attrs.bgColor : '') + ' url(' + img + ') center center',
          'background-size': 'cover'
        });
      });
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, utilsService, bookingHelpers, modalService, loggerService, favoritesService, tracking) {
  $scope.bookingUser = {};
  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  $scope.sanitizeNewlines = utilsService.sanitizeNewlines;

  $scope.confirmedUser = function (user) {
    return user.status === 'CONFIRMED';
  };

  $scope.$watch('booking', function (booking) {
    if (!booking) return;

    $scope.booking = booking;

    $scope.directMapUrl = utilsService.getMapUrl(booking.venue.location.address, true);
    $scope.receiptPDF = bookingHelpers.downloadTicketLink(booking);

    $scope.statusText = bookingHelpers.getStatusText(booking);

    $scope.status = bookingHelpers.getStatus(booking);

    checkFavorited();
    $rootScope.$on('favoritesChange', checkFavorited);
  });

  $scope.contactSupport = function () {
    var text = $scope.booking ? 'Booking ID: ' + $scope.booking.id : '';

    modalService.contactSupport({
      message: 'Hello Tablelist Concierge, I have a question about my booking. ' + text
    });
  };

  $scope.cancelReservation = function () {
    var text = $scope.booking ? 'Booking ID: ' + $scope.booking.id : '';

    modalService.contactSupport({
      message: 'Hello, I would like to cancel my reservation. ' + text
    });
  };

  $scope.shareEvent = function (booking) {
    var url = booking.event && booking.event.id ? '/event/' + booking.event.id : '/venue/' + booking.venue.id;
    var name = booking.event && booking.event.name ? booking.event.name : booking.venue.name;

    modalService.shareLink({
      url: utilsService.createUrl(url),
      message: 'Come join me at ' + name
    });
  };

  $scope.bookNow = function (venue) {
    modalService.bookingWidget({
      venue: venue
    });
  };

  $scope.favoriteVenue = function (venue) {
    $scope.disableFavoriting = true;

    var func = $scope.isFavorited ? favoritesService.removeFavorite : favoritesService.addFavorite;
    var increment = $scope.isFavorited ? -1 : 1;

    func(favoritesService.TYPES.VENUE, venue.id).then(function () {
      venue.favoriteCount += increment;

      var event = $scope.isFavorited ? _segmentEvents2.default.FavoritedVenue : _segmentEvents2.default.UnfavoritedVenue;

      tracking.trackEvent(event, {
        venueId: $scope.booking.venue.id,
        venueName: $scope.booking.venue.name
      });
    }).catch(function (err) {
      loggerService.error(err);
    }).finally(function () {
      $scope.disableFavoriting = false;
    });
  };

  function checkFavorited() {
    favoritesService.isFavorite(favoritesService.TYPES.VENUE, $scope.booking.venue.id).then(function (favorited) {
      $scope.isFavorited = favorited;
      $scope.disableFavoriting = false;
    }).catch(function (err) {
      loggerService.error(err);
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', 'utilsService', 'bookingHelpersService', 'modalService', 'loggerService', 'favoritesService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(833);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '=',
      review: '=',
      isReceipt: '='
    },
    template: _template2.default,
    controller: 'bookingCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(834);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '='
    },
    template: _template2.default,
    controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
      $scope.currentUser = $rootScope.currentUser;
    }]
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(835);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '='
    },
    template: _template2.default,
    controller: ['$scope', 'bookingHelpersService', function ($scope, bookingHelpers) {
      $scope.$watch('booking', function (booking) {
        if (booking) {
          $scope.bookingUser = bookingHelpers.findBookingUser(booking);
          $scope.pending = false;
        }
      });
    }]
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $state, jsSdkBooking, bookingHelpers, tracking) {
  $scope.$watch('booking', function (booking) {
    if (!booking) return;

    $scope.bookingUser = bookingHelpers.findBookingUser(booking);
  });

  $scope.confirmJoin = function () {
    jsSdkBooking.authorize($scope.booking.id, {
      userId: $rootScope.currentUser.id,
      paymentProfileId: $scope.paymentProfile.id
    }).then(function success(resp) {

      tracking.trackEvent(_segmentEvents2.default.JoinedOrder, {});

      $state.go('app.receipt', {
        booking: resp.id
      }, {
        reload: true
      });
    }, function error(response) {
      $scope.error = response.data;
    });
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$state', 'jsSdk.booking', 'bookingHelpersService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(836);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '='
    },
    template: _template2.default,
    controller: 'bookingStatusCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive($compile, $window) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.btnSelect = attrs.btnSelect;
      scope.btnSelectModel = attrs.btnSelectModel;
      scope.btnSelectItemProp = attrs.btnSelectItemProp;
      scope.btnSelectItemValue = attrs.btnSelectItemValue;

      var ngOptionsExpression = 'a.' + scope.btnSelectItemProp + ' as a.' + scope.btnSelectItemValue + ' for a in ' + scope.btnSelect;

      var wrapper = (0, _jquery2.default)('<div></div>').css('position', 'relative').addClass('btn-select');

      var template = (0, _jquery2.default)('<select></select>');
      template.attr('ng-options', ngOptionsExpression);
      template.attr('ng-model', scope.btnSelectModel);

      var compiledTemplate = $compile(template)(scope);

      element.wrap(wrapper);
      element.after(compiledTemplate);

      element.on('click', function () {
        open(template);
      });

      compiledTemplate.css('opacity', 0).css('position', 'absolute').css('bottom', 0).css('left', '50%').css('width', '0');

      function open(elem) {
        if (document.createEvent) {
          var e = document.createEvent('MouseEvents');
          e.initMouseEvent('mousedown', true, true, $window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          elem[0].dispatchEvent(e);
        } else if (element.fireEvent) {
          elem[0].fireEvent('onmousedown');
        }
      }
    }
  };
}

Directive.$inject = ['$compile', '$window'];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $uibModal, $timeout, utilsService, loggerService, tracking, jsSdkBooking, jsSdkUser, imgix) {
  $scope.fadeIn = false;
  $scope.loading = false;

  $scope.$watch('booking', function (booking) {
    if (booking && booking.venue) {
      $scope.tax = $scope.booking.taxPercent;
      $scope.tip = ($scope.booking.tipPercent * 100).toFixed(0);
      $scope.fadeIn = true;
    }
  });

  $scope.profileImg = function () {
    var user = jsSdkUser.getCurrentUser();
    var defaultImage = 'https://assets.tablelist.com/www/assets/default_profile.png';

    return user && user.imageUrl ? user.imageUrl : defaultImage;
  };

  $scope.imgix = function (src) {
    var options = {
      width: 50,
      height: 50
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.showRedeemCode = false;
  $scope.errorMsg = '';

  $scope.isLoggedIn = function () {
    return $rootScope.isLoggedIn();
  };

  $scope.addDiscount = function (form) {
    $scope.submittedCode = true;
    $scope.errorMsg = '';

    if (!$scope.promoCode || $scope.promoCode === '') {
      return;
    }

    var options = {
      promoCode: $scope.promoCode
    };

    $scope.loading = true;

    jsSdkBooking.addBookingDiscount($scope.booking.id, options).then(function (response) {
      _success(response);

      $scope.successMsg = 'Promo applied!';

      form.$setPristine();

      tracking.trackEvent(_segmentEvents2.default.RedeemedPromoCode, {
        code: $scope.promoCode
      });
    }, function (response) {
      _error(response);

      form.$setPristine();
    });
  };

  $scope.removeDiscount = function (discountId) {
    var message = 'Would you like to remove this discount?';

    if (!confirm(message)) return;

    var options = {
      bookingDiscountId: discountId
    };

    $scope.loading = true;

    jsSdkBooking.removeBookingDiscount($scope.booking.id, options).then(_success, _error);

    $scope.successMsg = null;
  };

  function _success(booking) {
    var promise = jsSdkBooking.readById(booking.id);

    promise.then(function (b) {
      $scope.loading = false;
      $scope.booking = b;
      $scope.submittedCode = false;
      $scope.errorMsg = '';
      $scope.promoCode = null;
    }, function (resp) {
      _error(resp);
    });
  }

  function _error(response) {
    loggerService.error(response);
    $scope.submittedCode = false;
    $scope.successMsg = null;
    $scope.errorMsg = response.data.errors[0].message;
    $scope.loading = false;
  }

  $scope.getInventoryName = function (inventoryType, inventoryQuantity) {
    if (!inventoryType || !inventoryQuantity) return null;

    var name = inventoryType.substring(0, 1).toUpperCase() + inventoryType.substring(1, inventoryType.length).toLowerCase();

    return inventoryQuantity > 1 ? name + 's' : name;
  };

  $scope.getBookingDateSentence = function (booking) {
    return utilsService.getBookingDateSentence(booking);
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$uibModal', '$timeout', 'utilsService', 'loggerService', 'trackingService', 'jsSdk.booking', 'jsSdk.user', 'jsSdk.imgix'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(837);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    scope: {
      booking: '=',
      venue: '=',
      inventory: '='
    },
    controller: 'checkoutPreviewCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $timeout, jsSdkUser, utilsService) {
  $scope.completeProfileSubmitting = null;
  $scope.completeProfileResult = null;
  $scope.completeProfileBtnOptions = {
    buttonDefaultText: 'UPDATE PROFILE',
    buttonSubmittingText: 'Updating profile....',
    buttonSuccessText: 'SUCCESS!',
    buttonErrorText: 'Error updating profile.',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.user = jsSdkUser.getCurrentUser();

  if (!$scope.user) {
    $scope.callback(null);

    return;
  }

  $scope.requiredKeys = [];

  _angular2.default.forEach($scope.config.keysToVerify, function (value) {
    $scope.requiredKeys[value] = true;
  });

  $scope.submit = function () {
    $scope.completeProfileSubmitting = true;

    var user = _underscore2.default.pick($scope.user, $scope.config.keysToVerify);

    updateUser(user);
  };

  $scope.closeAlert = function () {
    $scope.errorMsg = null;
  };

  var updateUser = function updateUser(user) {
    jsSdkUser.updateMe(user).then(function success(resp) {
      $scope.completeProfileResult = 'success';

      $rootScope.$broadcast('userUpdated');

      $scope.callback(resp);
    }, function error(resp) {
      $scope.error(resp);
    });
  };

  $scope.error = function (response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    $scope.completeProfileResult = false;
    $scope.completeProfileSubmitting = false;
    $scope.completeProfileResult = 'error';
  };
}

Ctrl.$inject = ['$scope', '$rootScope', '$timeout', 'jsSdk.user', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(838);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    scope: {
      callback: '=',
      config: '='
    },
    controller: 'completeProfileDirectiveCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, storage, events, supportService, conciergeState, conciergeMessageReceivedKey) {
  var STATE = conciergeState;
  var CONCIERGE_UNREAD_COUNT_KEY = 'tl_concierge_unread_count';

  $scope.STATE = STATE;
  $scope.checkedMessages = {};
  $scope.pendingUnreadMessages = [];
  $scope.visible = false;

  $scope.unreadMessages = function () {
    return storage.get(CONCIERGE_UNREAD_COUNT_KEY) || 0;
  };

  $scope.state = function () {
    return $rootScope.currentUser ? STATE.CHAT : STATE.SIGNUP;
  };

  $scope.show = function () {
    $scope.visible = true;
    $scope.markPendingMessagesRead();
  };

  $scope.hide = function () {
    $scope.visible = false;
    $scope.markPendingMessagesRead();
  };

  $scope.$on('new-concierge-message', function () {
    if (!$scope.visible) {
      $scope.show();
    }
  });

  $scope.markPendingMessagesRead = function () {
    if ($scope.pendingUnreadMessages.length > 0) {
      var messageIds = _underscore2.default.map($scope.pendingUnreadMessages, 'id');

      supportService.markMessagesRead(messageIds);
    }

    $scope.pendingUnreadMessages = [];

    storage.set(CONCIERGE_UNREAD_COUNT_KEY, 0);
  };

  events.on(conciergeMessageReceivedKey, function (event, message) {
    if (!$scope.visible && $scope.isUnreadMessage(message)) {
      $scope.pendingUnreadMessages.push(message);
      storage.set(CONCIERGE_UNREAD_COUNT_KEY, $scope.unreadMessages() + 1);
    } else if ($scope.visible && $scope.isUnreadMessage(message)) {
      supportService.markMessagesRead([message.id]);
    }
  });

  if ($scope.state() === STATE.CHAT) {
    var options = {
      messageState: ['sent', 'delivered'],
      fields: 'from.userType,to.userType',
      limit: 20
    };

    supportService.listClientMessages(options).then(function (result) {
      result = _underscore2.default.filter(result, $scope.isUnreadMessage);
      $scope.pendingUnreadMessages = result;
      storage.set(CONCIERGE_UNREAD_COUNT_KEY, result.length);
    });
  }

  $scope.isUnreadMessage = function (message) {
    if ($scope.checkedMessages[message.id]) return false;
    $scope.checkedMessages[message.id] = true;
    return message.from.userType === 'agent' && message.to.userType !== 'agent';
  };
}

Ctrl.$inject = ['$rootScope', '$scope', 'tl.storage', 'tl.ee', 'tl.support.service', 'conciergeState', 'conciergeMessageReceivedKey'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(839);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: _template2.default,
    controller: 'conciergeCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function linkify(text) {
  if (text.indexOf('href=') >= 0) return text;

  var urlRegex = '';

  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + '</a>';
  });
}

function imgify(url) {
  return '<img src="' + url + '" />';
}

function Ctrl($rootScope, $scope, $timeout, $window, supportService, tlHttp, events, conciergeMessageReceivedKey, tracking) {
  $scope.messages = {};
  $scope.messageText = '';

  $scope.sendMessage = function () {
    if ($scope.isSending) return;
    $scope.isSending = true;

    var text = $scope.messageText || 'Image:';
    var options = {};

    if ($scope.image) {
      options.data = {
        mediaUrl: $scope.image.original
      };
    }

    supportService.sendInboundMessage(text, options).then(success, error);

    function success(resp) {

      tracking.trackEvent(_segmentEvents2.default.ContactedConcierge, {
        message: resp.text
      });

      $scope.isSending = false;
      $scope.messageText = '';
      $scope.image = null;
    }

    function error() {
      $scope.isSending = false;

      $timeout(function () {
        window.alert('Failed to send message. Please try again.');
      }, 200);
    }
  };

  $scope.canSendMessage = function () {
    return !$scope.isSending && ($scope.messageText || $scope.image);
  };

  $scope.$on('new-concierge-message', function (event, args) {
    $scope.messageText = args.text || '';

    if (args.autosend) {
      $scope.sendMessage();
    }
  });

  $scope.fetchMessages = function () {
    if ($scope.loading) return;

    $scope.loading = true;

    var options = {
      limit: 20
    };

    supportService.listClientMessages(options).then(function (result) {
      $scope.messages = _lodash2.default.keyBy(result, 'id');

      $scope.loading = false;

      $timeout(function () {
        scrollToBottom(0);
      }, 100);
    }, function () {
      $scope.loading = false;
    });
  };

  $scope.getMessages = function () {
    return _lodash2.default.chain($scope.messages).values($scope.messages).filter(function (message) {
      return !$scope.isInternalMessage(message);
    }).value();
  };

  $scope.isInternalMessage = function (message) {
    return message.from.userType === 'agent' && message.to.userType === 'agent';
  };

  $scope.isUserMessage = function (message) {
    return message.from.userType !== 'agent';
  };

  $scope.isAgentMessage = function (message) {
    return message.from.userType === 'agent';
  };

  $scope.getMessageImageUrl = function (message) {
    var info = message.from.info || {};
    return $scope.getClientImageUrl(info);
  };

  $scope.getMessageName = function (message) {
    var info = message.from.info || {};
    return $scope.getClientName(info, message.messageType);
  };

  $scope.getMessageText = function (message) {
    var text = linkify(message.text || '');

    if (message.data && message.data.mediaUrl) {
      text = text.replace('(no text)', '');
      text += imgify(message.data.mediaUrl);
    }
    return text;
  };

  $scope.getClientImageUrl = function (info) {
    return info.imageUrl || 'https://assets.tablelist.com/www/images/user-icon-256.png';
  };

  $scope.getClientName = function (info) {
    if (info.firstName) {
      return info.firstName;
    }
    return 'Anonymous';
  };

  $scope.mediaUrl = function (message) {
    var data = message.data || {};

    return data.mediaUrl || null;
  };

  $scope.bookingUrl = function (message) {
    var data = message.data || {};
    return data.booking ? '/booking/' + data.booking : null;
  };

  $scope.eventUrl = function (message) {
    var data = message.data || {};
    return data.event ? '/event/' + data.event + '/inventory' : null;
  };

  $scope.venueUrl = function (message) {
    var data = message.data || {};
    return data.venue ? '/venues/' + data.venue + '/inventory' : null;
  };

  $scope.cityUrl = function (message) {
    var data = message.data || {};
    return data.city ? '/' + data.city + '/venues/' : null;
  };

  $scope.removeImage = function () {
    $scope.image = null;

    document.getElementById('input-img-upload').value = '';
  };

  $scope.uploadImage = function (files) {
    if ($scope.uploading) return;
    $scope.uploading = true;

    var fd = new $window.FormData();

    fd.append('image', files[0]);

    tlHttp.upload('/image?ignoreHeight=1', {}, fd).success(function (data) {
      $scope.image = data;
      $scope.uploading = false;

      document.getElementById('input-img-upload').value = '';
    }).error(function () {
      $scope.uploading = false;

      document.getElementById('input-img-upload').value = '';
    });
  };

  $scope.clientMessageSocket = supportService.listenForClientMessages(function (message) {
    $scope.$apply(function () {
      events.emit(conciergeMessageReceivedKey, message);
      $scope.messages[message.id] = message;
      $timeout(function () {
        scrollToBottom(400);
      }, 100);
    });
  });

  $scope.$on('$destroy', function () {
    $scope.clientMessageSocket.close();
  });

  $scope.showIntroDescription = function () {
    return (0, _keys2.default)($scope.messages).length === 0;
  };

  $scope.showConciergeDescription = function () {
    var messages = $scope.getMessages();

    if (!messages || messages.length === 0) return false;

    return !_lodash2.default.some(messages, function (message) {
      return message.from.userType === 'agent';
    });
  };

  function scrollToBottom(time) {
    var div = (0, _jquery2.default)('.message-list');

    div.animate({
      scrollTop: div[0].scrollHeight
    }, time);
  }

  $scope.fetchMessages();

  $scope.clientMessageSocket.connect();
}

Ctrl.$inject = ['$rootScope', '$scope', '$timeout', '$window', 'tl.support.service', 'tl.http', 'tl.ee', 'conciergeMessageReceivedKey', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(840);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: _template2.default,
    controller: 'conciergeChatCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($rootScope, $scope, utilsService, authService, supportService, tlConfig, modalService) {
  $scope.init = function () {
    $scope.loading = false;
    $scope.intro = true;
    $scope.form = {};
    $scope.reasons = ['I want to book a table', 'I want to buy a ticket', 'Help me plan my night', 'Technical issue', 'Credit and billing matters', 'Other'];
    $scope.selectedReason = $scope.reasons[0];
    $scope.message = '';
    $scope.errorMessage = null;
  };

  $scope.begin = function () {
    $scope.intro = false;
  };

  $scope.signIn = function () {
    modalService.authUser(null, null, {
      startState: 'existingUser'
    });
  };

  $scope.selectReason = function (reason) {
    $scope.selectedReason = reason;
  };

  $scope.startTalking = function () {
    if (!$scope.form.firstName || !$scope.form.lastName) {
      $scope.errorMessage = 'First and last name are required';
      return;
    }

    if (!$scope.form.phone) {
      $scope.errorMessage = 'Phone is required';
      return;
    }

    if (!$scope.form.email) {
      $scope.errorMessage = 'Email is required';
      return;
    }

    if (!$scope.form.password) {
      $scope.errorMessage = 'Password is required';
      return;
    }

    if (!$scope.message) {
      $scope.errorMessage = 'Please type in a message';
      return;
    }

    if ($scope.loading) return;
    $scope.loading = true;

    tlConfig.setSubclient('www-concierge');

    authService.register($scope.form, function () {
      var text = 'Reason: ' + $scope.selectedReason + '\n' + $scope.message;
      var options = {};

      supportService.sendInboundMessage(text, options);

      $scope.init();
    }, function (err) {
      $scope.loading = false;
      if (err.data.errors && err.data.errors[0]) {
        $scope.errorMessage = err.data.errors[0].message;
      } else {
        $scope.errorMessage = 'Something went wrong. Please try again.';
      }
    });
  };

  $scope.init();
}

Ctrl.$inject = ['$rootScope', '$scope', 'utilsService', 'tl.auth.service', 'tl.support.service', 'tl.config', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(841);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: _template2.default,
    controller: 'conciergeSignupCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, utilsService, conciergeService, modalService) {
  $scope.message = $scope.message || '';

  $scope.isMobile = utilsService.isMobileDevice();

  $scope.chat = function () {
    modalService.authUser(function () {
      conciergeService.sendMessage($scope.message, true);
    }, null, {
      startState: 'existingUser'
    });
  };

  $scope.email = function () {
    utilsService.mailto('hello@tablelist.com', 'Question for Tablelist Concierge', $scope.message);
  };

  $scope.sms = function () {
    utilsService.sms(6173408791, $scope.message);
  };
}

Ctrl.$inject = ['$scope', 'utilsService', 'conciergeService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(842);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    scope: {
      message: '='
    },
    controller: 'contactOptionsCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(843);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COOKIES_ACCEPTED_KEY = 'TL_COOKIES_ACCEPTED';

function Ctrl($rootScope, $scope, $timeout, $cookies) {
  var cookieShowValue = $cookies.get(COOKIES_ACCEPTED_KEY);

  $timeout(function () {
    $scope.visible = !cookieShowValue;
  }, 1000);

  $rootScope.$on('$stateChangeStart', function () {
    $scope.acceptCookies();
  });

  $scope.acceptCookies = function ($event) {
    if ($event) $event.preventDefault();

    $cookies.put(COOKIES_ACCEPTED_KEY, true, {
      expires: (0, _moment2.default)().add(1, 'year').toDate()
    });

    $scope.visible = false;
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$timeout', '$cookies'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(844);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'cookieBannerCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _template = __webpack_require__(845);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive($timeout, $interval) {
  return {
    restrict: 'E',
    replace: true,
    template: _template2.default,
    scope: {
      date: '='
    },
    link: function link($scope) {
      countdown();

      $interval(countdown, 1000);

      function countdown() {
        var now = (0, _moment2.default)();
        var then = (0, _moment2.default)($scope.date || new Date());

        var ms = then.diff(now, 'milliseconds', true);

        ms = then.diff(now, 'milliseconds', true);

        ms = then.diff(now, 'milliseconds', true);
        var days = Math.floor(_moment2.default.duration(ms).asDays());

        then = then.subtract(days, 'days');

        ms = then.diff(now, 'milliseconds', true);
        var hours = Math.floor(_moment2.default.duration(ms).asHours());

        then = then.subtract(hours, 'hours');

        ms = then.diff(now, 'milliseconds', true);
        var minutes = Math.floor(_moment2.default.duration(ms).asMinutes());

        then = then.subtract(minutes, 'minutes');

        ms = then.diff(now, 'milliseconds', true);
        var seconds = Math.floor(_moment2.default.duration(ms).asSeconds());

        $scope.countdownDays = days;
        $scope.countdownHours = hours;
        $scope.countdownMinutes = minutes;
        $scope.countdownSeconds = seconds;
      }
    }
  };
}

Directive.$inject = ['$timeout', '$interval'];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, jsSdkPaymentProfile, jsSdkUser, modalService) {
  $rootScope.$on('payment-profile-updated', function () {
    $scope.getDefaultPaymentProfile();
  });

  $scope.getDefaultPaymentProfile = function () {
    $scope.loading = true;

    var userId = jsSdkUser.getCurrentUser().id;

    jsSdkPaymentProfile.listByUserId(userId).then(function (resp) {
      if (!resp.length) {
        $scope.loading = false;
      }

      $scope.loading = false;

      $scope.card = (0, _find3.default)(resp, {
        default: true
      }) || resp.pop();
    }, function () {
      $scope.loading = false;
    }, function () {
      $scope.loading = false;
    });
  };

  $scope.editCreditCard = function () {
    modalService.editCreditCard();
  };

  $scope.getDefaultPaymentProfile();
}

Ctrl.$inject = ['$rootScope', '$scope', 'jsSdk.paymentProfile', 'jsSdk.user', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(846);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'creditCardPreviewCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, imgix) {
  $scope.maxTitleLength = 30;

  $scope.maxDescriptionLength = 200;

  $scope.getBackgroundImage = function () {
    if (!$scope.list) return null;

    var img = $scope.list.thumbnailImageUrl ? $scope.list.thumbnailImageUrl : $scope.list.imageUrl;

    return $scope.imgix(img);
  };

  $scope.imgix = function (src) {
    var options = {
      height: 370,
      width: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = ['$scope', 'jsSdk.imgix'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(847);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      list: '=',
      placeholder: '='
    },
    template: _template2.default,
    controller: 'curatedListCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $stateParams, imgix, modalService) {
  $scope.modified = function (item) {
    if (!item || !item.modified) return false;

    var modified = (0, _moment2.default)(item.modified);

    return (0, _moment2.default)().diff(modified, 'hours') < 48;
  };

  $scope.goToItem = function (item) {
    if ($scope.isPreview) {
      return modalService.getMembership();
    }

    if (item.type === 'EVENT') {
      $state.go('app.event', {
        seoPathname: item.contentSeoPathname || item.event.id,
        back: $stateParams.id
      });
    }

    if (item.type === 'VENUE') {
      $state.go('app.venue', {
        seoPathname: item.contentSeoPathname || item.venue.id,
        back: $stateParams.id
      });
    }

    return null;
  };

  $scope.eventDateString = function (event) {
    if (!event || !event.date) return null;

    var eventDate = _moment2.default.utc(event.date).startOf('day');

    $scope.date = eventDate;

    var now = _moment2.default.utc();

    var today = now.clone().startOf('day');
    var tomorrow = now.clone().add(1, 'days').startOf('day');

    if ($scope.isPast()) {
      return eventDate.format('M/D/YYYY') + ' at ';
    }

    if (eventDate.isSame(today, 'd')) {
      return 'Tonight, ' + eventDate.format('M/D') + ' at ';
    }

    if (eventDate.isSame(tomorrow, 'd')) {
      return 'Tomorrow, ' + eventDate.format('M/D') + ' at ';
    }

    return eventDate.format('dddd, M/D') + ' at ';
  };

  $scope.isPast = function () {
    if (!$scope.event) return false;

    var start = (0, _moment2.default)($scope.event.date, 'x');
    var now = (0, _moment2.default)();
    var diff = now.diff(start, 'hours');

    return diff >= 24;
  };

  $scope.imgix = function (src) {
    var options = {
      width: 270
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = ['$scope', '$state', '$stateParams', 'jsSdk.imgix', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(848);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      item: '=',
      placeholder: '=',
      isPreview: '='
    },
    template: _template2.default,
    controller: 'curatedListEventCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $stateParams, imgix, modalService) {
  console.log('$scope.list', $scope.list);

  $scope.modified = function (item) {
    if (!item || !item.modified) return false;

    var modified = (0, _moment2.default)(item.modified);

    return (0, _moment2.default)().diff(modified, 'hours') < 48;
  };

  $scope.goToItem = function (item) {
    if ($scope.isPreview) {
      return modalService.getMembership();
    }

    if (item.type === 'EVENT') {
      $state.go('app.event', {
        seoPathname: item.contentSeoPathname || (item.event && item.event.id ? item.event.id : item.event),
        back: $stateParams.id,
        backName: $scope.list ? $scope.list.title : null
      });
    }

    if (item.type === 'VENUE') {
      $state.go('app.venue', {
        seoPathname: item.contentSeoPathname || (item.venue && item.venue.id ? item.venue.id : item.venue),
        back: $stateParams.id,
        backName: $scope.list ? $scope.list.title : null
      });
    }

    return null;
  };

  $scope.imgix = function (src) {
    var options = {
      width: 500,
      height: 270
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
}

Ctrl.$inject = ['$scope', '$state', '$stateParams', 'jsSdk.imgix', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(849);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      item: '=',
      list: '=',
      placeholder: '=',
      isPreview: '='
    },
    template: _template2.default,
    controller: 'curatedListItemCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(792);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    require: 'ngModel',
    scope: {
      datePickerOptions: '=',
      singleDatePicker: '@',
      opens: '@',
      trigger: '='
    },
    template: '<div class="date-range-picker-single">\n    <input class="form-control" type="text" />\n    </div>',
    link: function link(scope, element, attrs, ngModelCtrl) {
      var picker = void 0;

      scope.datePickerOptions = scope.datePickerOptions || {};
      scope.parentEl = element;

      scope.datePickerOptions.handle = {
        show: function show() {
          picker.data('daterangepicker').show();
        },
        hide: function hide() {
          picker.data('daterangepicker').hide();
        }
      };

      if (scope.trigger === true) {
        scope.datePickerOptions.init = function () {
          init();

          picker.data('daterangepicker').setStartDate(ngModelCtrl.$viewValue);
        };
      } else {
        scope.datePickerOptions.init = function () {};

        init();
      }

      function init() {
        var options = {};

        _angular2.default.extend(options, scope.datePickerOptions);

        var inlineOptions = {};

        if (scope.opens) {
          inlineOptions.opens = scope.opens;
        }

        inlineOptions.singleDatePicker = true;

        _angular2.default.extend(options, inlineOptions);

        picker = element.find('input').daterangepicker(options, function (start) {
          ngModelCtrl.$setViewValue(start);
        });

        ngModelCtrl.$formatters.push(function (modelValue) {
          return modelValue;
        });

        ngModelCtrl.$render = function () {
          if (ngModelCtrl.$viewValue) picker.data('daterangepicker').setStartDate(ngModelCtrl.$viewValue);
        };

        ngModelCtrl.$parsers.push(function (viewValue) {
          return viewValue;
        });

        element.on('show.daterangepicker', function () {
          scope.safeApply(function () {
            if (scope.datePickerOptions.onShow) scope.datePickerOptions.onShow();
          });
        });

        element.on('hide.daterangepicker', function () {
          scope.safeApply(function () {
            if (scope.datePickerOptions.onHide) scope.datePickerOptions.onHide();
          });
        });
      }

      scope.safeApply = function (fn) {
        var phase = this.$root.$$phase;

        if (phase === '$apply' || phase === '$digest') {
          if (fn && typeof fn === 'function') {
            fn();
          }
        } else {
          this.$apply(fn);
        }
      };
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, imgix, favoritesService, tracking) {
  if ($scope.placeholder) return;

  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  favoritesService.isFavorite(favoritesService.TYPES.EVENT, $scope.event.id).then(function (favorited) {
    $scope.isFavorited = favorited;
    $scope.disableFavoriting = false;
  });

  $scope.imgix = function (src) {
    var options = {
      width: 360,
      height: 420
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.favoriteEvent = function (event) {
    $scope.disableFavoriting = true;

    var func = $scope.isFavorited ? favoritesService.removeFavorite : favoritesService.addFavorite;
    var increment = $scope.isFavorited ? -1 : 1;

    func(favoritesService.TYPES.EVENT, event.id).then(function () {
      event.favoriteCount += increment;

      $scope.isFavorited = !$scope.isFavorited;

      var eventName = $scope.isFavorited ? _segmentEvents2.default.FavoritedEvent : _segmentEvents2.default.UnfavoritedEvent;

      tracking.trackEvent(eventName, {
        eventId: $scope.event.id,
        eventName: $scope.event.name
      });
    }).finally(function () {
      $scope.disableFavoriting = false;
    });
  };

  $scope.opensAt = function (event) {
    return _moment2.default.utc(event.date).format('MMM DD, YYYY');
  };
}

Ctrl.$inject = ['$scope', 'jsSdk.imgix', 'favoritesService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(850);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      event: '=',
      placeholder: '='
    },
    template: _template2.default,
    controller: 'eventCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, imgix, loggerService, favoritesService, trackingService) {
  if ($scope.placeholder) return;

  $scope.maxDescriptionLength = 140;

  $scope.$watch('event', function (event) {
    $scope.date = _moment2.default.utc(event.date);

    var img = event.primaryImage || 'https://assets.tablelist.com/www/images/event-default-poster-v1.2.jpg';

    $scope.imageUrl = $scope.imgix(img);
  });

  $scope.isFavorited = false;

  $scope.disableFavoriting = true;

  favoritesService.isFavorite(favoritesService.TYPES.EVENT, $scope.event.id).then(function (favorited) {
    $scope.isFavorited = favorited;
    $scope.disableFavoriting = false;
  }).catch(function (err) {
    loggerService.error(err);
  });

  $scope.imgix = function (src) {
    if (!src) return null;

    var options = {
      width: 150,
      height: 200
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.favoriteEvent = function (event) {
    $scope.disableFavoriting = true;

    var func = $scope.isFavorited ? favoritesService.removeFavorite : favoritesService.addFavorite;
    var increment = $scope.isFavorited ? -1 : 1;

    func(favoritesService.TYPES.EVENT, event.id).then(function () {
      event.favoriteCount += increment;
      $scope.isFavorited = !$scope.isFavorited;

      var eventName = $scope.isFavorited ? _segmentEvents2.default.FavoritedEvent : _segmentEvents2.default.UnfavoritedEvent;

      trackingService.trackEvent(eventName, {
        eventId: $scope.event.id,
        eventName: $scope.event.name
      });
    }).catch(function (err) {
      loggerService.error(err);
    }).finally(function () {
      $scope.disableFavoriting = false;
    });
  };
}

Ctrl.$inject = ['$scope', 'jsSdk.imgix', 'loggerService', 'favoritesService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(851);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      event: '=',
      placeholder: '='
    },
    template: _template2.default,
    controller: 'eventListCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $timeout, utilsService, favoritesService, loggerService, tracking) {
  $scope.loading = true;
  $scope.type = null;
  $scope.id = null;
  $scope.favoriteCount = 0;
  $scope.isFavorited = false;

  $scope.$watch('venue', function (venue) {
    if (!venue || !venue.id) return;

    $scope.type = favoritesService.TYPES.VENUE;
    $scope.id = venue.id;

    initialize($scope.type, $scope.id);
  });

  $scope.$watch('event', function (event) {
    if (!event || !event.id) return;

    $scope.type = favoritesService.TYPES.EVENT;
    $scope.id = event.id;

    initialize($scope.type, $scope.id);
  });

  function initialize(type, id) {

    $scope.loading = true;

    favoritesService.isFavorite(type, id).then(function (favorited) {
      $scope.isFavorited = favorited;
      $scope.loading = false;
    }).catch(function (err) {
      loggerService.error(err);
      $scope.loading = false;
    });
  }

  $scope.favorite = function (type, id) {
    if (!type) return;
    if (!id) return;

    $scope.loading = true;

    var func = $scope.isFavorited ? favoritesService.removeFavorite : favoritesService.addFavorite;
    var increment = $scope.isFavorited ? -1 : 1;

    func(type, id).then(function () {
      $scope.favoriteCount += increment;
      $scope.isFavorited = !$scope.isFavorited;

      var isFavorited = $scope.isFavorited;
      var trackingEventName = void 0;
      var trackingEventData = void 0;

      if (type === favoritesService.TYPES.VENUE) {
        trackingEventName = isFavorited ? _segmentEvents2.default.FavoritedVenue : _segmentEvents2.default.UnfavoritedVenue;
        trackingEventData = {
          venueId: $scope.venue.id,
          venueName: $scope.venue.name
        };
      }

      if (type === favoritesService.TYPES.EVENT) {
        trackingEventName = $scope.isFavorited ? _segmentEvents2.default.FavoritedEvent : _segmentEvents2.default.UnfavoritedEvent;

        trackingEventData = {
          eventId: $scope.event.id,
          event: $scope.event.name
        };
      }

      if (!trackingEventName || !trackingEventData) return;

      tracking.trackEvent(trackingEventName, trackingEventData);
    }).catch(function (err) {
      loggerService.error(err);
    }).finally(function () {

      $timeout(function () {
        $scope.loading = false;
      }, 300);
    });
  };
}

Ctrl.$inject = ['$scope', '$timeout', 'utilsService', 'favoritesService', 'loggerService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(852);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      venue: '=',
      event: '='
    },
    template: _template2.default,
    controller: 'favoriteToggleCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<span ng-transclude></span>',
    link: function link(scope, element, attrs) {
      var fileInput = _angular2.default.element('<input type="file" style="display:none" />');
      var fileSelectedFn = scope.$eval(attrs.fileSelected);

      element.after(fileInput);

      scope.selectImage = function () {
        fileInput.click();
      };

      fileInput.on('change', function () {
        if (this.files) fileSelectedFn(this.files);
      });
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appHeader = __webpack_require__(405);

var _appHeader2 = _interopRequireDefault(_appHeader);

var _controller = __webpack_require__(404);

var _controller2 = _interopRequireDefault(_controller);

var _appFooter = __webpack_require__(403);

var _appFooter2 = _interopRequireDefault(_appFooter);

var _controller3 = __webpack_require__(402);

var _controller4 = _interopRequireDefault(_controller3);

var _bookingCard = __webpack_require__(409);

var _bookingCard2 = _interopRequireDefault(_bookingCard);

var _controller5 = __webpack_require__(408);

var _controller6 = _interopRequireDefault(_controller5);

var _bookingStatus = __webpack_require__(413);

var _bookingStatus2 = _interopRequireDefault(_bookingStatus);

var _controller7 = __webpack_require__(412);

var _controller8 = _interopRequireDefault(_controller7);

var _checkoutPreview = __webpack_require__(416);

var _checkoutPreview2 = _interopRequireDefault(_checkoutPreview);

var _controller9 = __webpack_require__(415);

var _controller10 = _interopRequireDefault(_controller9);

var _cityPicker = __webpack_require__(418);

var _cityPicker2 = _interopRequireDefault(_cityPicker);

var _controller11 = __webpack_require__(417);

var _controller12 = _interopRequireDefault(_controller11);

var _completeProfile = __webpack_require__(420);

var _completeProfile2 = _interopRequireDefault(_completeProfile);

var _controller13 = __webpack_require__(419);

var _controller14 = _interopRequireDefault(_controller13);

var _concierge = __webpack_require__(422);

var _concierge2 = _interopRequireDefault(_concierge);

var _controller15 = __webpack_require__(421);

var _controller16 = _interopRequireDefault(_controller15);

var _conciergeChat = __webpack_require__(424);

var _conciergeChat2 = _interopRequireDefault(_conciergeChat);

var _controller17 = __webpack_require__(423);

var _controller18 = _interopRequireDefault(_controller17);

var _conciergeSignup = __webpack_require__(426);

var _conciergeSignup2 = _interopRequireDefault(_conciergeSignup);

var _controller19 = __webpack_require__(425);

var _controller20 = _interopRequireDefault(_controller19);

var _contactOptions = __webpack_require__(428);

var _contactOptions2 = _interopRequireDefault(_contactOptions);

var _controller21 = __webpack_require__(427);

var _controller22 = _interopRequireDefault(_controller21);

var _creditCardPreview = __webpack_require__(434);

var _creditCardPreview2 = _interopRequireDefault(_creditCardPreview);

var _controller23 = __webpack_require__(433);

var _controller24 = _interopRequireDefault(_controller23);

var _curatedListCard = __webpack_require__(436);

var _curatedListCard2 = _interopRequireDefault(_curatedListCard);

var _controller25 = __webpack_require__(435);

var _controller26 = _interopRequireDefault(_controller25);

var _curatedListEventCard = __webpack_require__(438);

var _curatedListEventCard2 = _interopRequireDefault(_curatedListEventCard);

var _controller27 = __webpack_require__(437);

var _controller28 = _interopRequireDefault(_controller27);

var _curatedListItemCard = __webpack_require__(440);

var _curatedListItemCard2 = _interopRequireDefault(_curatedListItemCard);

var _controller29 = __webpack_require__(439);

var _controller30 = _interopRequireDefault(_controller29);

var _venueCard = __webpack_require__(488);

var _venueCard2 = _interopRequireDefault(_venueCard);

var _controller31 = __webpack_require__(487);

var _controller32 = _interopRequireDefault(_controller31);

var _eventCard = __webpack_require__(443);

var _eventCard2 = _interopRequireDefault(_eventCard);

var _controller33 = __webpack_require__(442);

var _controller34 = _interopRequireDefault(_controller33);

var _eventListCard = __webpack_require__(445);

var _eventListCard2 = _interopRequireDefault(_eventListCard);

var _controller35 = __webpack_require__(444);

var _controller36 = _interopRequireDefault(_controller35);

var _richVenueCard = __webpack_require__(475);

var _richVenueCard2 = _interopRequireDefault(_richVenueCard);

var _controller37 = __webpack_require__(474);

var _controller38 = _interopRequireDefault(_controller37);

var _richEventCard = __webpack_require__(473);

var _richEventCard2 = _interopRequireDefault(_richEventCard);

var _controller39 = __webpack_require__(472);

var _controller40 = _interopRequireDefault(_controller39);

var _favoriteToggle = __webpack_require__(447);

var _favoriteToggle2 = _interopRequireDefault(_favoriteToggle);

var _controller41 = __webpack_require__(446);

var _controller42 = _interopRequireDefault(_controller41);

var _login = __webpack_require__(455);

var _login2 = _interopRequireDefault(_login);

var _controller43 = __webpack_require__(454);

var _controller44 = _interopRequireDefault(_controller43);

var _loginEmail = __webpack_require__(457);

var _loginEmail2 = _interopRequireDefault(_loginEmail);

var _controller45 = __webpack_require__(456);

var _controller46 = _interopRequireDefault(_controller45);

var _loginFacebook = __webpack_require__(459);

var _loginFacebook2 = _interopRequireDefault(_loginFacebook);

var _controller47 = __webpack_require__(458);

var _controller48 = _interopRequireDefault(_controller47);

var _membershipCard = __webpack_require__(461);

var _membershipCard2 = _interopRequireDefault(_membershipCard);

var _controller49 = __webpack_require__(460);

var _controller50 = _interopRequireDefault(_controller49);

var _paymentProfile = __webpack_require__(465);

var _paymentProfile2 = _interopRequireDefault(_paymentProfile);

var _controller51 = __webpack_require__(464);

var _controller52 = _interopRequireDefault(_controller51);

var _promoBar = __webpack_require__(468);

var _promoBar2 = _interopRequireDefault(_promoBar);

var _controller53 = __webpack_require__(467);

var _controller54 = _interopRequireDefault(_controller53);

var _referralBlock = __webpack_require__(471);

var _referralBlock2 = _interopRequireDefault(_referralBlock);

var _controller55 = __webpack_require__(470);

var _controller56 = _interopRequireDefault(_controller55);

var _search = __webpack_require__(477);

var _search2 = _interopRequireDefault(_search);

var _controller57 = __webpack_require__(476);

var _controller58 = _interopRequireDefault(_controller57);

var _shareBar = __webpack_require__(480);

var _shareBar2 = _interopRequireDefault(_shareBar);

var _controller59 = __webpack_require__(479);

var _controller60 = _interopRequireDefault(_controller59);

var _smartBanner = __webpack_require__(483);

var _smartBanner2 = _interopRequireDefault(_smartBanner);

var _controller61 = __webpack_require__(482);

var _controller62 = _interopRequireDefault(_controller61);

var _smsDownloadLink = __webpack_require__(485);

var _smsDownloadLink2 = _interopRequireDefault(_smsDownloadLink);

var _controller63 = __webpack_require__(484);

var _controller64 = _interopRequireDefault(_controller63);

var _venueRating = __webpack_require__(490);

var _venueRating2 = _interopRequireDefault(_venueRating);

var _controller65 = __webpack_require__(489);

var _controller66 = _interopRequireDefault(_controller65);

var _cookieBanner = __webpack_require__(431);

var _cookieBanner2 = _interopRequireDefault(_cookieBanner);

var _controller67 = __webpack_require__(430);

var _controller68 = _interopRequireDefault(_controller67);

var _inventoryListItem = __webpack_require__(451);

var _inventoryListItem2 = _interopRequireDefault(_inventoryListItem);

var _selectedInventory = __webpack_require__(478);

var _selectedInventory2 = _interopRequireDefault(_selectedInventory);

var _meta = __webpack_require__(462);

var _meta2 = _interopRequireDefault(_meta);

var _autofocus = __webpack_require__(406);

var _autofocus2 = _interopRequireDefault(_autofocus);

var _bgImg = __webpack_require__(407);

var _bgImg2 = _interopRequireDefault(_bgImg);

var _bookingGuests = __webpack_require__(410);

var _bookingGuests2 = _interopRequireDefault(_bookingGuests);

var _bookingItems = __webpack_require__(411);

var _bookingItems2 = _interopRequireDefault(_bookingItems);

var _btnSelect = __webpack_require__(414);

var _btnSelect2 = _interopRequireDefault(_btnSelect);

var _countdown = __webpack_require__(432);

var _countdown2 = _interopRequireDefault(_countdown);

var _dateRangePickerSingle = __webpack_require__(441);

var _dateRangePickerSingle2 = _interopRequireDefault(_dateRangePickerSingle);

var _imgUpload = __webpack_require__(448);

var _imgUpload2 = _interopRequireDefault(_imgUpload);

var _inventoryIcon = __webpack_require__(450);

var _inventoryIcon2 = _interopRequireDefault(_inventoryIcon);

var _loading = __webpack_require__(452);

var _loading2 = _interopRequireDefault(_loading);

var _loadingDots = __webpack_require__(453);

var _loadingDots2 = _interopRequireDefault(_loadingDots);

var _ngEnter = __webpack_require__(463);

var _ngEnter2 = _interopRequireDefault(_ngEnter);

var _phoneNumber = __webpack_require__(466);

var _phoneNumber2 = _interopRequireDefault(_phoneNumber);

var _readmore = __webpack_require__(469);

var _readmore2 = _interopRequireDefault(_readmore);

var _slideDown = __webpack_require__(481);

var _slideDown2 = _interopRequireDefault(_slideDown);

var _soundcloudPlayer = __webpack_require__(486);

var _soundcloudPlayer2 = _interopRequireDefault(_soundcloudPlayer);

var _venueType = __webpack_require__(491);

var _venueType2 = _interopRequireDefault(_venueType);

var _contactUs = __webpack_require__(429);

var _contactUs2 = _interopRequireDefault(_contactUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  app.directive('appHeader', _appHeader2.default);
  app.controller('appHeaderCtrl', _controller2.default);

  app.directive('appFooter', _appFooter2.default);
  app.controller('appFooterCtrl', _controller4.default);

  app.directive('bookingCard', _bookingCard2.default);
  app.controller('bookingCardCtrl', _controller6.default);

  app.directive('bookingStatus', _bookingStatus2.default);
  app.controller('bookingStatusCtrl', _controller8.default);

  app.directive('checkoutPreview', _checkoutPreview2.default);
  app.controller('checkoutPreviewCtrl', _controller10.default);

  app.directive('cityPicker', _cityPicker2.default);
  app.controller('cityPickerCtrl', _controller12.default);

  app.directive('completeProfile', _completeProfile2.default);
  app.controller('completeProfileDirectiveCtrl', _controller14.default);

  app.directive('concierge', _concierge2.default);
  app.controller('conciergeCtrl', _controller16.default);

  app.directive('conciergeChat', _conciergeChat2.default);
  app.controller('conciergeChatCtrl', _controller18.default);

  app.directive('conciergeSignup', _conciergeSignup2.default);
  app.controller('conciergeSignupCtrl', _controller20.default);

  app.directive('contactOptions', _contactOptions2.default);
  app.controller('contactOptionsCtrl', _controller22.default);

  app.directive('creditCardPreview', _creditCardPreview2.default);
  app.controller('creditCardPreviewCtrl', _controller24.default);

  app.directive('curatedListCard', _curatedListCard2.default);
  app.controller('curatedListCardCtrl', _controller26.default);

  app.directive('curatedListEventCard', _curatedListEventCard2.default);
  app.controller('curatedListEventCardCtrl', _controller28.default);

  app.directive('curatedListItemCard', _curatedListItemCard2.default);
  app.controller('curatedListItemCardCtrl', _controller30.default);

  app.directive('venueCard', _venueCard2.default);
  app.controller('venueCardCtrl', _controller32.default);

  app.directive('eventListCard', _eventListCard2.default);
  app.controller('eventListCardCtrl', _controller36.default);

  app.directive('eventCard', _eventCard2.default);
  app.controller('eventCardCtrl', _controller34.default);

  app.directive('richVenueCard', _richVenueCard2.default);
  app.controller('richVenueCardCtrl', _controller38.default);

  app.directive('richEventCard', _richEventCard2.default);
  app.controller('richEventCardCtrl', _controller40.default);

  app.directive('favoriteToggle', _favoriteToggle2.default);
  app.controller('favoriteToggleCtrl', _controller42.default);

  app.directive('login', _login2.default);
  app.controller('loginDirectiveCtrl', _controller44.default);

  app.directive('loginEmail', _loginEmail2.default);
  app.controller('loginEmailDirectiveCtrl', _controller46.default);

  app.directive('loginFacebook', _loginFacebook2.default);
  app.controller('loginFacebookDirectiveCtrl', _controller48.default);

  app.directive('membershipCard', _membershipCard2.default);
  app.controller('membershipCardCtrl', _controller50.default);

  app.directive('paymentProfile', _paymentProfile2.default);
  app.controller('paymentProfileCtrl', _controller52.default);

  app.directive('promoBar', _promoBar2.default);
  app.controller('promoBarCtrl', _controller54.default);

  app.directive('referralBlock', _referralBlock2.default);
  app.controller('referralBlockCtrl', _controller56.default);

  app.directive('search', _search2.default);
  app.controller('searchDirectiveCtrl', _controller58.default);

  app.directive('shareBar', _shareBar2.default);
  app.controller('shareBarCtrl', _controller60.default);

  app.directive('smartBanner', _smartBanner2.default);
  app.controller('smartBannerCtrl', _controller62.default);

  app.directive('smsDownloadLink', _smsDownloadLink2.default);
  app.controller('smsDownloadLinkCtrl', _controller64.default);

  app.directive('venueRating', _venueRating2.default);
  app.controller('venueRatingCtrl', _controller66.default);

  app.directive('cookieBanner', _cookieBanner2.default);
  app.controller('cookieBannerCtrl', _controller68.default);

  app.directive('inventoryListItem', _inventoryListItem2.default);
  app.directive('selectedInventory', _selectedInventory2.default);

  app.directive('meta', _meta2.default);
  app.directive('autoFocus', _autofocus2.default);
  app.directive('bgImg', _bgImg2.default);
  app.directive('bookingGuests', _bookingGuests2.default);
  app.directive('bookingItems', _bookingItems2.default);
  app.directive('btnSelect', _btnSelect2.default);
  app.directive('countdown', _countdown2.default);
  app.directive('dateRangePickerSingle', _dateRangePickerSingle2.default);
  app.directive('imgUpload', _imgUpload2.default);
  app.directive('inventoryIcon', _inventoryIcon2.default);
  app.directive('loading', _loading2.default);
  app.directive('loadingDots', _loadingDots2.default);
  app.directive('ngEnter', _ngEnter2.default);
  app.directive('phoneNumber', _phoneNumber2.default);
  app.directive('readMore', _readmore2.default);
  app.directive('slideDown', _slideDown2.default);
  app.directive('soundcloudPlayer', _soundcloudPlayer2.default);
  app.directive('venueType', _venueType2.default);
  app.directive('contactUs', _contactUs2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(853);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: _template2.default,
    scope: {
      type: '='
    },
    controller: ['$scope', function ($scope) {
      var types = ['COVER', 'TICKET', 'TABLE', 'PACKAGE'];

      if (!types.includes($scope.type)) {
        $scope.type = 'UNKNOWN';
      }
    }]
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _template = __webpack_require__(854);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: _template2.default,
    scope: {
      inventory: '=',
      venue: '=',
      onClick: '='
    },
    controller: ['$scope', function ($scope) {
      if (!$scope.inventory) throw new Error('inventory');
      if (!$scope.venue) throw new Error('venue');

      $scope.getSoldOutTiers = function () {
        if (!$scope.inventory || !$scope.inventory.tier || !$scope.inventory.tier.levels || !$scope.inventory.tier.levels.length) return [];

        var activeLevel = (0, _find3.default)($scope.inventory.tier.levels, {
          _id: $scope.inventory.tier.activeLevel
        });
        var activeLevelIndex = $scope.inventory.tier.levels.indexOf(activeLevel);

        var levels = $scope.inventory.tier.levels.slice(0, activeLevelIndex).map(function (tier) {
          tier.name = $scope.inventory.name;
          return tier;
        });

        return levels.length > 1 ? levels.slice(Math.max(levels.length - 1, 1)) : levels;
      };

      $scope.onInventoryClicked = function ($event) {
        if ($event) $event.preventDefault();

        if ($scope.onClick) {
          $scope.onClick($scope.inventory);
        }
      };
    }]
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="loading">\n    <i class="icon"></i>\n</div>\n    '
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      loading: '=',
      dark: '='
    },
    template: '<div ng-class="{ \'loading-dots-dark\' : dark, \'loading-dots\' : !dark }">\n      <div class="loader">\n        <div class="circle">&nbsp;</div>\n        <div class="circle">&nbsp;</div>\n        <div class="circle">&nbsp;</div>\n        <div class="circle">&nbsp;</div>\n      </div>\n    </div>',
    link: function link(scope, element) {
      scope.$watch('loading', function (val) {
        if (val) {
          (0, _jquery2.default)(element).show();
        } else {
          (0, _jquery2.default)(element).hide();
        }
      });
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $rootScope, $timeout, $stateParams, AuthService, UserService, promoService, utilsService, modalService) {
  if ($rootScope.currentUser) {
    if ($scope.config.success) {
      $scope.config.success($rootScope.currentUser);
    } else {
      $state.go('app.me.profile');
    }
  }

  $scope.config.currentState = $scope.config.startState || 'existingUser';
  $scope.config.promo = resolvePromo();

  $scope.isMobile = function () {
    return (0, _jquery2.default)(window).width() < 768;
  };

  $scope.done = function (response, err) {
    if (err) {
      $scope.error = utilsService.errorMessage(response);
      loading(false);
      return;
    }

    $rootScope.$broadcast('login');

    if ($scope.config.promo) {
      redeemPromo(response.user, function () {
        UserService.me();

        verifyUser(response.user);
      }, function () {
        verifyUser(response.user);
      });
    } else {
      verifyUser(response.user);
    }
  };

  function verifyUser(user) {
    if ($scope.config.completeProfile === false) {
      $scope.config.success(user);

      return;
    }

    var isNewAccount = utilsService.isNewUser(user);
    var isFacebookLogin = $scope.config.facebookLogin;

    if (!isNewAccount) {
      $scope.config.success(user);

      return;
    }

    var keysToVerify = isFacebookLogin ? ['firstName', 'lastName', 'email', 'phone'] : ['phone'];

    $scope.config.success(user);

    modalService.completeProfile({
      keysToVerify: keysToVerify
    }, function () {}, function () {});
  }

  function resolvePromo() {
    var promo = $stateParams.code;

    promo = $scope.config.promo ? $scope.config.promo : promo;

    return promo;
  }

  function redeemPromo(user, success, error) {
    var promoCode = $scope.config.promo;

    promoService.redeem(promoCode).$promise.then(success, error);
  }

  function loading(status) {
    if (status) {
      $scope.error = null;
    }
    $scope.loading = status;
  }
}

Ctrl.$inject = ['$scope', '$state', '$rootScope', '$timeout', '$stateParams', 'tl.auth.service', 'tl.user.service', 'tl.promo.service', 'utilsService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(855);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'loginDirectiveCtrl',
    scope: {
      config: '='
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $state, $timeout, authService, utilsService, loggerService) {
  $scope.loginSubmitting = null;
  $scope.loginResult = null;
  $scope.loginBtnOptions = {
    buttonDefaultText: 'Log In',
    buttonSubmittingText: 'Logging in...',
    buttonSuccessText: 'Login succesful',
    buttonErrorText: 'Error logging in',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.signUpSubmitting = null;
  $scope.signUpResult = null;
  $scope.signUpBtnOptions = {
    buttonDefaultText: 'Sign Up',
    buttonSubmittingText: 'Processing...',
    buttonSuccessText: 'Sign up succesful',
    buttonErrorText: 'Error error signing up',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.create = function (user) {
    if (!user) return;

    $scope.signUpSubmitting = true;

    var userObj = {
      email: user.email,
      password: user.password,
      firstName: user.firstName,
      lastName: user.lastName
    };

    authService.register(userObj, function (response) {
      $scope.signUpSubmitting = false;

      $timeout(function () {
        $scope.signUpResult = 'success';
        success(response);
      }, 100);
    }, function (response) {
      $scope.signUpSubmitting = false;
      $scope.signUpResult = 'error';
      $scope.errorMsg = utilsService.errorMessage(response);

      error(response, $scope.errorMsg);
    });
  };

  $scope.login = function (user) {
    $scope.loginSubmitting = true;
    $scope.errorMsg = null;

    authService.login(user.email, user.password, function (response) {
      $scope.loginSubmitting = false;

      $timeout(function () {
        $scope.loginResult = 'success';
        success(response);
      }, 100);
    }, function (response) {
      $scope.loginSubmitting = false;
      $scope.loginResult = 'error';
      $scope.errorMsg = utilsService.errorMessage(response);

      error(response, $scope.errorMsg);
    });
  };

  $scope.changeState = function (newState) {
    if (newState !== 'newUser' && newState !== 'existingUser') return;

    $scope.errorMsg = null;

    $scope.config.currentState = newState;
  };

  var success = function success(response) {
    $scope.config.facebookLogin = false;

    if ($scope.callback) {
      $scope.callback(response);
    }
  };

  var error = function error(response) {
    loggerService.error(response);

    if ($scope.callback) {
      $scope.callback(response, 'Error Logging In.');
    }
  };
}

Ctrl.$inject = ['$scope', '$state', '$timeout', 'tl.auth.service', 'utilsService', 'loggerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(856);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'loginEmailDirectiveCtrl',
    scope: {
      config: '=',
      callback: '='
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $state, $timeout, authService, utilsService) {
  $scope.loginFbSubmitting = null;
  $scope.loginFbResult = null;
  $scope.loginFbBtnOptions = {
    buttonDefaultText: 'Sign up with Facebook',
    buttonSubmittingText: 'Logging in...',
    buttonSuccessText: 'Login successful',
    buttonErrorText: 'Error logging in',
    buttonDefaultIcon: 'fa fa-facebook-square',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonDefaultClass: 'btn-facebook',
    buttonSuccessClass: 'btn-success',
    buttonErrorClass: 'btn-danger'
  };

  $scope.facebook = function () {
    $scope.loginFbSubmitting = true;

    authService.loginWithFacebook(success, error);
  };

  var success = function success(response) {
    $scope.loginFbSubmitting = false;

    $scope.config.facebookLogin = true;

    $timeout(function () {
      $scope.loginFbResult = 'success';
      $scope.callback(response);
    }, 100);
  };

  var error = function error(response) {
    $scope.loginFbResult = 'error';
    $scope.facebookError = utilsService.errorMessage(response);
    $scope.callback(response, $scope.facebookError);
  };
}

Ctrl.$inject = ['$scope', '$state', '$timeout', 'tl.auth.service', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(857);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'loginFacebookDirectiveCtrl',
    scope: {
      config: '=',
      callback: '='
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, $stateParams, jsSdkUser, trackingService, partnerService) {
  $scope.citySlug = $stateParams.city || 'bos';

  var validMembershipPlans = ['bos', 'nyc', 'dc'];
  var user = jsSdkUser.getCurrentUser();

  $scope.showAd = function () {
    var isNotOnPartner = partnerService.partner && partnerService.partner.slug === 'www';
    var notPlatinum = user && user.membershipLevel ? user.membershipLevel < 25 : true;
    var validCity = validMembershipPlans.includes($scope.citySlug);

    return isNotOnPartner && notPlatinum && validCity;
  };

  $scope.goToMembership = function () {
    trackingService.trackEvent(_segmentEvents2.default.TappedFeaturedBanner);

    $state.go('app.membership.landing', {
      city: $scope.citySlug
    });
  };
}

Ctrl.$inject = ['$scope', '$state', '$stateParams', 'jsSdk.user', 'trackingService', 'partnerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(858);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      type: '='
    },
    template: _template2.default,
    controller: 'membershipCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function setElement(element, value) {
  var htmlEl = element[0];

  if (!htmlEl) return;

  var tagName = htmlEl.tagName;

  switch (tagName) {
    case 'META':
      element.attr('content', value);
      break;
    case 'TITLE':
      element.text(value);
      break;
    case 'LINK':
      element.attr('href', value);
      break;
    default:
      element.attr('content', value);
      break;
  }
}

function Directive(metaTagService) {
  return {
    restrict: 'EA',
    link: function link(scope, element, attrs) {
      var metaKey = attrs.metaKey;
      var metaTemplate = attrs.metaTemplate;

      if (!metaKey) return;

      var value = metaTagService.getKey(metaKey);

      if (value) {
        setElement(element, value);
      }

      metaTagService.subscribe('tagsChanged', scope, function () {
        var newValue = metaTagService.getKey(metaKey);

        if (metaTemplate) {
          newValue = metaTemplate.replace('@@', newValue);
        }

        setElement(element, newValue);
      });
    }
  };
}

Directive.$inject = ['metaTagService'];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('keydown', function (e) {
        if (e.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter, {
              e: e
            });
          });

          e.preventDefault();
        }
      });
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(69);

var _get3 = _interopRequireDefault(_get2);

var _find2 = __webpack_require__(43);

var _find3 = _interopRequireDefault(_find2);

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _last2 = __webpack_require__(1004);

var _last3 = _interopRequireDefault(_last2);

var _reject2 = __webpack_require__(111);

var _reject3 = _interopRequireDefault(_reject2);

var _paymentProfile = __webpack_require__(350);

var _paymentProfile2 = _interopRequireDefault(_paymentProfile);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PAYMENT_PROVIDER_TYPE = {
  BRAINTREE: 'BRAINTREE',
  STRIPE: 'STRIPE'
};

function Ctrl($window, $scope, $q, $rootScope, jsSdkSettings, jsSdkPaymentProfile, loggerService, $timeout, trackingService, utilsService, modalService) {
  $scope.paymentProvider = initialize();

  var lastSubmittedNonce = null;

  $scope.showPaymentProfilesList = false;

  $scope.showAddPayment = false;
  $scope.paymentProfiles = [];

  _loadPaymentProfiles();

  $scope.$on('login', function () {
    _loadPaymentProfiles();
  });

  $scope.deletePaymentProfile = function (paymentProfile, $event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    modalService.confirmation({
      modalMessage: 'Are you sure you want to delete this card?',
      confirmBtnTxt: 'Yes',
      confirmingBtnTxt: 'Deleting',
      cancelBtnTxt: 'No'
    }).then(function (result) {
      if (result && result.confirm) {
        $q.resolve(_paymentProfile2.default.deleteByIdAndUserId(paymentProfile.id, $rootScope.currentUser.id)).then(function () {
          $scope.paymentProfiles = (0, _reject3.default)($scope.paymentProfiles, {
            id: paymentProfile.id
          });

          if (paymentProfile.id === $scope.paymentProfile.id) {
            $scope.paymentProfile = null;

            if (!$scope.paymentProfiles.length) {
              $scope.addProfile();
            } else {
              _setDefaultPaymentProfile($scope.paymentProfiles[0]);
            }
          } else {
            $scope.setPaymentProfile(null);
          }
        }).then(function () {
          $rootScope.$emit('payment-profile-updated');

          result.modalInstance.close();
        }).catch(function (err) {
          $scope.errorMsg = err.message;

          result.modalInstance.close();
        });
      }
    });
  };

  $scope.hideAddPayment = function ($event) {
    if ($event) $event.preventDefault();

    $scope.showAddPayment = false;
  };

  function initialize() {
    return jsSdkSettings.paymentConfig().then(function (resp) {
      var type = resp.type,
          clientToken = resp.clientToken;


      var promise = void 0;

      switch (type) {
        case PAYMENT_PROVIDER_TYPE.STRIPE:
          promise = _initializeStripe(clientToken);
          break;
        default:
          promise = null;
      }

      return promise.then(function (client) {
        return {
          client: client,
          type: type
        };
      });
    });
  }

  function _initializeStripe(token) {
    $window.Stripe.setPublishableKey(token);

    return $q(function (resolve) {
      return resolve($window.Stripe.card);
    });
  }

  $scope.addNewCard = function (form, values) {
    $scope.saving = true;

    $scope.submitted = true;

    if (!form.$valid) {
      $scope.saving = false;

      return;
    }

    var providerType = void 0;

    $scope.paymentProvider.then(function (provider) {
      providerType = provider.type;
      return _createPaymentToken(provider, values);
    }).then(function (token) {
      return _addPaymentProfile(token, providerType);
    }).catch(function (err) {
      $scope.formErrors = ['Unable to save credit card.'];

      var errs = err.message ? [err] : (0, _get3.default)(err, 'details.originalError.fieldErrors["0"].fieldErrors');

      errs.forEach(function (error) {
        if (error && error.message) {
          $scope.formErrors.push(error.message);
        }
      });

      $scope.saving = false;
    });
  };

  $scope.selectProfile = function (selected) {
    setPaymentProfile(selected);

    _setDefaultPaymentProfile(selected);

    $scope.showPaymentProfilesList = false;
  };

  $scope.addProfile = function () {
    $scope.formErrors = [];
    $scope.showAddPayment = true;
  };

  $scope.showList = function ($event) {
    if ($event) $event.preventDefault();

    $scope.showPaymentProfilesList = true;
  };

  function _createPaymentToken(provider, values) {
    switch (provider.type) {
      case PAYMENT_PROVIDER_TYPE.BRAINTREE:
        return _createBraintreePaymentToken(provider.client, values);
      case PAYMENT_PROVIDER_TYPE.STRIPE:
        return _createStripePaymentToken(provider.client, values);
      default:
        return null;
    }
  }

  function _createBraintreePaymentToken(client, values) {
    var creditCard = {
      number: values.ccNumber,
      expirationDate: values.ccExpMonth + '/' + values.ccExpYear,
      cvv: values.ccCvc,
      billingAddress: {
        postalCode: values.postalCode
      }
    };

    var options = {
      endpoint: 'payment_methods/credit_cards',
      method: 'post',
      data: {
        creditCard: creditCard
      }
    };

    return $q(function (resolve, reject) {
      client.request(options, function (err, response) {
        if (err) return reject(err);

        var token = (0, _get3.default)(response, 'creditCards[0].nonce');

        return resolve(token);
      });
    });
  }

  function _createStripePaymentToken(client, values) {
    return $q(function (resolve, reject) {
      var options = {
        number: values.ccNumber,
        cvc: values.ccCvc,
        exp_month: values.ccExpMonth,
        exp_year: values.ccExpYear,
        address_zip: values.postalCode
      };

      client.createToken(options, function (status, response) {
        if (response.error) return reject(response.error);

        return resolve(response.id);
      });
    });
  }

  function setPaymentProfile(profile) {
    $scope.paymentProfile = profile;

    if ($scope.onChange) {
      $scope.onChange(profile);
    }
  }

  function _addPaymentProfile(nonce, providerType) {
    if (nonce === lastSubmittedNonce) {
      $scope.saving = false;

      $scope.formErrors.push('Unable to Save Card. Card already exists.');

      return null;
    }

    lastSubmittedNonce = nonce;

    return jsSdkPaymentProfile.createByNonceToken(nonce, {
      providerType: providerType
    }).then(function (resp) {
      return _setDefaultPaymentProfile(resp).then(function () {
        return resp;
      });
    }).then(function (resp) {
      setPaymentProfile(resp);

      $scope.paymentProfiles.push(resp);

      $scope.showAddPayment = false;

      $scope.saving = false;

      var trackingData = {
        cardType: resp.cardType,
        last4: resp.last4,
        paymentProfileId: resp.id
      };

      trackingService.trackEvent(_segmentEvents2.default.AddedCreditCard, trackingData);

      if ($scope.callback) {
        $scope.callback(resp);
      }
    }).catch(function (err) {
      var error = utilsService.errorMessage(err) || 'Error processing card';

      $scope.formErrors.push(error + ' - Please try again.');

      loggerService.error(err);

      $scope.saving = false;
    });
  }

  function _setDefaultPaymentProfile(paymentProfile) {
    $scope.saving = true;

    return jsSdkPaymentProfile.setDefault(paymentProfile.id).then(function () {
      $scope.saving = false;

      $scope.paymentProfile = paymentProfile;

      $rootScope.$emit('payment-profile-updated');
    }).catch(function (resp) {
      var msg = utilsService.errorMessage(resp);

      $scope.formErrors.push(msg);

      loggerService.error(resp);

      $scope.saving = false;
    });
  }

  function _loadPaymentProfiles() {
    $scope.loading = true;

    if (!$rootScope.isLoggedIn()) {
      $scope.loading = false;

      return;
    }

    $scope.paymentProvider.then(function (provider) {
      return jsSdkPaymentProfile.list({
        providerType: provider.type
      });
    }).then(function (resp) {
      $scope.loading = false;

      if (resp && resp.length) {
        setPaymentProfile(findDefaultPaymentProfile(resp));

        $scope.paymentProfiles = (0, _sortBy3.default)(resp, function (profile) {
          return profile.modified;
        }).reverse().slice(0, 4);
      } else {
        $scope.addProfile();
      }
    }).catch(function () {
      $scope.formErrors.push('Error loading Credit Card information. Please enter updated information.');

      $scope.loading = false;
    });
  }

  function findDefaultPaymentProfile(paymentProfiles) {
    var profile = (0, _find3.default)(paymentProfiles, {
      default: true
    });

    return profile || (0, _last3.default)(paymentProfiles);
  }
}

Ctrl.$inject = ['$window', '$scope', '$q', '$rootScope', 'jsSdk.settings', 'jsSdk.paymentProfile', 'loggerService', '$timeout', 'trackingService', 'utilsService', 'modalService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(859);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      paymentProfile: '=',
      onChange: '=',
      callback: '='
    },
    template: _template2.default,
    controller: 'paymentProfileCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'A',
    priority: 1,
    require: 'ngModel',
    link: function link(scope, element, attr, ngModelCtrl) {
      ngModelCtrl.$parsers.push(function (value) {
        if (value) {
          value = stripSymbols(value);
          parsePhoneNumber(value);
          return value;
        }

        return null;
      });

      ngModelCtrl.$formatters.push(function (value) {
        if (value) {
          value = stripSymbols(value);
          return parsePhoneNumber(value);
        }

        return null;
      });

      var stripSymbols = function stripSymbols(phoneNumber) {
        return phoneNumber.replace(/\D/g, '').trim();
      };

      var parsePhoneNumber = function parsePhoneNumber(phoneNumber) {
        var original = phoneNumber;

        if (original.length >= 4) {
          phoneNumber = '(' + phoneNumber.substring(0, 3) + ')' + phoneNumber.substring(3, phoneNumber.length);
        }
        if (original.length >= 4) {
          phoneNumber = phoneNumber.substring(0, 5) + ' ' + phoneNumber.substring(5, phoneNumber.length);
        }
        if (original.length >= 7) {
          phoneNumber = phoneNumber.substring(0, 9) + '-' + phoneNumber.substring(9, phoneNumber.length);
        }
        if (original.length >= 11) {
          phoneNumber = original;
        }

        ngModelCtrl.$viewValue = phoneNumber;
        ngModelCtrl.$render();

        return phoneNumber;
      };
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $state, utilsService, jsSdkConfig) {
  var banners = [];

  banners.push({
    src: 'cbs',
    message: 'Welcome Columbia Business School! You get to skip the application line. Your first month is free when you enter the code <strong>CBS</strong> at checkout.',
    link: {
      url: 'https://www.tablelist.com/membership/start?src=bsc',
      text: 'GET STARTED'
    }
  });

  banners.push({
    src: 'ivyholiday16',
    message: 'Welcome IVY Members! Skip the application line and receive Platinum Membership at $29/month. Enter <strong>IVYHOLIDAY29</strong> at checkout.',
    states: ['membership', 'membership.start'],
    link: {
      url: 'https://www.tablelist.com/membership/start?src=ivyholiday16',
      text: 'GET STARTED'
    }
  });

  var _subclient = jsSdkConfig.subClient || 'www';

  $scope.promo = _underscore2.default.find(banners, {
    src: _subclient
  });

  $scope.dismissed = false;

  $scope.showPromoBar = function () {
    if ($scope.dismissed) {
      return false;
    }

    if (_underscore2.default.isUndefined($scope.promo)) {
      return false;
    }

    if (!$scope.promo.states || $scope.promo.states.length < 1) {
      return true;
    }

    if ($scope.promo.states.length > 1) {
      return _underscore2.default.reduce($scope.promo.states, function (result, state) {
        return result || $state.includes(state);
      }, false);
    }

    return $state.includes('app.browse') || $state.includes('app.me') || $state.is('app.home');
  };
}

Ctrl.$inject = ['$scope', '$state', 'utilsService', 'jsSdk.config'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(860);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'promoBarCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<p class="read-more-text"></p>',
    scope: {
      text: '=',
      moreText: '@',
      lessText: '@',
      words: '@',
      ellipsis: '@',
      char: '@',
      limit: '@',
      content: '@'
    },
    link: function link(scope, elem, attr) {
      var moreText = '<a href="#" class="read-more">Read More...</a>';
      var lessText = '<a href="#" class="read-less">Read Less...</a>';

      var ellipsis = _angular2.default.isUndefined(scope.ellipsis) ? '' : scope.ellipsis;
      var limit = _angular2.default.isUndefined(scope.limit) ? 150 : parseInt(scope.limit, 10);

      scope.$watch('text', function (text) {
        if (!text) return;
        readmore(text);
      });

      function readmore(text) {
        if (!text) return;

        var orig = text;
        var regex = /\s+/gi;
        var charCount = text.length;
        var wordCount = text.trim().replace(regex, ' ').split(' ').length;
        var countBy = 'char';
        var count = charCount;
        var foundWords = [];
        var markup = text;
        var more = '';

        if (!_angular2.default.isUndefined(attr.words)) {
          countBy = 'words';
          count = wordCount;
        }

        if (countBy === 'words') {
          foundWords = text.split(/\s+/);

          if (foundWords.length > limit) {
            text = foundWords.slice(0, limit).join(' ') + ellipsis;
            more = foundWords.slice(limit, count).join(' ');
            markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
          }
        } else if (count > limit) {
          text = orig.slice(0, limit) + ellipsis;
          more = orig.slice(limit, count);
          markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
        }

        elem.append(markup);

        elem.find('.read-more').on('click', function () {
          (0, _jquery2.default)(this).hide();

          elem.find('.more-text').addClass('show').slideDown();
        });

        elem.find('.read-less').on('click', function () {
          elem.find('.read-more').show();
          elem.find('.more-text').hide().removeClass('show');
        });
      }
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($rootScope, $scope, jsSdkSettings, utilsService) {
  $scope.referralGetCredit = 25;
  $scope.referralGiveCredit = 25;

  $scope.currentUser = $rootScope.currentUser;

  var referralCode = $scope.currentUser && $scope.currentUser.referralCode ? $scope.currentUser.referralCode : '';

  $scope.shareBarConfig = {
    url: utilsService.createUrl('/invite/' + referralCode),
    message: 'Join @Tablelist with my promo code to get credit at your favorite clubs and lounges.'
  };

  jsSdkSettings.readConfig().then(function success(resp) {
    $scope.referralGetCredit = resp.referralGetCredit;
    $scope.referralGiveCredit = resp.referralGiveCredit;
    $scope.shareBarConfig.message = 'Join @Tablelist with my promo code to get $' + resp.referralGiveCredit + ' in credit at your favorite clubs and lounges.';
  });
}

Ctrl.$inject = ['$rootScope', '$scope', 'jsSdk.settings', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(861);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      booking: '='
    },
    template: _template2.default,
    controller: 'referralBlockCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(82);

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, utilsService, $sce) {
  $scope.richJson = function () {
    if (!$scope.event || !$scope.event.venue) return '';

    var event = $scope.event;

    var venue = event.venue;
    venue.location = venue.location || {};
    venue.location.address = venue.location.address || {};

    var json = {
      '@context': 'http://schema.org',
      '@type': 'Event',
      name: event.name,
      startDate: _moment2.default.utc(event.dateStart).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: _moment2.default.utc(event.dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
      url: utilsService.createUrl('/e/' + event.seoPathname),
      description: 'Buy tickets and tables to ' + event.name + ' at ' + venue.name,
      image: _lodash2.default.get(event, 'primaryImage.filename'),
      location: {
        '@type': 'Place',
        sameAs: utilsService.createUrl('/v/' + venue.seoPathname || venue.id),
        name: venue.name,
        address: venue.location.address.address + ', ' + venue.location.address.city + ', ' + venue.location.address.state + ' ' + venue.location.address.zip
      },

      offers: [{
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        price: 0,
        priceCurrency: venue.currencyCode,
        validFrom: _moment2.default.utc(event.dateStart).format('YYYY-MM-DDTHH:mm:ss'),
        url: utilsService.createUrl('/e/' + event.seoPathname)
      }]
    };

    if (event.performers && event.performers.length) {
      json.performer = event.performers.map(function (performer) {
        return {
          '@type': performer.group ? 'MusicGroup' : 'Person',
          name: performer.name,
          sameAs: performer.website
        };
      });
    }

    return $sce.trustAsHtml((0, _stringify2.default)(json, null, 2));
  };
}

Ctrl.$inject = ['$scope', 'utilsService', '$sce'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(862);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      event: '=',
      venue: '='
    },
    replace: true,
    template: _template2.default,
    controller: 'richEventCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(82);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, utilsService, $sce) {

  $scope.richJson = function () {
    if (!$scope.venue || !$scope.venue.id) return '';

    var venue = $scope.venue;


    var address = (venue.location ? venue.location.address : {}) || {};

    var json = {
      '@context': 'http://schema.org',
      '@type': 'NightClub',
      name: venue.name,
      url: utilsService.createUrl('/v/' + venue.seoPathname),
      image: venue.primaryImage ? venue.primaryImage.filename : null,
      address: address.address + ', ' + address.city + ', ' + address.state + ' ' + address.zip
    };

    return $sce.trustAsHtml((0, _stringify2.default)(json, null, 2));
  };
}

Ctrl.$inject = ['$scope', 'utilsService', '$sce'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(863);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      venue: '='
    },
    replace: true,
    template: _template2.default,
    controller: 'richVenueCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyBy2 = __webpack_require__(1002);

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _each2 = __webpack_require__(49);

var _each3 = _interopRequireDefault(_each2);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $state, $scope, jsSdkSearch, jsSdkCity, tracking, partnerService, $window) {
  var types = ['VENUE', 'EVENT', 'CURATED_LIST'];

  var cache = {};

  $scope.cities = {};
  $scope.input = '';

  jsSdkCity.list().then(function (resp) {
    $scope.cities = (0, _keyBy3.default)(resp, 'id');
  });

  $scope.clear = function () {
    $scope.fetching = false;
    $scope.input = null;
    $scope.pendingQuery = null;
    $scope.results = null;
    $scope.focus = 0;
  };

  $scope.hover = function (index) {
    $scope.focus = index;
  };

  $scope.select = function (result) {
    goTo(result);
  };

  $scope.search = function (value) {
    if (value.length < 1) {
      $scope.clear();
      return;
    }

    var options = {
      query: value,
      type: types,
      limit: 5
    };

    $scope.lastSearchQuery = value;

    var cacheKey = value.toLowerCase();

    $scope.pendingQuery = cacheKey;

    if (cache[cacheKey]) {
      $scope.results = cache[cacheKey];
      return;
    }

    $scope.fetching = true;

    jsSdkSearch.searchConsumer(options).then(function (resp) {
      var response = _flatten(resp);

      cache[cacheKey] = response;

      if ($scope.pendingQuery === cacheKey) {
        $scope.results = response;
      }

      $scope.fetching = false;
    }).catch(function () {
      $scope.fetching = false;
    });
  };

  $scope.keyup = function (event) {
    switch (event.keyCode) {
      case 38:
        $scope.focus -= 1;

        return null;
      case 40:
        $scope.focus += 1;

        return null;
      case 13:
        if (!$scope.results || $scope.results.length < 1) {
          return null;
        }
        var item = $scope.results[$scope.focus];

        if (item) {
          return $scope.select(item);
        }
        break;
      default:
        return null;
    }

    return null;
  };

  $rootScope.$on('$stateChangeStart', function () {
    $scope.clear();
  });

  function _flatten(results) {
    var array = [];

    (0, _each3.default)(types, function (type) {
      if (results[type].length <= 0) return;
      array = array.concat(results[type]);
    });

    return array;
  }

  function goTo(item) {
    var trackingData = {};

    trackingData.query = $scope.value;

    if (item.venue) {
      trackingData.type = 'venue';
      trackingData.name = item.name;

      if (_config2.default.NODE_ENV === 'production') {
        var fbqData = {
          search_string: $scope.lastSearchQuery,
          content_type: 'product',
          content_ids: [item.id],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'Search', fbqData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'Search', fbqData);
      }

      $state.go('app.venue', {
        seoPathname: item.venue.seoPathname || item.id
      });
    }

    if (item.event) {
      trackingData.type = 'event';
      trackingData.name = item.name;

      if (_config2.default.NODE_ENV === 'production') {
        var _fbqData = {
          search_string: $scope.lastSearchQuery,
          content_type: 'product',
          content_ids: [item.event.id],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'Search', _fbqData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'Search', _fbqData);
      }

      $state.go('app.event', {
        seoPathname: item.event.seoPathname || item.id
      });
    }

    if (item.curatedList) {
      trackingData.type = 'curatedList';
      trackingData.name = item.name;

      $state.go('app.curatedList', {
        id: item.id
      });
    }

    tracking.trackEvent(_segmentEvents2.default.SearchResultSelected, trackingData);

    $scope.clear();

    if ($scope.callback) {
      $scope.callback();
    }
  }

  $scope.clear();
}

Ctrl.$inject = ['$rootScope', '$state', '$scope', 'jsSdk.search', 'jsSdk.city', 'trackingService', 'partnerService', '$window'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(864);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    scope: {
      callback: '=',
      modal: '='
    },
    template: _template2.default,
    controller: 'searchDirectiveCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(865);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: _template2.default,
    scope: {
      inventory: '=',
      venue: '=',
      onBack: '='
    },
    controller: ['$scope', '$sce', '$rootScope', 'jsSdk.config', function ($scope, $sce, $rootScope, jsSdkConfig) {
      if (!$scope.inventory) throw new Error('inventory');
      if (!$scope.venue) throw new Error('venue');

      $scope.inventoryForm = {
        inventoryQuantity: 1
      };

      $scope.getBookingUrl = function () {
        var checkoutUrl = window.location.origin + '/buy';

        var quantity = $scope.inventoryForm.inventoryQuantity || 1;

        var url = checkoutUrl + '?inventory=' + $scope.inventory.id + '&quantity=' + quantity;

        if ($rootScope.affiliateId) {
          url += '&affiliateId=' + $rootScope.affiliateId;
        }

        if ($rootScope.trackingId) {
          url += '&trackingId=' + $rootScope.trackingId;
        }

        if (jsSdkConfig.attributionId) {
          url += '&attributionId=' + jsSdkConfig.attributionId;
        }

        url += '&client=web';

        $scope.bookingUrl = $sce.trustAsResourceUrl(url);
      };

      $scope.inventoryDescription = $sce.trustAsHtml($scope.inventory.description);

      $scope.getTicketSelectorQuantity = function () {
        if (!$scope.inventory) return [];

        var min = $scope.inventory.quantityMin || 0;
        var max = $scope.inventory.quantityMax || 10;

        var quantities = [];

        for (var i = min; i <= max; i++) {
          quantities.push(i);
        }

        return quantities;
      };

      $scope.back = function ($event) {
        if ($event) $event.preventDefault();

        if ($scope.onBack) {
          $scope.onBack();
        }
      };

      $scope.bookingFormSubmitted = function () {
        $scope.submittingBookingForm = true;
      };

      $scope.getBookingUrl();
    }]
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, utilsService) {
  var defaultURL = utilsService.createUrl('/');

  initialize();

  $scope.$watch('config', function (config) {
    if (!config) return;

    var url = config.url || defaultURL;
    var msg = config.message || url;

    initialize(url, msg);
  });

  function initialize(url, message) {
    $scope.url = url || defaultURL;

    var msg = message || $scope.url;

    $scope.facebookLink = utilsService.facebookLink($scope.url);
    $scope.twitterLink = utilsService.twitterLink($scope.url, msg);
    $scope.emailLink = utilsService.mailtoLink($scope.url, msg);
  }
}

Ctrl.$inject = ['$scope', 'utilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(866);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      config: '='
    },
    template: _template2.default,
    controller: 'shareBarCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'A',
    scope: {
      slideDown: '='
    },
    link: function link(scope, element) {
      element.hide();

      scope.$watch('slideDown', function (val) {
        if (val === true) {
          element.slideDown();
        } else {
          element.slideUp();
        }
      });
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope) {
  $scope.appId = function () {
    return '634444177';
  };

  $scope.appArgument = function () {
    return window.location.href;
  };
}

Ctrl.$inject = ['$scope'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _template = __webpack_require__(867);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    replace: true,
    scope: {
      config: '='
    },
    controller: 'smartBannerCtrl'
  };
}

Directive.$inject = [];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $http, tracking) {
  $scope.isSending = null;
  $scope.sendResult = null;
  $scope.buttonOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'SEND',
    buttonSubmittingText: ' ',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: ' ',
    buttonSuccessClass: 'btn-success',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error',
    buttonErrorClass: 'btn-danger'
  };

  $scope.resetForm = function () {
    $scope.phone = null;
    $scope.form.$setPristine();
    $scope.submitted = false;
  };

  $scope.sendSMS = function (form) {
    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.isSending = true;
    $scope.sendResult = null;

    var phone = $scope.phone;

    $http.post('/sms/appLink/', {
      phone: phone
    }).then(function success(response) {
      $scope.errorMsg = null;
      $scope.resetForm();

      $scope.sendResult = 'success';
      $scope.isSending = false;

      $scope.successMsg = response.message;

      tracking.trackEvent(_segmentEvents2.default.RequestedSMSDownloadLink, {
        phone: phone
      });
    }, function error() {

      $scope.successMsg = null;
      $scope.errorMsg = 'Sorry unable to send SMS to number.';
      $scope.resetForm();

      $scope.sendResult = 'error';
      $scope.isSending = false;
    });
  };

  $scope.closeAlert = function () {
    $scope.errorMsg = null;
  };
}

Ctrl.$inject = ['$rootScope', '$scope', 'jsSdk.http', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(868);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    template: _template2.default,
    controller: 'smsDownloadLinkCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive($compile, $timeout, $location, $sce) {
  return {
    restrict: 'E',
    scope: {
      src: '=',
      player: '=',
      height: '@',
      width: '@'
    },
    link: function link(scope, element) {

      if (!scope.src) return;

      var options = '&auto_play=false&buying=false&liking=false&download=false&sharing=false&show_artwork=false&show_comments=false&show_playcount=false';

      scope.src = scope.src && scope.src.$$unwrapTrustedValue ? scope.src.$$unwrapTrustedValue() : scope.src;

      scope.src = $sce.trustAsResourceUrl($location.protocol() + '://w.soundcloud.com/player/?url=' + scope.src + options);

      scope.height = scope.height || '450px';
      scope.width = scope.width || '100%';

      var templateElement = '<iframe width="{{ width }}" height="{{ height }}" scrolling="no" ng-src="{{ src }}" frameborder="no"></iframe>';
      var compiledElement = $compile(templateElement)(scope);

      element.replaceWith(compiledElement);

      var widgetElement = compiledElement[0];

      $timeout(function () {
        scope.player = window.SC.Widget(widgetElement);
        scope.player.EVENTS = window.SC.Widget.Events;

        scope.player.on = function (eventName, eventHandler) {
          var newEventHandler = function newEventHandler() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            scope.$apply(function () {
              eventHandler.call(scope.player, args);
            });
          };

          scope.player.bind.call(scope.player, eventName, newEventHandler);
        };

        scope.player.bind(window.SC.Widget.Events.READY, function () {
          scope.$emit('SOUNDCLOUD_READY');
          scope.player.ready = true;
        });

        scope.player.bind(window.SC.Widget.Events.PLAY, function () {
          scope.$apply(function () {
            scope.player.playing = true;
          });
        });

        scope.player.bind(window.SC.Widget.Events.PAUSE, function () {
          scope.$apply(function () {
            scope.player.playing = false;
          });
        });
      }, 2000);
    }
  };
}

Directive.$inject = ['$compile', '$timeout', '$location', '$sce'];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, imgix, loggerService, favoritesService, tracking) {
  if ($scope.placeholder) {
    return;
  }

  $scope.$watch('venue', function (venue) {
    if (!venue || !venue.tags) return;

    $scope.venue.type = _underscore2.default.find(venue.tags, function (tag) {
      return tag.key === 'VENUE_TYPE';
    });

    $scope.venue.subtype = _underscore2.default.find(venue.tags, function (tag) {
      return tag.key === 'VENUE_SUB_TYPE';
    });
  });

  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  if ($scope.venue && $scope.venue.id) {
    favoritesService.isFavorite(favoritesService.TYPES.VENUE, $scope.venue.id).then(function (favorited) {
      $scope.isFavorited = favorited;
      $scope.disableFavoriting = false;
    }).catch(function (err) {
      loggerService.error(err);
    });
  }

  $scope.imgix = function (src) {
    var options = {
      width: 360,
      height: 280
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.favoriteVenue = function (venue) {
    $scope.disableFavoriting = true;

    var func = $scope.isFavorited ? favoritesService.removeFavorite : favoritesService.addFavorite;
    var increment = $scope.isFavorited ? -1 : 1;

    func(favoritesService.TYPES.VENUE, venue.id).then(function () {
      venue.favoriteCount += increment;
      $scope.isFavorited = !$scope.isFavorited;

      var event = $scope.isFavorited ? _segmentEvents2.default.FavoritedVenue : _segmentEvents2.default.UnfavoritedVenue;

      tracking.trackEvent(event, {
        venueId: $scope.venue.id,
        venueName: $scope.venue.name
      });
    }).catch(function (err) {
      loggerService.error(err);
    }).finally(function () {
      $scope.disableFavoriting = false;
    });
  };
}

Ctrl.$inject = ['$scope', 'jsSdk.imgix', 'loggerService', 'favoritesService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = __webpack_require__(869);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      venue: '=',
      placeholder: '='
    },
    template: _template2.default,
    controller: 'venueCardCtrl'
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope) {
  $scope.$watch('ratingAverage', function () {
    generateStars();
  });

  function generateStars() {
    if (!$scope.ratingAverage) return;

    $scope.stars = [];

    $scope.ratingAverage = parseFloat($scope.ratingAverage);

    var numPart = $scope.ratingAverage % 1;
    var numWhole = $scope.ratingAverage - numPart;
    numPart = numPart.toFixed(2);

    for (var i = 1; i <= numWhole; i++) {
      $scope.stars.push({
        icon: 'fa fa-star'
      });
    }

    if (numPart && numPart >= 0.5) {
      $scope.stars.push({
        icon: 'fa fa-star-half-full'
      });
    }

    var emptyStars = 5 - $scope.stars.length;

    for (var _i = 1; _i <= emptyStars; _i++) {
      $scope.stars.push({
        icon: 'fa fa-star-o'
      });
    }
  }
}

Ctrl.$inject = ['$scope'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: '<span class="{{ star.icon }}" ng-repeat="star in stars"></span>',
    scope: {
      ratingAverage: '='
    },
    controller: 'venueRatingCtrl',
    priority: 20
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Directive() {
  return {
    restrict: 'E',
    template: '<div class="venue-type">\n      <span>{{:: venue.type }}</span>\n      <span ng-show="venue.subtype"> | {{:: venue.subtype }}</span>\n      <span ng-show="venue.location.neighborhood"> in {{:: venue.location.neighborhood }}</span>\n    </div>',
    replace: true,
    scope: {
      venue: '='
    }
  };
}

Directive.$inject = [];

exports.default = Directive;
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (num) {
    if (num === undefined || num === null || num === false) return 0;

    return num.toFixed(2);
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports["default"];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truncateStringFilter = __webpack_require__(500);

var _truncateStringFilter2 = _interopRequireDefault(_truncateStringFilter);

var _localizeFilter = __webpack_require__(495);

var _localizeFilter2 = _interopRequireDefault(_localizeFilter);

var _decimalFilter = __webpack_require__(492);

var _decimalFilter2 = _interopRequireDefault(_decimalFilter);

var _phoneNumberFilter = __webpack_require__(498);

var _phoneNumberFilter2 = _interopRequireDefault(_phoneNumberFilter);

var _utcFilter = __webpack_require__(501);

var _utcFilter2 = _interopRequireDefault(_utcFilter);

var _momentFilter = __webpack_require__(496);

var _momentFilter2 = _interopRequireDefault(_momentFilter);

var _venueCurrencyFilter = __webpack_require__(502);

var _venueCurrencyFilter2 = _interopRequireDefault(_venueCurrencyFilter);

var _limitFilter = __webpack_require__(494);

var _limitFilter2 = _interopRequireDefault(_limitFilter);

var _percentageFilter = __webpack_require__(497);

var _percentageFilter2 = _interopRequireDefault(_percentageFilter);

var _tlCurrencyFilter = __webpack_require__(499);

var _tlCurrencyFilter2 = _interopRequireDefault(_tlCurrencyFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  app.filter('truncateString', _truncateStringFilter2.default);
  app.filter('localize', _localizeFilter2.default);
  app.filter('decimal', _decimalFilter2.default);
  app.filter('phoneNumber', _phoneNumberFilter2.default);
  app.filter('utc', _utcFilter2.default);
  app.filter('moment', _momentFilter2.default);
  app.filter('venueCurrency', _venueCurrencyFilter2.default);
  app.filter('limit', _limitFilter2.default);
  app.filter('percentage', _percentageFilter2.default);
  app.filter('tlCurrency', _tlCurrencyFilter2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (value, wordwise, max, tail) {
    if (!value) return '';

    max = parseInt(max, 10);

    if (!max) return value;

    if (value.length <= max) return value;

    value = value.substr(0, max);

    if (wordwise) {
      var lastspace = value.lastIndexOf(' ');

      if (lastspace !== -1) {
        value = value.substr(0, lastspace);
      }
    }

    return value + (tail || ' …');
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Filter() {
  return function (date) {
    if (_angular2.default.isNumber(date) || typeof date === 'string') {
      date = new Date(Number(date));
    }

    if (!date) return null;

    var offset = new Date().getTimezoneOffset();

    var time = date.getTime() + offset * 60 * 1000;

    return new Date(time);
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (moment, format) {
    if (!moment || !moment.format) return moment;

    return moment.format(format);
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports["default"];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (input) {
    if (!input) return null;

    var numString = input.toString();
    var length = numString.substring(numString.indexOf('.') + 1).length;

    var precision = length < 2 ? 0 : length - 2;

    if (numString.indexOf('.') === -1) {
      precision = 0;
    }

    var final = (input * 100).toFixed(precision) + '%';

    return final;
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (phone) {
    if (!phone) {
      return '';
    }

    phone = phone.replace(/[^\d]/g, '');

    return '(' + phone.substring(0, 3) + ')' + ' ' + phone.substring(3, 6) + '-' + phone.substring(6);
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (amount, currencySymbol) {

    if (!amount) {
      return currencySymbol + "0";
    }

    amount = parseFloat(amount);

    if (amount % 1 === 0) {
      amount = amount.toFixed(0);
    } else {
      amount = amount.toFixed(2);
    }

    return currencySymbol + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports["default"];

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter(utilsService) {
  return function (message, length) {
    return utilsService.truncateString(message, length);
  };
}

Filter.$inject = ['utilsService'];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Filter() {
  return function (date) {
    if (date) {
      if (_angular2.default.isNumber(date) || typeof date === 'string') {
        date = new Date(date);
      }
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    return null;
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Filter() {
  return function (value) {
    var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    var languageCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';


    var formatter = new Intl.NumberFormat(languageCode, {
      style: 'currency',
      currency: currencyCode
    });

    return formatter.format(value);
  };
}

Filter.$inject = [];

exports.default = Filter;
module.exports = exports['default'];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(552);

var _assign2 = _interopRequireDefault(_assign);

var _jsCookie = __webpack_require__(889);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _isNumber2 = __webpack_require__(1000);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isBoolean2 = __webpack_require__(998);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _cookieOptions = __webpack_require__(399);

var _cookieOptions2 = _interopRequireDefault(_cookieOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCAL_STORAGE = 'localStorage';
var SESSION_STORAGE = 'sessionStorage';
var IN_MEMORY = {};
var STUB_STORAGE = {
  getItem: function getItem() {},
  setItem: function setItem() {},
  removeItem: function removeItem() {}
};

function getStorageByType(type) {
  var storage = void 0;

  try {
    if (type === LOCAL_STORAGE) storage = localStorage;
    if (type === SESSION_STORAGE) storage = sessionStorage;
  } catch (e) {
    console.log('error accessing storage', e);
  }

  return storage || STUB_STORAGE;
}

function _setItem(type, key, val) {
  var storage = getStorageByType(type);

  try {
    storage.setItem(key, val);
  } catch (e) {
    console.log('localStorage setItem error', e);
  }
}

function _getItem(type, key) {
  var storage = getStorageByType(type);

  var storedVal = void 0;

  try {
    storedVal = storage.getItem(key);
  } catch (e) {
    console.log('localStorage getItem error', e);
  }

  return storedVal;
}

function _removeItem(type, key) {
  var storage = getStorageByType(type);

  try {
    storage.removeItem(key);
  } catch (e) {
    console.log('localStorage removeItem error', e);
  }
}

exports.default = {
  getItem: function getItem(key) {
    if (!key) throw new Error('key');

    return _jsCookie2.default.get(key) || _getItem(LOCAL_STORAGE, key) || _getItem(SESSION_STORAGE, key) || IN_MEMORY[key];
  },
  setItem: function setItem(key, val, options) {
    if (!key) throw new Error('key');

    options = options || {};

    if (!(0, _isBoolean3.default)(options.cookie)) {
      options.cookie = true;
    }

    var cookieOptions = {};

    if ((0, _isNumber3.default)(options.expires)) {
      cookieOptions.expires = options.expires;
    }

    if ((0, _isBoolean3.default)(options.session)) {
      cookieOptions.session = options.session;
    }

    _jsCookie2.default.set(key, val, (0, _assign2.default)(_cookieOptions2.default, cookieOptions));

    _setItem(LOCAL_STORAGE, key, val);
  },
  removeItem: function removeItem(key) {
    if (!key) throw new Error('key');

    _jsCookie2.default.remove(key, _cookieOptions2.default);

    _removeItem(LOCAL_STORAGE, key);

    delete IN_MEMORY[key];
  }
};
module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

var _helper = __webpack_require__(112);

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RootScopeGlobals($rootScope, $state, $stateParams, $location, tlSettingsService, regexService, tlQuery, partnerService, tlUserService, utilsService, tlAuthService, imgixService, jsSdkAuthService, tlTrackService, jsSdkConfig, jsSdkKeychain, tlKeychain, jsSdkUserService, tlEventEmitter, trackingService, fraudService) {
  (0, _jquery2.default)('body').on('touchstart.dropdown', '.dropdown-menu', function (e) {
    e.stopPropagation();
  });

  jsSdkSync();

  tlEventEmitter.on(tlUserService.EVENTS().USER_UPDATED, function () {
    jsSdkSync();

    $rootScope.currentUser = tlUserService.currentUser();

    if ($rootScope.currentUser && utilsService.isNewUser($rootScope.currentUser)) {
      trackingService.trackEvent(_segmentEvents2.default.SignedUp);
    }

    fraudService.setUser($rootScope.currentUser);
  });

  if ($rootScope.affiliateId) {
    tlTrackService.setAffiliate($rootScope.affiliateId);
  }

  jsSdkConfig.setApiKey(_config2.default.TL_API_KEY);

  if (tlQuery.get('attributionId')) {
    jsSdkConfig.setAttributionId(tlQuery.get('attributionId'));
  }

  if (tlQuery.get('attributionType')) {
    jsSdkConfig.setAttributionType(tlQuery.get('attributionType'));
  }

  if (tlQuery.get('auth')) {
    var auth = tlQuery.get('auth');

    _helper2.default.setAuthToken(auth);

    jsSdkKeychain.setConsumerAuthToken(auth);
    tlKeychain.setAuthToken(auth);
  } else if (tlQuery.get('prospect')) {
    var prospect = tlQuery.get('prospect');

    _helper2.default.setProspectToken(prospect);

    jsSdkKeychain.setPropsectToken(prospect);
    tlKeychain.setProspectToken(prospect);
  }

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.currentDate = new Date();
  $rootScope.config = tlSettingsService.config();
  $rootScope.regexes = regexService;
  $rootScope.fullpage = $location.search() ? $location.search().fullpage === 'true' : false;
  $rootScope.affiliateId = tlQuery.get('affiliateId') || tlQuery.get('affiliate') || null;
  $rootScope.trackingId = tlQuery.get('trackingId') || tlQuery.get('tracking') || null;
  $rootScope.partner = partnerService.partner;
  $rootScope.browseVenues = function () {
    $state.go('app.browse.venues', {
      city: utilsService.defaultCitySlug()
    });
  };
  $rootScope.browseCity = function () {
    $state.go('app.browse.city', {
      city: utilsService.defaultCitySlug()
    });
  };
  $rootScope.showConcierge = function () {
    return partnerService.partner && partnerService.partner.default;
  };
  $rootScope.currentUserImageUrl = function (size) {
    if (!$rootScope.currentUser || !$rootScope.currentUser.imageUrl) return null;

    return imgixService.url($rootScope.currentUser.imageUrl, {
      width: size || 100,
      height: size || 100
    });
  };
  $rootScope.isLoggedIn = function () {
    return jsSdkAuthService.isLoggedIn();
  };
  $rootScope.logout = function () {
    jsSdkAuthService.logout();
    tlAuthService.logout();
    _helper2.default.removeAuthToken();

    $rootScope.$broadcast('logout');

    $state.go('app.home');
  };

  function jsSdkSync() {
    var authToken = tlAuthService.authToken();
    var prospectToken = tlKeychain.prospectToken();
    var user = tlUserService.currentUser();

    if (authToken) {
      jsSdkKeychain.setConsumerAuthToken(authToken);
    }

    if (prospectToken) {
      jsSdkKeychain.setPropsectToken(prospectToken);
    } else {
      jsSdkKeychain.removeProspectToken();
    }

    if (user) {
      jsSdkUserService.setCurrentUser(user);
    } else {
      jsSdkUserService.removeCurrentUser();
    }
  }
}

RootScopeGlobals.$inject = ['$rootScope', '$state', '$stateParams', '$location', 'tl.settings.service', 'regexService', 'tl.query', 'partnerService', 'tl.user.service', 'utilsService', 'tl.auth.service', 'jsSdk.imgix', 'jsSdk.auth', 'tl.track.service', 'jsSdk.config', 'jsSdk.keychain', 'tl.keychain', 'jsSdk.user', 'tl.ee', 'trackingService', 'fraudService'];

exports.default = RootScopeGlobals;
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(803);

var _app2 = _interopRequireDefault(_app);

var _home = __webpack_require__(819);

var _home2 = _interopRequireDefault(_home);

var _search = __webpack_require__(824);

var _search2 = _interopRequireDefault(_search);

var _about = __webpack_require__(794);

var _about2 = _interopRequireDefault(_about);

var _concierge = __webpack_require__(809);

var _concierge2 = _interopRequireDefault(_concierge);

var _faq = __webpack_require__(817);

var _faq2 = _interopRequireDefault(_faq);

var _tableservice = __webpack_require__(826);

var _tableservice2 = _interopRequireDefault(_tableservice);

var _legal = __webpack_require__(820);

var _legal2 = _interopRequireDefault(_legal);

var _privacy = __webpack_require__(821);

var _privacy2 = _interopRequireDefault(_privacy);

var _browse = __webpack_require__(804);

var _browse2 = _interopRequireDefault(_browse);

var _browseCity = __webpack_require__(805);

var _browseCity2 = _interopRequireDefault(_browseCity);

var _browseEvents = __webpack_require__(806);

var _browseEvents2 = _interopRequireDefault(_browseEvents);

var _browseVenues = __webpack_require__(807);

var _browseVenues2 = _interopRequireDefault(_browseVenues);

var _curatedList = __webpack_require__(810);

var _curatedList2 = _interopRequireDefault(_curatedList);

var _curatedListsHalloween = __webpack_require__(811);

var _curatedListsHalloween2 = _interopRequireDefault(_curatedListsHalloween);

var _curatedListsNewYears = __webpack_require__(812);

var _curatedListsNewYears2 = _interopRequireDefault(_curatedListsNewYears);

var _account = __webpack_require__(795);

var _account2 = _interopRequireDefault(_account);

var _accountProfile = __webpack_require__(798);

var _accountProfile2 = _interopRequireDefault(_accountProfile);

var _accountBooking = __webpack_require__(796);

var _accountBooking2 = _interopRequireDefault(_accountBooking);

var _accountFavorites = __webpack_require__(797);

var _accountFavorites2 = _interopRequireDefault(_accountFavorites);

var _accountTickets = __webpack_require__(802);

var _accountTickets2 = _interopRequireDefault(_accountTickets);

var _accountReviews = __webpack_require__(801);

var _accountReviews2 = _interopRequireDefault(_accountReviews);

var _accountReview = __webpack_require__(800);

var _accountReview2 = _interopRequireDefault(_accountReview);

var _accountPromo = __webpack_require__(799);

var _accountPromo2 = _interopRequireDefault(_accountPromo);

var _venue = __webpack_require__(828);

var _venue2 = _interopRequireDefault(_venue);

var _venueEvents = __webpack_require__(829);

var _venueEvents2 = _interopRequireDefault(_venueEvents);

var _venueInfo = __webpack_require__(830);

var _venueInfo2 = _interopRequireDefault(_venueInfo);

var _event = __webpack_require__(816);

var _event2 = _interopRequireDefault(_event);

var _checkout = __webpack_require__(808);

var _checkout2 = _interopRequireDefault(_checkout);

var _receipt = __webpack_require__(822);

var _receipt2 = _interopRequireDefault(_receipt);

var _signup = __webpack_require__(825);

var _signup2 = _interopRequireDefault(_signup);

var _errorNotFound = __webpack_require__(814);

var _errorNotFound2 = _interopRequireDefault(_errorNotFound);

var _errorServer = __webpack_require__(815);

var _errorServer2 = _interopRequireDefault(_errorServer);

var _download = __webpack_require__(813);

var _download2 = _interopRequireDefault(_download);

var _forgotPassword = __webpack_require__(818);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _resetPassword = __webpack_require__(823);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _terms = __webpack_require__(827);

var _terms2 = _interopRequireDefault(_terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureRoutes($stateProvider) {
  $stateProvider.state('app', {
    url: '',
    controller: 'appCtrl',
    template: _app2.default,
    resolve: {
      currentUser: ['jsSdk.user', 'jsSdk.auth', '$q', function (userService, authService, $q) {
        if (!authService.isLoggedIn()) {
          return $q.resolve(null);
        }

        return userService.me();
      }]
    }
  }).state('app.home', {
    url: '/',
    template: _home2.default,
    controller: 'homeCtrl'
  }).state('app.search', {
    url: '/search?cityId&guestsMin&guestsMax&date&priceMin&priceMax',
    template: _search2.default,
    controller: 'searchCtrl'
  }).state('app.about', {
    url: '/about',
    template: _about2.default,
    controller: 'aboutCtrl'
  }).state('app.concierge', {
    url: '/concierge',
    template: _concierge2.default,
    controller: 'conciergeCtrl'
  }).state('app.faq', {
    url: '/faq',
    template: _faq2.default,
    controller: 'faqCtrl'
  }).state('app.tableservice', {
    url: '/bottleservice101',
    template: _tableservice2.default,
    controller: 'tableserviceCtrl'
  }).state('app.legal', {
    template: _legal2.default
  }).state('app.legal.privacy', {
    url: '/legal/privacy',
    template: _privacy2.default
  }).state('app.browse', {
    abstract: true,
    template: _browse2.default,
    controller: 'browseCtrl'
  }).state('app.browse.city', {
    url: '/:city/discover/',
    template: _browseCity2.default,
    controller: 'browseCityCtrl'
  }).state('app.browse.events', {
    url: '/:city/events/:tag?date',
    template: _browseEvents2.default,
    controller: 'browseEventsCtrl'
  }).state('app.browse.venues', {
    url: '/:city/venues/?date&sort',
    template: _browseVenues2.default,
    controller: 'browseVenuesCtrl'
  }).state('app.curatedList', {
    url: '/list/:id',
    template: _curatedList2.default,
    controller: 'curatedListCtrl'
  }).state('app.curatedListWithCityHalloween', {
    url: '/halloween/:city',
    template: _curatedListsHalloween2.default,
    controller: 'curatedListHalloweenCtrl',
    reloadOnSearch: false
  }).state('app.curatedListWithCityNewYears', {
    url: '/newyears/:city',
    template: _curatedListsNewYears2.default,
    controller: 'curatedListsNewYearsCtrl',
    reloadOnSearch: false
  }).state('app.me', {
    abstract: true,
    template: _account2.default,
    controller: 'accountCtrl',
    authenticate: true
  }).state('app.me.profile', {
    url: '/profile/:action?section&pastDue',
    template: _accountProfile2.default,
    controller: 'accountProfileCtrl',
    authenticate: true
  }).state('app.me.bookings', {
    url: '/booking',
    template: _accountBooking2.default,
    controller: 'accountBookingCtrl',
    authenticate: true
  }).state('app.me.favorites', {
    url: '/favorites',
    template: _accountFavorites2.default,
    controller: 'accountFavoritesCtrl',
    authenticate: true
  }).state('app.me.tickets', {
    url: '/tickets',
    template: _accountTickets2.default,
    controller: 'accountTicketsCtrl',
    authenticate: true
  }).state('app.me.reviews', {
    url: '/reviews',
    template: _accountReviews2.default,
    controller: 'accountReviewsCtrl',
    authenticate: true
  }).state('app.me.review', {
    url: '/review/:reviewId',
    template: _accountReview2.default,
    controller: 'accountReviewCtrl',
    authenticate: true
  }).state('app.me.promo', {
    url: '/promo',
    template: _accountPromo2.default,
    controller: 'accountPromoCtrl',
    authenticate: true
  }).state('app.me.promos', {
    url: '/promo/:code',
    template: _accountPromo2.default,
    controller: 'accountPromoCtrl',
    authenticate: true
  }).state('app.venue', {
    url: '/v/:seoPathname?book&back&backName',
    template: _venue2.default,
    controller: 'venueCtrl'
  }).state('app.venueOld', {
    url: '/venues/:name?book',
    template: _venue2.default,
    controller: 'venueCtrl'
  }).state('app.venue.events', {
    url: '/events',
    template: _venueEvents2.default,
    controller: 'venueEventsCtrl'
  }).state('app.venueOld.events', {
    url: '/events',
    template: _venueEvents2.default,
    controller: 'venueEventsCtrl'
  }).state('app.venue.info', {
    url: '/:page',
    template: _venueInfo2.default,
    controller: 'venueInfoCtrl'
  }).state('venueOld.info', {
    url: '/:page',
    template: _venueInfo2.default,
    controller: 'venueInfoCtrl'
  }).state('app.eventOld', {
    url: '/event/:eventId?book',
    template: _event2.default,
    controller: 'eventCtrl'
  }).state('app.event', {
    url: '/e/:seoPathname?book&back&backName',
    template: _event2.default,
    controller: 'eventCtrl'
  }).state('app.checkout', {
    url: '/checkout/:bookingId?theme',
    template: _checkout2.default,
    controller: 'checkoutCtrl'
  }).state('app.checkout-widget', {
    url: '/checkout-widget/:bookingId?theme',
    template: _checkout2.default,
    controller: 'checkoutCtrl'
  }).state('app.receipt', {
    url: '/booking/:booking?isNew',
    template: _receipt2.default,
    controller: 'receiptCtrl',
    authenticate: true
  }).state('app.signup', {
    url: '/signup/:code?redirectState&redirectParams',
    template: _signup2.default,
    controller: 'signupCtrl'
  }).state('app.login', {
    url: '/login?redirectState&redirectParams&redirectUrl',
    template: _signup2.default,
    controller: 'signupCtrl'
  }).state('app.logout', {
    url: '/logout',
    controller: ['$rootScope', function ($rootScope) {
      $rootScope.logout();
    }]
  }).state('app.404', {
    url: '/404?target&message',
    params: {
      message: null
    },
    template: _errorNotFound2.default,
    controller: 'errorNotFoundCtrl'
  }).state('app.400', {
    url: '/400?message',
    params: {
      message: null
    },
    template: _errorServer2.default,
    controller: 'errorServerCtrl'
  }).state('app.download', {
    url: '/download',
    template: _download2.default,
    controller: 'downloadCtrl'
  }).state('app.forgot-password', {
    url: '/forgot-password',
    template: _forgotPassword2.default,
    controller: 'forgotPasswordCtrl'
  }).state('app.reset-password', {
    url: '/reset-password/:resetToken',
    template: _resetPassword2.default,
    controller: 'resetPasswordCtrl'
  }).state('app.terms', {
    url: '/terms',
    template: _terms2.default,
    controller: ['$scope', 'metaTagService', function ($scope, metaTagService) {
      metaTagService.set({
        title: 'Terms of Use | Tablelist',
        description: 'These terms of use apply to any and all use of the Tablelist website, applications, services, features, content, and tools.'
      });
    }]
  });
}

function RouterConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  if (window.history && window.history.pushState) {
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
  }

  $urlRouterProvider.when('', '/');

  $urlRouterProvider.otherwise(function ($injector, $location) {
    var path = '/404';

    if ($location && $location.$$absUrl) {
      path += '?target=' + $location.$$absUrl;
    }

    return path;
  });

  configureRoutes($stateProvider);

  $urlRouterProvider.when('/:city/events?date', '/:city/events/?date');
  $urlRouterProvider.when('/:city/venues?date&sort', '/:city/venues/?date&sort');
  $urlRouterProvider.when('/events', '/venue');
  $urlRouterProvider.when('/event', '/venue');
  $urlRouterProvider.when('/venue/:id?book', '/venues/:id?book');
  $urlRouterProvider.when('/profile', '/profile/');
  $urlRouterProvider.when('/share', '/dashboard');
  $urlRouterProvider.when('/membership/:id', '/membership');
  $urlRouterProvider.when('/membership/:id/start', '/membership/start');
  $urlRouterProvider.when('/membership/my-membership', '/membership/perks');
  $urlRouterProvider.when('/login/', '/login');
  $urlRouterProvider.when('/signup', '/signup/');
  $urlRouterProvider.when('/invite', '/signup/');
  $urlRouterProvider.when('/invite/:code?redirectState&redirectParams', '/signup/:code?redirectState&redirectParams');
  $urlRouterProvider.when('/support', '/faq');
  $urlRouterProvider.when('/book', '/venue');
  $urlRouterProvider.when('/city', '/venue');
  $urlRouterProvider.when('/bookings', '/booking');
  $urlRouterProvider.when('/account', '/me');


  $urlRouterProvider.when('/home', '/');
  $urlRouterProvider.when('/appstore', '/download');
  $urlRouterProvider.when('/events', '/download');
  $urlRouterProvider.when('/event', '/download');
  $urlRouterProvider.when('/reward', '/download');
  $urlRouterProvider.when('/rewards', '/download');
  $urlRouterProvider.when('/tableservice', '/bottleservice101');
  $urlRouterProvider.when('/company', '/about');
  $urlRouterProvider.when('/legal', '/legal/privacy');

  $urlRouterProvider.when('/newyears', '/newyears/').when('/halloween', '/halloween/');
}

RouterConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

exports.default = RouterConfig;
module.exports = exports['default'];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = bookingHelperService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

bookingHelperService.$inject = ['$rootScope', 'jsSdk.keychain'];

function bookingHelperService($rootScope, jsSdkKeychain) {
  var BookingHelperService = function () {
    function BookingHelperService() {
      (0, _classCallCheck3.default)(this, BookingHelperService);
    }

    (0, _createClass3.default)(BookingHelperService, [{
      key: 'isValid',
      value: function isValid(booking) {
        return _underscore2.default.includes(['CANCELLED', 'PROCESSED', 'WAITING'], booking.status);
      }
    }, {
      key: 'isCancelled',
      value: function isCancelled(booking) {
        return _underscore2.default.includes(['CANCELLED', 'VOIDED', 'EXPIRED'], booking.status);
      }
    }, {
      key: 'isTicket',
      value: function isTicket(booking) {
        if (!booking) return false;
        return _underscore2.default.includes(['TICKET', 'COVER'], booking.inventoryType);
      }
    }, {
      key: 'isTable',
      value: function isTable(booking) {
        if (!booking) return false;
        return _underscore2.default.includes(['TABLE', 'PACKAGE'], booking.inventoryType);
      }
    }, {
      key: 'isGuestCheckout',
      value: function isGuestCheckout(booking) {
        if (!booking) return false;
        return booking && booking.primaryUser && booking.primaryUser.user === null;
      }
    }, {
      key: 'isReservation',
      value: function isReservation(booking) {
        if (!booking) return null;

        return booking.payment === 'VENUE';
      }
    }, {
      key: 'isUpcomingBooking',
      value: function isUpcomingBooking(booking) {
        if (!booking) return false;

        return (0, _moment2.default)(booking.date).startOf('day') >= (0, _moment2.default)().startOf('day');
      }
    }, {
      key: 'isPastBooking',
      value: function isPastBooking(booking) {
        if (!booking) return false;
        return (0, _moment2.default)(booking.date).startOf('day') < (0, _moment2.default)().startOf('day');
      }
    }, {
      key: 'findBookingUser',
      value: function findBookingUser(booking) {
        if (!booking) return null;

        return _underscore2.default.find(booking.users, function (user) {
          var myUserId = $rootScope.currentUser.id;

          if (user && user.user && user.user.id) {
            return user.user.id === myUserId;
          } else if (user && user.user) {
            return user.user === myUserId;
          }

          return null;
        });
      }
    }, {
      key: 'findPrimaryBooker',
      value: function findPrimaryBooker(booking) {
        if (!booking) return null;

        return _underscore2.default.find(booking.users, function (user) {
          return user.type === 'MAIN';
        });
      }
    }, {
      key: 'getStatusText',
      value: function getStatusText(booking) {
        if (this.isUpcomingBooking(booking)) {
          return 'Complete';
        }

        if (this.isReservation(booking) && this.isUpcomingBooking(booking)) {
          return 'Reserved. Pay at the venue.';
        }

        if (booking.status === 'COMPLETE' || booking.status === 'PROCESSED') {
          return 'Complete';
        }

        if (!this.isValid(booking)) {
          return 'Cancelled';
        }

        return 'Pending booking...';
      }
    }, {
      key: 'getPaymentStatusText',
      value: function getPaymentStatusText() {
        return 'feature in progress....';
      }
    }, {
      key: 'hasTickets',
      value: function hasTickets(booking) {
        if (!booking) return false;
        return booking.hasTickets ? booking.hasTickets : false;
      }
    }, {
      key: 'downloadTicketLink',
      value: function downloadTicketLink(booking) {
        if (!booking) return null;

        var apiURL = _config2.default.SDK_API_URL;

        return apiURL + '/booking/' + booking.id + '/ticket/print?auth=' + jsSdkKeychain.getConsumerAuthToken();
      }
    }, {
      key: 'getStatus',
      value: function getStatus(booking) {
        if (!booking) return null;

        var status = {
          _booking: booking,
          _users: {
            bookingUser: this.findBookingUser(booking),
            bookingUserPrimary: this.findPrimaryBooker(booking)
          },
          isValid: this.isValid(booking),
          isCancelled: this.isCancelled(booking),
          isTicket: this.isTicket(booking),
          isTable: this.isTable(booking),
          isGuestCheckout: this.isGuestCheckout(booking),
          isReservation: this.isReservation(booking),
          isUpcoming: this.isUpcomingBooking(booking),
          isPast: this.isPastBooking(booking),
          hasTickets: this.hasTickets(booking)
        };

        return status;
      }
    }]);
    return BookingHelperService;
  }();

  return new BookingHelperService();
}
module.exports = exports['default'];

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = conciergeService;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

conciergeService.$inject = ['$rootScope'];

function conciergeService($rootScope) {
  var ConciergeService = function () {
    function ConciergeService() {
      (0, _classCallCheck3.default)(this, ConciergeService);
    }

    (0, _createClass3.default)(ConciergeService, [{
      key: 'sendMessage',
      value: function sendMessage(text, autosend) {
        text = text || '';
        autosend = autosend || false;

        $rootScope.$broadcast('new-concierge-message', {
          text: text,
          autosend: autosend
        });
      }
    }]);
    return ConciergeService;
  }();

  return new ConciergeService();
}
module.exports = exports['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = dateUtilsService;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

dateUtilsService.$inject = [];

function dateUtilsService() {
  var DateUtilsService = function () {
    function DateUtilsService() {
      (0, _classCallCheck3.default)(this, DateUtilsService);
    }

    (0, _createClass3.default)(DateUtilsService, [{
      key: 'toUTCMomentWithoutTime',
      value: function toUTCMomentWithoutTime(date) {
        if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required');
        if (!_underscore2.default.isDate(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object');

        return _moment2.default.isMoment(date) ? _moment2.default.utc([date.get('year'), date.get('month'), date.get('date'), 6]) : _moment2.default.utc([date.getFullYear(), date.getMonth(), date.getDate(), 6]);
      }
    }, {
      key: 'toUTCMomentWithoutTime',
      value: function toUTCMomentWithoutTime(date) {
        if (!date) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date is required');
        if (!_underscore2.default.isDate(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCMomentWithoutTime() - date must be a Date object or a Moment object');

        return _moment2.default.isMoment(date) ? _moment2.default.utc([date.get('year'), date.get('month'), date.get('date'), 6]) : _moment2.default.utc([date.getFullYear(), date.getMonth(), date.getDate(), 6]);
      }
    }, {
      key: 'toUTCTimestampWithoutTime',
      value: function toUTCTimestampWithoutTime(date) {
        if (!date) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date is required');
        if (!_underscore2.default.isDate(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithoutTime() - date must be a Date object or a Moment object');

        return _moment2.default.isMoment(date) ? Date.UTC(date.get('year'), date.get('month'), date.get('date'), 6) : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 6);
      }
    }, {
      key: 'toUTCTimestampWithTime',
      value: function toUTCTimestampWithTime(date) {
        if (!date) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date is required');
        if (!_underscore2.default.isDate(date) && !_moment2.default.isMoment(date)) throw new Error('dateUtilsService - toUTCTimestampWithTime() - date must be a Date object or a Moment object');

        return _moment2.default.isMoment(date) ? Date.UTC(date.get('year'), date.get('month'), date.get('date'), date.get('hour'), date.get('minute'), date.get('second'), date.get('millisecond')) : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
      }
    }]);
    return DateUtilsService;
  }();

  return new DateUtilsService();
}
module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = eventHelpersService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

eventHelpersService.$inject = [];

function eventHelpersService() {
  var EventHelpersService = function () {
    function EventHelpersService() {
      (0, _classCallCheck3.default)(this, EventHelpersService);
    }

    (0, _createClass3.default)(EventHelpersService, [{
      key: 'isWidgetVisible',
      value: function isWidgetVisible(event) {
        var widget = _underscore2.default.get(event, 'config.enableTablelist');

        return _underscore2.default.isUndefined(widget) ? true : widget;
      }
    }, {
      key: 'isGuestlistVisible',
      value: function isGuestlistVisible(event) {
        var guestlist = _underscore2.default.get(event, 'config.disableGuestList');

        return _underscore2.default.isUndefined(guestlist) ? false : !guestlist;
      }
    }, {
      key: 'isReservationRequestVisible',
      value: function isReservationRequestVisible(event) {
        var request = _underscore2.default.get(event, 'config.disableReservation');

        return _underscore2.default.isUndefined(request) ? false : !request;
      }
    }, {
      key: 'isExternalTicketLinkVisible',
      value: function isExternalTicketLinkVisible(event) {
        var external = _underscore2.default.get(event, 'config.externalTicketLink');

        return _underscore2.default.isUndefined(external) ? false : external;
      }
    }]);
    return EventHelpersService;
  }();

  return new EventHelpersService();
}
module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = favoritesService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

favoritesService.$inject = ['$rootScope', '$q', 'tl.user.service', 'loggerService', 'utilsService'];

var SUPPORTED_FAVORITE_TYPES = {
  EVENT: 'event',
  VENUE: 'venue'
};

function favoritesService($rootScope, $q, userService, loggerService, utilsService) {
  var FavoritesService = function () {
    function FavoritesService() {
      var _this = this;

      (0, _classCallCheck3.default)(this, FavoritesService);

      this.favorites = null;
      this.favoritesPromise = null;

      var currentUser = userService.currentUser();

      if (currentUser) {
        this._loadFavorites(currentUser.id);
      }

      $rootScope.$on('login', function () {
        var user = userService.currentUser();

        _this._loadFavorites(user.id);
      });

      $rootScope.$on('logout', function () {
        _this.favorites = null;
        _this.currentUser = null;
      });
    }

    (0, _createClass3.default)(FavoritesService, [{
      key: 'toggleFavorite',
      value: function toggleFavorite(type, id) {
        var _this2 = this;

        if (!type) return $q.reject("Type required. 'event' or 'venue'");
        if (!id) return $q.reject('No id provided unable to favorite');

        return this._requireUser().then(function () {
          return _this2._requireFavorites();
        }).then(function () {
          return _this2.isFavorite(type, id);
        }).then(function (favorited) {
          return favorited ? _this2._unfavorite(type, id) : _this2._favorite(type, id);
        });
      }
    }, {
      key: 'addFavorite',
      value: function addFavorite(type, id) {
        var _this3 = this;

        if (!type) return $q.reject("Type required. 'event' or 'venue'");
        if (!id) return $q.reject('No id provided unable to favorite');

        return this._requireUser().then(function () {
          return _this3._requireFavorites();
        }).then(function () {
          return _this3._favorite(type, id);
        });
      }
    }, {
      key: 'removeFavorite',
      value: function removeFavorite(type, id) {
        var _this4 = this;

        if (!type) return $q.reject("Type required. 'event' or 'venue'");
        if (!id) return $q.reject('No id provided unable to remove');

        return this._requireUser().then(function () {
          return _this4._requireFavorites();
        }).then(function () {
          return _this4._unfavorite(type, id);
        });
      }
    }, {
      key: 'isFavorite',
      value: function isFavorite(type, id) {
        var _this5 = this;

        return $q(function (resolve, reject) {
          var currentUser = userService.currentUser();

          if (!currentUser) return resolve(false);

          return _this5._requireFavorites().then(function (favs) {
            var match = _underscore2.default.find(favs, function (fav) {
              return fav[type] === id;
            });

            resolve(typeof match !== 'undefined');
          }).catch(function (err) {
            reject(err);
          });
        });
      }
    }, {
      key: 'listFavorites',
      value: function listFavorites() {
        var currentUser = userService.currentUser();

        if (!currentUser) {
          return $q.resolve([]);
        }

        return userService.listFavorites({
          userId: currentUser.id,
          fields: 'preferences.favorites.venue(name,seoPathname,rating,images,schedule,type,location.address),' + 'preferences.favorites.event(name,seoPathname,description,images,date,city,venue)'
        });
      }
    }, {
      key: '_requireUser',
      value: function _requireUser() {
        var _this6 = this;

        return $q(function (resolve, reject) {
          var currentUser = userService.currentUser();

          if (currentUser && currentUser.id) {
            return resolve(currentUser);
          }

          var options = {
            startState: 'existingUser'
          };

          return utilsService.authUser(function (resp) {
            currentUser = resp.user;

            if (_this6.favoritesPromise === null) {
              _this6._loadFavorites(currentUser.id);
            }

            resolve(currentUser);
          }, function (err) {
            reject(err);
          }, options);
        });
      }
    }, {
      key: '_requireFavorites',
      value: function _requireFavorites() {
        var _this7 = this;

        return $q(function (resolve, reject) {
          if (_this7.favorites) {
            return resolve(_this7.favorites);
          }

          return _this7.favoritesPromise.then(function (response) {
            _this7.favorites = response;

            resolve(response);
          }, function (err) {
            reject(err);
          });
        });
      }
    }, {
      key: '_loadFavorites',
      value: function _loadFavorites(userId) {
        this.favoritesPromise = userService.listFavorites({
          userId: userId
        });
      }
    }, {
      key: '_favorite',
      value: function _favorite(type, id) {
        var _this8 = this;

        return $q(function (resolve, reject) {
          if (!id) {
            return reject('Missing id to favorite');
          }

          var currentUser = userService.currentUser();

          if (!currentUser) {
            return reject('Error. Missing user object to add favorite');
          }

          var options = {
            userId: currentUser.id
          };

          if (type === SUPPORTED_FAVORITE_TYPES.VENUE) {
            options.venueId = id;
          } else if (type === SUPPORTED_FAVORITE_TYPES.EVENT) {
            options.eventId = id;
          } else {
            return reject('Invaild type for add favorite');
          }

          return userService.favorite(options).then(function (response) {
            _this8.favorites.push(response);

            $rootScope.$broadcast('favoritesChange');

            resolve(response);
          }, function (response) {
            reject(response);
          });
        });
      }
    }, {
      key: '_unfavorite',
      value: function _unfavorite(type, id) {
        var _this9 = this;

        return $q(function (resolve, reject) {
          if (!id) {
            return reject('Missing id to favorite');
          }

          var currentUser = userService.currentUser();

          if (!currentUser) {
            return reject('Error. Missing user object to remove favorite');
          }

          if (type !== SUPPORTED_FAVORITE_TYPES.VENUE && type !== SUPPORTED_FAVORITE_TYPES.EVENT) {
            return reject('Invaild type for remove favorite');
          }

          var favorite = _underscore2.default.find(_this9.favorites, function (fav) {
            return fav[type] === id;
          });

          var options = {
            userId: currentUser.id,
            favoriteId: favorite.id
          };

          return userService.unfavorite(options).then(function () {
            var index = _this9.favorites.indexOf(favorite);
            _this9.favorites.splice(index, 1);

            $rootScope.$broadcast('favoritesChange');

            resolve();
          }).catch(reject);
        });
      }
    }, {
      key: 'TYPES',
      get: function get() {
        return SUPPORTED_FAVORITE_TYPES;
      }
    }]);
    return FavoritesService;
  }();

  return new FavoritesService();
}
module.exports = exports['default'];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormHelpersServiceFn() {
  var FormHelpersService = function () {
    function FormHelpersService() {
      (0, _classCallCheck3.default)(this, FormHelpersService);
    }

    (0, _createClass3.default)(FormHelpersService, [{
      key: 'getFormErrors',
      value: function getFormErrors(form) {
        if (!form) throw new Error('formHelpersService - getFormErrors() - form is required');

        var errors = [];

        if (form.$error && form.$error.required) {
          _lodash2.default.each(form.$error.required, function (requiredField) {
            errors.push(requiredField.$name + ' is required');
          });
        }

        return errors;
      }
    }, {
      key: 'getChangedFormValues',
      value: function getChangedFormValues(form) {
        if (!form) throw new Error('formHelpersService - getChangedFormValues() - form is required');

        var changedValues = {};

        _angular2.default.forEach(form, function (value, key) {
          if (!key || key[0] === '$') return;

          if (value.$dirty || !value.$untouched) {
            changedValues[key] = value.$modelValue === '' ? null : value.$modelValue;
          }
        });

        return changedValues;
      }
    }]);
    return FormHelpersService;
  }();

  return new FormHelpersService();
}

FormHelpersServiceFn.$inject = [];

exports.default = FormHelpersServiceFn;
module.exports = exports['default'];

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = fraudService;

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

fraudService.$inject = ['tl.keychain'];

function fraudService(keychain) {
  var FraudService = function () {
    function FraudService() {
      (0, _classCallCheck3.default)(this, FraudService);

      window._sift = [['_setAccount', _config2.default.SIFT_KEY]];
    }

    (0, _createClass3.default)(FraudService, [{
      key: 'push',
      value: function push(event, data) {
        if (!event) throw new Error('event is required');

        if (!this.loaded) {
          this.loadScript();
        }

        var track = [event];

        if (data) track.push(data);

        window._sift.push(track);
      }
    }, {
      key: 'setUser',
      value: function setUser(user) {
        this.push('_setUserId', user ? user.id : '');
        this.push('_setSessionId', keychain.prospectToken());
      }
    }, {
      key: 'trackPageView',
      value: function trackPageView() {
        this.push('_trackPageview');
      }
    }, {
      key: 'loadScript',
      value: function loadScript() {
        this.loaded = true;
        var e = document.createElement('script');
        e.type = 'text/javascript';
        e.async = true;
        e.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.siftscience.com/s.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(e, s);
      }
    }]);
    return FraudService;
  }();

  return new FraudService();
}
module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function NpHttpInterceptor($rootScope, $q) {
  return {
    request: function request(data) {
      data = data || {};

      data.headers = data.headers || [];

      return data;
    },
    responseError: function responseError(response) {
      if (response.status === 401) {
        $rootScope.$emit('unauthorized');
      }

      return $q.reject(response);
    }
  };
}

NpHttpInterceptor.$inject = ['$rootScope', '$q'];

exports.default = NpHttpInterceptor;
module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(82);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = iframeService;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

iframeService.$inject = ['$window', '$timeout', 'loggerService', '$stateParams'];

function iframeService($window, $timeout, logger, $stateParams) {
  var IframeService = function () {
    function IframeService() {
      (0, _classCallCheck3.default)(this, IframeService);
    }

    (0, _createClass3.default)(IframeService, [{
      key: 'postMessage',
      value: function postMessage(message, targetOrigin) {
        var _this = this;

        $timeout(function () {
          targetOrigin = targetOrigin || '*';

          message.widgetId = $stateParams.widget_id;

          message = (0, _stringify2.default)(message);

          if (!_this.inIframe()) {
            return;
          }

          $window.top.postMessage(message, targetOrigin);
        });
      }
    }, {
      key: 'inIframe',
      value: function inIframe() {
        try {
          return $window.self !== $window.top;
        } catch (e) {
          return true;
        }
      }
    }]);
    return IframeService;
  }();

  return new IframeService();
}
module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partnerService = __webpack_require__(540);

var _partnerService2 = _interopRequireDefault(_partnerService);

var _partnerConfigsService = __webpack_require__(539);

var _partnerConfigsService2 = _interopRequireDefault(_partnerConfigsService);

var _loggerService = __webpack_require__(517);

var _loggerService2 = _interopRequireDefault(_loggerService);

var _bookingHelpersService = __webpack_require__(506);

var _bookingHelpersService2 = _interopRequireDefault(_bookingHelpersService);

var _dateUtilsService = __webpack_require__(508);

var _dateUtilsService2 = _interopRequireDefault(_dateUtilsService);

var _eventHelpersService = __webpack_require__(509);

var _eventHelpersService2 = _interopRequireDefault(_eventHelpersService);

var _favoritesService = __webpack_require__(510);

var _favoritesService2 = _interopRequireDefault(_favoritesService);

var _formHelpersService = __webpack_require__(511);

var _formHelpersService2 = _interopRequireDefault(_formHelpersService);

var _fraudService = __webpack_require__(512);

var _fraudService2 = _interopRequireDefault(_fraudService);

var _iframeService = __webpack_require__(514);

var _iframeService2 = _interopRequireDefault(_iframeService);

var _inventorySearchService = __webpack_require__(516);

var _inventorySearchService2 = _interopRequireDefault(_inventorySearchService);

var _membershipService = __webpack_require__(518);

var _membershipService2 = _interopRequireDefault(_membershipService);

var _metaTagService = __webpack_require__(519);

var _metaTagService2 = _interopRequireDefault(_metaTagService);

var _regexService = __webpack_require__(541);

var _regexService2 = _interopRequireDefault(_regexService);

var _resizeService = __webpack_require__(542);

var _resizeService2 = _interopRequireDefault(_resizeService);

var _urlService = __webpack_require__(544);

var _urlService2 = _interopRequireDefault(_urlService);

var _utilsService = __webpack_require__(545);

var _utilsService2 = _interopRequireDefault(_utilsService);

var _modalService = __webpack_require__(535);

var _modalService2 = _interopRequireDefault(_modalService);

var _trackingService = __webpack_require__(543);

var _trackingService2 = _interopRequireDefault(_trackingService);

var _conciergeService = __webpack_require__(507);

var _conciergeService2 = _interopRequireDefault(_conciergeService);

var _modal = __webpack_require__(533);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  _modal2.default.init(app);

  app.service('partnerService', _partnerService2.default);
  app.service('partnerConfigs', _partnerConfigsService2.default);
  app.service('loggerService', _loggerService2.default);
  app.service('bookingHelpersService', _bookingHelpersService2.default);
  app.service('dateUtilsService', _dateUtilsService2.default);
  app.service('eventHelpersService', _eventHelpersService2.default);
  app.service('favoritesService', _favoritesService2.default);
  app.service('formHelpersService', _formHelpersService2.default);
  app.service('fraudService', _fraudService2.default);
  app.service('iframeService', _iframeService2.default);
  app.service('inventorySearchService', _inventorySearchService2.default);
  app.service('membershipService', _membershipService2.default);
  app.service('metaTagService', _metaTagService2.default);
  app.service('regexService', _regexService2.default);
  app.service('resizeService', _resizeService2.default);
  app.service('urlService', _urlService2.default);
  app.service('utilsService', _utilsService2.default);
  app.service('modalService', _modalService2.default);
  app.service('trackingService', _trackingService2.default);
  app.service('conciergeService', _conciergeService2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = inventorySearchService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

inventorySearchService.$inject = ['$timeout', 'loggerService', 'jsSdk.inventorySummary'];

function formatSummaries(inventorySummaries) {
  var summaries = inventorySummaries.map(function (summary) {
    summary.venue.type = _underscore2.default.find(summary.venue.tags, {
      key: 'VENUE_TYPE'
    });

    summary.venue.type = summary.venue.type ? summary.venue.type.name : null;

    summary.venue.subtype = _underscore2.default.find(summary.venue.tags, {
      key: 'VENUE_SUB_TYPE'
    });

    summary.venue.subtype = summary.venue.subtype ? summary.venue.subtype.name : null;
    summary.inventory = _underscore2.default.filter(summary.days && summary.days.length ? summary.days[0].inventory : [], function (inv) {
      return inv.type !== 'COVER';
    });
    summary.events = summary.days && summary.days.length ? summary.days[0].events : [];

    if (summary.events && summary.events.length > 0) {
      summary.event = summary.events[0];
    }

    summary.description = getDescription(summary);

    _underscore2.default.each(summary.inventory, function (i) {
      i.priceTotal = calculatePriceTotal(i);

      i.pricePerGuest = i.priceTotal / i.guests;
    });

    summary.inventory = _underscore2.default.sortBy(summary.inventory, function (i) {
      return i.pricePerGuest;
    });

    summary.inventory = _underscore2.default.filter(summary.inventory, function (i) {
      return i.enable;
    });

    return summary;
  });
  summaries = _underscore2.default.filter(summaries, function (summary) {
    return summary.inventory.length > 0;
  });
  summaries = _underscore2.default.sortBy(summaries, function (summary) {
    return summary.event ? 0 : 1;
  });

  return summaries;
}

function calculatePriceTotal(inventory) {
  var base = inventory.price ? inventory.price : 0;
  var tax = inventory.tax ? base * inventory.tax : base * 0.07;
  var tip = inventory.tip ? base * inventory.tip : base * 0.20;

  return base + tax + tip;
}

function getDescription(summary) {
  var description = null;

  if (summary.venue.details && summary.venue.details.shortDescription) {
    description = summary.venue.details.shortDescription;
  }

  if (summary.event) {
    description = summary.event.description;
  }

  if (description && description.length > 240) {
    description = description.slice(0, 240) + '...';
  }

  return description;
}

function inventorySearchService($timeout, loggerService, jsSdkInventorySummary) {
  var InventorySearchService = function () {
    function InventorySearchService() {
      (0, _classCallCheck3.default)(this, InventorySearchService);
    }

    (0, _createClass3.default)(InventorySearchService, [{
      key: 'getInventorySummaries',
      value: function getInventorySummaries(options, success, error) {
        jsSdkInventorySummary.list(options).then(function (response) {
          success(formatSummaries(response));
        }).catch(function (response) {
          loggerService.error(response);

          error(response);
        });
      }
    }]);
    return InventorySearchService;
  }();

  return new InventorySearchService();
}
module.exports = exports['default'];

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = loggerService;

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

loggerService.$inject = ['jsSdk.user'];

function loggerService(userService) {
  var LoggerService = function () {
    function LoggerService() {
      (0, _classCallCheck3.default)(this, LoggerService);
    }

    (0, _createClass3.default)(LoggerService, [{
      key: 'init',
      value: function init() {
        if (this._rollbarInitialized) return;

        var currentUser = userService.getCurrentUser();

        window.Rollbar.configure({
          accessToken: _config2.default.ROLLBAR_ACCESS_TOKEN,
          enabled: _config2.default.ROLLBAR_ENABLE,
          payload: {
            person: currentUser ? {
              id: currentUser.id,
              username: currentUser.firstName + ' ' + currentUser.lastName,
              email: currentUser.email
            } : null,
            environment: _config2.default.NODE_ENV || 'development',
            client: {
              javascript: {
                source_map_enabled: true,
                code_version: _config2.default.COMMIT_HASH,
                guess_uncaught_frames: true
              }
            }
          }
        });

        this._rollbarInitialized = true;
      }
    }, {
      key: 'error',
      value: function error(msg) {
        if (!msg) throw new Error('loggerService - error() - msg is required');

        console.log('**ERROR**', msg);
      }
    }]);
    return LoggerService;
  }();

  return new LoggerService();
}
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = membershipService;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

membershipService.$inject = ['jsSdk.user'];

var MEMBERSHIP_LEVEL_MIN = 50;

var cities = [{
  id: '301072f4d252999a',
  slug: 'bos',
  name: 'Boston'
}, {
  id: 'aa211bf5d25100ac',
  slug: 'nyc',
  name: 'New York'
}, {
  id: '070ac346cd2d446f',
  slug: 'dc',
  name: 'D.C.'
}];

var venues = [{
  slug: 'royal',
  name: 'Royale',
  image: 'https://moth.imgix.net/data/CFA6-C9E4-E69F-f0c81194.jpg',
  city: 'bos',
  perks: ['preferred pricing', 'free entry']
}, {
  slug: 'storyville',
  name: 'Storyville',
  image: 'https://moth.imgix.net/d2/e2/d2e246d1-8adf2f62-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'bijou',
  name: 'Bijou',
  image: 'https://moth.imgix.net/data/7B33-A36F-FFEE-a9e4da4c.jpg',
  city: 'bos',
  perks: ['free entry', 'preferred pricing']
}, {
  slug: 'gem',
  name: 'Gem',
  image: 'https://moth.imgix.net/49/d4/49d4d96d-66c88e9c-IMG_7698.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'icon',
  name: 'ICON',
  image: 'https://images.tablelist.com/9a/87/9a87ed15-fd2f9c6b-large.jpg',
  city: 'bos',
  perks: ['free entry']
}, {
  slug: 'whiskysaigon',
  name: 'Whisky Saigon',
  image: 'https://moth.imgix.net/e0/d7/e0d7c71f-e871a716-1506138_213161352205296_1420796859_o.jpg',
  city: 'bos',
  perks: ['line jumpers', 'free entry']
}, {
  slug: 'alibi',
  name: 'Alibi',
  image: 'https://moth.imgix.net/cf/17/cf17f946-a72f9bb9-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'tunnel',
  name: 'Tunnel',
  image: 'https://moth.imgix.net/7a/27/7a277926-d7746303-xlarge.jpg',
  city: 'bos',
  perks: ['table deals', 'line jumpers', 'free entry']
}, {
  slug: 'marqueenyc',
  name: 'Marquee',
  image: 'https://moth.imgix.net/data/BD6D-E542-53E0-9e58ab6f.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'lavo',
  name: 'Lavo',
  image: 'https://moth.imgix.net/data/ABF7-3AAA-F02B-5e86b34a.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'tao',
  name: 'Tao',
  image: 'https://moth.imgix.net/data/2D3E-7527-8A92-aec3a3e9.jpg',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'flash',
  name: 'Flash Factory',
  image: 'https://moth.imgix.net/c12d9f38-0d02-dd67-7d509d91488b.png',
  city: 'nyc',
  perks: ['free entry']
}, {
  slug: 'bounce',
  name: 'Bounce',
  image: 'https://moth.imgix.net/data/2EC8-61F3-B20F-f8d66965.jpg',
  city: 'nyc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'hotelchantelle',
  name: 'Hotel Chantelle',
  image: 'https://moth.imgix.net/data/253C-357D-DDB9-5c076307.jpg',
  city: 'nyc',
  perks: ['line jumpers', 'table deals']
}, {
  slug: 'gansevoort',
  name: 'Gansevoort Park Ave',
  image: 'https://moth.imgix.net/cbc8ebad-b450-1da7-5f4e979eab97.jpg',
  city: 'nyc',
  perks: ['table deals']
}, {
  slug: 'gildedlily',
  name: 'Gilded Lily',
  image: 'https://moth.imgix.net/68/fa/68fa2155-c8150446-AG1424_Monarch_Shot2_Final.jpg',
  city: 'nyc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'living-room-dc',
  name: 'Living Room',
  image: 'https://moth.imgix.net/c65d0bf5-4623-d35c-b0d6f9bd2247.jpg',
  city: 'dc',
  perks: ['free entry']
}, {
  slug: 'capitale',
  name: 'Capitale',
  image: 'https://moth.imgix.net/data/9674-A457-E428-2723fad2.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'manor',
  name: 'Manor',
  image: 'https://moth.imgix.net/data/42DA-07BB-EE0B-071a306a.jpg',
  city: 'dc',
  perks: ['free entry', 'line jumpers']
}, {
  slug: 'heist1',
  name: 'Heist',
  image: 'https://moth.imgix.net/data/A9B0-5231-F4E4-5160e4b7.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals']
}, {
  slug: 'sax',
  name: 'Sax',
  image: 'https://moth.imgix.net/data/2355-A62B-7E02-d96d30fa.jpg',
  city: 'dc',
  perks: ['free entry', 'drink deals']
}, {
  slug: 'kabin',
  name: 'Kabin',
  image: 'https://moth.imgix.net/data/E752-77FA-49BD-39b15276.jpg',
  city: 'dc',
  perks: ['free entry', 'table deals', 'drink deals']
}, {
  slug: 'flash',
  name: 'Flash',
  image: 'https://moth.imgix.net/data/B9D6-6945-E14D-c1941847.png',
  city: 'dc',
  perks: ['free entry']
}, {
  slug: 'provision14',
  name: 'Provision 14',
  image: 'https://moth.imgix.net/data/8C6D-CE08-1213-56be2154.jpeg',
  city: 'dc',
  perks: ['free entry', 'line jumpers', 'drink deals']
}];

var states = {
  CANCELLED: 'CANCELLED',
  ACTIVE: 'ACTIVE'
};

function membershipService(jsSdkUser) {
  var MembershipService = function () {
    function MembershipService() {
      (0, _classCallCheck3.default)(this, MembershipService);
    }

    (0, _createClass3.default)(MembershipService, [{
      key: 'isUserSubscribed',
      value: function isUserSubscribed() {
        var user = jsSdkUser.getCurrentUser();
        if (!user) return false;
        return user.membershipLevel >= MEMBERSHIP_LEVEL_MIN;
      }
    }, {
      key: 'membershipLevel',
      value: function membershipLevel() {
        var user = jsSdkUser.getCurrentUser();
        if (!user) return 0;
        return user.membershipLevel;
      }
    }, {
      key: 'getCities',
      value: function getCities() {
        return cities;
      }
    }, {
      key: 'getStates',
      value: function getStates() {
        return states;
      }
    }, {
      key: 'getVenues',
      value: function getVenues() {
        return venues;
      }
    }, {
      key: 'getMinMembershipLevel',
      value: function getMinMembershipLevel() {
        return MEMBERSHIP_LEVEL_MIN;
      }
    }]);
    return MembershipService;
  }();

  return new MembershipService();
}
module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = metaTagService;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

metaTagService.$inject = ['$rootScope', '$window', '$location'];

var serviceEventNamespace = 'metatag-service-event';

var defaults = {
  title: 'Tablelist',
  description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',

  facebookTitle: 'Tablelist - A better night out',
  facebookDescription: 'Life is a celebration, and finding the party has never been easier.',
  facebookImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image-better-night-out.jpg',

  twitterTitle: 'Tablelist - A better night out',
  twitterDescription: 'Life is a celebration, and finding the party has never been easier.',
  twitterImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image-better-night-out.jpg',

  deeplink: '/',

  canonicalUrl: null,
  statusCode: 200
};

function metaTagService($rootScope, $window, $location) {
  var MetaTagService = function () {
    function MetaTagService() {
      (0, _classCallCheck3.default)(this, MetaTagService);

      this._meta = defaults;
    }

    (0, _createClass3.default)(MetaTagService, [{
      key: 'publish',
      value: function publish(eventName, msg) {
        if (!eventName) return;

        $rootScope.$emit(serviceEventNamespace, {
          event: eventName,
          msg: msg
        });
      }
    }, {
      key: 'subscribe',
      value: function subscribe(eventName, scope, callback) {
        if (!scope || !eventName || !callback) return;

        var handler = $rootScope.$on(serviceEventNamespace, function (event, msg) {
          if (msg && msg.event === eventName) {
            return callback(msg.msg);
          }

          return null;
        });

        scope.$on('$destroy', handler);
      }
    }, {
      key: 'set',
      value: function set(input) {
        input = input || {};

        var canonicalUrl = $window.location.origin + (input.canonicalPath || $location.path());

        this._meta = {
          title: 'Tablelist | ' + (input.title || defaults.title),
          description: input.description || defaults.description,

          facebookTitle: input.facebookTitle || input.title || defaults.facebookTitle,
          facebookDescription: input.facebookDescription || input.description || defaults.facebookDescription,
          facebookImage: input.facebookImage || defaults.facebookImage,

          twitterTitle: input.twitterTitle || input.title || defaults.facebookTitle,
          twitterDescription: input.twitterDescription || input.description || defaults.facebookDescription,
          twitterImage: input.twitterImage || defaults.facebookImage,

          deeplink: input.deeplink || defaults.deeplink,

          canonicalUrl: canonicalUrl,
          statusCode: input.statusCode || defaults.statusCode
        };

        this.publish('tagsChanged');

        return this._meta;
      }
    }, {
      key: 'setKey',
      value: function setKey(key, value) {
        if (!key || !value) return null;

        this._meta[key] = value;

        this.publish('tagsChanged');

        return key;
      }
    }, {
      key: 'getKey',
      value: function getKey(key) {
        if (!key) return null;

        return this._meta[key];
      }
    }, {
      key: 'meta',
      get: function get() {
        return this._meta;
      }
    }]);
    return MetaTagService;
  }();

  return new MetaTagService();
}
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $stateParams, $uibModalInstance, input, $location, jsSdkConfig, partnerService, $window) {
  $scope.venue = input.venue;
  $scope.inventoryId = input.inventory;

  setTimeout(function () {
    var inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-modal-widget');

    inventoryListWidget.init({
      venueId: $scope.venue.id,
      inventoryId: $scope.inventoryId,
      date: input.startDate,
      client: $location.search().client || 'web',
      theme: 'theme-light',
      attributionId: jsSdkConfig.attributionId,
      attributionType: jsSdkConfig.attributionType,
      disableInlineCheckout: true,
      checkoutUrl: _config2.default.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
      onInventoryAddedToCart: function onInventoryAddedToCart(inventory) {
        if (_config2.default.NODE_ENV === 'production') {
          var fbqData = {
            content_type: 'product',
            value: inventory.price,
            currency: 'USD',
            content_ids: [inventory.venue],
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            language: navigator.language
          };

          $window.fbq('init', '1606722376242558');
          $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData);
          $window.fbq('init', '316401409092218');
          $window.fbq('trackSingle', '316401409092218', 'AddToCart', fbqData);
        }
      }
    });
  }, 300);

  $scope.$on('widget-checkout', function () {
    $uibModalInstance.close();
  });

  $scope.cancel = function ($event) {
    if ($event) $event.preventDefault();

    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'input', '$location', 'jsSdk.config', 'partnerService', '$window'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance, input) {
  $scope.config = input.config;

  $scope.done = function () {
    $uibModalInstance.dismiss(false);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss(false);
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'input'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function ConfirmationModalCtrl($scope, $sce, $uibModalInstance, $timeout, modalHeader, modalMessage, confirmBtnTxt, confirmingBtnTxt, cancelBtnTxt, deferred, confirmingBtnClass, hideCancelBtn) {
  _initScope();

  function _initScope() {
    $scope.modalHeader = modalHeader;
    $scope.modalMessage = modalMessage;
    $scope.modalMessageHtml = $sce.trustAsHtml(modalMessage || 'Click ' + (confirmBtnTxt || 'Confirm') + ' to continue.');
    $scope.confirmBtnTxt = confirmBtnTxt;
    $scope.confirmingBtnTxt = confirmingBtnTxt;
    $scope.confirmingBtnClass = confirmingBtnClass;
    $scope.hideCancelBtn = hideCancelBtn;
    $scope.cancelBtnTxt = cancelBtnTxt;

    $scope.confirm = _confirm;
    $scope.close = _close;
  }

  function _confirm($event) {
    if ($event) $event.preventDefault();

    $scope.saving = true;

    $timeout(function () {
      deferred.resolve(true);
    }, 100);
  }

  function _close() {
    deferred.resolve(false);
  }
}

ConfirmationModalCtrl.$inject = ['$scope', '$sce', '$uibModalInstance', '$timeout', 'modalHeader', 'modalMessage', 'confirmBtnTxt', 'confirmingBtnTxt', 'cancelBtnTxt', 'deferred', 'confirmingBtnClass', 'hideCancelBtn'];

exports.default = ConfirmationModalCtrl;
module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance, input) {
  $scope.message = input && input.message ? input.message : '';

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'input'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance) {
  $uibModalInstance.dismiss('cancel');
}

Ctrl.$inject = ['$scope', '$uibModalInstance'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $stateParams, $timeout, $uibModalInstance, jsSdkUser, jsSdkCity, loggerService) {
  $scope.errorMsg = '';
  $scope.successMsg = '';
  $scope.loading = true;

  var user = jsSdkUser.getCurrentUser();

  $scope.selectedCityId = user && user.location && user.location.preferred && user.location.preferred.id ? user.location.preferred.id : null;

  jsSdkCity.list().then(function (resp) {

    $scope.loading = false;

    $scope.cities = (0, _sortBy3.default)(resp, function (city) {
      return city.id !== $scope.selectedCityId;
    });
  }).catch(function (resp) {
    loggerService.error(resp);

    $scope.errorMsg = 'Unable to load city list';
  });

  $scope.setCity = function (cityId) {
    $scope.errorMsg = null;
    $scope.successMsg = null;

    if (!cityId) {
      $scope.errorMsg = 'Please select a city.';
      return;
    }

    jsSdkUser.updatePreferredCity(cityId).then(function () {
      return jsSdkUser.me();
    }).then(function () {
      $scope.loading = false;
      $scope.successMsg = 'Default city updated.';
    }).catch(function (resp) {
      loggerService.error(resp);

      $scope.loading = false;
      $scope.errorMsg = 'Unable to change preferred city.';
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$stateParams', '$timeout', '$uibModalInstance', 'jsSdk.user', 'jsSdk.city', 'loggerService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = __webpack_require__(234);

var _pick3 = _interopRequireDefault(_pick2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $state, $timeout, $uibModalInstance, utilsService, jsSdkUser) {
  $scope.user = $rootScope.currentUser;

  $scope.saveUser = function () {
    var user = (0, _pick3.default)($scope.user, ['email', 'phone']);

    jsSdkUser.updateMe(user).then(function (resp) {
      $scope.user = resp;

      $scope.updateUserResult = 'success';
      $scope.isUpdatingUser = false;

      $uibModalInstance.dismiss(false);
    }).catch(function () {
      $scope.updateUserResult = 'error';
      $scope.isUpdatingUser = false;
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.isUpdatingUser = null;
  $scope.updateUserResult = null;
  $scope.updateUserBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save Contact Information',
    buttonSubmittingText: 'Saving Changes...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Changes Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Saving Changes',
    buttonErrorClass: 'animated-button-error'
  };
}

Ctrl.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$uibModalInstance', 'utilsService', 'jsSdk.user'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($rootScope, $scope, $uibModalInstance) {
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$uibModalInstance'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sortBy2 = __webpack_require__(37);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _extend2 = __webpack_require__(110);

var _extend3 = _interopRequireDefault(_extend2);

var _reject2 = __webpack_require__(111);

var _reject3 = _interopRequireDefault(_reject2);

var _membershipStatuses = __webpack_require__(113);

var _membershipStatuses2 = _interopRequireDefault(_membershipStatuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $uibModalInstance, utilsService, jsSdkUser, jsSdkMembership, membershipService) {
  var actions = {
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD'
  };

  $scope.error = null;
  $scope.success = null;

  $scope.loading = true;

  getUserMembership();

  $scope.membershipStates = membershipService.getStates();

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.save = function (membership, paymentProfile) {
    $scope.error = null;
    $scope.success = null;

    if (!membership || !membership.id) {
      $scope.error = 'Missing membership id.';
      return;
    }

    if (!paymentProfile || !paymentProfile.id) {
      $scope.error = 'Unable to update payment';
      return;
    }

    updatePayment(membership.id, paymentProfile.id);
  };

  function getUserMembership() {
    var user = jsSdkUser.getCurrentUser();

    if (!user || !user.id) {
      return;
    }

    $scope.loading = true;

    jsSdkMembership.listByUserId(user.id, {}).then(function (resp) {
      $scope.loading = false;

      var memberships = (0, _sortBy3.default)((0, _reject3.default)(resp, {
        status: _membershipStatuses2.default.CANCELLED
      }), 'created');

      if (memberships && memberships[0]) {
        $scope.membership = memberships[0];
      }
    }).catch(function (resp) {
      $scope.error = utilsService.errorMessage(resp);
      $scope.loading = false;
    });
  }

  function updatePayment(membershipId, paymentProfileId) {

    $scope.error = null;
    $scope.loading = true;

    var options = {
      paymentProfileId: paymentProfileId
    };

    return jsSdkMembership.performAction(membershipId, actions.UPDATE_PAYMENT_METHOD, options).then(function () {
      $scope.loading = false;
      $scope.success = 'Payment method updated.';

      membershipUpdated();
    }).catch(function (resp) {
      $scope.error = utilsService.errorMessage(resp);
      $scope.loading = false;
    });
  }

  function membershipUpdated() {
    getUserMembership();

    jsSdkUser.me().then(function (currentUser) {
      (0, _extend3.default)($rootScope.currentUser, currentUser);
    });
  }
}

Ctrl.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'utilsService', 'jsSdk.user', 'jsSdk.membership', 'membershipService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = __webpack_require__(234);

var _pick3 = _interopRequireDefault(_pick2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $rootScope, $state, $timeout, $uibModalInstance, utilsService, jsSdkUser, imageService, dateUtilsService) {
  $scope.user = $scope.currentUser;

  $scope.selectedGender = $scope.currentUser.gender;

  if ($scope.currentUser.gender !== 'male' && $scope.currentUser.gender !== 'female') {
    $scope.selectedGender = 'custom';
  }

  $scope.birthday = new Date($scope.currentUser.birthday);

  $scope.saveUser = function () {
    $scope.user.birthday = dateUtilsService.toUTCTimestampWithoutTime($scope.birthday);

    var user = (0, _pick3.default)($scope.user, ['name', 'birthday', 'gender']);

    jsSdkUser.updateMe(user).then(function (updatedUser) {
      $scope.user = updatedUser;
      $scope.updateUserResult = 'success';
      $scope.isUpdatingUser = false;

      $uibModalInstance.dismiss('cancel');
    }).catch(function () {
      $scope.updateUserResult = 'error';
      $scope.isUpdatingUser = false;
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.isUpdatingUser = null;
  $scope.updateUserResult = null;
  $scope.updateUserBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save Profile',
    buttonSubmittingText: 'Saving Changes...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Changes Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Saving Changes',
    buttonErrorClass: 'animated-button-error'
  };

  $scope.isSubmittingProfilePic = null;
  $scope.profilePicResult = null;
  $scope.profilePicBtnOptions = {
    buttonInitialIcon: 'icon-left fa fa-image',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Change Avatar',
    buttonDefaultIcon: 'icon-left fa fa-image',
    buttonSubmittingText: 'Saving Profile Pic...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Profile Pic Updated',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Uploading Profile Pic',
    buttonErrorClass: 'animated-button-error'
  };

  $scope.updateProfilePic = function (files) {
    $scope.isSubmittingProfilePic = true;
    $scope.profilePicResult = null;

    return imageService.upload(files[0], {
      size: 'smallSquare'
    }).then(function success(response) {
      jsSdkUser.updateMe({
        imageUrl: response.smallSquare
      }, function successUpdatingUser(response2) {
        $scope.profilePicResult = 'success';
        $scope.currentUser.imageUrl = response2.imageUrl;
        $scope.isSubmittingProfilePic = false;
      }, function errorUpdatingUser() {
        $scope.profilePicResult = 'error';
        $scope.isSubmittingProfilePic = false;
      });
    }, function error(response) {

      $scope.errorUploadingPicMsg = response;
      $scope.profilePicResult = 'error';
      $scope.isSubmittingProfilePic = false;
    });
  };
}

Ctrl.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$uibModalInstance', 'utilsService', 'jsSdk.user', 'tl.image.service', 'dateUtilsService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($rootScope, $scope, $stateParams, $timeout, $uibModalInstance, jsSdkPromo, jsSdkUser, metaTagService, tracking) {
  metaTagService.set({
    title: 'Enter Promo Code | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.error = '';

  $scope.form = {
    promoCode: $stateParams.code
  };

  $scope.isRedeemingPromo = null;
  $scope.redeemPromoResult = null;
  $scope.redeemPromoBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Redeem Promo',
    buttonSubmittingText: 'Redeeming Promo...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Promo Redeemed',
    buttonSuccessClass: 'btn-success',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Invalid Promo Code',
    buttonErrorClass: 'btn-danger'
  };

  $scope.resetFormValidation = function () {
    $scope.form.promoCode = '';
    $scope.promoCodeForm.$setPristine();
    $scope.submitted = false;
  };

  $scope.redeemPromoCode = function (promoCodeForm) {

    $scope.submitted = true;

    if (!promoCodeForm.$valid) return;

    $scope.isRedeemingPromo = true;
    $scope.redeemPromoResult = null;

    jsSdkPromo.redeem({
      code: $scope.form.promoCode
    }).then(function success(response) {
      $scope.errorMsg = null;
      $scope.resetFormValidation();

      $scope.redeemPromoResult = 'success';
      $scope.isRedeemingPromo = false;

      $scope.successMsg = response.message;

      jsSdkUser.me();

      tracking.trackEvent(_segmentEvents2.default.RedeemedPromoCode, {});
    }, function error() {
      $scope.successMsg = null;
      $scope.errorMsg = 'Sorry that promo code is not valid';
      $scope.resetFormValidation();

      $scope.redeemPromoResult = 'error';
      $scope.isRedeemingPromo = false;
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$rootScope', '$scope', '$stateParams', '$timeout', '$uibModalInstance', 'jsSdk.promo', 'jsSdk.user', 'metaTagService', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $uibModalInstance, authService, tracking) {
  $scope.error = '';
  $scope.submitted = false;
  $scope.loading = false;
  $scope.emailSent = false;

  $scope.sendEmail = function (form) {
    $scope.submitted = true;

    if (form.$invalid) {
      $scope.error = 'Please enter a valid email';
      return;
    }

    authService.forgotPassword($scope.email, function () {
      $scope.submitted = false;
      $scope.emailSent = true;

      tracking.trackEvent(_segmentEvents2.default.ForgotPassword);
    }, function (resp) {
      $scope.error = resp.data.errors[0].message;
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'tl.auth.service', 'trackingService'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance) {
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bookingWidgetModalCtrl = __webpack_require__(520);

var _bookingWidgetModalCtrl2 = _interopRequireDefault(_bookingWidgetModalCtrl);

var _completeProfileModalCtrl = __webpack_require__(521);

var _completeProfileModalCtrl2 = _interopRequireDefault(_completeProfileModalCtrl);

var _contactSupportModalCtrl = __webpack_require__(523);

var _contactSupportModalCtrl2 = _interopRequireDefault(_contactSupportModalCtrl);

var _earnCreditModalCtrl = __webpack_require__(524);

var _earnCreditModalCtrl2 = _interopRequireDefault(_earnCreditModalCtrl);

var _editCitiesModalCtrl = __webpack_require__(525);

var _editCitiesModalCtrl2 = _interopRequireDefault(_editCitiesModalCtrl);

var _editContactInformationModalCtrl = __webpack_require__(526);

var _editContactInformationModalCtrl2 = _interopRequireDefault(_editContactInformationModalCtrl);

var _editCreditCardModalCtrl = __webpack_require__(527);

var _editCreditCardModalCtrl2 = _interopRequireDefault(_editCreditCardModalCtrl);

var _editMembershipModalCtrl = __webpack_require__(528);

var _editMembershipModalCtrl2 = _interopRequireDefault(_editMembershipModalCtrl);

var _editProfileModalCtrl = __webpack_require__(529);

var _editProfileModalCtrl2 = _interopRequireDefault(_editProfileModalCtrl);

var _enterPromoModalCtrl = __webpack_require__(530);

var _enterPromoModalCtrl2 = _interopRequireDefault(_enterPromoModalCtrl);

var _forgotPasswordModalCtrl = __webpack_require__(531);

var _forgotPasswordModalCtrl2 = _interopRequireDefault(_forgotPasswordModalCtrl);

var _getMembershipModalCtrl = __webpack_require__(532);

var _getMembershipModalCtrl2 = _interopRequireDefault(_getMembershipModalCtrl);

var _loginModalCtrl = __webpack_require__(534);

var _loginModalCtrl2 = _interopRequireDefault(_loginModalCtrl);

var _searchModalCtrl = __webpack_require__(536);

var _searchModalCtrl2 = _interopRequireDefault(_searchModalCtrl);

var _shareLinkModalCtrl = __webpack_require__(537);

var _shareLinkModalCtrl2 = _interopRequireDefault(_shareLinkModalCtrl);

var _termsModalCtrl = __webpack_require__(538);

var _termsModalCtrl2 = _interopRequireDefault(_termsModalCtrl);

var _controller = __webpack_require__(522);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('bookingWidgetModalCtrl', _bookingWidgetModalCtrl2.default);
  app.controller('completeProfileModalCtrl', _completeProfileModalCtrl2.default);
  app.controller('contactSupportModalCtrl', _contactSupportModalCtrl2.default);
  app.controller('earnCreditModalCtrl', _earnCreditModalCtrl2.default);
  app.controller('editCitiesModalCtrl', _editCitiesModalCtrl2.default);
  app.controller('editContactInformationModalCtrl', _editContactInformationModalCtrl2.default);
  app.controller('editCreditCardModalCtrl', _editCreditCardModalCtrl2.default);
  app.controller('editMembershipModalCtrl', _editMembershipModalCtrl2.default);
  app.controller('editProfileModalCtrl', _editProfileModalCtrl2.default);
  app.controller('enterPromoModalCtrl', _enterPromoModalCtrl2.default);
  app.controller('forgotPasswordModalCtrl', _forgotPasswordModalCtrl2.default);
  app.controller('getMembershipModalCtrl', _getMembershipModalCtrl2.default);
  app.controller('loginModalCtrl', _loginModalCtrl2.default);
  app.controller('searchModalCtrl', _searchModalCtrl2.default);
  app.controller('shareLinkModalCtrl', _shareLinkModalCtrl2.default);
  app.controller('termsModalCtrl', _termsModalCtrl2.default);
  app.controller('confirmationModalCtrl', _controller2.default);
}

exports.default = {
  init: init
};
module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__(110);

var _extend3 = _interopRequireDefault(_extend2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $uibModalInstance, input) {
  $scope.cancel = function () {
    $uibModalInstance.dismiss(false);
  };

  $scope.config = (0, _extend3.default)(input, {
    success: function success(resp) {
      $uibModalInstance.close(resp);
    },
    error: function error(resp) {
      $scope.cancel(resp);
    },
    compactLayout: true
  });
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'input'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = modalService;

var _completeProfile = __webpack_require__(871);

var _completeProfile2 = _interopRequireDefault(_completeProfile);

var _login = __webpack_require__(883);

var _login2 = _interopRequireDefault(_login);

var _editProfile = __webpack_require__(879);

var _editProfile2 = _interopRequireDefault(_editProfile);

var _editContactInformation = __webpack_require__(876);

var _editContactInformation2 = _interopRequireDefault(_editContactInformation);

var _editCreditCard = __webpack_require__(877);

var _editCreditCard2 = _interopRequireDefault(_editCreditCard);

var _editMembership = __webpack_require__(878);

var _editMembership2 = _interopRequireDefault(_editMembership);

var _editCities = __webpack_require__(875);

var _editCities2 = _interopRequireDefault(_editCities);

var _enterPromo = __webpack_require__(880);

var _enterPromo2 = _interopRequireDefault(_enterPromo);

var _forgotPassword = __webpack_require__(881);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _contactSupport = __webpack_require__(873);

var _contactSupport2 = _interopRequireDefault(_contactSupport);

var _shareLink = __webpack_require__(885);

var _shareLink2 = _interopRequireDefault(_shareLink);

var _bookingWidgetModal = __webpack_require__(870);

var _bookingWidgetModal2 = _interopRequireDefault(_bookingWidgetModal);

var _getMembershipModal = __webpack_require__(882);

var _getMembershipModal2 = _interopRequireDefault(_getMembershipModal);

var _searchModal = __webpack_require__(884);

var _searchModal2 = _interopRequireDefault(_searchModal);

var _template = __webpack_require__(872);

var _template2 = _interopRequireDefault(_template);

var _terms = __webpack_require__(886);

var _terms2 = _interopRequireDefault(_terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

modalService.$inject = ['$uibModal', '$rootScope', '$uibModalStack', 'tl.user.service', 'tl.auth.service', '$q'];

function modalService($uibModal, $rootScope, $uibModalStack, userService, authService, $q) {
  var ModalService = function () {
    function ModalService() {
      (0, _classCallCheck3.default)(this, ModalService);
    }

    (0, _createClass3.default)(ModalService, [{
      key: 'confirmation',
      value: function confirmation(options) {
        if (!options) throw new Error('modalService - confirmation() - options is required');
        if (!options.modalMessage) throw new Error('modalService - confirmation() - options.modalMessage is required');

        var _deferred = $q.defer();

        var modalInstance = $uibModal.open({
          template: _template2.default,
          controller: 'confirmationModalCtrl',
          windowClass: 'confirmation-modal-window',
          size: options.size || 'md',
          resolve: {
            modalHeader: function modalHeader() {
              return options.modalHeader || null;
            },
            modalMessage: function modalMessage() {
              return options.modalMessage || null;
            },
            confirmingBtnClass: function confirmingBtnClass() {
              return options.confirmingBtnClass || null;
            },
            confirmBtnTxt: function confirmBtnTxt() {
              return options.confirmBtnTxt || null;
            },
            confirmingBtnTxt: function confirmingBtnTxt() {
              return options.confirmingBtnTxt || null;
            },
            hideCancelBtn: function hideCancelBtn() {
              return options.hideCancelBtn || false;
            },
            cancelBtnTxt: function cancelBtnTxt() {
              return options.cancelBtnTxt || null;
            },
            deferred: function deferred() {
              return _deferred;
            }
          }
        });

        return $q(function (resolve, reject) {
          _deferred.promise.then(function (result) {
            if (result === false) {
              return modalInstance.close(null);
            }

            return resolve({
              confirm: result,
              modalInstance: modalInstance
            });
          }).catch(_catchModalError(reject));
        });
      }
    }, {
      key: 'completeProfile',
      value: function completeProfile(authConfig, success, error) {
        if (!$rootScope.currentUser) {
          if (error) error(false);
          return;
        }

        if (!authConfig.keysToVerify || authConfig.keysToVerify.length < 1) {
          if (error) error(false);
          return;
        }

        var modalInstance = $uibModal.open({
          template: _completeProfile2.default,
          controller: 'completeProfileModalCtrl',
          windowClass: 'complete-profile-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: {
              config: authConfig
            }
          }
        });

        modalInstance.result.then(function () {
          success();
        }).catch(function () {
          error();
        });
      }
    }, {
      key: 'editProfile',
      value: function editProfile() {
        $uibModal.open({
          template: _editProfile2.default,
          controller: 'editProfileModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'editContactInformation',
      value: function editContactInformation() {
        $uibModal.open({
          template: _editContactInformation2.default,
          controller: 'editContactInformationModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'editCreditCard',
      value: function editCreditCard(input, success, error) {
        $uibModal.open({
          template: _editCreditCard2.default,
          controller: 'editCreditCardModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'editMembership',
      value: function editMembership(input, success, error) {
        var modalInstance = $uibModal.open({
          template: _editMembership2.default,
          controller: 'editMembershipModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });

        modalInstance.result.then(function () {
          success();
        }).catch(function () {
          error();
        });
      }
    }, {
      key: 'editCities',
      value: function editCities() {
        $uibModal.open({
          template: _editCities2.default,
          controller: 'editCitiesModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'enterPromo',
      value: function enterPromo() {
        $uibModal.open({
          template: _enterPromo2.default,
          controller: 'enterPromoModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'forgotPassword',
      value: function forgotPassword(input, success, error) {
        $uibModal.open({
          template: _forgotPassword2.default,
          controller: 'forgotPasswordModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: input
          }
        });
      }
    }, {
      key: 'contactSupport',
      value: function contactSupport(input) {
        $uibModal.open({
          template: _contactSupport2.default,
          controller: 'contactSupportModalCtrl',
          windowClass: 'edit-form-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: input
          }
        });
      }
    }, {
      key: 'bookingWidget',
      value: function bookingWidget(input) {
        $uibModal.open({
          template: _bookingWidgetModal2.default,
          controller: 'bookingWidgetModalCtrl',
          windowClass: 'venue-book-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: input
          }
        });
      }
    }, {
      key: 'shareLink',
      value: function shareLink(input) {
        $uibModal.open({
          template: _shareLink2.default,
          controller: 'shareLinkModalCtrl',
          windowClass: 'venue-book-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: input
          }
        });
      }
    }, {
      key: 'authUser',
      value: function authUser(success, error, authConfig) {
        var user = userService.currentUser();
        var token = authService.authToken();

        if (user && token) {
          return success({
            user: user,
            token: token
          });
        }

        if (!authConfig) {
          authConfig = {};
        }

        var modalInstance = $uibModal.open({
          template: _login2.default,
          controller: 'loginModalCtrl',
          windowClass: 'login-modal',
          backdrop: true,
          keyboard: true,
          hideClose: false,
          startState: authConfig.startState ? authConfig.startStatetState : 'newUser',
          scope: $rootScope.$new(),
          resolve: {
            input: authConfig
          }
        });

        modalInstance.result.then(function () {
          user = userService.currentUser();
          token = authService.authToken();

          $rootScope.currentUser = user;

          if (success) {
            success({
              user: user,
              token: token
            });
          }
        }).catch(function () {
          if (error) {
            error(false);
          }
        });
      }
    }, {
      key: 'getMembership',
      value: function getMembership() {
        $uibModal.open({
          template: _getMembershipModal2.default,
          controller: 'getMembershipModalCtrl',
          windowClass: 'membership-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'search',
      value: function search() {
        $uibModal.open({
          template: _searchModal2.default,
          controller: 'searchModalCtrl',
          windowClass: 'search-modal',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new()
        });
      }
    }, {
      key: 'terms',
      value: function terms(input) {
        $uibModal.open({
          template: _terms2.default,
          controller: 'termsModalCtrl',
          backdrop: true,
          keyboard: true,
          scope: $rootScope.$new(),
          resolve: {
            input: input
          }
        });
      }
    }, {
      key: 'dismissAll',
      value: function dismissAll() {
        $uibModalStack.dismissAll();
      }
    }]);
    return ModalService;
  }();

  function _catchModalError(reject) {
    return function (error) {
      if (error && (error === 'backdrop click' || error === 'escape key press')) return;

      reject(error);
    };
  }

  return new ModalService();
}
module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ctrl($scope, $timeout, $window, $uibModalInstance) {
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $timeout(function () {
    var element = (0, _jquery2.default)('.search-modal input');

    if (element) {
      element.focus();
    }
  }, 300);
}

Ctrl.$inject = ['$scope', '$timeout', '$window', '$uibModalInstance'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance, input) {
  $scope.shareBarConfig = input;

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'input'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function Ctrl($scope, $uibModalInstance, input) {
  console.log('input', input);

  $scope.terms = input.terms;

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = ['$scope', '$uibModalInstance', 'input'];

exports.default = Ctrl;
module.exports = exports['default'];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partnerConfigs;

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

var _lodash = __webpack_require__(72);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

partnerConfigs.$inject = ['$rootScope', 'tl.query', 'tl.storage', '$location', '$window', '$timeout', '$state', 'jsSdk.booking', 'jsSdk.keychain', 'jsSdk.config', 'iframeService', 'urlService'];

var CURRENT_YEAR = new Date().getFullYear();

function partnerConfigs($rootScope, query, storage, $location, $window, $timeout, $state, jsSdkBooking, jsSdkKeychain, jsSdkConfig, iframeService, urlService) {
  function createPartnerConfig(options) {
    var result = _lodash2.default.extend({}, defaultPartnerConfig, options);
    return result;
  }

  var defaultPartnerConfig = {
    hiderHeader: false,
    hideFooter: false,
    logoLink: '/',
    logo: 'https://assets.tablelist.com/www-2/tablelist/tablelist_logo_white_new_v2.png',
    configure: function configure() {
      var $body = _angular2.default.element('body');
      $body.addClass('partner-' + this.slug);

      if (!this.attributionId) this.attributionId = query.get('attributionId');
      if (!this.attributionType) this.attributionType = query.get('attributionType');
    },
    createBooking: function createBooking(bookingData) {
      if (this.attributionId && this.attributionType) {
        bookingData.attributionId = this.attributionId;
        bookingData.attributionType = this.attributionType;
      }

      return jsSdkBooking.create(bookingData);
    },

    onBookingCreated: function onBookingCreated(booking, options) {
      if (!booking) return;

      options = options || {};

      var uiRouterOptions = options.replaceState ? {
        location: 'replace'
      } : {};

      $timeout(function () {
        $state.go('app.checkout', {
          bookingId: booking.id,
          iframe: options.iframe,
          theme: options.theme
        }, uiRouterOptions);
      });
    },
    filterVenues: function filterVenues(venues) {
      var _this = this;

      venues = _lodash2.default.filter(venues, function (venue) {
        return _lodash2.default.includes(_this.venues, venue.id);
      });
      return venues;
    },
    filterCities: function filterCities(cities) {
      var _this = this;

      if (_this.cities) {
        cities = _lodash2.default.filter(cities, function (city) {
          return _lodash2.default.includes(_this.cities, city.slugName);
        });
      }

      return cities;
    },
    filterByAllowedItemTypes: function filterByAllowedItemTypes(itemTypes) {
      var _this = this;

      if (_this.itemType) {
        var lockTo = _this.itemType;

        itemTypes = _lodash2.default.filter(itemTypes, function (itemType) {
          return itemType.name === lockTo;
        });
      }

      return itemTypes;
    },
    getTags: function getTags() {
      var _this = this;

      return _this.tags && _this.tags.length ? _this.tags : [];
    },
    getItemType: function getItemType() {
      var _this = this;

      return _this.itemType ? _this.itemType : 'Venues';
    },
    widgetSettings: {
      lockTo: null
    }
  };

  var www = createPartnerConfig({
    slug: 'www',
    name: 'Tablelist',
    logo: 'https://assets.tablelist.com/www-2/tablelist/tablelist_logo_white_new_v2.png',
    hideHeader: false,
    hideFooter: false,
    default: true
  });

  var checkout = createPartnerConfig({
    slug: 'checkout',
    name: 'Tablelist Checkout',
    hideHeader: true
  });

  var venue = createPartnerConfig({
    slug: 'venue',
    name: 'Tablelist Venue',
    hideHeader: true,
    hideFooter: true,
    widgetSettings: {
      lockTo: 'venue'
    }
  });

  var widget = createPartnerConfig({
    slug: 'widget',
    name: 'Tablelist Widget',
    hideHeader: true,
    hideFooter: true,
    widgetSettings: {
      lockTo: 'venue'
    },
    onBookingCreated: function onBookingCreated(booking) {
      if (!booking) return;

      var queryParams = {};

      if ($location.search() && $location.search().src) {
        queryParams.src = $location.search().src;
      }

      var prospectToken = jsSdkKeychain.getProspectToken();

      if (prospectToken) {
        queryParams.prospect = prospectToken;
      }

      if ($rootScope.affiliateId) {
        queryParams.affiliateId = $rootScope.affiliateId;
      }

      if (jsSdkConfig.attributionId) {
        queryParams.attributionId = jsSdkConfig.attributionId;
      }

      if (jsSdkConfig.attributionType) {
        queryParams.attributionType = jsSdkConfig.attributionType;
      }

      var targetURL = _config2.default.DOMAIN + '/checkout/' + booking.id;

      var params = {
        eventType: 'checkoutRedirect',
        url: urlService.addQueryParams(targetURL, queryParams)
      };

      iframeService.postMessage(params);

      $timeout(function () {
        defaultPartnerConfig.onBookingCreated(booking);
      }, 300);
    }
  });

  var halloween = createPartnerConfig({
    slug: 'halloween',
    name: 'Halloween ' + CURRENT_YEAR,
    path: '/halloween'
  });

  var nye = createPartnerConfig({
    slug: 'nye',
    name: 'New Years ' + CURRENT_YEAR,
    path: '/newyears'
  });

  var newyears = createPartnerConfig({
    slug: 'newyears',
    name: 'New Years ' + CURRENT_YEAR,
    path: '/newyears'
  });

  var rockwellmmwchuckie = createPartnerConfig({
    slug: 'rockwellmmwchuckie',
    name: 'Rockwell MMW Chuckie',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/chuckie-exclusive-hip-hop-set-benefitting-fuck-cancer-at-rockwell-miami-aba689d7b654aaf5',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  var rockwellmmwtorylanez = createPartnerConfig({
    slug: 'rockwellmmwtorylanez',
    name: 'Rockwell MMW Tory Lanel',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/tory-lanez-album-release-party-at-rockwell-64a4341f480cee61',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  var rockwellmmwirie = createPartnerConfig({
    slug: 'rockwellmmwirie',
    name: 'Rockwell MMW Irie',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/irie-miami-music-week-at-rockwell-dc3d0227b9bb6f9a',
    attributionId: '39cb704404bfb421',
    attributionType: 'MEMBER'
  });

  var superbowlAtFilifera = createPartnerConfig({
    slug: 'super-bowl-lii-at-filifera',
    name: 'Super Bowl LII at Filifera',
    logo: 'https://assets.tablelist.com/www/assets/tablelist_logo_new.png',
    path: '/e/super-bowl-lii-at-filifera-f38025d54fd045c9',
    attributionId: '3ecbe3e1d32b0b38',
    attributionType: 'MEMBER'
  });

  var redfez = createPartnerConfig({
    slug: 'redfez',
    name: 'Red Fez',
    path: '/e/red-fez-3-the-final-edition-at-living-room-at-the-w-austin-d1763f60df717ff6',
    attributionId: '0251887142817af4',
    attributionType: 'MEMBER'
  });

  var yelp = createPartnerConfig({
    slug: 'yelp',
    name: 'Yelp',
    hideHeader: true,
    hideFooter: true,
    doNotVerifyInfo: true,
    hideBookingBgImages: true,
    widgetSettings: {
      lockTo: 'venue'
    },
    configure: function configure() {

      var _this = this;

      _this.opportunityToken = query.get('opportunity_token') || storage.get('opportunity_token');

      _this.targetOrigin = _this.getTargetOrigin();

      query.set('opportunity_token', _this.opportunityToken);
      storage.set('opportunity_token', _this.opportunityToken);

      return defaultPartnerConfig.configure.call(_this);
    },
    createBooking: function createBooking(bookingData) {
      var _this = this;

      if (!_this.opportunityToken) {
        _this.opportunityToken = query.get('opportunity_token');
      }

      bookingData = bookingData || {};
      bookingData.status = null;
      bookingData.partner = {
        type: _this.name,
        data: {
          opportunityToken: _this.opportunityToken
        }
      };

      bookingData.client = 'yelp';

      return defaultPartnerConfig.createBooking.call(_this, bookingData);
    },
    onBookingCreated: function onBookingCreated(booking) {
      var _this = this;

      if (!booking) return;

      var params = {
        eventType: 'checkoutRedirect',
        orderID: booking.partner.id
      };

      iframeService.postMessage(params, _this.targetOrigin);
    },
    getTargetOrigin: function getTargetOrigin() {
      var yelpSite = query.get('yelp_site') || 'www';
      var yelpLocale = query.get('yelp_locale') || 'en_US';

      var targetOrigins = [{
        yelp_site: 'www',
        yelp_locale: 'en_US',
        origin: 'https://www.yelp.com'
      }, {
        yelp_site: 'm',
        yelp_locale: 'en_US',
        origin: 'https://m.yelp.com'
      }, {
        yelp_site: 'www',
        yelp_locale: 'en_GB',
        origin: 'https://www.yelp.co.uk'
      }, {
        yelp_site: 'm',
        yelp_locale: 'en_GB',
        origin: 'https://m.yelp.co.uk'
      }, {
        yelp_site: 'www',
        yelp_locale: 'fr_FR',
        origin: 'https://www.yelp.fr'
      }, {
        yelp_site: 'm',
        yelp_locale: 'fr_FR',
        origin: 'https://m.yelp.fr'
      }, {
        yelp_site: 'www',
        yelp_locale: 'fr_CA',
        origin: 'https://fr.yelp.ca'
      }, {
        yelp_site: 'm',
        yelp_locale: 'fr_CA',
        origin: 'https://fr.m.yelp.ca'
      }, {
        yelp_site: 'www',
        yelp_locale: 'ch_CH',
        origin: 'https://it.yelp.ch'
      }, {
        yelp_site: 'm',
        yelp_locale: 'ch_CH',
        origin: 'https://m.yelp.ch'
      }, {
        yelp_site: 'm',
        yelp_locale: 'it_CH',
        origin: 'https://it.m.yelp.ch'
      }, {
        yelp_site: 'w',
        yelp_locale: 'ch_CH',
        origin: 'https://www.yelp.ch'
      }];

      var targetOrigin = _lodash2.default.find(targetOrigins, {
        yelp_site: yelpSite,
        yelp_locale: yelpLocale
      });

      return targetOrigin ? targetOrigin.origin : null;
    }
  });

  return {
    www: www,
    local: www,
    checkout: checkout,
    venue: venue,
    widget: widget,

    halloween: halloween,
    nye: nye,
    newyears: newyears,

    rockwellmmwchuckie: rockwellmmwchuckie,
    rockwellmmwtorylanez: rockwellmmwtorylanez,
    rockwellmmwirie: rockwellmmwirie,
    superbowlAtFilifera: superbowlAtFilifera,
    redfez: redfez,

    yelp: yelp,

    'yelp-dev': yelp,
    eventWidget: widget,
    venueWidget: widget
  };
}
module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = partnerService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

partnerService.$inject = ['$rootScope', '$location', '$window', 'tl.http', 'tl.query', '$state', 'utilsService', 'tl.config', 'partnerConfigs', 'jsSdk.config'];

function partnerService($rootScope, $location, $window, $http, query, $state, utilsService, tlConfig, partnerConfigs, jsSdkConfig) {
  function getSubdomain() {
    var subdomain = query.subdomain().replace('-dev', '');

    return subdomain !== 'localhost' ? subdomain : null;
  }

  var PartnerService = function () {
    function PartnerService() {
      (0, _classCallCheck3.default)(this, PartnerService);
    }

    (0, _createClass3.default)(PartnerService, [{
      key: 'init',
      value: function init() {
        var partner = query.get('partner') || getSubdomain();

        var partnerName = partner || 'www';

        this.partner = partnerConfigs[partnerName] || _underscore2.default.find(_underscore2.default.values(partnerConfigs), {
          slug: partnerName
        }) || partnerConfigs.www;

        this.partner.configure();

        if (this.partner.attributionId) {
          jsSdkConfig.setAttributionId(this.partner.attributionId);
        }

        if (this.partner.attributionType) {
          jsSdkConfig.setAttributionType(this.partner.attributionType);
        }
      }
    }, {
      key: 'filterByAllowedItemTypes',
      value: function filterByAllowedItemTypes(itemTypes) {
        return this.partner ? this.partner.filterByAllowedItemTypes(itemTypes) : null;
      }
    }, {
      key: 'filterCities',
      value: function filterCities(cities) {
        return this.partner ? this.partner.filterCities(cities) : null;
      }
    }, {
      key: 'getTags',
      value: function getTags() {
        return this.partner ? this.partner.getTags() : null;
      }
    }, {
      key: 'getItemType',
      value: function getItemType() {
        return this.partner ? this.partner.getItemType() : null;
      }
    }]);
    return PartnerService;
  }();

  return new PartnerService();
}
module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = regexService;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

regexService.$inject = [];

function regexService() {
  var RegexService = function () {
    function RegexService() {
      (0, _classCallCheck3.default)(this, RegexService);
    }

    (0, _createClass3.default)(RegexService, [{
      key: "email",
      get: function get() {
        return new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/);
      }
    }]);
    return RegexService;
  }();

  return new RegexService();
}
module.exports = exports["default"];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = resizeService;

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

resizeService.$inject = ['$rootScope', '$window', '$location', '$timeout', 'loggerService', 'iframeService', 'partnerService'];

function resizeService($rootScope, $window, $location, $timeout, logger, iframeService, partnerService) {
  var ResizeService = function () {
    function ResizeService() {
      (0, _classCallCheck3.default)(this, ResizeService);
    }

    (0, _createClass3.default)(ResizeService, [{
      key: 'resizeToElementHeight',
      value: function resizeToElementHeight(elementSelector, minHeight) {
        var targetOrigin = partnerService.partner ? partnerService.partner.targetOrigin : null;

        $timeout(function () {
          var $el = _angular2.default.element(elementSelector);

          var outerHeight = $el.outerHeight();

          var message = {
            eventType: 'setHeight',
            height: minHeight && outerHeight < minHeight ? minHeight : outerHeight
          };

          iframeService.postMessage(message, targetOrigin);
        });
      }
    }]);
    return ResizeService;
  }();

  return new ResizeService();
}
module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(553);

var _values2 = _interopRequireDefault(_values);

exports.default = trackingService;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _appboy = __webpack_require__(156);

var _appboy2 = _interopRequireDefault(_appboy);

var _segmentEvents = __webpack_require__(6);

var _segmentEvents2 = _interopRequireDefault(_segmentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

trackingService.$inject = ['$rootScope', 'segment', 'tl.user.service', 'tl.track.service', 'tl.user.service', 'tl.ee', 'tl.config'];

function trackingService($rootScope, segmentService, userService, tlTrackingService, UserService, tlEE, tlConfig) {
  tlEE.on(UserService.EVENTS().USER_UPDATED, function (event, user) {
    identify(user);
  });

  $rootScope.$on('$stateChangeSuccess', function () {
    pageview();

    if ($rootScope.currentUser) {
      identify($rootScope.currentUser);
    }
  });

  $rootScope.$on('login', function () {
    trackEvent(_segmentEvents2.default.LoggedIn);
  });

  $rootScope.$on('logout', function () {
    trackEvent(_segmentEvents2.default.LoggedOut);
  });

  function pageview() {
    return segmentService.page();
  }

  function identify(user) {
    if (!user) return null;

    var createdAt = (0, _moment2.default)(user.created).toISOString();

    var traits = {
      firstName: user.firstName,
      lastName: user.lastName,
      name: user.name,
      email: user.email,
      gender: user.gender,
      phone: user.phone,
      createdAt: createdAt
    };

    _appboy2.default.resumeWebTracking();

    _appboy2.default.init();

    _appboy2.default.identify(user);

    window.snaptr('init', '02831f2c-e454-4816-95c6-c81efcec10b2', {
      user_email: user.email
    });

    return segmentService.identify(user.id, traits);
  }

  function trackEvent(eventName) {
    var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!eventName) {
      console.log('Tracking Error. No segment event name provided');

      return;
    }

    if (!(0, _values2.default)(_segmentEvents2.default).includes(eventName)) {
      console.log('Unable to find valid segment event for ' + eventName + '. Please send a correct tracking event');

      return;
    }

    console.log('TRACK EVENT', eventName);

    eventData.src = tlConfig.SUB_CLIENT;

    segmentService.track(eventName, eventData);

    tlTrackingService.send(eventName, eventData);

    _appboy2.default.track(eventName, eventData);

    window.snaptr('track', 'PAGE_VIEW');
  }

  return {
    trackEvent: trackEvent,
    identify: identify
  };
}
module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = urlService;

var _underscore = __webpack_require__(22);

var _underscore2 = _interopRequireDefault(_underscore);

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

urlService.$inject = [];

var production = _config2.default.NODE_ENV === 'production';

function urlService() {
  var UrlService = function () {
    function UrlService() {
      (0, _classCallCheck3.default)(this, UrlService);
    }

    (0, _createClass3.default)(UrlService, [{
      key: 'venuePartnerLink',
      value: function venuePartnerLink(venueSlug) {
        var base = production ? 'partner' : 'partner-dev';
        var url = 'https://' + base + '.tablelist.com/register-venue/';

        return '' + url + venueSlug + '/step_one';
      }
    }, {
      key: 'eventLink',
      value: function eventLink(eventId) {
        var base = production ? 'www' : 'www-dev';
        var url = 'https://' + base + '.tablelist.com';

        return url + '/event/' + eventId;
      }
    }, {
      key: 'venueLink',
      value: function venueLink(venueSlug) {
        var base = production ? 'www' : 'www-dev';
        var url = 'https://' + base + '.tablelist.com/venues/';

        return url + venueSlug;
      }
    }, {
      key: 'bookLink',
      value: function bookLink(venueSlug) {
        var base = production ? 'www' : 'www-dev';
        var url = 'https://' + base + '.tablelist.com/book/';

        return url + venueSlug;
      }
    }, {
      key: 'addQueryParams',
      value: function addQueryParams(url, params) {
        if (!url) return '';
        if (!params) return url;

        params = _underscore2.default.pickBy(params, function (value) {
          return value !== null && value !== undefined;
        });

        url += '?' + _angular2.default.element.param(params);

        return url;
      }
    }]);
    return UrlService;
  }();

  return new UrlService();
}
module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(11);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = utilsService;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(15);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

utilsService.$inject = ['$rootScope', '$state', '$document', '$timeout', '$q', 'tl.auth.service', 'tl.user.service', 'loggerService', 'jsSdk.user'];

function todaysDate() {
  var utcDate = _moment2.default.utc();

  if (utcDate.hours() < 6) {
    utcDate.date(utcDate.date() - 1);
  }

  utcDate.hours(6);
  utcDate.minutes(0);
  utcDate.seconds(0);
  utcDate.milliseconds(0);

  return utcDate;
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function utilsService($rootScope, $state, $document, $timeout, $q, authService, userService, loggerService, jsSdkUserService) {
  var UtilsService = function () {
    function UtilsService() {
      (0, _classCallCheck3.default)(this, UtilsService);
    }

    (0, _createClass3.default)(UtilsService, [{
      key: 'sanitizeNewlines',
      value: function sanitizeNewlines(content) {
        if (content) return content.replace(/\n\r?/g, '<br />');

        return '';
      }
    }, {
      key: 'isMobileDevice',
      value: function isMobileDevice() {
        return this.isMobile.Android() || this.isMobile.iOS();
      }
    }, {
      key: 'isNewUser',
      value: function isNewUser(user) {
        var diff = (Date.now() - user.created) / 1000;

        return diff <= 10;
      }
    }, {
      key: 'guid',
      value: function guid() {
        return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
    }, {
      key: 'scrollTo',
      value: function scrollTo(_id, _offset, _speed, _delay) {
        var id = _id || null;
        var offset = _offset || 30;
        var delay = _delay || 0;

        var el = document.getElementById(id);

        $timeout(function () {
          try {
            $document.scrollToElement(el, offset, 500);
          } catch (err) {
            console.log(err);
          }
        }, delay);
      }
    }, {
      key: 'slugify',
      value: function slugify(name) {
        return name.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
      }
    }, {
      key: 'link',
      value: function link(url, params) {
        if (params) {
          url += this.convertParamsToQueryString(params);
        }

        window.location = url;
      }
    }, {
      key: 'mailto',
      value: function mailto(target, subject, body) {
        if (!subject) {
          subject = '';
        }

        if (!body) {
          body = '';
        }

        var mailtoLink = 'mailto:' + target + '?Subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);

        this.link(mailtoLink);
      }
    }, {
      key: 'sms',
      value: function sms(number) {
        this.link('sms:' + number);
      }
    }, {
      key: 'futureDate',
      value: function futureDate(time) {
        var today = todaysDate();

        return today.date(today.date() + time);
      }
    }, {
      key: 'getDayName',
      value: function getDayName(dayNumber) {
        dayNumber = parseInt(dayNumber, 10);

        switch (dayNumber) {
          case 0:
            return 'Sunday';
          case 1:
            return 'Monday';
          case 2:
            return 'Tuesday';
          case 3:
            return 'Wednesday';
          case 4:
            return 'Thursday';
          case 5:
            return 'Friday';
          case 6:
            return 'Saturday';
          default:
            return '';
        }
      }
    }, {
      key: 'getDayNameShort',
      value: function getDayNameShort(dayNumber) {
        var day = void 0;

        switch (dayNumber) {
          case 0:
            day = 'Sun';
            break;
          case 1:
            day = 'Mon';
            break;
          case 2:
            day = 'Tues';
            break;
          case 3:
            day = 'Wed';
            break;
          case 4:
            day = 'Thurs';
            break;
          case 5:
            day = 'Fri';
            break;
          case 6:
            day = 'Sat';
            break;
          default:
            break;
        }

        return day;
      }
    }, {
      key: 'logout',
      value: function logout() {
        authService.logout();

        $rootScope.currentUser = null;

        $state.go('app.home');
      }
    }, {
      key: 'getMapUrl',
      value: function getMapUrl(address, link) {
        if (!address || !address.city || !address.state || !address.zip) return;

        var query = [address.address, address.city, address.state, address.zip].join(' ');

        if (link) {
          return 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&key=AIzaSyABdXTugKjdXcNgwYO9wdX6GfVJNHD2_84';
        }

        return _config2.default.GOOGLE_MAPS_API_URL + '?q=' + encodeURIComponent(query) + '&key=' + _config2.default.GOOGLE_MAPS_API_KEY;
      }
    }, {
      key: 'createUrl',
      value: function createUrl(path) {
        var baseUrl = window.location.protocol + '//' + window.location.host;

        return baseUrl + path;
      }
    }, {
      key: 'mailtoLink',
      value: function mailtoLink(url, content) {
        var message = 'Here';

        return 'mailto:?subject=' + content + '&body=' + encodeURIComponent(message) + '';
      }
    }, {
      key: 'twitterLink',
      value: function twitterLink(url, content) {
        return 'https://twitter.com/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(content);
      }
    }, {
      key: 'facebookLink',
      value: function facebookLink(url) {
        var appId = '301282840002421';
        var redirect = 'https://www.tablelist.com/download';

        return 'https://www.facebook.com/dialog/share?app_id=' + encodeURIComponent(appId) + '&display=page' + '&href=' + encodeURIComponent(url) + '&redirect_uri=' + redirect;
      }
    }, {
      key: 'convertParamsToQueryString',
      value: function convertParamsToQueryString(params) {
        if (!params) return null;

        var data = [];

        for (var key in params) {
          var val = params[key];
          var param = encodeURIComponent(key) + '=' + encodeURIComponent(val);
          data.push(param);
        }

        return '?' + data.join('&');
      }
    }, {
      key: 'errorMessage',
      value: function errorMessage(resp) {
        var error = 'An error has occurred. Please try again or contact hello@tablelist.com for support.';

        if (resp && resp.message) {
          error = resp.message;
        } else if (resp && resp.errors && resp.errors[0] && resp.errors[0].message) {
          error = resp.errors[0].message;
        } else if (resp && resp.data && resp.data.errors && resp.data.errors[0] && resp.data.errors[0].message) {
          error = resp.data.errors[0].message;
        }

        return error;
      }
    }, {
      key: 'getBookingDateSentence',
      value: function getBookingDateSentence(booking) {
        if (!booking || !booking.date) return '';

        var now = _moment2.default.utc();
        var bookingDate = _moment2.default.utc(booking.date);

        var isToday = now.isSame(bookingDate, 'day');

        var a = isToday ? 'Today' : bookingDate.format('dddd');

        return a + ', ' + bookingDate.format('MMM Do YYYY') + ' at ' + booking.venue.name;
      }
    }, {
      key: 'defaultCityId',
      value: function defaultCityId() {
        var user = $rootScope.currentUser;

        if (user && user.location && user.location.preferred && user.location.preferred.id) {
          var city = user.location.preferred;

          return city.id;
        }

        return _config2.default.DEFAULT_CITY_ID;
      }
    }, {
      key: 'defaultCitySlug',
      value: function defaultCitySlug() {
        var user = $rootScope.currentUser;
        var citySlug = void 0;

        if (user && user.location && user.location.preferred && user.location.preferred.slugName) {
          citySlug = user.location.preferred.slugName;
        }

        return citySlug || _config2.default.DEFAULT_CITY_SLUG;
      }
    }, {
      key: 'setPreferredCity',
      value: function setPreferredCity(cityId) {
        if (!cityId) throw new Error('cityId');

        var user = $rootScope.currentUser;

        if (!user) return $q.reject(new Error('no current user'));

        if (user.location && user.location.preferred && user.location.preferred.id === cityId) {
          return $q.resolve(user);
        }

        return jsSdkUserService.updatePreferredCity(cityId, {
          city: cityId
        }).then(function () {
          return jsSdkUserService.me();
        });
      }
    }, {
      key: 'truncateString',
      value: function truncateString(string, maxLength) {
        if (!string) return '';
        if (!maxLength) return string;

        if (string.length > maxLength) {
          string = string.slice(0, maxLength) + ' ...';
        }

        return string;
      }
    }, {
      key: 'isMobile',
      get: function get() {
        return {
          Android: function Android() {
            return navigator.userAgent.match(/Android/i);
          },
          iOS: function iOS() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          }
        };
      }
    }]);
    return UtilsService;
  }();

  return new UtilsService();
}
module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function StateChange($rootScope, $state, jsSdkAuthService, tlAuthService, modalService, $timeout, $window, iframeService, $location, fraudService, metaTagService, partnerService) {
  partnerService.init();

  var appInitialized = false;

  $rootScope.$on('$stateChangeStart', function () {
    modalService.dismissAll();
  });

  $rootScope.$on('$stateChangeSuccess', function (fromState, toState) {
    if (!fromState) return;

    if (toState.scrollToTop === false) {
      return;
    }

    $timeout(function () {
      $window.scrollTo(0, 0);
    }, 100);

    iframeService.postMessage({
      eventType: 'routeChange',
      url: $location.absUrl()
    });

    fraudService.trackPageView();
  });

  $rootScope.$on('unauthorized', function () {
    jsSdkAuthService.logout();
    tlAuthService.logout();

    $state.go('app.login');
  });

  $rootScope.$on('$viewContentLoaded', function () {
    $timeout(function () {
      iframeService.postMessage({
        eventType: 'metaChange',
        title: metaTagService.getKey('title'),
        description: metaTagService.getKey('description'),
        facebookTitle: metaTagService.getKey('facebookTitle'),
        facebookDescription: metaTagService.getKey('facebookDescription'),
        deeplink: metaTagService.getKey('deeplink')
      });
    });
  });

  $rootScope.$on('$locationChangeStart', function () {
    if (appInitialized) return;

    appInitialized = true;

    var partner = partnerService.partner;

    if (partner && partner.path && partner.path !== $location.path() && $location.path() !== '/404') {
      $location.path(partner.path);
    }
  });
}

StateChange.$inject = ['$rootScope', '$state', 'jsSdk.auth', 'tl.auth.service', 'modalService', '$timeout', '$window', 'iframeService', '$location', 'fraudService', 'metaTagService', 'partnerService'];

exports.default = StateChange;
module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getErrorFromApiResponse: function getErrorFromApiResponse(response) {
    if (!response) return null;

    if (response.errors && response.errors.length) {
      return response.errors[0].message;
    }

    return 'Error';
  }
};
module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function combinePaths(path1, path2) {
  if (path1.indexOf('/') === path1.length - 1) path1 = path1.substring(0, path1.length - 1);
  if (path2.indexOf('/') === 0) path2 = path2.substring(1, path2.length);

  return path1 + '/' + path2;
}

exports.default = {
  combinePaths: combinePaths
};
module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('ng-bs-animated-button', []);

_angular2.default.module('ng-bs-animated-button', []).directive('ngBsAnimatedButton', ['$timeout', function ($timeout) {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      isSubmitting: '=',
      result: '=',
      options: '=?'
    },
    controller: ['$scope', function ($scope) {
      $scope.options = $scope.options || {};
      $scope.options = {
        buttonDefaultClass: $scope.options.buttonDefaultClass || 'btn-primary',
        buttonSubmittingClass: $scope.options.buttonSubmittingClass || 'btn-primary',
        buttonSuccessClass: $scope.options.buttonSuccessClass || 'btn-primary',
        buttonErrorClass: $scope.options.buttonErrorClass || 'btn-danger',
        buttonSizeClass: $scope.options.buttonSizeClass || null,
        buttonDefaultText: $scope.options.buttonDefaultText || 'Submit',
        buttonSubmittingText: $scope.options.buttonSubmittingText || 'Submitting...',
        buttonSuccessText: $scope.options.buttonSuccessText || 'Completed',
        buttonErrorText: $scope.options.buttonErrorText || 'There was an error',
        buttonSubmittingIcon: $scope.options.buttonSubmittingIcon || 'glyphicon glyphicon-refresh',
        buttonSuccessIcon: $scope.options.buttonSuccessIcon || 'glyphicon glyphicon-ok',
        buttonErrorIcon: $scope.options.buttonErrorIcon || 'glyphicon glyphicon-remove',
        buttonDefaultIcon: $scope.options.buttonDefaultIcon || '',
        formIsInvalid: $scope.options.formIsInvalid || '',
        animationCompleteTime: $scope.options.animationCompleteTime || '2000',
        iconsPosition: $scope.options.iconsPosition || 'left'
      };
    }],
    template: '<button type="submit" class="btn {{buttonClass}} {{buttonSize}} btn-ng-bs-animated clearfix" ng-disabled="{{formIsInvalid}}">' + '<div class="icons pull-{{iconsPosition}}">' + '<span class="{{buttonDefaultIcon}} icon-default"></span>' + '<span class="{{buttonSubmittingIcon}} icon-spinner icon-submit hidden"></span>' + '<span class="{{buttonSuccessIcon}} icon-result icon-success hidden"></span>' + '<span class="{{buttonErrorIcon}} icon-result icon-error hidden"></span>' + '</div>' + '<div class="text {{buttonTextFloatClass}}">{{buttonText}}</div>' + '</button>',
    link: function link(scope, element) {
      var el = element;

      var icons = {
        default: _angular2.default.element(el[0].querySelector('.icon-default')),
        submitting: _angular2.default.element(el[0].querySelector('.icon-submit')),
        result: _angular2.default.element(el[0].querySelectorAll('.icon-result')),
        success: _angular2.default.element(el[0].querySelector('.icon-success')),
        error: _angular2.default.element(el[0].querySelector('.icon-error'))
      };

      var endAnimation = function endAnimation() {
        scope.result = null;
        scope.buttonClass = scope.options.buttonDefaultClass;
        scope.buttonText = scope.options.buttonDefaultText;
        icons.default.removeClass('hidden');
        el.removeClass('is-active').attr('disabled', false);
        icons.result.addClass('hidden');
      };

      var setButtonTextFloatClass = function setButtonTextFloatClass() {
        if (scope.iconsPosition === 'left') {
          return 'pull-right';
        } else {
          return 'pull-left';
        }
      };

      scope.buttonClass = scope.options.buttonDefaultClass;
      scope.buttonSize = scope.options.buttonSizeClass;
      scope.formIsInvalid = scope.options.formIsInvalid;
      scope.iconsPosition = scope.options.iconsPosition;
      scope.buttonSubmittingIcon = scope.options.buttonSubmittingIcon;
      scope.buttonDefaultIcon = scope.options.buttonDefaultIcon;
      scope.buttonSuccessIcon = scope.options.buttonSuccessIcon;
      scope.buttonErrorIcon = scope.options.buttonErrorIcon;
      scope.iconsPosition = scope.options.iconsPosition;
      scope.buttonText = scope.options.buttonDefaultText;
      scope.buttonTextFloatClass = setButtonTextFloatClass();

      scope.$watch('isSubmitting', function (newValue) {
        if (newValue) {
          scope.buttonClass = scope.options.buttonSubmittingClass;
          scope.buttonText = scope.options.buttonSubmittingText;
          el.attr('disabled', true).addClass('is-active');
          icons.submitting.removeClass('hidden');
          icons.default.addClass('hidden');
        }
      }, true).bind(this);

      scope.$watch('result', function (newValue) {
        scope.isSubmitting = null;
        if (newValue === 'success') {
          scope.buttonClass = scope.options.buttonSuccessClass;
          scope.buttonText = scope.options.buttonSuccessText;
          icons.submitting.addClass('hidden');
          icons.success.removeClass('hidden');
          $timeout(endAnimation, scope.options.animationCompleteTime);
        }
        if (newValue === 'error') {
          scope.buttonClass = scope.options.buttonErrorClass;
          scope.buttonText = scope.options.buttonErrorText;
          icons.submitting.addClass('hidden');
          icons.error.removeClass('hidden');
          $timeout(endAnimation, scope.options.animationCompleteTime);
        }
      }, true).bind(this);
    }
  };
}]);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _stringify = __webpack_require__(82);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(64);

var _keys2 = _interopRequireDefault(_keys);

var _angular = __webpack_require__(13);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(339);

__webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('tl', ['ngResource', 'ngCookies', 'ngWebSocket']).provider('TablelistSdk', function () {

  var TL_ENV = window.TL_ENV || 'production';
  var TL_CLIENT = window.TL_CLIENT || 'web';

  var ENV_DEV = TL_ENV === 'development';
  var ENV_PROD = TL_ENV === 'production';
  var ENV_LOCAL = TL_ENV === 'local';
  var ENV_TEST = TL_ENV === 'test';

  var API = {
    production: 'https://api.tablelist.com',
    development: 'https://api-dev.tablelist.com',
    local: 'http://localhost:3000',
    test: 'https://api-dev.tablelist.com'
  };

  var WS = {
    production: 'wss://ws.tablelist.com',
    development: 'wss://ws-dev.tablelist.com',
    local: 'ws://localhost:3000',
    test: 'wss://ws-dev.tablelist.com'
  };

  var config = {
    ENV: TL_ENV,
    CLIENT: TL_CLIENT,
    SUB_CLIENT: null,
    ENV_DEV: ENV_DEV,
    ENV_PROD: ENV_PROD,
    ENV_LOCAL: ENV_LOCAL,
    ENV_TEST: ENV_TEST,
    API: API[TL_ENV],
    WS: WS[TL_ENV],
    setSubclient: setSubclient,
    setVersion: setVersion,
    setApiKey: setApiKey
  };

  function setEnv(env) {
    var api = API[env];
    var ws = WS[env];

    if (!api) throw new Error('Enviroment : ' + env + ' is not valid');

    config.ENV = env;
    config.ENV_DEV = env === 'development';
    config.ENV_PROD = env === 'production';
    config.ENV_LOCAL = env === 'local';
    config.ENV_TEST = env === 'test';
    config.API = api;
    config.WS = ws;
  }

  function setSubclient(subclient) {
    config.SUB_CLIENT = subclient;
  }

  function setVersion(version) {
    config.VERSION = version;
  }

  function setUseAuthHeader(useAuthHeader) {
    config.useAuthHeader = useAuthHeader || false;
  }

  function setApiUrl(apiUrl) {
    config.API = apiUrl;
  }

  function setApiKey(apiKey) {
    config.apiKey = apiKey;
  }

  return {
    setEnv: setEnv,
    setSubclient: setSubclient,
    setVersion: setVersion,
    setUseAuthHeader: setUseAuthHeader,
    setApiUrl: setApiUrl,
    setApiKey: setApiKey,

    $get: function $get() {
      return config;
    }

  };
}).service('tl.config', ['TablelistSdk', function (tablelist) {
  return tablelist;
}]);

_angular2.default.module('tl').factory('tl.resource', ['$resource', 'tl.http', function ($resource, http) {
  'use strict';

  function _url(endpoint) {
    return http.apiUrl(endpoint);
  }

  function _params(params) {
    return params;
  }

  function _actions(actions) {
    var _data = _commonActions();
    var actionKeys = (0, _keys2.default)(actions);
    for (var i = 0; i < actionKeys.length; i++) {
      var key = actionKeys[i];
      _data[key] = actions[key];
    }

    var keys = (0, _keys2.default)(_data);
    for (var n = 0; n < keys.length; n++) {
      var objectKey = keys[n];
      var action = _data[objectKey];
      if (action.url) {
        action.url = _url(action.url);
      }
    }

    return _data;
  }

  function _commonActions(endpoint) {
    return {

      update: {
        method: 'PUT',
        url: endpoint
      },

      listImages: {
        method: 'GET',
        url: endpoint + '/image',
        isArray: true
      },
      addImage: {
        method: 'POST',
        url: endpoint + '/image',
        isArray: true
      },
      deleteImage: {
        method: 'DELETE',
        url: endpoint + '/image/:imageId',
        isArray: true
      },
      setPrimaryImage: {
        method: 'PUT',
        url: endpoint + '/image/:imageId',
        isArray: true
      }
    };
  }

  function _resource(endpoint, url, params, actions) {
    var resource = $resource(url, params, actions);
    resource.ENDPOINT = endpoint;
    resource.URL = url;
    return resource;
  }

  return function (endpoint, urlParams, defaultActions) {

    var url = _url(endpoint);
    var params = _params(urlParams);
    var actions = _actions(defaultActions);

    return _resource(endpoint, url, params, actions);
  };
}]);

_angular2.default.module('tl').factory('tl.service', ['tl.http', 'tl.keychain', function (http, tlKeychain) {
  'use strict';

  var Service = function Service(resource) {
    this.resource = resource;
  };

  var extend = function extend(resource) {
    var ExtendedService = function ExtendedService() {
      Service.call(this, resource);
    };

    var proto = Service.prototype;
    var keys = (0, _keys2.default)(proto);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key !== 'constructor') {
        ExtendedService.prototype[key] = proto[key];
      }
    }

    return ExtendedService;
  };

  var DEFAULT_LIMIT = 100;
  var DEFAULT_SORT = '-created';

  Service.prototype.create = function (data, success, error) {
    return this.resource.save({}, data, success, error);
  };

  Service.prototype.read = function (id, success, error) {
    return this.resource.get({
      id: id
    }, success, error);
  };

  Service.prototype.update = function (id, data, success, error) {
    return this.resource.update({
      id: id
    }, data, success, error);
  };

  Service.prototype.delete = function (id, success, error) {
    return this.resource.delete({
      id: id
    }, success, error);
  };

  Service.prototype.list = function (limit, sort, success, error) {
    return this.resource.query({
      sort: sort || DEFAULT_SORT,
      limit: limit || DEFAULT_LIMIT
    }, success, error);
  };

  Service.prototype.query = function (query, limit, sort, success, error) {
    var queryString = this.buildQueryString(query);
    if (!queryString) return null;

    return this.resource.query({
      query: queryString,
      sort: sort || DEFAULT_SORT,
      limit: limit || DEFAULT_LIMIT
    }, success, error);
  };

  Service.prototype.totals = function (query, sort, success, error) {
    var queryString = this.buildQueryString(query);
    if (!queryString) return null;

    return this.resource.query({
      total: true,
      query: queryString,
      sort: sort || DEFAULT_SORT
    }, success, error);
  };

  Service.prototype.buildQueryString = function (query) {
    try {
      return (0, _stringify2.default)(query);
    } catch (err) {
      return null;
    }
  };

  Service.prototype.listImages = function (id, success, error) {
    return this.resource.listImages({
      id: id
    }, success, error);
  };

  Service.prototype.addImage = function (id, image, success, error) {
    image.id = id;
    return this.resource.addImage(image, success, error);
  };

  Service.prototype.deleteImage = function (id, imageId, success, error) {
    return this.resource.deleteImage({
      id: id,
      imageId: imageId
    }, success, error);
  };

  Service.prototype.setPrimaryImage = function (id, imageId, success, error) {
    return this.resource.setPrimaryImage({
      id: id,
      imageId: imageId
    }, success, error);
  };

  Service.prototype.exportUrl = function (query, sort) {
    var endpoint = this.resource.ENDPOINT;
    var index = this.resource.ENDPOINT.indexOf(":");
    if (index > -1) endpoint = endpoint.substring(0, index);
    var url = this.resource.URL.substring(0, this.resource.URL.lastIndexOf(":") - 1);
    url += "?query=" + encodeURIComponent((0, _stringify2.default)(query));
    url += "&sort=" + sort;
    url += "&admin=" + true;
    url += "&csv=" + true;
    url += "&auth=" + tlKeychain.authToken();
    return url;
  };

  return {
    extend: extend,
    common: Service
  };
}]);

_angular2.default.module('tl').service('tl.affiliatesale', ['tl.affiliatesale.resource', 'tl.affiliatesale.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.affiliatesale.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/affiliate-sale';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    },
    update: {
      method: 'PUT',
      url: endpoint + '/:id'
    }
  });
}]);

_angular2.default.module('tl').service('tl.affiliatesale.service', ['tl.affiliatesale.resource', 'tl.service', function (AffiliateSale, Service) {
  'use strict';

  var AffiliateSaleService = Service.extend(AffiliateSale);

  AffiliateSaleService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return AffiliateSale.list(options).$promise;
  };

  return new AffiliateSaleService();
}]);

_angular2.default.module('tl').factory('tl.cookie', ['$cookies', 'tl.config', function ($cookies, config) {

  var DOMAIN = '.tablelist.com';

  var Cookie = function Cookie() {};

  Cookie.prototype.get = function (key) {
    if (!key) throw new Error('jsSdk.cookie - get() - key is required');
    return $cookies.get(key);
  };

  Cookie.prototype.set = function (key, value) {
    if (!key) throw new Error('jsSdk.cookie - set() - key is required');
    if (!value) throw new Error('jsSdk.cookie - set() - value is required');

    var secure = config.ENV_PROD;

    var expires = 'Fri, 31 Dec 9999 23:59:59 GMT';

    $cookies.put(key, value, {
      domain: DOMAIN,
      secure: secure,
      expires: expires
    });

    return true;
  };

  Cookie.prototype.remove = function (key) {
    if (!key) throw new Error('jsSdk.cookie - remove() - key is required');

    var secure = config.ENV_PROD;

    var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

    $cookies.remove(key, {
      domain: DOMAIN,
      secure: secure,
      expires: expires
    });

    return true;
  };

  Cookie.prototype.exists = function (key) {
    return typeof this.get(key) !== 'undefined';
  };

  return new Cookie();
}]);

_angular2.default.module('tl').factory('tl.ee', ['$rootScope', function ($rootScope) {

  var Event = function Event() {};

  Event.prototype.on = function (name, callback) {
    return $rootScope.$on(name, callback);
  };

  Event.prototype.emit = function (name, obj1, obj2, obj3) {
    return $rootScope.$emit(name, obj1, obj2, obj3);
  };

  return new Event();
}]);

_angular2.default.module('tl').factory('tl.facebook', ['tl.config', function (config) {

  var PERMISSIONS = ['public_profile', 'email'];

  var Facebook = function Facebook() {};

  Facebook.prototype.login = function (next) {
    try {
      return FB.login(function (response) {
        if (response && response.authResponse) {
          var accessToken = response.authResponse.accessToken;
          next(null, accessToken);
        } else {
          next(response);
        }
      }, { scope: PERMISSIONS });
    } catch (err) {
      return false;
    }
  };

  Facebook.prototype.events = function () {
    try {
      return FB.AppEvents.EventNames;
    } catch (err) {
      return {};
    }
  };

  Facebook.prototype.logEvent = function () {
    if (!config.ENV_PROD) return;

    try {
      return FB.AppEvents.logEvent.apply(this, arguments);
    } catch (err) {
      return false;
    }
  };

  Facebook.prototype.logPurchase = function () {
    if (!config.ENV_PROD) return;

    try {
      return FB.AppEvents.logPurchase.apply(this, arguments);
    } catch (err) {
      return false;
    }
  };

  return new Facebook();
}]);

_angular2.default.module('tl').factory('tlHTTPInterceptor', ['tl.config', 'tl.keychain', '$rootScope', '$q', function (config, keychain, $rootScope, $q) {
  'use strict';

  return {
    request: function request(data) {
      var headers = data.headers || {};

      var authToken = keychain.authToken();
      var prospectToken = keychain.prospectToken();

      if (authToken) {
        headers['x-access-token'] = authToken;
      } else {
        headers['x-prospect-token'] = prospectToken;
      }

      if (config.apiKey) {
        headers['api-key'] = config.apiKey;
      }

      if (config.apiKey) {
        headers['api-key'] = config.apiKey;
      }

      data.headers = headers;

      return data;
    },
    responseError: function responseError(response) {
      if (response.status === 401) {
        $rootScope.$emit('unauthorized');
      }
      return $q.reject(response);
    }
  };
}]).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('tlHTTPInterceptor');
}]).factory('tl.http', ['$http', 'tl.keychain', 'tl.config', function ($http, keychain, config) {

  var HTTP = function HTTP() {};

  HTTP.prototype.get = function (endpoint, params, options) {
    options = options || {};
    options.headers = buildHeaders(options.headers);
    return $http.get(this.apiUrl(endpoint, params), options);
  };

  HTTP.prototype.post = function (endpoint, body, options) {
    options = options || {};
    options.headers = buildHeaders(options.headers);
    return $http.post(this.apiUrl(endpoint), body, options);
  };

  HTTP.prototype.put = function (endpoint, body, options) {
    options = options || {};
    options.headers = buildHeaders(options.headers);
    return $http.put(this.apiUrl(endpoint), body, options);
  };

  HTTP.prototype.delete = function (endpoint, params, options) {
    options = options || {};
    options.headers = buildHeaders(options.headers);
    return $http.delete(this.apiUrl(endpoint, params), options);
  };

  HTTP.prototype.upload = function (endpoint, query, body, options) {
    options = options || {};
    options.headers = buildHeaders(options.headers);
    options.headers['Content-Type'] = undefined;

    options.transformRequest = _angular2.default.identity;
    return $http.post(this.apiUrl(endpoint, query), body, options);
  };

  HTTP.prototype.apiUrl = function (endpoint, params) {
    return buildUrl(config.API, endpoint, params);
  };

  HTTP.prototype.wsUrl = function (endpoint, params) {
    return buildUrl(config.WS, endpoint, params);
  };

  function buildUrl(base, endpoint, params) {
    params = params || {};

    if (endpoint.slice(0, 1) !== '/') {
      endpoint = '/' + endpoint;
    }

    var data = [];
    var keys = (0, _keys2.default)(params);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var val = params[key];
      var param = encodeURIComponent(key) + '=' + encodeURIComponent(val);
      data.push(param);
    }

    var url = base + endpoint;
    if (data.length > 0) {
      url += '?' + data.join('&');
    }
    return url;
  }

  function buildHeaders(headers) {
    headers = headers || {};

    var client = config.CLIENT;
    var subClient = config.SUB_CLIENT;
    if (subClient) {
      client = client + '-' + subClient;
    }
    headers['x-client-type'] = client;

    return headers;
  }

  return new HTTP();
}]);

_angular2.default.module('tl').factory('tl.keychain', ['tl.cookie', 'tl.utils', 'tl.config', function (cookie, utils, config) {
  'use strict';

  var SUFFIX = config.ENV_PROD ? '' : '_dev';
  var AUTH_KEY = 'tl_auth' + SUFFIX;
  var PROSPECT_KEY = 'tl_prospect' + SUFFIX;

  var _authToken = null;
  var _prospectToken = null;

  var Keychain = function Keychain() {};

  Keychain.prototype.authToken = function () {
    return _authToken || function () {
      _authToken = cookie.get(AUTH_KEY);
      return _authToken;
    }();
  };

  Keychain.prototype.setAuthToken = function (token) {
    _authToken = token || null;

    if (_authToken) {
      return cookie.set(AUTH_KEY, token);
    } else {
      return cookie.remove(AUTH_KEY);
    }
  };

  Keychain.prototype.prospectToken = function () {

    var token = _prospectToken || function () {
      _prospectToken = cookie.get(PROSPECT_KEY);
      return _prospectToken;
    }();

    if (!token) {
      token = utils.guid(16, '-');
      this.setProspectToken(token);
    }

    return token;
  };

  Keychain.prototype.setProspectToken = function (token) {
    _prospectToken = token || null;

    if (_prospectToken) {
      return cookie.set(PROSPECT_KEY, token);
    } else {
      return cookie.remove(PROSPECT_KEY);
    }
  };

  return new Keychain();
}]);

_angular2.default.module('tl').factory('tl.query', ['tl.config', '$location', function (config, $location) {

  var Query = function Query() {};

  Query.prototype.params = function () {
    return $location.search() || {};
  };

  Query.prototype.subdomain = function () {
    return window.location.hostname.split('.')[0];
  };

  Query.prototype.get = function (key) {
    return this.params()[key];
  };

  Query.prototype.set = function (key, value) {
    var data = this.params();
    data[key] = value;
    $location.search(data);
  };

  return new Query();
}]);

_angular2.default.module('tl').factory('tl.session', [function () {

  var CACHE = {};

  var Session = function Session() {};

  Session.prototype.get = function (key) {
    var json = null;
    try {
      var val = sessionStorage.getItem(key);
      json = JSON.parse(val);
    } catch (e) {
      json = CACHE[key];
    }
    return json;
  };

  Session.prototype.set = function (key, obj) {
    if (obj) {
      var success = null;
      try {
        var val = (0, _stringify2.default)(obj);
        success = sessionStorage.setItem(key, val);
      } catch (e) {
        CACHE[key] = obj;
        success = true;
      }
      return success;
    } else {
      this.remove(key);
    }
  };

  Session.prototype.remove = function (key) {
    var removed = null;
    try {
      removed = sessionStorage.removeItem(key);
    } catch (e) {
      delete CACHE[key];
      removed = true;
    }
    return removed;
  };

  Session.prototype.exists = function (key) {
    var exists = null;
    try {
      exists = this.get(key) !== null && this.get(key) !== undefined;
    } catch (e) {
      exists = CACHE[key] ? true : false;
    }
    return exists;
  };

  Session.prototype.clear = function () {
    var cleared = null;
    try {
      cleared = sessionStorage.clear();
    } catch (e) {
      CACHE = {};
      cleared = true;
    }
    return cleared;
  };

  return new Session();
}]);

_angular2.default.module('tl').factory('tl.socket', ['$websocket', 'tl.http', 'tl.keychain', function ($websocket, http, keychain) {

  var MAX_EVENTS = 200;

  return function (endpoint, onMessage, onError) {
    onMessage = onMessage || function () {};
    onError = onError || function () {};

    var _events = [];
    var ws = null;

    this.connect = function () {
      this.ws = ws = $websocket(this.socketUrl(endpoint), {
        reconnectIfNotNormalClose: true
      });

      ws.onMessage(function (message) {
        var data;

        try {
          data = JSON.parse(message.data);
        } catch (err) {
          return;
        }

        _events.unshift(data);

        onMessage(data);

        if (_events.length >= MAX_EVENTS) {
          _events.pop();
        }
      });

      return this;
    };

    this.events = function () {
      return _events;
    };

    this.isConnected = function () {
      return ws.readyState === 1;
    };

    this.close = function () {
      return ws.close(true);
    };

    this.socketUrl = function (endpoint) {
      var auth = keychain.authToken();
      var prospect = keychain.prospectToken();
      var params = {};

      if (auth) {
        params.auth = auth;
      } else {
        params.prospect = prospect;
      }

      return http.wsUrl(endpoint, params);
    };
  };
}]);

_angular2.default.module('tl').factory('tl.storage', [function () {
  'use strict';

  var CACHE = {};

  var Storage = function Storage() {};

  Storage.prototype.get = function (key) {
    var json = null;
    try {
      var val = localStorage.getItem(key);
      json = JSON.parse(val);
    } catch (e) {
      json = CACHE[key];
    }
    return json;
  };

  Storage.prototype.set = function (key, obj) {
    if (obj) {
      var success = null;
      try {
        var val = (0, _stringify2.default)(obj);
        success = localStorage.setItem(key, val);
      } catch (e) {
        CACHE[key] = obj;
        success = true;
      }
      return success;
    } else {
      this.remove(key);
    }
  };

  Storage.prototype.remove = function (key) {
    var removed = null;
    try {
      removed = localStorage.removeItem(key);
    } catch (e) {
      delete CACHE[key];
      removed = true;
    }
    return removed;
  };

  Storage.prototype.exists = function (key) {
    var exists = null;
    try {
      exists = this.get(key) !== null && this.get(key) !== undefined;
    } catch (e) {
      exists = CACHE[key] ? true : false;
    }
    return exists;
  };

  Storage.prototype.clear = function () {
    var cleared = null;
    try {
      cleared = localStorage.clear();
    } catch (e) {
      CACHE = {};
      cleared = true;
    }
    return cleared;
  };

  return new Storage();
}]);

_angular2.default.module('tl').factory('tl.utils', [function () {

  var Utils = function Utils() {};

  Utils.prototype.noop = function () {};

  Utils.prototype.slugify = function (string) {
    return string.trim().replace(/\s/gi, '-').replace(/('|\.)/gi, '').toLowerCase();
  };

  Utils.prototype.digits = function (text) {
    if (!text) return null;
    text = text + '';
    return text.replace(/\D/g, '').trim();
  };

  Utils.prototype.guid = function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };

  Utils.prototype.csv = function (lines) {
    var result = "data:text/csv;charset=utf-8,";
    result += lines.map(function (line) {
      return line.map(function (text) {
        return text && text.replace ? text.replace(/,/gi, '') : text;
      }).join(',');
    }).join('\n');
    window.open(encodeURI(result));
  };

  return new Utils();
}]);
_angular2.default.module('tl').service('tl.affiliatepayout', ['tl.affiliatepayout.resource', 'tl.affiliatepayout.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.affiliatepayout.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/affiliate-payout';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    },
    update: {
      method: 'PUT',
      url: endpoint + '/:id'
    }
  });
}]);
_angular2.default.module('tl').service('tl.affiliatepayout.service', ['tl.affiliatepayout.resource', 'tl.service', function (AffiliatePayout, Service) {
  'use strict';

  var AffiliatePayoutService = Service.extend(AffiliatePayout);

  AffiliatePayoutService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return AffiliatePayout.list(options).$promise;
  };

  return new AffiliatePayoutService();
}]);

_angular2.default.module('tl').service('tl.affiliate', ['tl.affiliate.resource', 'tl.affiliate.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.affiliate.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/affiliate/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    getById: {
      method: 'GET',
      url: endpoint,
      isArray: false
    },
    getPayoutStructuresById: {
      method: 'GET',
      url: endpoint + '/payoutstructure',
      isArray: true
    },
    create: {
      method: 'POST',
      url: 'affiliate',
      isArray: false
    },
    update: {
      method: 'PATCH',
      url: endpoint,
      isArray: false
    },
    list: {
      method: 'GET',
      url: 'affiliate',
      isArray: true
    },
    listSales: {
      method: 'GET',
      url: endpoint + '/sale',
      isArray: true
    },
    getSalesTotal: {
      method: 'GET',
      url: endpoint + '/sale/total'
    },
    getSalesLeaderboard: {
      method: 'GET',
      url: endpoint + '/leaderboard',
      isArray: true
    },
    getPayoutPeriod: {
      method: 'GET',
      url: endpoint + '/payout-period',
      isArray: true
    },
    getPromoCode: {
      method: 'GET',
      url: endpoint + '/promo',
      isArray: true
    },
    getTrackers: {
      method: 'GET',
      url: endpoint + '/tracker',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.affiliate.service', ['tl.affiliate.resource', 'tl.service', function (Affiliate, Service) {
  'use strict';

  var AffiliateService = Service.extend(Affiliate);

  AffiliateService.prototype.getById = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getById(options).$promise;
  };

  AffiliateService.prototype.getPayoutStructuresById = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getPayoutStructuresById(options).$promise;
  };

  AffiliateService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    return Affiliate.list(options).$promise;
  };

  AffiliateService.prototype.create = function (options) {
    if (!options) throw new Error('options is required');

    return Affiliate.create({}, options).$promise;
  };

  AffiliateService.prototype.update = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var affiliateId = options.id;
    delete options.id;

    return Affiliate.update({
      id: affiliateId
    }, options).$promise;
  };

  AffiliateService.prototype.listSales = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.listSales(options).$promise;
  };

  AffiliateService.prototype.getSalesTotal = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getSalesTotal(options).$promise;
  };

  AffiliateService.prototype.getSalesLeaderboard = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getSalesLeaderboard(options).$promise;
  };

  AffiliateService.prototype.getPayoutPeriod = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getPayoutPeriod(options).$promise;
  };

  AffiliateService.prototype.getPromoCode = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getPromoCode(options).$promise;
  };

  AffiliateService.prototype.listTrackers = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Affiliate.getTrackers(options).$promise;
  };

  return new AffiliateService();
}]);

_angular2.default.module('tl').service('tl.ambassador ', ['tl.ambassador.resource', 'tl.ambassador.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.ambassador.resource', ['tl.resource', function (resource) {

  var endpoint = '/ambassador';

  return resource(endpoint, {
    id: '@id'
  }, {
    getAll: {
      method: 'GET',
      url: 'ambassador',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.ambassador.service', ['tl.service', 'tl.ambassador.resource', function (Service, Ambassador) {

  var AmbassadorService = Service.extend(Ambassador);

  AmbassadorService.prototype.getAll = function () {
    return Ambassador.getAll();
  };

  return new AmbassadorService();
}]);

_angular2.default.module('tl').service('tl.auth', ['tl.auth.resource', 'tl.auth.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.auth.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/auth';

  return resource(endpoint, {}, {

    register: {
      method: 'POST',
      url: endpoint + '/register',
      isArray: false
    },

    login: {
      method: 'POST',
      url: endpoint + '/login',
      isArray: false
    },

    loginFacebook: {
      method: 'POST',
      url: endpoint + '/facebook',
      isArray: false
    },

    forgotPassword: {
      method: 'POST',
      url: endpoint + '/forgot',
      isArray: false
    },

    resetPassword: {
      method: 'POST',
      url: endpoint + '/reset',
      isArray: false
    }

  });
}]);

_angular2.default.module('tl').service('tl.auth.service', ['tl.auth.resource', 'tl.keychain', 'tl.user.service', 'tl.facebook', function (Auth, keychain, user, fb) {
  'use strict';

  var AuthService = function AuthService() {};

  AuthService.prototype.authToken = function () {
    return keychain.authToken();
  };

  AuthService.prototype.isLoggedIn = function () {
    return this.authToken() ? true : false;
  };

  AuthService.prototype.setAuthToken = function (token) {
    return keychain.setAuthToken(token);
  };

  AuthService.prototype.register = function (options, success, error) {
    success = success || function () {};

    if (!options) throw new Error('options is required');
    if (!options.email) throw new Error('options.email is required');
    if (!options.password) throw new Error('options.password is required');
    if (!options.firstName) throw new Error('options.firstName is required');
    if (!options.lastName) throw new Error('options.lastName is required');

    var _this = this;

    _this.setAuthToken(null);
    user.setCurrentUser(null);

    return Auth.register({}, options).$promise.then(function (auth) {
      _this.setAuthToken(auth.token);
      user.setCurrentUser(auth.user);
      success(auth);
    }, error);
  };

  AuthService.prototype.login = function (email, password, success, error) {
    success = success || function () {};

    var _this = this;

    _this.setAuthToken(null);
    user.setCurrentUser(null);

    return Auth.login({}, {
      email: email,
      password: password
    }).$promise.then(function (auth) {
      _this.setAuthToken(auth.token);
      user.setCurrentUser(auth.user);
      success(auth);
    }, error);
  };

  AuthService.prototype.loginWithFacebook = function (success, error) {
    success = success || function () {};

    var _this = this;

    _this.setAuthToken(null);
    user.setCurrentUser(null);

    fb.login(function (err, token) {
      if (err) {
        return error(err);
      } else {
        return Auth.loginFacebook({}, {
          facebookToken: token
        }).$promise.then(function (auth) {
          _this.setAuthToken(auth.token);
          user.setCurrentUser(auth.user);
          success(auth);
        }, error);
      }
    });
  };

  AuthService.prototype.logout = function () {
    this.setAuthToken(null);
    user.setCurrentUser(null);
    keychain.setProspectToken(null);
    return true;
  };

  AuthService.prototype.forgotPassword = function (email, success, error) {
    return Auth.forgotPassword({}, {
      email: email
    }, success, error);
  };

  AuthService.prototype.resetPassword = function (token, password, success, error) {
    return Auth.resetPassword({}, {
      resetToken: token,
      password: password
    }, success, error);
  };

  return new AuthService();
}]);

_angular2.default.module('tl').service('tl.answer', ['tl.answer.resource', 'tl.answer.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.answer.resource', ['tl.resource', function (resource) {

  var endpoint = '/answer';

  return resource(endpoint, {}, {});
}]);

_angular2.default.module('tl').service('tl.answer.service', ['tl.service', 'tl.answer.resource', function (Service, Answer) {

  var AnswerService = Service.extend(Answer);

  return new AnswerService();
}]);

_angular2.default.module('tl').service('tl.booking', ['tl.booking.resource', 'tl.booking.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.booking.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/booking/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    read: {
      method: 'GET',
      url: endpoint
    },
    create: {
      method: 'POST',
      url: 'booking'
    },
    complete: {
      method: 'POST',
      url: endpoint + '/complete'
    },
    void: {
      method: 'POST',
      url: endpoint + '/void'
    },
    refund: {
      method: 'POST',
      url: endpoint + '/refund'
    },
    cancellation: {
      method: 'POST',
      url: endpoint + '/cancellation'
    },
    join: {
      method: 'POST',
      url: 'booking/join'
    },
    decline: {
      method: 'POST',
      url: endpoint + '/decline'
    },
    updateBookingUser: {
      method: 'PUT',
      url: endpoint + '/users/:userId'
    },
    listOutgoingPayment: {
      method: 'GET',
      url: endpoint + '/outgoing-payment',
      isArray: true
    },
    createOutgoingPayment: {
      method: 'POST',
      url: endpoint + '/outgoing-payment'
    },
    readSplitTable: {
      method: 'GET',
      url: 'booking/split/:code'
    },
    listTerms: {
      method: 'GET',
      url: 'booking/:id/terms',
      isArray: true
    },
    addCondition: {
      method: 'POST',
      url: 'booking/:id/condition'
    },
    accept: {
      method: 'POST',
      url: 'booking/:id/accept'
    },
    authorize: {
      method: 'POST',
      url: 'booking/:id/authorize'
    },
    refundBookingUser: {
      method: 'POST',
      url: endpoint + '/user/:userId/refund'
    },
    listBookingTickets: {
      method: 'GET',
      url: endpoint + '/ticket',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.booking.service', ['tl.booking.resource', 'tl.service', function (Booking, Service) {
  'use strict';

  var DEFAULT_LIMIT = 100;
  var DEFAULT_SORT = '-created';

  var BookingService = Service.extend(Booking);

  BookingService.prototype.read = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Booking.read(options).$promise;
  };

  BookingService.prototype.query = function (options) {
    if (!options) throw new Error('options is required');

    var opts = {};
    var _this = this;

    opts.sort = options.sort || DEFAULT_SORT;
    opts.limit = options.limit || DEFAULT_LIMIT;
    opts.admin = options.admin || false;
    opts.select = options.select || opts.select;
    delete options.sort;
    delete options.limit;
    delete options.admin;
    delete options.select;
    opts.query = options;
    opts.query = _this.buildQueryString(opts.query);

    return Booking.query(opts).$promise;
  };

  BookingService.prototype.create = function (options) {
    if (!options) throw new Error('options is required');

    return Booking.create({}, options).$promise;
  };

  BookingService.prototype.complete = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var bookingId = options.id;
    delete options.id;

    return Booking.complete({
      id: bookingId
    }, options).$promise;
  };

  BookingService.prototype.void = function (id, options, success, error) {
    return Booking.void({
      id: id
    }, options, success, error);
  };

  BookingService.prototype.refund = function (id, amount, reason, success, error) {
    return Booking.refund({}, {
      id: id,
      money: amount,
      reason: reason
    }, success, error);
  };

  BookingService.prototype.cancellation = function (id, amount) {
    if (!id) throw new Error('id is required');
    if (!amount) throw new Error('amount is required');

    return Booking.cancellation({
      id: id
    }, {
      amount: amount
    }).$promise;
  };

  BookingService.prototype.join = function (splitCode, success, error) {
    return Booking.join({}, {
      splitCode: splitCode
    }, success, error);
  };

  BookingService.prototype.decline = function (id, userId, success, error) {
    return Booking.decline({
      id: id
    }, {
      userId: userId
    }, success, error);
  };

  BookingService.prototype.updateBookingUser = function (id, userId, updates, success, error) {
    return Booking.updateBookingUser({
      id: id,
      userId: userId
    }, updates, success, error);
  };

  BookingService.prototype.listOutgoingPayment = function (id, success, error) {
    return Booking.listOutgoingPayment({
      id: id
    }, success, error);
  };

  BookingService.prototype.createOutgoingPayment = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var id = options.id;
    delete options.id;

    return Booking.createOutgoingPayment({
      id: id
    }, options).$promise;
  };

  BookingService.prototype.readSplitTable = function (splitCode, success, error) {
    return Booking.readSplitTable({
      code: splitCode
    }, {}, success, error);
  };

  BookingService.prototype.listTerms = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Booking.listTerms(options).$promise;
  };

  BookingService.prototype.addCondition = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.condition) throw new Error('options.condition is required');

    var id = options.id;
    delete options.id;

    return Booking.addCondition({
      id: id
    }, options).$promise;
  };

  BookingService.prototype.accept = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.userId) throw new Error('options.userId is required');
    if (!options.paymentProfileId) throw new Error('options.paymentProfileId is required');

    var id = options.id;
    delete options.id;

    return Booking.accept({
      id: id
    }, options).$promise;
  };

  BookingService.prototype.authorize = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.userId) throw new Error('options.userId is required');
    if (!options.paymentProfileId) throw new Error('options.paymentProfileId is required');

    var id = options.id;
    delete options.id;

    return Booking.authorize({
      id: id
    }, options).$promise;
  };

  BookingService.prototype.refundBookingUser = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.userId) throw new Error('options.userId is required');
    if (!options.type) throw new Error('options.type is required');

    var id = options.id;
    delete options.id;
    var userId = options.userId;
    delete options.userId;

    return Booking.refundBookingUser({
      id: id,
      userId: userId
    }, options).$promise;
  };

  BookingService.prototype.listBookingTickets = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var id = options.id;
    delete options.id;

    return Booking.listBookingTickets({
      id: id
    }, options).$promise;
  };

  BookingService.prototype.update = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var id = options.id;
    delete options.id;

    return Booking.update({
      id: id
    }, options).$promise;
  };

  return new BookingService();
}]);

_angular2.default.module('tl').service('tl.campaign', ['tl.campaign.resource', 'tl.campaign.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.campaign.resource', ['tl.resource', function (resource) {

  var endpoint = '/campaign/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.campaign.service', ['tl.storage', 'tl.campaign.resource', 'tl.service', function (storage, Campaign, Service) {

  var CampaignService = Service.extend(Campaign);

  CampaignService.prototype.listInternal = function () {
    return Campaign.list({ internal: true }).$promise;
  };

  return new CampaignService();
}]);

_angular2.default.module('tl').service('tl.city', ['tl.city.resource', 'tl.city.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.city.resource', ['tl.resource', function (resource) {
  return resource('/city/:id', {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.city.service', ['tl.service', 'tl.city.resource', function (Service, City) {

  var CityService = Service.extend(City);

  return new CityService();
}]);

_angular2.default.module('tl').service('tl.client', ['tl.client.resource', 'tl.client.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.client.resource', ['tl.resource', function (resource) {

  var endpoint = '/client';

  return resource(endpoint, {}, {
    paymentToken: {
      method: 'POST',
      url: endpoint + '/paymentToken',
      isArray: false
    },
    startup: {
      method: 'GET',
      url: endpoint + '/startup',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.client.service', ['tl.service', 'tl.client.resource', function (Service, Client) {

  var ClientService = function ClientService() {};

  ClientService.prototype.paymentToken = function () {
    return Client.paymentToken().$promise;
  };

  ClientService.prototype.startup = function () {
    return Client.startup().$promise;
  };

  return new ClientService();
}]);

_angular2.default.module('tl').service('tl.event', ['tl.event.resource', 'tl.event.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.event.resource', ['tl.resource', function (resource) {

  var endpoint = '/event/:id';

  return resource(endpoint, {
    id: '@id',
    imageId: '@imageId'
  }, {
    update: {
      method: 'PATCH',
      url: endpoint,
      isArray: false
    },
    list: {
      method: 'GET',
      url: '/event',
      isArray: true
    },
    listForCity: {
      method: 'GET',
      url: '/city/:cityId/event',
      isArray: true
    },
    addStaff: {
      method: 'POST',
      url: endpoint + '/staff',
      isArray: false
    },
    updateStaff: {
      method: 'PUT',
      url: endpoint + '/staff/:staffId',
      isArray: false
    },
    deleteStaff: {
      method: 'DELETE',
      url: endpoint + '/staff/:staffId',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.event.service', ['tl.service', 'tl.event.resource', function (Service, Event) {

  var EventService = Service.extend(Event);

  EventService.prototype.list = function list(options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return Event.list(options).$promise;
  };

  EventService.prototype.read = function read(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Event.get(options).$promise;
  };

  EventService.prototype.create = function create(options) {
    if (!options) throw new Error('options is required');

    return Event.save({}, options).$promise;
  };

  EventService.prototype.update = function update(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Event.update({
      id: options.id
    }, options).$promise;
  };

  EventService.prototype.listForCity = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.cityId) throw new Error('options.cityId is required');

    return Event.listForCity(options).$promise;
  };

  EventService.prototype.listCityTonight = function (cityId, success, error) {
    return Event.listCityTonight({
      cityId: cityId
    }, success, error);
  };

  EventService.prototype.addStaff = function (eventId, userId, success, error) {
    return Event.addStaff({
      id: eventId
    }, {
      userId: userId
    }, success, error);
  };

  EventService.prototype.updateStaff = function (eventId, staffId, updates, success, error) {
    return Event.updateStaff({
      id: eventId,
      staffId: staffId
    }, updates, success, error);
  };

  EventService.prototype.deleteStaff = function (eventId, staffId, success, error) {
    return Event.deleteStaff({
      id: eventId,
      staffId: staffId
    }, success, error);
  };

  return new EventService();
}]);

_angular2.default.module('tl').service('tl.feed', ['tl.feed.resource', 'tl.feed.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.feed.resource', ['tl.resource', function (resource) {

  var endpoint = '/feed';

  return resource(endpoint, {
    id: '@id',
    userId: '@userId'
  }, {
    create: {
      method: 'POST',
      url: endpoint,
      isArray: true
    },
    remove: {
      method: 'DELETE',
      url: endpoint + '/:id',
      isArray: false
    },
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    },
    listUserFeed: {
      method: 'GET',
      url: '/user/:userId/feed',
      isArray: true
    },
    addLike: {
      method: 'POST',
      url: endpoint + '/:id/like',
      isArray: false
    },
    removeLike: {
      method: 'DELETE',
      url: endpoint + '/:id/like',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.feed.service', ['tl.service', 'tl.feed.resource', function (Service, Feed) {

  var FeedService = Service.extend(Feed);

  FeedService.prototype.create = function (options) {
    if (!options) throw new Error('FeedService.create - options is required');

    return Feed.create({}, options).$promise;
  };

  FeedService.prototype.remove = function (feedId, options) {
    if (!feedId) throw new Error('FeedService.remove - feedId is required');
    options = options || {};

    options.id = feedId;

    return Feed.remove(options).$promise;
  };

  FeedService.prototype.list = function (options) {
    options = options || {};
    return Feed.list(options).$promise;
  };

  FeedService.prototype.listUserFeed = function (userId, options) {
    if (!userId) throw new Error('FeedService.listUserFeed - userId is required');
    options = options || {};

    options.userId = userId;

    return Feed.listUserFeed(options).$promise;
  };

  FeedService.prototype.addLike = function (feedId, options) {
    if (!feedId) throw new Error('FeedService.addLike - feedId is required');

    return Feed.addLike({ id: feedId }, options).$promise;
  };

  FeedService.prototype.removeLike = function (feedId, options) {
    if (!feedId) throw new Error('FeedService.removeLike - feedId is required');

    return Feed.removeLike({ id: feedId }, options).$promise;
  };

  return new FeedService();
}]);

_angular2.default.module('tl').service('tl.image', ['tl.image.resource', 'tl.image.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.image.resource', ['tl.resource', function (resource) {

  var endpoint = '/image';

  return resource(endpoint, {}, {});
}]);

_angular2.default.module('tl').service('tl.image.service', ['tl.service', 'tl.image.resource', 'tl.http', '$q', function (Service, Image, tlhttp, $q) {

  var ImageService = Service.extend(Image);

  ImageService.prototype.upload = function (file, options) {

    var deferred = $q.defer();

    var formData = new FormData();
    formData.append('image', file);

    var maxFileSize = 16000000;

    if (file.size > maxFileSize) {
      deferred.reject('File cannot be greater than 4mb');
    }

    tlhttp.upload('/image', options, formData).success(function (data, status, headers, config) {
      deferred.resolve(data, status, headers, config);
    }).error(function (data, status, headers, config) {
      deferred.reject(data, status, headers, config);
    });

    return deferred.promise;
  };

  return new ImageService();
}]);

_angular2.default.module('tl').service('tl.inventory', ['tl.inventory.resource', 'tl.inventory.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.inventory.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/inventory/:id';

  return resource(endpoint, {
    id: '@id',
    tierId: '@tierId'
  }, {
    listForVenue: {
      method: 'GET',
      url: '/inventory',
      isArray: true
    },
    createTier: {
      method: 'POST',
      url: endpoint + '/tier',
      isArray: false
    },
    updateTier: {
      method: 'PUT',
      url: endpoint + '/tier/:tierId',
      isArray: false
    },
    deleteTier: {
      method: 'DELETE',
      url: endpoint + '/tier/:tierId',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.inventory.service', ['tl.service', 'tl.inventory.resource', function (Service, Inventory) {
  'use strict';

  var InventoryService = Service.extend(Inventory);

  InventoryService.prototype.listForVenue = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.venue) throw new Error('options.venue is required');

    options.start = options.start || moment().startOf('month').format("YYYY-MM-DD");
    options.end = options.end || moment().endOf('month').format("YYYY-MM-DD");

    return Inventory.listForVenue(options).$promise;
  };

  InventoryService.prototype.createTier = function (inventoryId, options) {
    if (!inventoryId) throw new Error('inventoryId is required');
    if (!options) throw new Error('options is required');
    if (options.price === undefined) throw new Error('options.price is required');
    if (options.quantity === undefined) throw new Error('options.quantity is required');

    return Inventory.createTier({
      id: inventoryId
    }, options).$promise;
  };

  InventoryService.prototype.updateTier = function (inventoryId, tierId, options) {
    if (!inventoryId) throw new Error('inventoryId is required');
    if (!tierId) throw new Error('tierId is required');
    if (!options) throw new Error('options is required');

    return Inventory.updateTier({
      id: inventoryId,
      tierId: tierId
    }, options).$promise;
  };

  InventoryService.prototype.deleteTier = function (inventoryId, tierId, options) {
    if (!inventoryId) throw new Error('inventoryId is required');
    if (!tierId) throw new Error('tierId is required');

    return Inventory.deleteTier({
      id: inventoryId,
      tierId: tierId
    }, options).$promise;
  };

  return new InventoryService();
}]);

_angular2.default.module('tl').service('tl.inquiry', ['tl.inquiry.resource', 'tl.inquiry.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.inquiry.resource', ['tl.resource', function (resource) {

  var endpoint = '/inquiry/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    approve: {
      method: 'POST',
      url: endpoint + '/approve',
      isArray: false
    },
    decline: {
      method: 'POST',
      url: endpoint + '/decline',
      isArray: false
    }
  });
}]);
_angular2.default.module('tl').service('tl.inquiry.service', ['tl.service', 'tl.inquiry.resource', function (Service, Inquiry) {
  'use strict';

  var DEFAULT_LIMIT = 100;
  var DEFAULT_SORT = '-created';

  var InquiryService = Service.extend(Inquiry);

  InquiryService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    options.sort = options.sort || DEFAULT_SORT;
    options.limit = options.limit || DEFAULT_LIMIT;

    return Inquiry.query(options).$promise;
  };

  InquiryService.prototype.approve = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.inquiryId) throw new Error('options.inquiryId is required');

    options.id = options.inquiryId;
    delete options.inquiryId;

    return Inquiry.approve(options).$promise;
  };

  InquiryService.prototype.decline = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.inquiryId) throw new Error('options.inquiryId is required');

    options.id = options.inquiryId;
    delete options.inquiryId;

    return Inquiry.decline(options).$promise;
  };

  return new InquiryService();
}]);

_angular2.default.module('tl').service('tl.inventory-tier-config', ['tl.inventory-tier-config.resource', 'tl.inventory-tier-config.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.inventory-tier-config.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/inventory-tier-config/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: '/inventory-tier-config',
      isArray: true
    },
    listInventory: {
      method: 'GET',
      url: '/inventory-tier-config/:id/inventory',
      isArray: true
    },
    create: {
      method: 'POST',
      url: '/inventory-tier-config',
      isArray: false
    },
    update: {
      method: 'PATCH',
      url: endpoint,
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.inventory-tier-config.service', ['tl.service', 'tl.inventory-tier-config.resource', function (Service, InventoryTierConfig) {
  'use strict';

  var InventoryTierConfigService = Service.extend(InventoryTierConfig);

  InventoryTierConfigService.prototype.create = function (options) {
    if (!options) throw new Error('options is required');

    return InventoryTierConfig.save({}, options).$promise;
  };

  InventoryTierConfigService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    return InventoryTierConfig.list(options).$promise;
  };

  InventoryTierConfigService.prototype.listInventory = function (options) {
    if (!options) throw new Error('options is required');

    return InventoryTierConfig.listInventory(options).$promise;
  };

  InventoryTierConfigService.prototype.update = function update(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return InventoryTierConfig.update({
      id: options.id
    }, options).$promise;
  };

  return new InventoryTierConfigService();
}]);

_angular2.default.module('tl').service('tl.inventory-summary', ['tl.inventory-summary.resource', 'tl.inventory-summary.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.inventory-summary.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/inventory-summary';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.inventory-summary.service', ['tl.service', 'tl.inventory-summary.resource', function (Service, InventorySummary) {
  'use strict';

  var InventorySummaryService = Service.extend(InventorySummary);

  InventorySummaryService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    return InventorySummary.list(options).$promise;
  };

  return new InventorySummaryService();
}]);

_angular2.default.module('tl').service('tl.invoice', ['tl.invoice.resource', 'tl.invoice.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.invoice.resource', ['tl.resource', function (resource) {

  var endpoint = '/invoice/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    update: {
      method: 'PUT',
      url: endpoint,
      isArray: false
    },
    readPdf: {
      method: 'GET',
      url: endpoint + '/pdf',
      isArray: false
    },
    createPdf: {
      method: 'POST',
      url: endpoint + '/pdf',
      isArray: false
    }

  });
}]);

_angular2.default.module('tl').service('tl.invoice.service', ['tl.service', 'tl.invoice.resource', function (Service, Invoice) {

  var InvoiceService = Service.extend(Invoice);

  InvoiceService.prototype.readPdf = function (invoiceId) {
    return Invoice.readPdf({
      id: invoiceId
    });
  };

  InvoiceService.prototype.createPdf = function (invoiceId) {
    return Invoice.createPdf({
      id: invoiceId
    });
  };

  return new InvoiceService();
}]);

_angular2.default.module('tl').service('tl.item', ['tl.item.resource', 'tl.item.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.item.resource', ['tl.resource', function (resource) {

  var endpoint = '/item/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: '/item',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.item.service', ['tl.service', 'tl.item.resource', function (Service, Item) {

  var ItemService = Service.extend(Item);

  ItemService.prototype.list = function list(options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return Item.list(options).$promise;
  };

  return new ItemService();
}]);

_angular2.default.module('tl').service('tl.metric', ['tl.metric.resource', 'tl.metric.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.metric.resource', ['tl.resource', function (resource) {

  var endpoint = '/metric/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    available: {
      method: 'GET',
      url: '/metric/available',
      isArray: true
    },

    queryMetrics: {
      method: 'GET',
      url: '/metric'
    }
  });
}]);

_angular2.default.module('tl').service('tl.metric.service', ['tl.service', 'tl.metric.resource', function (Service, Metric) {

  var MetricService = Service.extend(Metric);

  MetricService.prototype.availableMetrics = function (success, error) {
    return Metric.available({}, success, error);
  };

  MetricService.prototype.queryMetrics = function (metrics, period, range, options, success, error) {
    if (arguments.length < 6) {
      error = success;
      success = options;
      options = null;
    }

    var query = {
      metric: metrics,
      period: period,
      start: range[0].getTime(),
      end: range[1].getTime()
    };

    if (options) {
      var keys = (0, _keys2.default)(options);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        query[key] = options[key];
      }
    }

    return Metric.queryMetrics(query, success, error);
  };

  return new MetricService();
}]);

_angular2.default.module('tl').service('tl.outgoingPayment', ['tl.outgoingPayment.resource', 'tl.outgoingPayment.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.outgoingPayment.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/outgoing-payment/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    listTransaction: {
      method: 'GET',
      url: endpoint + '/transaction',
      isArray: true
    },
    listAuthorization: {
      method: 'GET',
      url: endpoint + '/authorization',
      isArray: true
    },
    update: {
      method: 'PUT',
      url: endpoint
    },
    delete: {
      method: 'DELETE',
      url: endpoint
    }
  });
}]);

_angular2.default.module('tl').service('tl.outgoingPayment.service', ['tl.outgoingPayment.resource', 'tl.service', function (OutgoingPayment, Service) {
  'use strict';

  var OutgoingPaymentService = Service.extend(OutgoingPayment);

  OutgoingPaymentService.prototype.listTransaction = function (id, success, error) {
    return OutgoingPayment.listTransaction({
      id: id
    }, success, error);
  };

  OutgoingPaymentService.prototype.listAuthorization = function (id, success, error) {
    return OutgoingPayment.listAuthorization({
      id: id
    }, success, error);
  };

  OutgoingPaymentService.prototype.update = function (id, options) {
    if (!id) throw new Error('id is required');
    if (!options) throw new Error('options is required');

    return OutgoingPayment.update({
      id: id
    }, options).$promise;
  };

  OutgoingPaymentService.prototype.delete = function (id) {
    if (!id) throw new Error('id is required');

    return OutgoingPayment.delete({
      id: id
    }).$promise;
  };

  return new OutgoingPaymentService();
}]);

_angular2.default.module('tl').service('tl.notify', ['tl.metric.resource', 'tl.metric.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.notify.resource', ['tl.resource', function (resource) {

  var endpoint = '/notify/adminapp';

  return resource(endpoint, {
    id: '@id'
  }, {
    sendAdminApp: {
      method: 'POST',
      url: endpoint,
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.notify.service', ['tl.service', 'tl.notify.resource', function (Service, Notify) {

  var NotifyService = Service.extend(Notify);

  NotifyService.prototype.sendAdminApp = function () {
    return Notify.sendAdminApp().$promise;
  };

  return new NotifyService();
}]);

_angular2.default.module('tl').service('tl.payment', ['tl.payment.resource', 'tl.payment.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.payment.resource', ['tl.resource', function (resource) {

  var endpoint = '/paymentProfile/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);
_angular2.default.module('tl').service('tl.payment.service', ['tl.service', 'tl.payment.resource', 'tl.utils', function (Service, Payment, utils) {
  'use strict';

  var PaymentService = Service.extend(Payment);

  PaymentService.prototype.addPaymentMethodNonce = function (options) {
    var data = {
      paymentMethodNonce: options.paymentMethodNonce
    };

    return this.create(data).$promise;
  };

  PaymentService.prototype.setDefaultPaymentProfile = function (options) {

    var profileId = options.id;

    if (!profileId) {
      throw "An existing profile is required. Missing options.id";
    }
    var data = {
      default: true
    };

    return this.update(profileId, data).$promise;
  };

  PaymentService.prototype.addPaymentProfile = function (options) {
    console.log('DEPRECATED - use .addPaymentMethodNonce');

    var data = {
      cardholderName: options.name,
      cardNumber: utils.digits(options.number),
      cardExpMonth: utils.digits(options.month),
      cardExpYear: utils.digits(options.year),
      cardCvv: utils.digits(options.cvv),
      cardZip: utils.digits(options.zip)
    };
    return this.create(data).$promise;
  };

  PaymentService.prototype.updatePaymentProfile = function (options) {

    var profileId = options.id;

    if (!profileId) {
      throw "An existing profile is required. Missing options.id";
    }
    var data = {
      cardholderName: options.name,
      cardNumber: utils.digits(options.number),
      cardExpMonth: utils.digits(options.month),
      cardExpYear: utils.digits(options.year),
      cardCvv: utils.digits(options.cvv),
      cardZip: utils.digits(options.zip)
    };
    return this.update(profileId, data).$promise;
  };

  PaymentService.prototype.addProfile = function (name, number, month, year, cvv, address, city, state, zip, success, error) {
    console.log('DEPRECATED - use .addPaymentProfile');
    var data = {
      cardholderName: name,
      cardNumber: utils.digits(number),
      cardExpMonth: utils.digits(month),
      cardExpYear: utils.digits(year),
      cardCvv: utils.digits(cvv),
      cardZip: utils.digits(zip),
      address: {
        address: address,
        city: city,
        state: state
      }
    };

    return this.create(data, success, error);
  };

  PaymentService.prototype.updateProfile = function (profileId, name, number, month, year, cvv, address, city, state, zip, success, error) {
    console.log('DEPRECATED - use .updatePaymentProfile');
    if (!profileId) {
      return this.addProfile(name, number, month, year, cvv, address, city, state, zip, success, error);
    }

    var data = {
      cardholderName: name,
      cardNumber: utils.digits(number),
      cardExpMonth: utils.digits(month),
      cardExpYear: utils.digits(year),
      cardCvv: utils.digits(cvv),
      cardZip: utils.digits(zip),
      address: {
        address: address,
        city: city,
        state: state
      }
    };

    return this.update(profileId, data, success, error);
  };

  return new PaymentService();
}]);

_angular2.default.module('tl').service('tl.permission', ['tl.permission.resource', 'tl.permission.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.permission.resource', ['tl.resource', function (resource) {

  var endpoint = '/permission/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    listVenuePermissions: {
      method: 'GET',
      url: '/permission/venue'
    }
  });
}]);

_angular2.default.module('tl').service('tl.permission.service', ['tl.permission.resource', 'tl.service', function (Permission, Service) {

  var PermissionService = Service.extend(Permission);

  PermissionService.prototype.listVenuePermissions = function listVenuePermissions(options) {
    return Permission.listVenuePermissions(options).$promise;
  };

  return new PermissionService();
}]);

_angular2.default.module('tl').service('tl.promo', ['tl.promo.resource', 'tl.promo.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.promo.resource', ['tl.resource', function (resource) {

  var endpoint = '/promo/:id';


  return resource(endpoint, {
    id: '@id',
    code: '@code'
  }, {
    redeem: {
      method: 'POST',
      url: '/promo/redeem'
    }
  }, {
    check: {
      method: 'GET',
      url: '/promo/check/:code'
    }
  });
}]);

_angular2.default.module('tl').service('tl.promo.service', ['tl.storage', 'tl.promo.resource', 'tl.service', function (storage, Promo, Service) {

  var PromoService = Service.extend(Promo);

  PromoService.prototype.redeem = function (promoCode) {
    return Promo.redeem({
      code: promoCode
    });
  };

  PromoService.prototype.check = function (promoCode) {
    return Promo.check({
      code: promoCode
    });
  };

  return new PromoService();
}]);

_angular2.default.module('tl').service('tl.prospect', ['tl.prospect.resource', 'tl.prospect.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.prospect.resource', ['tl.resource', function (resource) {

  var endpoint = '/prospect/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.prospect.service', ['tl.service', 'tl.prospect.resource', function (Service, Prospect) {

  var ProspectService = Service.extend(Prospect);

  ProspectService.prototype.updateProspect = function (data, success, error) {
    delete data._id;
    delete data.id;

    return Prospect.update({}, data, success, error);
  };

  return new ProspectService();
}]);
_angular2.default.module('tl').service('tl.question', ['tl.question.resource', 'tl.question.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.question.resource', ['tl.resource', function (resource) {

  var endpoint = '/question';

  return resource(endpoint, {
    id: '@id'
  }, {
    get: {
      method: 'GET',
      url: endpoint + '/:id'
    },
    listAnswers: {
      method: 'GET',
      url: endpoint + '/:id/answers',
      isArray: true
    },
    listTotalsForAnswers: {
      method: 'GET',
      url: endpoint + '/:id/answers/totals',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.question.service', ['tl.question.resource', 'tl.service', function (Question, Service) {

  var QuestionService = Service.extend(Question);

  QuestionService.prototype.listAnswers = function (id) {
    return Question.listAnswers({
      id: id
    });
  };

  QuestionService.prototype.listTotalsForAnswers = function (id) {
    return Question.listTotalsForAnswers({
      id: id
    });
  };

  return new QuestionService();
}]);

_angular2.default.module('tl').service('tl.report', ['tl.report.resource', 'tl.report.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.report.resource', ['tl.resource', function (resource) {

  var endpoint = '/report/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    reports: {
      method: 'GET',
      url: '/report-type'
    },
    download: {
      method: 'GET',
      url: endpoint + '/download'
    }
  });
}]);

_angular2.default.module('tl').service('tl.report.service', ['tl.service', 'tl.report.resource', function (Service, Report) {

  var ReportService = Service.extend(Report);

  ReportService.prototype.reports = function (success, error) {
    return Report.reports({}, success, error);
  };

  ReportService.prototype.listReports = function (key, success, error) {
    return Report.query({ report: key }, success, error);
  };

  ReportService.prototype.download = function (reportId, success, error) {
    return Report.download({ id: reportId }, success, error);
  };

  return new ReportService();
}]);

_angular2.default.module('tl').service('tl.review', ['tl.review.resource', 'tl.review.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.review.resource', ['tl.resource', function (resource) {

  var endpoint = '/review/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.review.service', ['tl.service', 'tl.review.resource', function (Service, Review) {

  var ReviewService = Service.extend(Review);

  ReviewService.prototype.read = function read(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Review.get(options).$promise;
  };

  ReviewService.prototype.update = function update(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Review.update({ id: options.id }, options).$promise;
  };

  return new ReviewService();
}]);

_angular2.default.module('tl').service('tl.reward', ['tl.reward.resource', 'tl.reward.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.reward.resource', ['tl.resource', function (resource) {

  var endpoint = '/reward/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.reward.service', ['tl.service', 'tl.reward.resource', function (Service, Reward) {

  var RewardService = Service.extend(Reward);

  return new RewardService();
}]);

_angular2.default.module('tl').service('tl.sale', ['tl.sale.resource', 'tl.sale.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.sale.resource', ['tl.resource', function (resource) {

  var endpoint = '/sale';

  return resource(endpoint, {
    id: '@id'
  }, {
    read: {
      method: 'GET',
      url: endpoint + '/:id',
      isArray: false
    },
    update: {
      method: 'PUT',
      url: endpoint + '/:id',
      isArray: false
    },
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.sale.service', ['tl.service', 'tl.sale.resource', function (Service, Sale) {

  var SaleService = Service.extend(Sale);

  SaleService.prototype.read = function read(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Sale.read(options).$promise;
  };

  SaleService.prototype.update = function update(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var id = options.id;
    delete options.id;

    return Sale.update({
      id: id
    }, options).$promise;
  };

  SaleService.prototype.list = function (options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return Sale.list(options).$promise;
  };

  return new SaleService();
}]);

_angular2.default.module('tl').service('tl.schedule', ['tl.schedule.resource', 'tl.schedule.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.schedule.resource', ['tl.resource', function (resource) {

  var endpoint = '/schedule/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.schedule.service', ['tl.service', 'tl.schedule.resource', function (Service, Schedule) {

  var ScheduleService = Service.extend(Schedule);

  return new ScheduleService();
}]);

_angular2.default.module('tl').service('tl.settings', ['tl.settings.resource', 'tl.settings.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.settings.resource', ['tl.resource', function (resource) {

  var endpoint = '/config';

  return resource(endpoint, {}, {

    status: {
      method: 'GET',
      url: '/status',
      isArray: false
    },

    config: {
      method: 'GET',
      url: '/config',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.settings.service', ['tl.service', 'tl.settings.resource', function (Service, Settings) {

  var SettingsService = function SettingsService() {};

  SettingsService.prototype.status = function (success, error) {
    return Settings.status({}, success, error);
  };

  SettingsService.prototype.config = function (success, error) {
    return Settings.config({}, success, error);
  };

  return new SettingsService();
}]);

_angular2.default.module('tl').service('tl.subscription', ['tl.subscription.resource', 'tl.subscription.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.subscription.resource', ['tl.resource', function (resource) {

  var endpoint = '/subscription/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    cancelSubscription: {
      method: "DELETE",
      url: '/subscription/:id'
    },
    subscriptionAction: {
      method: "POST",
      url: endpoint + '/action',
      params: {
        id: '@id'
      }
    }
  });
}]);
_angular2.default.module('tl').service('tl.subscription.service', ['tl.service', 'tl.subscription.resource', function (Service, Subscription) {
  'use strict';

  var SUBSCRIPTION_ACTION = {
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD'
  };

  var SubscriptionService = Service.extend(Subscription);

  SubscriptionService.prototype.cancelSubscription = function (id, success, error) {
    return Subscription.cancelSubscription({
      id: id
    }, success, error);
  };

  SubscriptionService.prototype.updateSubscriptionPaymentMethod = function (options, success, error) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.paymentProfileId) throw new Error('options.paymentProfileId is required');

    var body = {
      type: SUBSCRIPTION_ACTION.UPDATE_PAYMENT_METHOD,
      paymentProfileId: options.paymentProfileId
    };

    return Subscription.subscriptionAction({
      id: options.id
    }, body, success, error);
  };

  return new SubscriptionService();
}]);
_angular2.default.module('tl').service('tl.support', ['tl.support.service', 'tl.support.message', 'tl.support.task', function (service, message, task) {
  this.service = service;
  this.message = message;
  this.task = task;
}]);

_angular2.default.module('tl').service('tl.support.service', ['tl.socket', 'tl.support.message', function (Socket, Message) {
  'use strict';

  var SupportService = function SupportService() {};

  SupportService.prototype.listClientMessages = function (options) {
    options = options || {};
    return Message.resource.list(options).$promise;
  };

  SupportService.prototype.sendInboundMessage = function (text, options) {
    options = options || {};

    return Message.resource.sendInboundMessage({}, {
      text: text,
      data: options.data,
      city: options.city
    }).$promise;
  };

  SupportService.prototype.markMessagesRead = function (messageIds) {
    return Message.resource.markMessagesRead({}, {
      messageIds: messageIds
    }).$promise;
  };

  SupportService.prototype.listenForClientMessages = function (onMessage) {
    return new Socket('/support/message/client', onMessage);
  };

  return new SupportService();
}]);

_angular2.default.module('tl').service('tl.tag', ['tl.tag.resource', 'tl.tag.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.tag.resource', ['tl.resource', function (resource) {

  var endpoint = '/tag';

  return resource(endpoint, {}, {
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.tag.service', ['tl.service', 'tl.tag.resource', function (Service, Tag) {
  'use strict';

  var TagService = Service.extend(Tag);

  TagService.prototype.list = function (options) {
    return Tag.list(options).$promise;
  };

  return new TagService();
}]);

_angular2.default.module('tl').service('tl.table', ['tl.table.resource', 'tl.table.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.table.resource', ['tl.resource', function (resource) {

  var endpoint = '/table/:id';

  return resource(endpoint, {
    id: '@id'
  }, {});
}]);

_angular2.default.module('tl').service('tl.table.service', ['tl.service', 'tl.table.resource', function (Service, Table) {

  var TableService = Service.extend(Table);

  return new TableService();
}]);

_angular2.default.module('tl').constant('TRACK_EVENTS', {
  UserVerifiedPhoneNumber: "TLUserPhoneVerified",
  UserUpdatedProfilePicture: "TLUserUpdatedProfilePicture",
  UserCompletedProfile: "TLUserCompletedProfile",

  CityViewed: "TLCityViewed",
  CityFeaturedViewed: "TLCityFeaturedViewed",
  CityTonightViewed: "TLCityTonightViewed",
  CityThisWeekViewed: "TLCityThisWeekViewed",
  CityApplied: "TLCityApplied",
  CityShared: "TLCityShared",

  VenueViewed: "TLVenueViewed",
  VenueInfoViewed: "TLVenueInfoViewed",
  VenueContactViewed: "TLVenueContactViewed",
  VenueMapViewed: "TLVenueMapViewed",
  VenueAppliedForAccess: "TLVenueAppliedForAccess",

  EventViewed: "TLEventViewed",

  BookingInventoryViewed: "TLBookingInventoryViewed",
  BookingAddBottlesViewed: "TLBookingAddBottlesViewed",
  BookingInfoViewed: "TLBookingInfoViewed",
  BookingReviewViewed: "TLBookingReviewViewed",
  BookingTermsViewed: "TLBookingTermsViewed",
  BookingComplete: "TLBookingComplete",
  BookingReservationComplete: "TLBookingReservationComplete",
  BookingPromoterComplete: "TLBookingPromoterComplete",
  BookingFailed: "TLBookingFailed",
  BookingReservationFailed: "TLBookingReservationFailed",
  BookingAddedToPassbook: "TLBookingAddedToPassbook",
  BookingInquiryViewed: "TLBookingInquiryViewed",
  BookingInquirySubmitted: "TLBookingInquirySubmitted",

  BookingJoinPending: "TLBookingJoinPending",
  BookingJoinAccepted: "TLBookingJoinAccepted",
  BookingJoinCodeSent: "TLBookingJoinCodeSent",

  BookingReviewSubmitted: "TLBookingReviewSubmitted",

  MembershipInfoViewed: "TLMembershipInfoViewed",
  MembershipApplyViewed: "TLMembershipApplyViewed",
  MembershipCheckoutViewed: "TLMembershipCheckoutViewed",
  MembershipSubscribed: "TLMembershipSubscribed",
  MembershipUnsubscribed: "TLMembershipUnsubscribed",

  FavoritedVenue: "TLFavoritedVenue",
  FavoritedEvent: "TLFavoritedEvent",

  ReferralEntered: "TLReferralEntered",
  ReferralSentFB: "TLReferralSentFB",
  ReferralSentTW: "TLReferralSentTW",
  ReferralSentSMS: "TLReferralSentSMS",
  ReferralSentEmail: "TLReferralSentEmail",

  SMSDownloadLinkRequested: "TLSMSDownloadLinkRequested",

  PaymentAdded: "TLPaymentAdded",
  PaymentUpdated: "TLPaymentUpdated",
  PaymentInfoError: "TLPaymentInfoError",

  CodeRedeemed: "TLPromoCodeRedeemed",

  RewardViewed: "TLRewardViewed",
  RewardRedeemed: "TLRewardRedeemed",

  AboutBlogViewed: "TLAboutBlogViewed",
  AboutFacebookViewed: "TLAboutFacebookViewed",
  AboutTwitterViewed: "TLAboutTwitterViewed",
  AboutWebsiteViewed: "TLAboutWebsiteViewed",

  EasterEggAccountProfilePicture: "TLEasterEggAccountProfilePicture",

  InventorySearched: "TLInventorySearched",
  InventorySearchResultSelected: "TLInventorySearchResultSelected"
});

_angular2.default.module('tl').service('tl.track', ['tl.track.resource', 'tl.track.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.track.resource', ['tl.resource', function (resource) {

  var endpoint = '/track/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    funnel: {
      method: 'POST',
      url: '/track/funnel',
      isArray: true
    },
    listPossibleEvents: {
      method: 'GET',
      url: '/track/events',
      isArray: true
    }
  });
}]);
_angular2.default.module('tl').service('tl.track.service', ['tl.service', 'tl.track.resource', 'TRACK_EVENTS', 'tl.config', function (Service, Track, EVENTS, config) {

  var AFFILIATE = null;

  var TrackService = Service.extend(Track);

  TrackService.prototype.trackingEvents = function () {
    return EVENTS;
  };

  TrackService.prototype.send = function (eventName, data) {
    var track = {
      event: eventName,
      data: data,
      client: {
        os: config.CLIENT,
        version: config.VERSION,
        device: window.navigator ? window.navigator.userAgent : null
      }
    };

    if (config.SUB_CLIENT) track.client.os = track.client.os + ('-' + config.SUB_CLIENT);
    if (AFFILIATE) {
      track.data = track.data || {};
      track.data.affiliate = AFFILIATE;
    }

    return Track.save({}, track);
  };

  TrackService.prototype.setAffiliate = function (affiliateId) {
    AFFILIATE = affiliateId || null;
  };

  TrackService.prototype.listPossibleEvents = function (success, error) {
    return Track.listPossibleEvents({}, success, error).$promise;
  };

  TrackService.prototype.funnel = function (events, options, success, error) {
    return Track.funnel({}, {
      events: events,
      start: options.start.getTime(),
      end: options.end.getTime(),
      data: options.data,
      client: options.client
    }, success, error).$promise;
  };

  return new TrackService();
}]);

_angular2.default.module('tl').service('tl.tracker', ['tl.tracker.resource', 'tl.tracker.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.tracker.resource', ['tl.resource', function (resource) {

  var endpoint = '/tracker';

  return resource(endpoint, {}, {
    create: {
      method: 'POST',
      url: endpoint,
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.tracker.service', ['tl.service', 'tl.tracker.resource', function (Service, Tracker) {
  'use strict';

  var TrackerService = Service.extend(Tracker);

  TrackerService.prototype.create = function (options) {
    return Tracker.save({}, options).$promise;
  };

  return new TrackerService();
}]);

_angular2.default.module('tl').service('tl.user', ['tl.user.resource', 'tl.user.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.user.resource', ['tl.resource', function (resource) {
  'use strict';

  var endpoint = '/user/:id';

  return resource(endpoint, {
    id: '@id'
  }, {
    list: {
      method: 'GET',
      url: '/user',
      isArray: true
    },
    me: {
      method: 'GET',
      url: '/me'
    },
    updateMe: {
      method: 'PUT',
      url: '/me'
    },
    search: {
      method: 'GET',
      url: '/user/search',
      isArray: true
    },
    push: {
      method: 'POST',
      url: '/notify/push',
      isArray: false
    },
    listBookings: {
      method: 'GET',
      url: endpoint + '/booking',
      isArray: true
    },
    updatePreferredCity: {
      method: 'PUT',
      url: '/user/city'
    },
    requestVerificationCode: {
      method: 'GET',
      url: '/user/verify/:id'
    },
    requestVerificationCodeForCurrentUser: {
      method: 'GET',
      url: '/user/verify'
    },
    verifyPhoneNumber: {
      method: 'PUT',
      url: '/user/verify/:id'
    },
    verifyPhoneNumberForCurrentUser: {
      method: 'PUT',
      url: '/user/verify'
    },
    listPaymentProfiles: {
      method: 'GET',
      url: endpoint + '/paymentProfiles',
      isArray: true
    },
    listReferrals: {
      method: 'GET',
      url: endpoint + '/referral',
      isArray: true
    },
    listPromos: {
      method: "GET",
      url: endpoint + "/promo",
      isArray: true
    },
    listTasks: {
      method: 'GET',
      url: endpoint + '/task',
      isArray: true
    },
    listQuestions: {
      method: 'GET',
      url: endpoint + '/question',
      isArray: true
    },
    listAnswers: {
      method: 'GET',
      url: endpoint + '/answer',
      isArray: true
    },
    listNotifications: {
      method: "GET",
      url: '/notify/:id',
      isArray: true
    },
    listHighPriority: {
      method: "GET",
      url: '/user/priority',
      isArray: true
    },
    addCredit: {
      method: "POST",
      url: endpoint + '/credit'
    },
    listSubscriptions: {
      method: "GET",
      url: endpoint + '/subscription',
      isArray: true
    },
    addSubscription: {
      method: "POST",
      url: endpoint + '/subscription'
    },
    getMembershipStatus: {
      method: "GET",
      url: endpoint + '/membership'
    },
    findByReferral: {
      method: "GET",
      url: '/referral/:code'
    },
    getReferralStats: {
      method: "GET",
      url: endpoint + '/referral/stats'
    },
    listVenues: {
      method: "GET",
      url: endpoint + '/venue',
      isArray: true
    },
    listStats: {
      method: "GET",
      url: endpoint + '/stats',
      isArray: true
    },
    favorite: {
      method: "POST",
      url: endpoint + '/favorite',
      isArray: false
    },
    unfavorite: {
      method: "DELETE",
      url: endpoint + '/favorite/:favoriteId',
      isArray: false
    },
    listFavorites: {
      method: "GET",
      url: endpoint + '/favorite',
      isArray: true
    },
    listReviews: {
      method: 'GET',
      url: endpoint + '/review',
      isArray: true
    },
    markAffiliate: {
      method: "POST",
      url: endpoint + '/affiliate',
      isArray: false
    },
    listAffiliates: {
      method: "GET",
      url: 'user/:id/affiliate',
      isArray: true
    },
    access: {
      method: 'GET',
      url: 'user/:id/access',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.user.service', ['$timeout', 'tl.storage', 'tl.keychain', 'tl.ee', 'tl.user.resource', 'tl.service', function ($timeout, storage, keychain, ee, User, Service) {
  'use strict';

  var USER_KEY = 'tl_user';
  var EVENTS = {
    USER_UPDATED: 'tl.user.updated'
  };

  var UserService = Service.extend(User);

  UserService.prototype.list = function list(options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return User.list(options).$promise;
  };

  UserService.prototype.currentUser = function () {
    return keychain.authToken() ? storage.get(USER_KEY) : null;
  };

  UserService.prototype.EVENTS = function () {
    return EVENTS;
  };

  UserService.prototype.setCurrentUser = function (user) {
    $timeout(function () {
      ee.emit(EVENTS.USER_UPDATED, user);
    });
    return storage.set(USER_KEY, user);
  };

  UserService.prototype.saveCurrentUser = function (user) {
    var _user = this.currentUser() || {};
    var keys = (0, _keys2.default)(user);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var val = user[key];
      _user[key] = val;
    }
    this.setCurrentUser(_user);
  };

  UserService.prototype.me = function (success, error) {
    var _this = this;

    var promise = User.me().$promise;

    promise.then(function (user) {
      _this.saveCurrentUser(user);
      if (success) {
        success(user);
      }
    }, error);

    return promise;
  };

  UserService.prototype.updateMe = function (body, success, error) {
    var _this = this;
    return User.updateMe({}, body).$promise.then(function (user) {
      _this.saveCurrentUser(user);
      if (success) {
        success(user);
      }
    }, error);
  };

  UserService.prototype.updatePreferredCity = function (cityId, success, error) {
    var _this = this;
    var body = {
      city: cityId
    };
    return User.updatePreferredCity({}, body).$promise.then(function (user) {
      _this.saveCurrentUser(user);
      if (success) {
        success(user);
      }
    }, error);
  };

  UserService.prototype.requestVerificationCode = function (id, success, error) {
    return User.requestVerificationCode({
      id: id
    }, success, error);
  };

  UserService.prototype.requestVerificationCodeForCurrentUser = function (success, error) {
    return User.requestVerificationCodeForCurrentUser({}, success, error);
  };

  UserService.prototype.verifyPhoneNumber = function (id, code, success, error) {
    var _this = this;
    var data = {
      id: id,
      verificationCode: code
    };
    return User.verifyPhoneNumber({}, data).$promise.then(function (user) {
      _this.saveCurrentUser(user);
      if (success) {
        success(user);
      }
      return user;
    }, error);
  };

  UserService.prototype.verifyPhoneNumberForCurrentUser = function (code, success, error) {
    var _this = this;
    var data = {
      verificationCode: code
    };
    return User.verifyPhoneNumber({}, data).$promise.then(function (user) {
      _this.saveCurrentUser(user);
      if (success) {
        success(user);
      }
      return user;
    }, error);
  };

  UserService.prototype.listPaymentProfiles = function (userId, success, error) {
    return User.listPaymentProfiles({
      id: userId
    }, success, error);
  };

  UserService.prototype.listReferrals = function (userId, success, error) {
    return User.listReferrals({
      id: userId
    }, success, error);
  };

  UserService.prototype.listBookings = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return User.listBookings(options).$promise;
  };

  UserService.prototype.listPromos = function (userId, success, error) {
    return User.listPromos({
      id: userId
    }, success, error);
  };

  UserService.prototype.listTasks = function (userId, success, error) {
    return User.listTasks({
      id: userId
    }, success, error);
  };

  UserService.prototype.listNotifications = function (userId, success, error) {
    return User.listNotifications({
      id: userId
    }, success, error);
  };

  UserService.prototype.listQuestions = function (userId, type, success, error) {
    return User.listQuestions({
      id: userId,
      type: type
    }, success, error);
  };

  UserService.prototype.listAnswers = function (userId, success, error) {
    return User.listAnswers({
      id: userId
    }, success, error);
  };

  UserService.prototype.listHighPriority = function (hours, priority, cityId, success, error) {
    return User.listHighPriority({
      hours: hours || 24,
      priority: priority || 7,
      city: cityId
    }, success, error);
  };

  UserService.prototype.addCredit = function (userId, amount, campaignId, success, error) {
    return User.addCredit({
      id: userId
    }, {
      amount: amount,
      campaign: campaignId
    }, success, error);
  };

  UserService.prototype.listSubscriptions = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listSubscriptions(options).$promise;
  };

  UserService.prototype.addSubscription = function (options, success, error) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');
    if (!options.externalId) {
      if (!options.planId) throw new Error('options.planId is required');
      if (!options.paymentProfileId) throw new Error('options.paymentProfileId is required');
    }

    return User.addSubscription({
      id: options.userId
    }, options, success, error);
  };

  UserService.prototype.getMembershipStatus = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.getMembershipStatus(options).$promise;
  };

  UserService.prototype.findByReferral = function (code, success, error) {
    return User.findByReferral({
      code: code
    }, success, error);
  };

  UserService.prototype.getReferralStats = function (userId, success, error) {
    return User.getReferralStats({
      id: userId
    }, success, error);
  };

  UserService.prototype.search = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.query) throw new Error('options.query is required');

    return User.search(options).$promise;
  };

  UserService.prototype.listVenues = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listVenues(options).$promise;
  };

  UserService.prototype.favorite = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    var userId = options.userId;
    delete options.userId;

    return User.favorite({
      id: userId
    }, options).$promise;
  };

  UserService.prototype.unfavorite = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');
    if (!options.favoriteId) throw new Error('options.favoriteId is required');

    var userId = options.userId;
    delete options.userId;
    var favoriteId = options.favoriteId;
    delete options.favoriteId;

    return User.unfavorite({
      id: userId,
      favoriteId: favoriteId
    }, options).$promise;
  };

  UserService.prototype.listFavorites = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listFavorites(options).$promise;
  };

  UserService.prototype.listReviews = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listReviews(options).$promise;
  };

  UserService.prototype.markAffiliate = function (userId, options) {
    if (!userId) throw new Error('userId is required');
    if (!options) throw new Error('options is required');
    if (!options.name) throw new Error('options.name is required');

    return User.markAffiliate({
      id: userId
    }, options).$promise;
  };

  UserService.prototype.listAffiliates = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listAffiliates(options).$promise;
  };

  UserService.prototype.listStats = function (options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.listStats(options).$promise;
  };

  UserService.prototype.access = function access(options) {
    if (!options) throw new Error('options is required');
    if (!options.userId) throw new Error('options.userId is required');

    options.id = options.userId;
    delete options.userId;

    return User.access(options).$promise;
  };

  return new UserService();
}]);

_angular2.default.module('tl').service('tl.venue', ['tl.venue.resource', 'tl.venue.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);
_angular2.default.module('tl').factory('tl.venue.resource', ['tl.resource', function (resource) {

  var endpoint = '/venue/:id';

  return resource(endpoint, {
    id: '@id',
    itemId: '@itemId',
    imageId: '@imageId',
    cityId: '@cityId',
    onlyEnabled: '@onlyEnabled'
  }, {
    list: {
      method: 'GET',
      url: '/venue',
      isArray: true
    },


    listForCity: {
      method: 'GET',
      url: '/city/:cityId/venue',
      isArray: true
    },
    listCityFeatured: {
      method: 'GET',
      url: '/city/:cityId/venue/featured',
      isArray: true
    },
    listCityTonight: {
      method: 'GET',
      url: '/city/:cityId/venue/tonight',
      isArray: true,
      cache: true
    },

    schedule: {
      method: 'GET',
      url: endpoint + '/schedule'
    },
    updateSchedule: {
      method: 'PUT',
      url: endpoint + '/schedule'
    },

    listInventory: {
      method: 'GET',
      url: endpoint + '/inventory',
      isArray: false
    },
    listActiveInventory: {
      method: 'GET',
      url: endpoint + '/active-inventory',
      isArray: true
    },
    listInventoryAdmin: {
      method: 'GET',
      url: endpoint + '/inventory/admin',
      isArray: false
    },
    readInventory: {
      method: 'GET',
      url: endpoint + '/inventory/:tableId',
      isArray: false
    },
    addInventory: {
      method: 'POST',
      url: endpoint + '/inventory',
      isArray: false
    },
    updateInventory: {
      method: 'PUT',
      url: endpoint + '/inventory/:tableId',
      isArray: false
    },
    listInventoryTierConfigs: {
      method: 'GET',
      url: endpoint + '/inventory-tier-config',
      isArray: true
    },

    listEvents: {
      method: 'GET',
      url: endpoint + '/event',
      isArray: true
    },
    addEvent: {
      method: 'POST',
      url: '/event',
      isArray: false
    },

    listItems: {
      method: 'GET',
      url: endpoint + '/item',
      isArray: true
    },
    addItem: {
      method: 'POST',
      url: endpoint + '/item'
    },
    updateItem: {
      method: 'PUT',
      url: endpoint + '/item/:itemId'
    },
    deleteItem: {
      method: 'DELETE',
      url: endpoint + '/item/:itemId'
    },

    listInfo: {
      method: 'GET',
      url: endpoint + '/info',
      isArray: true
    },
    readInfo: {
      method: 'GET',
      url: endpoint + '/info/:key'
    },
    updateInfo: {
      method: 'PUT',
      url: endpoint + '/info/:key'
    },
    createInfo: {
      method: 'POST',
      url: endpoint + '/info'
    },

    listStaff: {
      method: 'GET',
      url: endpoint + '/staff',
      isArray: true
    },
    readStaff: {
      method: 'GET',
      url: endpoint + '/staff/:staffId',
      isArray: false
    },
    createStaff: {
      method: 'POST',
      url: endpoint + '/staff',
      isArray: false
    },
    updateStaff: {
      method: 'PUT',
      url: endpoint + '/staff/:staffId',
      isArray: false
    },
    deleteStaff: {
      method: 'DELETE',
      url: endpoint + '/staff/:staffId',
      isArray: false
    },

    listBookings: {
      method: 'GET',
      url: endpoint + '/booking',
      isArray: true
    },

    listTableBookings: {
      method: 'GET',
      url: endpoint + '/booking/table',
      isArray: true
    },

    listAdmissionBookings: {
      method: 'GET',
      url: endpoint + '/booking/admission',
      isArray: true
    },

    listTickets: {
      method: 'GET',
      url: endpoint + '/ticket',
      isArray: true
    },

    listTicketStats: {
      method: 'GET',
      url: endpoint + '/ticket/stats',
      isArray: false
    },

    listReviews: {
      method: 'GET',
      url: endpoint + '/review',
      isArray: true
    },

    addStaffPermission: {
      method: 'POST',
      url: endpoint + '/staff/:staffId/permission',
      isArray: true
    },

    removeStaffPermission: {
      method: 'DELETE',
      url: endpoint + '/staff/:staffId/permission/:permission',
      isArray: false
    },

    listStaffPermissions: {
      method: 'GET',
      url: endpoint + '/staff/:staffId/permission',
      isArray: true
    }
  });
}]);

_angular2.default.module('tl').service('tl.venue.service', ['tl.service', 'tl.venue.resource', function (Service, Venue) {
  'use strict';

  var VenueService = Service.extend(Venue);

  VenueService.prototype.list = function list(options) {
    if (!options) throw new Error('options is required');

    options.query = options.query ? (0, _stringify2.default)(options.query) : options.query;

    return Venue.list(options).$promise;
  };

  VenueService.prototype.read = function read(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.get(options).$promise;
  };

  VenueService.prototype.create = function create(options) {
    if (!options) throw new Error('options is required');

    return Venue.save({}, options).$promise;
  };

  VenueService.prototype.update = function update(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.update({
      id: options.id
    }, options).$promise;
  };

  VenueService.prototype.listForCity = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.cityId) throw new Error('options.cityId is required');

    return Venue.listForCity(options).$promise;
  };

  VenueService.prototype.listCityFeatured = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.cityId) throw new Error('options.cityId is required');

    return Venue.listCityFeatured(options).$promise;
  };

  VenueService.prototype.listCityTonight = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.cityId) throw new Error('options.cityId is required');

    return Venue.listCityTonight(options).$promise;
  };

  VenueService.prototype.listInventory = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    options.start = options.start || moment().startOf('month').format("YYYY-MM-DD");
    options.end = options.end || moment().endOf('month').format("YYYY-MM-DD");

    return Venue.listInventory(options).$promise;
  };

  VenueService.prototype.listActiveInventory = function (venueId, options) {

    if (!venueId) throw new Error('venueId is required');
    if (!options) throw new Error('options is required');
    if (!options.start) throw new Error('options.start required');
    if (!options.end) throw new Error('options.end required');

    options.id = venueId;
    options.start = options.start;
    options.end = options.end;

    return Venue.listActiveInventory(options).$promise;
  };

  VenueService.prototype.listInventoryTierConfigs = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    options.start = options.start || moment().startOf('month').toDate().getTime();
    options.end = options.end || moment().endOf('month').toDate().getTime();

    return Venue.listInventoryTierConfigs(options).$promise;
  };

  VenueService.prototype.addItem = function createItem(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');

    var venueId = options.id;
    delete options.id;

    return Venue.addItem({
      id: venueId
    }, options).$promise;
  };

  VenueService.prototype.listItems = function listItems(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listItems(options).$promise;
  };

  VenueService.prototype.updateItem = function updateItem(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.itemId) throw new Error('options.itemId is required');

    var venueId = options.id;
    delete options.id;

    var itemId = options.itemId;
    delete options.itemId;

    return Venue.updateItem({
      id: venueId,
      itemId: itemId
    }, options).$promise;
  };

  VenueService.prototype.deleteItem = function createItem(options) {
    if (!options) throw new Error('options is required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.itemId) throw new Error('options.itemId is required');

    var venueId = options.id;
    delete options.id;

    var itemId = options.itemId;
    delete options.itemId;

    return Venue.deleteItem({
      id: venueId,
      itemId: itemId
    }, options).$promise;
  };

  VenueService.prototype.listInfo = function listInfo(venueId, options) {
    if (!venueId) throw new Error('venueId is required');

    options = options || {};

    return Venue.listInfo({
      id: venueId
    }, options).$promise;
  };

  VenueService.prototype.createInfo = function createInfo(venueId, options) {
    if (!venueId) throw new Error('venueId is required');
    if (!options) throw new Error('options is required');
    if (!options.key) throw new Error('options.key is required');

    return Venue.createInfo({
      id: venueId
    }, options).$promise;
  };

  VenueService.prototype.readInfo = function readInfo(venueId, key) {
    if (!venueId) throw new Error('venueId is required');
    if (!key) throw new Error('key is required');

    return Venue.readInfo({
      id: venueId,
      key: key
    }).$promise;
  };

  VenueService.prototype.updateInfo = function updateInfo(venueId, key, options) {
    if (!venueId) throw new Error('venueId is required');
    if (!key) throw new Error('key is required');

    options = options || {};

    return Venue.updateInfo({
      id: venueId,
      key: key
    }, options).$promise;
  };

  VenueService.prototype.listBookings = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listBookings(options).$promise;
  };

  VenueService.prototype.listTableBookings = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listTableBookings(options).$promise;
  };

  VenueService.prototype.listAdmissionBookings = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listAdmissionBookings(options).$promise;
  };

  VenueService.prototype.listTickets = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listTickets(options).$promise;
  };

  VenueService.prototype.listTicketStats = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listTicketStats(options).$promise;
  };

  VenueService.prototype.listEvents = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listEvents(options).$promise;
  };

  VenueService.prototype.listReviews = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listReviews(options).$promise;
  };

  VenueService.prototype.listStaff = function listStaff(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    return Venue.listStaff(options).$promise;
  };

  VenueService.prototype.readStaff = function readStaff(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');

    return Venue.readStaff(options).$promise;
  };

  VenueService.prototype.createStaff = function createStaff(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');

    var venueId = options.id;
    delete options.id;

    return Venue.createStaff({
      id: venueId
    }, options).$promise;
  };

  VenueService.prototype.updateStaff = function updateStaff(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');
    if (!options.updates) throw new Error('options.updates is required');

    var venueId = options.id;
    delete options.id;

    var staffId = options.staffId;
    delete options.staffId;

    return Venue.updateStaff({
      id: venueId,
      staffId: staffId
    }, options.updates).$promise;
  };

  VenueService.prototype.deleteStaff = function deleteStaff(options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');

    var venueId = options.id;
    delete options.id;

    var staffId = options.staffId;
    delete options.staffId;

    return Venue.deleteStaff({
      id: venueId,
      staffId: staffId
    }, options).$promise;
  };

  VenueService.prototype.addStaffPermission = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');
    if (!options.permission) throw new Error('options.permission is required');

    var venueId = options.id;
    delete options.id;

    var staffId = options.staffId;
    delete options.staffId;

    return Venue.addStaffPermission({
      id: venueId,
      staffId: staffId
    }, options).$promise;
  };

  VenueService.prototype.removeStaffPermission = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');
    if (!options.permission) throw new Error('options.permission is required');

    return Venue.removeStaffPermission(options).$promise;
  };

  VenueService.prototype.listStaffPermissions = function (options) {
    if (!options) throw new Error('options.required');
    if (!options.id) throw new Error('options.id is required');
    if (!options.staffId) throw new Error('options.staffId is required');

    return Venue.listStaffPermissions(options).$promise;
  };

  return new VenueService();
}]);

_angular2.default.module('tl').service('tl.support.agent', ['tl.support.agent.resource', 'tl.support.agent.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.support.agent.resource', ['tl.resource', function (resource) {

  var endpoint = '/agent';

  return resource(endpoint, {
    id: '@id'
  }, {
    read: {
      method: 'GET',
      url: endpoint + '/:id',
      isArray: false
    },
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    },
    create: {
      method: 'POST',
      url: endpoint,
      isArray: false
    },
    update: {
      method: 'PUT',
      url: endpoint + '/:id',
      isArray: false
    },
    patch: {
      method: 'PATCH',
      url: endpoint + '/:id',
      isArray: false
    },
    remove: {
      method: 'DELETE',
      url: endpoint + '/:id',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.support.agent.service', ['tl.service', 'tl.support.agent.resource', function (Service, Agent) {
  'use strict';

  var SupportAgentService = Service.extend(Agent);

  SupportAgentService.prototype.read = function (agentId, options) {
    if (!agentId) throw new Error('agentId is required');
    options = options || {};

    options.id = agentId;

    return Agent.read(options).$promise;
  };

  SupportAgentService.prototype.list = function (options) {
    options = options || {};
    return Agent.list(options).$promise;
  };

  SupportAgentService.prototype.create = function (options) {
    if (!options) throw new Error('options is required');

    return Agent.create({}, options).$promise;
  };

  SupportAgentService.prototype.update = function (agentId, options) {
    if (!agentId) throw new Error('agentId is required');
    if (!options) throw new Error('options is required');

    return Agent.update({ id: agentId }, options).$promise;
  };

  SupportAgentService.prototype.patch = function (agentId, options) {
    if (!agentId) throw new Error('agentId is required');
    if (!options) throw new Error('options is required');

    return Agent.patch({ id: agentId }, options).$promise;
  };

  SupportAgentService.prototype.remove = function (agentId, options) {
    if (!agentId) throw new Error('agentId is required');
    options = options || {};

    options.id = agentId;

    return Agent.remove(options).$promise;
  };

  return new SupportAgentService();
}]);

_angular2.default.module('tl').service('tl.support.message', ['tl.support.message.resource', 'tl.support.message.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.support.message.resource', ['tl.resource', function (resource) {

  var endpoint = '/support/message';

  return resource(endpoint, {}, {
    list: {
      method: 'GET',
      url: endpoint,
      isArray: true
    },
    markMessagesRead: {
      method: 'POST',
      url: endpoint + '/read',
      isArray: true
    },
    sendInboundMessage: {
      method: 'POST',
      url: endpoint + '/inbound',
      isArray: false
    },
    sendOutboundMessage: {
      method: 'POST',
      url: endpoint + '/outbound',
      isArray: false
    },
    sendInternalMessage: {
      method: 'POST',
      url: endpoint + '/internal',
      isArray: false
    }
  });
}]);

_angular2.default.module('tl').service('tl.support.message.service', ['tl.service', 'tl.support.message.resource', function (Service, Message) {
  'use strict';

  var SupportMessageService = Service.extend(Message);

  return new SupportMessageService();
}]);

_angular2.default.module('tl').service('tl.support.task', ['tl.support.task.resource', 'tl.support.task.service', function (resource, service) {
  this.resource = resource;
  this.service = service;
}]);

_angular2.default.module('tl').factory('tl.support.task.resource', ['tl.resource', function (resource) {

  var endpoint = '/support/task';

  return resource(endpoint, {}, {});
}]);

_angular2.default.module('tl').service('tl.support.task.service', ['tl.service', 'tl.support.task.resource', function (Service, Task) {
  'use strict';

  var SupportTaskService = Service.extend(Task);

  return new SupportTaskService();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<div id=\"about\" class=\"clearfix\">\n  <div id=\"hero\">\n    <h1>Here's to the good life.</h1>\n    <p>About Tablelist</p>\n  </div>\n  <div class=\"container\">\n    <div class=\"col-md-8 col-md-offset-2\">\n      <!-- About Tablelist -->\n      <p>Tablelist began in 2013 with a mission: to provide easy access to the best night possible. Since then, we’ve worked tirelessly (and done plenty of “research”) to provide this unforgettable experiences for each of our users. </p>\n      <p>Life is too short to miss out on the good times, and we want you to have as many options as possible.</p>\n      <!-- About Con't -->\n      <h2>It’s all about convenience</h2>\n      <p>Having fun should never feel like work. Plan a night with our complimentary concierge; discover new events, book tables, and browse venues from our app; pre-pay cover charges and manage guest lists. The night is yours with Tablelist.</p>\n      <!-- Download Links -->\n      <div class=\"download-row\">\n        <div class=\"col-sm-6\">\n          <a class=\"apple\" href=\"https://itunes.apple.com/app/tablelist/id634444177?mt=8\" target=\"_blank\" title=\"Download for iOS\">\n            <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_apple.png\">\n          </a>\n        </div>\n        <div class=\"col-sm-6\">\n          <a class=\"android\" href=\"https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod\" target=\"_blank\" title=\"Download for Android\">\n            <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_android.png\">\n          </a>\n        </div>\n      </div>\n      <br>\n      <!-- Relationships -->\n      <h2>It all about relationships</h2>\n      <p>Our relationships with our users and venues are the foundation of the Tablelist platform. We exist to foster relationships and transform them into the service we are proud to share with you.</p>\n      <!-- Markets -->\n      <h2>{{ cities.length }} markets and counting</h2>\n      <p class=\"cities\">\n        <span>Party with us in </span>\n        <span ng-repeat=\"city in cities\">\n          <span ng-if=\"$index >= cities.length - 1\">and</span>\n          <a href=\"/{{ city.slugName }}/venues/\" target=\"_blank\">{{ city.name }}</a>\n          <span ng-if=\"$index < cities.length - 1\">, </span>\n        </span>.\n      </p>\n\n      <!-- Tablelist Jobs -->\n      <h2>Adding to the Team</h2>\n      <p>Please checkout out our <a href=\"https://jobs.lever.co/tablelist\" target=\"_blank\">Jobs Page</a> or reach out to us at <a href=\"mailto:jobs@tablelist.com\">jobs@tablelist.com</a></p>\n      </p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "<div id=\"account\" class=\"container-fluid\">\n  <div class=\"row\">\n    <div id=\"account-menu\" class=\"center\">\n      <ul class=\"menu\">\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.profile') }\">\n          <a href=\"#\" ui-sref=\"app.me.profile\">My Account</a>\n        </li>\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.tickets') || $state.includes('app.me.booking') }\">\n          <a href=\"#\" ui-sref=\"app.me.tickets\">Your Tickets\n            <div class=\"count\" ng-show=\"ticketCount > 0\">{{ ticketCount }}</div>\n          </a>\n        </li>\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.bookings') || $state.includes('app.me.booking') }\">\n          <a href=\"#\" ui-sref=\"app.me.bookings\">Your Tables\n            <div class=\"count\" ng-show=\"tableCount > 0\">{{ tableCount }}</div>\n          </a>\n        </li>\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.reviews') }\">\n          <a href=\"#\" ui-sref=\"app.me.reviews\">Reviews\n            <div class=\"count\" ng-show=\"pendingReviewCount > 0\">{{ pendingReviewCount }}</div>\n          </a>\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.favorites') }\">\n          <a href=\"#\" ui-sref=\"app.me.favorites\">Favorites </a>\n        </li>\n        <li class=\"menu-item signout\">\n          <a href=\"#\" ng-click=\"logout()\">Log Out<i class=\"fa fa-sign-out\"></i></a>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div ui-view></div>\n</div>\n";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "<div id=\"account-booking\" class=\"bookings-list\">\n  <div class=\"container\">\n    <div class=\"list-header\">\n      <div class=\"account-bookings-title\">Your Tables</div>\n    </div>\n    <div class=\"loading-wrapper\" ng-if=\"loading\">\n      <loading></loading>\n    </div>\n    <div class=\"show-on-load\" ng-class=\"{'active' : !loading }\">\n      <div class=\"redundant-text clearfix\" id=\"upcoming\" ng-hide=\"sortedBookings.upcoming.length < 1\"><strong>{{ sortedBookings.upcoming.length }} Upcoming Tables</strong> reserved.</div>\n      <div ng-repeat=\"booking in sortedBookings.upcoming | orderBy: '-calendarDate'\" class=\"booking list\">\n        <div class=\"content\">\n          <booking-card booking=\"booking\"></booking-card>\n        </div>\n      </div>\n      <div class=\"redundant-text\" id=\"past\"><strong>{{ sortedBookings.past.length }} Previous Tables</strong> reserved.</div>\n      <div ng-repeat=\"booking in sortedBookings.past | orderBy: '-calendarDate'\" class=\"booking list\">\n        <div class=\"content\">\n          <booking-card booking=\"booking\"></booking-card>\n        </div>\n      </div>\n      <div class=\"no-bookings-err\" ng-show=\"sortedBookings && sortedBookings.all && sortedBookings.all.length === 0\">\n        <span>You don't have any table bookings currently. <a ng-click=\"browseVenues()\" href=\"#\">Make some plans</a></span>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<div class=\"bookings-list account-favorites-list\">\n  <div class=\"container\">\n    <h1>Your Favorites</h1>\n    <section ng-show=\"followedLists.length > 0\">\n      <h2>Lists</h2>\n      <hr>\n      <curated-list-card list=\"list.curatedList\" ng-repeat=\"list in followedLists\"></curated-list-card>\n    </section>\n    <section>\n      <h2>Events</h2>\n      <hr>\n      <event-card placeholder=\"true\" ng-repeat=\"item in [1,2,3]\" ng-show=\"loading\"></event-card>\n      <event-card event=\"event.event\" ng-repeat=\"event in events | orderBy: 'date'\" ng-hide=\"loading\"></event-card>\n      <p class=\"empty-state\" ng-if=\"!events && !loading\">\n        You don't have any events favorited\n      </p>\n    </section>\n    <section>\n      <h2>Venues</h2>\n      <hr>\n      <venue-card placeholder=\"true\" ng-repeat=\"item in [1,2,3]\" ng-show=\"loading\"></venue-card>\n      <venue-card venue=\"venue.venue\" ng-repeat=\"venue in venues | orderBy: 'venue.name'\" ng-hide=\"loading\"></venue-card>\n      <p class=\"empty-state\" ng-if=\"!venues && !loading\">\n        You don't have any venues favorited\n      </p>\n    </section>\n  </div>\n  <contact-us></contact-us>\n</div>\n";

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<section id=\"account-profile\">\n  <div class=\"container\">\n    <div id=\"account-error\" class=\"row account-error\" ng-show=\"errorMsg\">\n      <div class=\"alert alert-danger center\" type=\"'danger'\" close=\"closeAlert(0)\">{{ errorMsg }}</div>\n    </div>\n    <div class=\"row\">\n      <div class=\"cell first-row col-sm-4\">\n        <img class=\"profile-picture\" ng-src=\"{{ currentUserImageUrl(150) }}\" height=\"150\" width=\"150\" />\n        <a href=\"/logout\" class=\"logout\">Log Out</a>\n      </div>\n      <div class=\"cell first-row col-sm-4\">\n        <p>Full Name</p>\n        <p class=\"large\">{{ currentUser.name }}</p>\n        <p>Birthday</p>\n        <p ng-show=\"currentUser.birthday\" class=\"large\">{{ currentUser.birthday | date }}</p>\n        <p ng-hide=\"currentUser.birthday\" class=\"large\">N/A</p>\n        <p>Gender</p>\n        <p class=\"large\" ng-show=\"currentUser.gender\" style=\"text-transform: uppercase;\">{{ currentUser.gender }}</p>\n        <p class=\"large\" ng-hide=\"currentUser.gender\">N/A</p>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"editProfile()\">Edit Info</div>\n      </div>\n      <div class=\"cell first-row col-sm-4\">\n        <p>Membership</p>\n        <p class=\"large\">{{ currentUser.membershipStatus }}</p>\n        <p>Referral Code</p>\n        <p class=\"large\">{{ currentUser.referralCode }}</p>\n        <p>Created Account</p>\n        <p class=\"large\">{{ currentUser.created | date }}</p>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"cell col-sm-4 membership-cell\" ng-show=\"!membership\">\n        <h2>Membership Status</h2>\n        <p>You are not currently subscribed. Join Tablelist Membership for free tickets, line jumpers, and exclusive member's events.</p>\n        <div class=\"btn btn-default btn-edit\" ui-sref=\"app.membership.landing\">Learn More</div>\n      </div>\n      <div class=\"cell col-sm-4 membership-cell membership-cell-active\" ng-show=\"membership\">\n        <h2>Membership Status</h2>\n        <div id=\"membership-section\" class=\"membership-status\">\n          <div class=\"diamond-block\">\n            <img class=\"diamond\" src=\"https://assets.tablelist.com/www-2/tablelist/tl-membership-diamond@3x.png\" />\n            <p class=\"text\" ng-if=\"membership.billingInterval === 1\">\n              {{ currentUser.membershipStatus }} -\n              Monthly Plan\n            </p>\n            <p class=\"text\" ng-if=\"membership.billingInterval === 12\">\n              {{ currentUser.membershipStatus }} -\n              Yearly Plan\n            </p>\n          </div>\n          <p class=\"status\" ng-if=\"membership.status === 'CANCEL_PENDING'\">\n            Cancelled - Your membership will stop at the end of the month.\n          </p>\n        </div>\n        <br>\n        <button class=\"btn btn-default btn-edit\" ng-if=\"membership.status !== 'CANCEL_PENDING'\" ng-click=\"editMembership()\">Change Membership Info</button>\n        <a class=\"btn btn-link btn-sub-edit\" ng-if=\"membership.status !== 'CANCEL_PENDING'\" ng-click=\"cancelMembership()\">Cancel Membership</a>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Contact Information</h2>\n        <p>Email Address</p>\n        <p class=\"bold\">{{ currentUser.email }}</p>\n        <p>Phone Number</p>\n        <p class=\"bold\">{{ currentUser.phone | phoneNumber }}</p>\n        <p class=\"bold\" ng-hide=\"currentUser.phone\">???</p>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"editContactInformation()\">Change Contact Information</div>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Password</h2>\n        <p>Current Password</p>\n        <p class=\"bold fake-password\">***********</p>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"forgotPassword()\">Change Password</div>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Saved Credit Cards</h2>\n        <credit-card-preview></credit-card-preview>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"editCreditCard()\">Manage Payment Methods</div>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Cities</h2>\n        <p>Current City</p>\n        <p class=\"bold\">{{ currentUser.location.preferred.displayName }}</p>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"editCities()\">Change Current City</div>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Promo Code</h2>\n        <p>${{ currentUser.credit }} Credit</p>\n        <p>{{ currentUser.points }} Reward Points</p>\n        <div class=\"btn btn-default btn-edit\" ng-click=\"enterPromo()\">Enter Promo Code</div>\n      </div>\n      <div class=\"cell col-sm-4\">\n        <h2>Services</h2>\n        <p ng-show=\"currentUser.facebook\">Facebook</p>\n        <p ng-show=\"currentUser.facebook\" class=\"bold\">{{ currentUser.facebook.id }}</p>\n        <p ng-hide=\"currentUser.facebook\">No connected services</p>\n      </div>\n    </div>\n  </div>\n</section>\n";

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "<section id=\"account-promo\">\n  <div class=\"clearfix account-error alert alert-danger\" ng-show=\"errorMsg\">\n    <br>\n    <div class=\"clearfix\" ng-show=\"errorMsg\">\n      <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n    </div>\n  </div>\n  <div class=\"clearfix account-error alert alert-success\" ng-show=\"successMsg\">\n    <br>\n    <div class=\"clearfix\" ng-show=\"successMsg\">\n      <div class=\"alert alert-danger\">{{ successMsg }}</div>\n    </div>\n  </div>\n  <p class=\"center\">Enter a promo code to earn Tablelist credit.</p>\n  <br>\n  <form class=\"account-form tl-form form-horizontal\" name=\"promoCodeForm\" role=\"form\" novalidate>\n    <div class=\"form-group\" ng-class=\"{ 'has-errors' : submitted && promoCodeForm.promoCode.$invalid }\">\n      <input class=\"small form-control\" type=\"text\" placeholder=\"Enter your promo code\" name=\"promoCode\" ng-model=\"form.promoCode\" value=\"user.referralCode\" tabindex=\"1\" required>\n    </div>\n    <br>\n    <p class=\"center\">\n      <button class=\"btn center btn-animated-no-icon\" type=\"submit\" ng-click=\"redeemPromoCode(promoCodeForm)\" tabindex=\"2\" ng-bs-animated-button=\"\" is-submitting=\"isRedeemingPromo\" result=\"redeemPromoResult\" options=\"redeemPromoBtnOptions\"></button>\n    </p>\n  </form>\n</section>\n";

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<div class=\"loading gray\" ng-show=\"loading\" style=\"margin-top: 40px;\"></div>\n<div id=\"review\" class=\"bookings-list\" ng-hide=\"loading\">\n  <div class=\"back-button\">\n    <a ui-sref=\"app.me.reviews\"><i class=\"fa fa-long-arrow-left\"></i> Back to your Reviews</a>\n  </div>\n  <div class=\"list-header\">\n    <div class=\"account-bookings-title\">How was your night out?</div>\n  </div>\n  <div class=\"review-content booking-card-directive\">\n    <div class=\"booking-card-body\">\n      <div class=\"booking-card-wrapper\">\n        <div class=\"booking-info-wrapper\">\n          <div class=\"image-wrapper\">\n            <img class=\"venue-image\" ng-src=\"{{ booking.venue.primaryImage.small }}\" />\n          </div>\n          <div class=\"booking-details\">\n            <h2 class=\"name clickable\" ui-sref=\"app.receipt({booking : booking.id })\">{{ booking.name }} @ {{ booking.venue.name }}</h2>\n            <p>{{ booking.venue.type }}</p>\n            <p>{{ booking.date | date:'EEE, MMM dd, yyyy' }} <span ng-show=\"booking.arrivalTime\">- {{ booking.arrivalTime | localize | date:'h:mm a' }}</span></p>\n          </div>\n        </div>\n        <div class=\"review-form-wrapper\">\n          <form name=\"userForm\" class=\"review-form\" ng-submit=\"submitForm()\" novalidate>\n            <div class=\"questions\" ng-repeat=\"question in review.questions\">\n              <br>\n              <h4>{{ question.title }}\n                <span class=\"error\" ng-hide=\"question.valid\">This question is required</span>\n              </h4>\n              <div class=\"large-response-box\">\n                <span class=\"btn\" ng-repeat=\"response in responses\" ng-class=\"{ selected: question.rating == $index+1 }\" ng-click=\"respondToQuestion(question.key, $index+1)\" ng-bind=\"response\"></span>\n              </div>\n              <div class=\"small-response-box\">\n                <span class=\"fa fa-star\" ng-class=\"{ 'filled' : question.rating >= i, 'spin' : question.spin >= i  }\" ng-disabled=\"question.disableResponses\" ng-click=\"respondToQuestion(question.key, i)\" ng-repeat=\"i in [1,2,3,4,5]\"></span>\n              </div>\n              <br>\n            </div>\n            <br>\n            <span class=\"note\">*optional</span>\n            <div class=\"details-header clearfix\">\n              <h4>Write specific details about your night out at {{ booking.venue.name }}</h4>\n            </div>\n            <div class=\"details-content\">\n              <textarea ng-model=\"review.comment\" placeholder=\"Your review helps others learn about great nightlife venues.  &#10;&#10;Please don't review this business if you received a freebie for writing this review, or if you're connected in any way to the owner or employees.\"></textarea>\n            </div>\n            <br><br>\n            <div>\n              <input type=\"submit\" class=\"btn btn-primary\" value=\"Submit Review\" />\n              <span class=\"error\" ng-hide=\"valid\">Please answer all the required questions</span>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "<div id=\"reviews\">\n  <div id=\"account-booking\" class=\"bookings-list\">\n    <div class=\"container\">\n      <div class=\"list-header\">\n        <div class=\"account-bookings-title\">Your Reviews</div>\n        <div class=\"more-redundant-text-wrapper\" ng-if=\"pendingReviews.length !== 0\">\n          <div class=\"more-redundant-text\">Unfinished Reviews</div>\n        </div>\n      </div>\n      <div class=\"loading-wrapper\" ng-if=\"loading\">\n        <loading></loading>\n      </div>\n      <div class=\"no-reviews-err\" ng-show=\"!loading && pendingReviews < 1 && finishedReviews < 1\">\n        <p><strong>0 Reviews</strong> Pending</p>\n        <p class=\"empty-state\"><a ui-sref=\"app.search\">Reserve a table</a> and let us know how awesome your night was!</p>\n      </div>\n      <booking-card ng-repeat=\"review in pendingReviews\" booking=\"review.booking\" review=\"review.review\" class=\"clearfix\"></booking-card>\n      <div class=\"more-redundant-text-wrapper\" ng-if=\"finishedReviews.length !== 0\">\n        <div class=\"more-redundant-text\">Past Reviews</div>\n      </div>\n      <booking-card ng-repeat=\"review in finishedReviews\" booking=\"review.booking\" review=\"review.review\" class=\"clearfix\"></booking-card>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<div id=\"account-booking\" class=\"bookings-list\">\n  <div class=\"container\">\n    <div class=\"list-header\">\n      <div class=\"account-bookings-title\">Your Tickets</div>\n    </div>\n    <div class=\"loading-wrapper\" ng-if=\"loading\">\n      <loading></loading>\n    </div>\n    <div class=\"show-on-load\" ng-class=\"{'active' : !loading }\">\n      <div class=\"redundant-text\" id=\"upcoming\" ng-hide=\"sortedBookings.upcoming.length < 1\"><strong>{{ sortedBookings.upcoming.length }} Upcoming Tickets</strong> reserved.</div>\n      <div ng-repeat=\"booking in sortedBookings.upcoming | orderBy: '-arrivalTime'\" class=\"booking list\">\n        <div class=\"content\">\n          <booking-card booking=\"booking\"></booking-card>\n        </div>\n      </div>\n      <div class=\"redundant-text\" id=\"past\"><strong>{{ sortedBookings.past.length }} Previous Tickets</strong> reserved.</div>\n      <div ng-repeat=\"booking in sortedBookings.past | orderBy: '-arrivalTime'\" class=\"booking list\">\n        <div class=\"content\">\n          <booking-card booking=\"booking\"></booking-card>\n        </div>\n      </div>\n      <div class=\"no-bookings-err\" ng-show=\"sortedBookings && sortedBookings.all && sortedBookings.all.length === 0\">\n        <p>You don't have any tickets currently.</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "<div id=\"app\">\n  <app-header></app-header>\n  <div id=\"content\">\n    <div class=\"view-container view-frame view-fade-in\" ui-view>\n    </div>\n  </div>\n  <cookie-banner></cookie-banner>\n  <app-footer></app-footer>\n</div>\n";

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "<div id=\"browse\">\n  <div ui-view></div>\n</div>\n";

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "<div id=\"browseCity\">\n  <div class=\"header\">\n    <div class=\"top-header container\">\n      <div class=\"top-text animated fadeInUp\">\n        Discover\n      </div>\n      <div class=\"bottom-text animated delay-three fadeInUp clearfix\">\n        <div class=\"text pull-left\">\n          nightlife in\n        </div>\n        <div class=\"dropdown current-city-dropdown\">\n          <div class=\"city-name\">\n            {{ city.name }}\n          </div>\n          <select class=\"form-control\" ng-model=\"selectedCity\" ng-change=\"changeCity()\" ng-options=\"city as city.name for city in cities\"></select>\n          <i class=\"icon ion-chevron-down\"></i>\n        </div>\n      </div>\n    </div>\n    <div class=\"background-image-overlay\">\n    </div>\n    <div class=\"background-image\" ng-style=\"{'background-image':'url('+imgix(city.primaryImage.xlarge)+')'}\"></div>\n  </div>\n  <div class=\"browse-nav\">\n    <div class=\"container\">\n      <a ng-cloak class=\"item\" ng-if=\"loading.venues || venues.length > 0\" ng-click=\"scrollTo('venues')\">Venues</a>\n      <a ng-cloak class=\"item\" ng-if=\"loading.events || events.length > 0\" ng-click=\"scrollTo('events')\">Events</a>\n      <a ng-cloak class=\"item\" ng-if=\"loading.lists || curatedLists.length > 0\" ng-click=\"scrollTo('lists')\">Picks</a>\n      <a ng-cloak class=\"item\" ng-if=\"loading.featured || featured.length > 0\" ng-click=\"scrollTo('featured')\">Spotlight</a>\n    </div>\n  </div>\n  <section class=\"seasonal\" ng-show=\"seasonalLists.length > 0\" id=\"featured\">\n    <div class=\"container\">\n      <div class=\"section-header\">\n        <img src=\"//assets.tablelist.com/www/images/halloween-2016-logo-v1.0.png\">\n      </div>\n      <div class=\"section-content row curated-lists\">\n        <curated-list-card placeholder=\"true\" ng-repeat=\"list in [1,2,3]\" ng-show=\"loading.lists\"></curated-list-card>\n        <curated-list-card list=\"list\" ng-repeat=\"list in seasonalLists = (curatedLists | limitTo: curatedListLimit | filter: onlySeasonal)\" ng-hide=\"loading.lists\"></curated-list-card>\n      </div>\n    </div>\n    <p ng-click=\"scrollTo('lists')\">For everything else {{ city.name }} related</p>\n    <p ng-click=\"scrollTo('lists')\"><i class=\"fa fa-chevron-down\"></i></p>\n  </section>\n  <div class=\"container main-container\">\n    <section class=\"lists\" ng-show=\"loading.featured || featured.length > 0\" ng-hide=\"seasonalLists.length > 0\">\n      <div class=\"section-header\">\n        <h2 id=\"featured\">Spotlight</h2>\n        <hr>\n      </div>\n      <div class=\"section-content row curated-list\">\n        <curated-list-item-card placeholder=\"true\" ng-repeat=\"list in [1,2,3]\" ng-show=\"loading.featured\"></curated-list-item-card>\n        <curated-list-item-card item=\"item\" ng-repeat=\"item in featured | limitTo: 3\" ng-hide=\"loading.featured\"></curated-list-item-card>\n      </div>\n      <div class=\"see-more\" ng-show=\"loading.featured || featured.length > 3\">\n        <a href=\"/list/{{featured[0].curatedList}}\" class=\"btn btn-default clickable\">See More</a>\n      </div>\n    </section>\n    <section class=\"venues\" ng-show=\"loading.venues || venues.length > 0\">\n      <div class=\"section-header\">\n        <h2 id=\"venues\">Venues in {{ city.name }}</h2>\n        <hr>\n      </div>\n      <div class=\"section-content\">\n        <div class=\"venues clearfix\" ng-show=\"loading.venues\">\n          <venue-card placeholder=\"true\" ng-repeat=\"n in [1,2,3]\"></venue-card>\n        </div>\n        <div class=\"venues clearfix\" ng-hide=\"loading.venues\">\n          <venue-card venue=\"venue\" ng-repeat=\"venue in filteredVenues = (venues | orderBy : sortVenues)\"></venue-card>\n        </div>\n        <div class=\"see-more\">\n          <a href=\"#\" class=\"btn btn-default clickable\" ui-sref=\"app.browse.venues({city : city.slugName})\">See All Venues</a>\n        </div>\n      </div>\n    </section>\n    <section class=\"events\" ng-show=\"loading.events || events.length > 0\">\n      <div class=\"section-header\">\n        <h2 id=\"events\">Events in {{ city.name }}</h2>\n        <hr>\n      </div>\n      <div class=\"section-content\">\n        <div class=\"events clearfix\" ng-show=\"loading.events\">\n          <event-card placeholder=\"true\" ng-repeat=\"n in [1,2,3]\"></event-card>\n        </div>\n        <div class=\"events clearfix\" ng-hide=\"loading.events\">\n          <event-card event=\"event\" ng-repeat=\"event in filteredEvents = (events | limitTo:3)\"></event-card>\n        </div>\n        <div class=\"see-more\" ng-show=\"loading.events || events.length > 2\">\n          <a href=\"#\" class=\"btn btn-default clickable\" ui-sref=\"app.browse.events({city : city.slugName})\">See All Events</a>\n        </div>\n      </div>\n    </section>\n    <section class=\"lists\" id=\"lists\" ng-show=\"loading.lists || curatedLists.length > 0\">\n      <div class=\"section-header\">\n        <h2 id=\"lists\">Tablelist's picks in {{ city.name }}</h2>\n        <hr>\n      </div>\n      <div class=\"section-content row curated-lists\">\n        <curated-list-card placeholder=\"true\" ng-repeat=\"list in [1,2,3,4,5,6]\" ng-show=\"loading.lists\"></curated-list-card>\n        <curated-list-card list=\"list\" ng-repeat=\"list in curatedLists | filter: noSeasonal | limitTo: curatedListLimit\" ng-hide=\"loading.lists\"></curated-list-card>\n      </div>\n      <div class=\"see-more\" ng-show=\"loading.lists || (curatedListLimit <= 6 && curatedLists.length > 6)\">\n        <a href=\"#\" class=\"btn btn-default clickable\" ng-click=\"curatedListLimit = 100\">Show More</a>\n      </div>\n    </section>\n  </div>\n</div>\n";

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "<div id=\"browse-events\">\n  <div class=\"browse-options-wrapper\">\n    <!-- Venue Filters -->\n    <div class=\"browse-options\" ng-hide=\"partner.hideBrowseOptions\">\n      <div class=\"container\">\n        <div class=\"city-venue filters pull-left\">\n          <!-- City Picker -->\n          <div class=\"dropdown dropdown-round dropdown-gray city-picker\">\n            <button class=\"btn btn-default btn-round btn-block dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n              <span style=\"\" ng-show=\"city.id\">{{ city.name }}</span>\n              <span style=\"\" ng-hide=\"city.id\">Loading....</span>\n              <i class=\"icon ion-ios-arrow-down pull-right\" ng-hide=\"cities.length < 2\"></i>\n            </button>\n            <ul class=\"dropdown-menu\" ng-hide=\"cities.length < 2\">\n              <li ng-repeat=\"city in cities\">\n                <a tabindex=\"-1\" href=\"#\" ng-click=\"changeCity(city.slugName)\">{{ city.name }}</a>\n              </li>\n            </ul>\n          </div>\n          <!-- Venue vs Events -->\n          <div class=\"toggle-venues-events clearfix\">\n            <div class=\"item-type btn btn-default btn-round pull-left\" ui-sref=\"app.browse.venues({city : city.slugName})\">\n              Venues\n            </div>\n            <div class=\"item-type btn btn-default btn-round pull-left active\">\n              Events\n            </div>\n          </div>\n        </div>\n        <!-- Filter Items by Time -->\n        <div class=\"date filters pull-left\">\n          <div class=\"dropdown dropdown-round dropdown-gray\">\n            <button class=\"btn btn-default btn-round dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n              <i class=\"icon ion-clock\"></i>{{ currentTimeRange }}\n              <i class=\"icon ion-ios-arrow-down\"></i>\n            </button>\n            <ul class=\"dropdown-menu\">\n              <li ng-repeat=\"timeRange in timeRanges\" ng-class=\"{'active' : timeRange === currentTimeRange}\" ng-click=\"changeEventTimeRange(timeRange)\">\n                <a tabindex=\"-1\" href=\"#\">{{ timeRange }}</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"venues-and-events\" class=\"venue-and-events-list container\">\n    <p class=\"tags\" ng-show=\"filters.length > 0\">Showing events for: <span ng-repeat=\"tag in filters\"> {{ tag.name }}</span> </p>\n    <div class=\"events clearfix\" ng-show=\"loading\">\n      <event-card placeholder=\"true\" ng-repeat=\"n in [1,2,3,4,5,6]\"></event-card>\n    </div>\n    <div class=\"events clearfix\" ng-hide=\"loading\">\n      <p class=\"search-text\" ng-show=\"search\">Showing events containing: <strong>{{ search }}</strong></p>\n      <event-card event=\"event\" ng-repeat-start=\"event in filteredEvents = events\"></event-card>\n      <div ng-if=\"$index==1\" ng-repeat-end>\n        <membership-card type=\"'event'\"></membership-card>\n      </div>\n    </div>\n    <div class=\"events clearfix\" ng-show=\"!loading && filteredEvents.length < 1\">\n      <div class=\"empty-state\" ng-class=\"{ 'active' : filteredEvents.length < 1 }\">\n        <h4>Sorry, no results found.</h4>\n        <p>Please refine your search and try again</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<div id=\"browse-venues\">\n  <div class=\"browse-options-wrapper\">\n    <div class=\"browse-options\">\n      <div class=\"container\">\n        <div class=\"city-venue filters pull-left\">\n          <div class=\"dropdown dropdown-round dropdown-gray city-picker\">\n            <button class=\"btn btn-default btn-round btn-block dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n              <span style=\"\" ng-show=\"city.id\">{{ city.name }}</span>\n              <span style=\"\" ng-hide=\"city.id\">Loading....</span>\n              <i class=\"icon ion-ios-arrow-down pull-right\" ng-hide=\"cities.length < 2\"></i>\n            </button>\n            <ul class=\"dropdown-menu\" ng-hide=\"cities.length < 2\">\n              <li ng-repeat=\"city in cities\">\n                <a tabindex=\"-1\" href=\"#\" ng-click=\"changeCity(city.slugName)\">{{ city.name }}</a>\n              </li>\n            </ul>\n          </div>\n          <div class=\"toggle-venues-events clearfix\">\n            <div class=\"item-type btn btn-default btn-round pull-left active\">\n              Venues\n            </div>\n            <div class=\"item-type btn btn-default btn-round pull-left\" ui-sref=\"app.browse.events({city : city.slugName})\">\n              Events\n            </div>\n          </div>\n        </div>\n        <!-- Filter Items by Time -->\n        <div class=\"date filters pull-left\">\n          <div class=\"dropdown dropdown-round dropdown-gray\">\n            <button class=\"btn btn-default btn-round dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n              <i class=\"icon ion-clock\"></i>{{ currentTimeRange }}\n              <i class=\"icon ion-ios-arrow-down\"></i>\n            </button>\n            <ul class=\"dropdown-menu\">\n              <li ng-repeat=\"timeRange in timeRanges\" ng-click=\"changeTimeRange(timeRange)\" ng-class=\"{'active' : currentTimeRange === timeRange}\">\n                <a tabindex=\"-1\" href=\"#\">{{ timeRange === 'All' ? 'All Venues' : timeRange }}</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"filters date pull-left\">\n          <div class=\"dropdown dropdown-round dropdown-gray\">\n            <button class=\"btn btn-default btn-round dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n              <span>Sort By</span>\n              <i class=\"icon ion-arrow-down-c\"></i>\n            </button>\n            <ul class=\"dropdown-menu\">\n              <li ng-repeat=\"sorter in sorters\" ng-click=\"setSortBy(sorter)\" ng-class=\"{ active : sortBy === sorter }\">\n                <a tabindex=\"-1\" href=\"#\">{{ sorter }}</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"venues-and-events\" class=\"venue-and-events-list container\">\n    <!-- Loading -->\n    <div class=\"venues clearfix\" ng-show=\"loading\">\n      <venue-card placeholder=\"true\" ng-repeat=\"n in [1,2,3,4,5,6]\"></venue-card>\n    </div>\n    <!-- Results -->\n    <div class=\"venues clearfix\" ng-hide=\"loading\">\n      <venue-card venue=\"venue\" ng-repeat=\"venue in filteredVenues = (venues | orderBy : sortVenues | filter : filterItems )\"></venue-card>\n      <!-- <div ng-if=\"$index==1\" ng-repeat-end>\n        <membership-card type=\"'venue'\"></membership-card>\n      </div> -->\n    </div>\n    <!-- No Results -->\n    <div class=\"venues clearfix\" ng-show=\"!loading && filteredVenues.length < 1\">\n      <div class=\"empty-state\" ng-class=\"{ 'active' : filteredVenues.length < 1 }\">\n        <h4>Sorry, no venues match your search.</h4>\n        <p>Please refine your search and try again</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div id=\"checkout\" class=\"clearfix\">\n  <div class=\"container\">\n    <div class=\"container-inner\">\n      <form name=\"updateUserAngularForm\" role=\"form\" novalidate>\n        <div id=\"checkout-inner\" class=\"clearfix row\">\n          <!-- LEFT COLUMN -->\n          <div class=\"left-column col-sm-7 clearfix\">\n            <!-- LOGIN -->\n            <section class=\"login-section\" ng-if=\"!currentUser\">\n              <p>Not on Tablelist? No problem</p>\n              <login config=\"loginConfig\" ng-if=\"booking\"></login>\n            </section>\n            <section class=\"login-section\" ng-if=\"currentUser\">\n              <a href=\"#\" ng-click=\"signOut($event)\" class=\"logout\">Not {{ currentUser.firstName || currentUser.email }}? Log Out</a>\n            </section>\n            <!-- CONTACT INFO -->\n            <section class=\"info-section clearfix\" ng-if=\"currentUser\">\n              <div class=\"section-header\">\n                Contact Info\n              </div>\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <div class=\"clearfix row\">\n                    <div class=\"col-xs-12 form-group\" ng-class=\"{ 'has-errors': submitted && !updateUserAngularForm.email.$valid }\">\n                      <p>Email</p>\n                      <input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"updateUserForm.email\" required>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" ng-class=\"{ 'has-errors': submitted && !updateUserAngularForm.phone.$valid }\">\n                    <p>Phone</p>\n                    <input type=\"text\" name=\"phone\" class=\"form-control\" ng-model=\"updateUserForm.phone\" placeholder=\"(555)-555-5555\" required>\n                  </div>\n                  <div class=\"form-group\" ng-show=\"showArrivalTime()\">\n                    <p>What time will you arrive?</p>\n                    <div class=\"dropdown dropdown-gray\">\n                      <button class=\"btn arrival-time-btn btn-default btn-block dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" ng-disabled=\"bookingHasConfirmationRequestWithArrivalTime()\">\n                        <span ng-hide=\"selectedArrivalTime\">Select arrival time</span>\n                        <span ng-show=\"selectedArrivalTime\">{{ selectedArrivalTime | date: 'h:mma' : 'UTC' }}</span>\n                        <i class=\"icon-chevron-down pull-right\"></i>\n                      </button>\n                      <ul class=\"dropdown-menu btn-block\">\n                        <li ng-repeat=\"arrivalTime in arrivalTimes\">\n                          <a ng-click=\"changeArrivalTime(arrivalTime)\">{{ arrivalTime | date: 'h:mma' : 'UTC' }}</a>\n                        </li>\n                      </ul>\n                    </div>\n                  </div>\n                  <div class=\"form-group\" style=\"margin-bottom: 0;\" ng-if=\"venueShowMarketingOptIn\">\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"customerMarketingOptIn\" ng-model=\"booking.customerMarketingOptIn\" ng-change=\"customerMarketingOptInChanged(booking.customerMarketingOptIn)\">\n                        <span style=\"position: relative; top: 2px;\" class=\"checkbox-label no-select\">{{ venueMarketingOptInText }}</span>\n                      </label>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </section>\n            <!-- PAYMENT -->\n            <section class=\"payment-section payment-container\" ng-if=\"currentUser && booking.payment !== 'NONE'\">\n              <div class=\"section-header\">\n                Payment method\n              </div>\n              <payment-profile payment-profile=\"paymentProfile\" on-change=\"setPaymentProfile\"></payment-profile>\n            </section>\n            <div class=\"alert alert-danger purchase-errors\" ng-show=\"errorMessage\">{{ errorMessage }}</div>\n          </div>\n          <!-- RIGHT COLUMN -->\n          <div class=\"right-column col-sm-5\">\n            <checkout-preview booking=\"booking\" venue=\"venue\" inventory=\"inventory\"></checkout-preview>\n            <div class=\"checkout-btn\" ng-if=\"booking\">\n              <button class=\"btn btn-primary btn-block\" type=\"submit\" ng-click=\"checkout(updateUserAngularForm)\" ng-disabled=\"!paymentProfile\" ng-if=\"booking.payment !== BOOKING_PAYMENT_TYPES.NONE && booking.payment !== BOOKING_PAYMENT_TYPES.VENUE\">\n                <span ng-show=\"!completingPurchase\">\n                  Pay {{ booking.totalWithCredit | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}\n                </span>\n                <span ng-show=\"completingPurchase\">\n                  <i class=\"fa fa-spin fa-spinner\"></i>\n                </span>\n              </button>\n              <button class=\"btn btn-primary btn-block\" type=\"submit\" ng-click=\"checkout(updateUserAngularForm)\" ng-if=\"booking.payment === BOOKING_PAYMENT_TYPES.NONE || booking.payment === BOOKING_PAYMENT_TYPES.VENUE\">\n                <span ng-show=\"!completingPurchase\">\n                  Complete\n                </span>\n                <span ng-show=\"completingPurchase\">\n                  <i class=\"fa fa-spin fa-spinner\"></i>\n                </span>\n              </button>\n              <div class=\"terms\">\n                <span ng-if=\"booking.payment !== BOOKING_PAYMENT_TYPES.NONE && booking.payment !== BOOKING_PAYMENT_TYPES.VENUE\">\n                  By clicking \"Pay\" you agree to the <a href=\"#\" ng-click=\"showVenueTerms($event)\">venue's terms and conditions</a>\n                </span>\n                <span ng-if=\"booking.payment === BOOKING_PAYMENT_TYPES.NONE || booking.payment === BOOKING_PAYMENT_TYPES.VENUE\">\n                  By clicking \"Complete\" you agree to the <a href=\"#\" ng-click=\"showVenueTerms($event)\">venue's terms and conditions</a>\n                </span>\n                and our <a href=\"#\" ng-click=\"showTablelistTerms($event)\">terms &amp; conditions</a> and consent to receiving text or email messages about your order.\n              </div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<div id=\"concierge-page\">\n  <div class=\"container\">\n    <div class=\"col-md-6 options\">\n      <contact-options message=\"message\"></contact-options>\n    </div>\n    <div class=\"col-md-6 details\">\n      <h1>Tablelist Concierge</h1>\n      <p>The Tablelist concierge is available via chat, email, or text message. Simply start up a conversation. Here are a few things we can do for you:</p>\n      <br>\n      <ul>\n        <li>Find you the best venues</li>\n        <li>Plan your night out</li>\n        <li>Create custom table packages </li>\n        <li>Provide last minute booking support</li>\n      </ul>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<div id=\"curatedList\">\n  <div class=\"list-header\">\n    <div class=\"background-image\" ng-style=\"{'background-image':'url('+imgix(curatedList.imageUrl)+')'}\"></div>\n    <div class=\"container\">\n      <a class=\"back clickable\" ui-sref=\"app.browse.city({ city : city.slugName })\" ng-class=\"{'visible' : city.slugName}\"><img src=\"https://assets.tablelist.com/www/assets/arrow.svg\" /> Back to {{ city.name }}</a>\n      <h1>{{curatedList.title}}</h1>\n      <p class=\"description\">{{ curatedList.description }}</p>\n      <div class=\"list-share-bar clearfix\">\n        <div class=\"share-btn pull-left\" ng-hide=\"curatedList.type === 'FEATURED'\">\n          <div class=\"btn btn-sm btn-primary\" ng-click=\"toggleFollow(curatedList)\" ng-hide=\"saving || isFollowing()\">Follow</div>\n          <div class=\"btn btn-sm btn-primary\" ng-click=\"toggleFollow(curatedList)\" ng-show=\"!saving && isFollowing()\"><i class=\"fa fa-check\"></i> Following</div>\n          <div class=\"btn btn-sm btn-primary\" ng-show=\"saving\"><i class=\"fa fa-spin fa-refresh\"></i></div>\n        </div>\n        <div class=\"share-links pull-left\" ng-show=\"curatedList.title\">\n          <a target=\"_blank\" href=\"{{ facebookLink }}\"><i class=\"fa fa-facebook-square\"></i></a>\n          <a target=\"_blank\" href=\"{{ twitterLink }}\"><i class=\"fa fa-twitter\"></i></a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"loading-list\" ng-show=\"loading\">\n    <div class=\"container list\" ng-show=\"loading || (!loading && eventItems.length > 0)\">\n      <div class=\"row\">\n        <curated-list-item-card placeholder=\"true\" ng-repeat=\"item in [1,2,3]\" ng-show=\"loading\"></curated-list-item-card>\n      </div>\n    </div>\n  </div>\n  <!-- VENUES THEME -->\n  <div class=\"venues-theme\" ng-if=\"!curatedList.theme || curatedList.theme === 'theme-venues-list'\">\n    <div class=\"container list\" ng-show=\"eventItems.length > 0\">\n      <h2>Events</h2>\n      <hr>\n      <div class=\"row\">\n        <curated-list-item-card item=\"item\" list=\"curatedList\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' })\" ng-hide=\"loading\"></curated-list-item-card>\n      </div>\n    </div>\n    <div class=\"container list\" ng-show=\"venueItems.length > 0\">\n      <h2>Venues</h2>\n      <hr>\n      <div class=\"row\">\n        <curated-list-item-card item=\"item\" list=\"curatedList\" ng-repeat=\"item in venueItems = (items | filter: { type : 'VENUE' })\"></curated-list-item-card>\n      </div>\n    </div>\n  </div>\n  <!-- EVENTS THEME -->\n  <div class=\"events-theme\" ng-if=\"curatedList.theme === 'theme-events-list'\">\n    <div class=\"container list\" ng-show=\"eventItems.length > 0\">\n      <div class=\"row\">\n        <div class=\"col-sm-3 hidden-xs venue-list-column\">\n          <h4 class=\"header\">Venues</h4>\n          <ul class=\"venue-list\">\n            <li ng-repeat=\"venue in venues\">\n              <a href=\"#\" ng-click=\"toggleCurrentVenue(venue)\" ng-class=\"{ 'active' : currentVenueFilter.id === venue.id }\">\n                {{ venue.name }}\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"col-sm-9 col-xs-12\">\n          <curated-list-event-card item=\"item\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' } | filter:filterByCurrentVenue)\" ng-hide=\"loading\"></curated-list-event-card>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"container list saved-lists\" ng-show=\"loading || (!loading && venueItems.length > 0)\">\n    <h2>Your Saved Lists <a href=\"#\" ui-sref=\"app.me.favorites\" class=\"see-more\">See All</a></h2>\n    <hr>\n    <div class=\"row\">\n      <curated-list-card list=\"list.curatedList\" ng-repeat=\"list in followedLists | limitTo: 3\"></curated-list-card>\n    </div>\n    <div class=\"row\">\n      <p class=\"context\" ng-hide=\"followedLists.length < 1\">Follow lists to know when new events and venues are added!</p>\n      <p class=\"context\" ng-show=\"followedLists.length < 1\">You are not currently following any curated lists. Click the 'Follow' button to save your interests, and receive notifications when new items are added!</p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<div class=\"curated-lists-page curated-lists-page-halloween\">\n  <div class=\"list-header\">\n    <div class=\"container\">\n      <div class=\"top-header-wrapper center\">\n        <div class=\"top-header center\">\n          Halloween 2021\n        </div>\n        <div class=\"city-picker-directive\" ng-if=\"!showCountdown\">\n          <div class=\"form-control-wrapper\">\n            <div class=\"city-name\">\n              {{ cityForm.city.name }}\n            </div>\n            <select class=\"form-control\" ng-model=\"cityForm.city\" ng-change=\"selectCity()\" ng-options=\"city as city.name for city in  (cities | orderBy : 'name' )\"></select>\n            <i class=\"icon ion-chevron-down\"></i>\n          </div>\n        </div>\n      </div>\n      <div class=\"countdown-wrapper center\" ng-if=\"showCountdown\">\n        <countdown ng-if=\"showCountdown\" date=\"eventDate\"></countdown>\n      </div>\n    </div>\n  </div>\n  <div class=\"loading-wrapper center\" ng-show=\"loading\">\n    <loading></loading>\n  </div>\n  <div class=\"lists-wrapper\" ng-if=\"!loading && items.length && !showCountdown\">\n    <!-- VENUES THEME -->\n    <div class=\"theme venues-theme\" ng-if=\"!loading && (!curatedList.theme || curatedList.theme === 'theme-venues-list')\">\n      <div class=\"container theme-list\" ng-show=\"eventItems.length > 0\">\n        <div class=\"theme-list-header\">\n          <h2>Events</h2>\n        </div>\n        <div class=\"clearfix\">\n          <curated-list-item-card item=\"item\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' })\" ng-hide=\"loading\"></curated-list-item-card>\n        </div>\n      </div>\n      <div class=\"container theme-list\" ng-show=\"venueItems.length > 0\">\n        <div class=\"theme-list-header\">\n          <h2>Venues</h2>\n        </div>\n        <div class=\"clearfix\">\n          <curated-list-item-card item=\"item\" ng-repeat=\"item in venueItems = (items | filter: { type : 'VENUE' })\"></curated-list-item-card>\n        </div>\n      </div>\n    </div>\n    <!-- EVENTS THEME -->\n    <div class=\"theme events-theme\" ng-if=\"!loading && (curatedList.theme === 'theme-events-list')\">\n      <div class=\"container theme-list\" ng-show=\"eventItems.length > 0\">\n        <div class=\"clearfix\">\n          <div class=\"col-sm-3 hidden-xs venue-list-column\">\n            <h4 class=\"theme-header\">Venues</h4>\n            <ul class=\"venue-list\">\n              <li ng-repeat=\"venue in venues\">\n                <a href=\"#\" ng-click=\"toggleCurrentVenue(venue)\" ng-class=\"{ 'active' : currentVenueFilter.id === venue.id }\">\n                  {{ venue.name }}\n                </a>\n              </li>\n            </ul>\n          </div>\n          <div class=\"col-sm-9 col-xs-12\">\n            <curated-list-event-card item=\"item\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' } | filter:filterByCurrentVenue)\" ng-hide=\"loading\"></curated-list-event-card>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<div class=\"curated-lists-page curated-lists-page-newyears\">\n  <div class=\"list-header\">\n    <div class=\"container\">\n      <div class=\"top-header-wrapper center\">\n        <div class=\"top-header top-header-nye center\">\n          <div class=\"num\">\n            {{ currentYear }}\n          </div>\n          New Year's Eve\n        </div>\n        <div class=\"countdown-wrapper\">\n          <countdown date=\"eventDate\"></countdown>\n        </div>\n        <div class=\"city-picker-directive\" ng-if=\"!showCountdown\">\n          <div class=\"form-control-wrapper\">\n            <div class=\"city-name\">\n              {{ cityForm.city.name }}\n            </div>\n            <select class=\"form-control\" ng-model=\"cityForm.city\" ng-change=\"selectCity()\" ng-options=\"city as city.name for city in  (cities | orderBy : 'name' )\"></select>\n            <i class=\"icon ion-chevron-down\"></i>\n          </div>\n        </div>\n      </div>\n      <div class=\"countdown-wrapper center\" ng-if=\"showCountdown\">\n        <countdown ng-if=\"showCountdown\" date=\"eventDate\"></countdown>\n      </div>\n    </div>\n  </div>\n  <div class=\"loading-wrapper center\" ng-show=\"loading\">\n    <loading></loading>\n  </div>\n  <div class=\"lists-wrapper\" ng-if=\"!loading && items.length && !showCountdown\">\n    <!-- VENUES THEME -->\n    <div class=\"theme venues-theme\" ng-if=\"!loading && (!curatedList.theme || curatedList.theme === 'theme-venues-list')\">\n      <div class=\"container theme-list\" ng-show=\"eventItems.length > 0\">\n        <div class=\"theme-list-header\">\n          <h2>Events</h2>\n        </div>\n        <div class=\"clearfix\">\n          <curated-list-item-card item=\"item\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' })\" ng-hide=\"loading\"></curated-list-item-card>\n        </div>\n      </div>\n      <div class=\"container theme-list\" ng-show=\"venueItems.length > 0\">\n        <div class=\"theme-list-header\">\n          <h2>Venues</h2>\n        </div>\n        <div class=\"clearfix\">\n          <curated-list-item-card item=\"item\" ng-repeat=\"item in venueItems = (items | filter: { type : 'VENUE' })\"></curated-list-item-card>\n        </div>\n      </div>\n    </div>\n    <!-- EVENTS THEME -->\n    <div class=\"theme events-theme\" ng-if=\"!loading && (curatedList.theme === 'theme-events-list')\">\n      <div class=\"container theme-list\" ng-show=\"eventItems.length > 0\">\n        <div class=\"clearfix\">\n          <div class=\"col-sm-3 hidden-xs venue-list-column\">\n            <h4 class=\"theme-header\">Venues</h4>\n            <ul class=\"venue-list\">\n              <li ng-repeat=\"venue in venues\">\n                <a href=\"#\" ng-click=\"toggleCurrentVenue(venue)\" ng-class=\"{ 'active' : currentVenueFilter.id === venue.id }\">\n                  {{ venue.name }}\n                </a>\n              </li>\n            </ul>\n          </div>\n          <div class=\"col-sm-9 col-xs-12\">\n            <curated-list-event-card item=\"item\" ng-repeat=\"item in eventItems = (items | filter: { type : 'EVENT' } | filter:filterByCurrentVenue)\" ng-hide=\"loading\"></curated-list-event-card>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "<div id=\"download\" class=\"clearfix\">\n  <div id=\"download-header\" class=\"clearfix download-section\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-sm-7\">\n          <h1>Access the best<br>nightlife with a tap<br>of a button.</h1>\n          <div class=\"row clearfix sms-me\">\n            <p class=\"center\">Text me the app</p>\n            <sms-download-link></sms-download-link>\n          </div>\n        </div>\n        <div class=\"col-sm-5\">\n          <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www/assets/download-devices-v1.2.png\" alt=\"Download Tablelist for iOS and Android\">\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"download-personalize\" class=\"clearfix hidden-xs\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-sm-5\">\n          <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www/assets/download-devices-v1.3.png\" alt=\"Download Tablelist for iOS and Android\">\n        </div>\n        <div class=\"col-sm-7 features\">\n          <h2>Browse and Discover</h2>\n          <p>From member-only events to local hot spots, narrow down your destination based on type, neighborhood, and more.</p>\n          <br>\n          <h2>Personalize your table</h2>\n          <p>Choose a table size, desired location, and preferred alcohol types, all tailored exactly the way you want it.</p>\n          <br>\n          <h2>Pay in advance</h2>\n          <p>Invite your friends, and cover everything from tax to tip, all directly within the app.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"download-waiting\" class=\"clearfix hidden-xs\">\n    <div class=\"container\">\n      <h2 class=\"center\">What are you waiting for?</h2>\n      <br>\n      <div id=\"download-links\">\n        <div class=\"col-md-6\">\n          <a class=\"apple\" href=\"https://itunes.apple.com/app/tablelist/id634444177?mt=8\" target=\"_blank\" title=\"Download for iOS\"><img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_apple.png\"></a>\n        </div>\n        <div class=\"col-md-6\">\n          <a class=\"android\" href=\"https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod\" target=\"_blank\" title=\"Download for Android\"><img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_android.png\"></a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fourohfour\">\n  <div class=\"container\">\n    <h1 ng-hide=\"message\">This page is dead, but your night isn't</h1>\n    <h1 ng-show=\"message\">{{ message }}</h1>\n    <p>The information you requested could not be found.</p>\n    <button ng-click=\"browseVenues()\" href=\"#\" class=\"btn btn-default\">Browse Venues</button>\n\n    {{ message }}\n  </div>\n</div>\n";

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fourohfour\">\n  <div class=\"container\">\n    <h1>Something went wrong</h1>\n    <p>{{ message }}</p>\n    <button ng-click=\"browseVenues()\" href=\"#\" class=\"btn btn-default\">Browse Venues</button>\n  </div>\n</div>\n";

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<div id=\"event\">\n  <div class=\"back-btn-wrapper container\" ng-if=\"showBackBtn\">\n    <a href=\"#\" ui-sref=\"app.curatedList({ id : backId })\">\n      <img src=\"https://assets.tablelist.com/www/assets/arrow.svg\">\n      <span ng-if=\"backName\">Back to {{ backName }}</span>\n      <span ng-if=\"!backName\">Back</span>\n    </a>\n  </div>\n  <div class=\"event-header\">\n    <div class=\"container\">\n      <div class=\"event-details\">\n        <div class=\"event-image pull-left hidden-xs\">\n          <img ng-src=\"{{ imgix(event.primaryImage.filename, 400) }}\">\n        </div>\n        <div class=\"wrapper clearfix\">\n          <h1 class=\"name\">{{ event.name }}</h1>\n          <h4 class=\"time\">{{ eventDateString(event) }} <a href=\"#\" ui-sref=\"app.venue({ seoPathname: event.venue.seoPathname })\">{{ event.venue.name }}</a></h4>\n          <p class=\"door-time\">Doors open at {{ event.dateStart | utc | date:'h:mma' }}</p>\n          <div class=\"share-event\">\n            <span class=\"text\">Share this event</span>\n            <share-bar config=\"shareBarConfig\"></share-bar>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"event-content clearfix\">\n    <div class=\"event-about clearfix\">\n      <div class=\"container\">\n        <div class=\"map-widget clearfix\" ng-class=\"{ 'enabled' : event.isMapWidgetEnabled }\">\n          <div id=\"inventory-list-map-widget\"></div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-7 left-column\">\n            <div class=\"event-soundcloud hidden-xs\" ng-if=\"event.details.soundcloud\">\n              <div id=\"soundcloud\" class=\"player\">\n                <soundcloud-player src=\"event.details.soundcloud\" height=\"480px\" player=\"soundcloudPlayer\"></soundcloud-player>\n              </div>\n            </div>\n            <div class=\"box\" ng-show=\"!canBookNow || isPast()\">\n              <div class=\"clearfix row alert alert-warning\">\n                <div class=\"col-xs-12\">\n                  <p ng-show=\"isPast()\">This event has past. <a href=\"#\" ui-sref=\"app.venue.events({ seoPathname : event.venue.seoPathname })\">See Upcoming Events.</a></p>\n                  <p ng-show=\"!canBookNow()\">Tickets are not currently available</p>\n                </div>\n              </div>\n            </div>\n            <div class=\"box visible-xs visible-sm no-border\">\n              <div class=\"clearfix row\">\n                <div class=\"col-xs-12\">\n                  <div class=\"event-image\" ng-show=\"event.primaryImage && event.primaryImage.filename\">\n                    <img ng-src=\"{{ imgix(event.primaryImage.filename, 400) }}\">\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"box\" ng-show=\"event.details.description\">\n              <h4 class=\"section-title\">{{ event.name }}</h4>\n              <div class=\"info-text dark-info-text\">\n                <read-more limit=\"500\" text=\"event.details.description\"></read-more>\n              </div>\n            </div>\n            <div id=\"inventory-list-widget-xs\" class=\"visible-sm visible-xs\" ng-if=\"event.id && !event.isMapWidgetEnabled\">\n            </div>\n            <!-- Soundcloud (mobile) -->\n            <div class=\"box visible-sm\" ng-if=\"event.details.soundcloud\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Soundcloud</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"clearfix\">\n                    <div id=\"soundcloud\" class=\"player\">\n                      <soundcloud-player src=\"event.details.soundcloud\" height=\"480px\" player=\"soundcloudPlayer\"></soundcloud-player>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Why we like it -->\n            <div class=\"box\" ng-show=\"event.details.shortDescription\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Why we like it</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix\">\n                    <p>{{ event.details.shortDescription }}</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- When -->\n            <div class=\"box\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">When</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix\">\n                    <p>{{ event.date | utc | date:'EEEE, MMMM d, yyyy' }}</p>\n                    <p>\n                      <span ng-show=\"event.dateStart\">{{ event.dateStart | utc | date:'h:mma' }}</span>\n                      <span ng-show=\"event.dateEnd\"> - {{ event.dateEnd | utc | date:'h:mma' }}</span>\n                    </p>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Tags -->\n            <div class=\"box\" ng-show=\"event.userDefinedTags.length > 0\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Tags</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <span ng-repeat=\"tag in event.userDefinedTags\">{{tag.name}}{{$last ? '' : ', '}}</span>\n                </div>\n              </div>\n            </div>\n            <!-- Curated Lists -->\n            <div class=\"box\" ng-show=\"curatedLists.length > 0\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Featured In:</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <span ng-repeat=\"list in curatedLists\"><a href=\"#\" class=\"link\" ui-sref=\"app.curatedList({ id : list.id })\">{{list.title}}</a>{{$last ? '' : ', '}}</span>\n                </div>\n              </div>\n            </div>\n            <!-- Music -->\n            <div class=\"box\" ng-show=\"event.musicTags.length > 0\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Music Type</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix\">\n                    <span ng-repeat=\"tag in event.musicTags\">{{tag.name}}{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Age -->\n            <div class=\"box\" ng-show=\"event.details.minAge || event.venue.details.minAge\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Age</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix\">\n                    <span>{{ event.details.minAge || event.venue.details.minAge }}+</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Clothes -->\n            <div class=\"box\" ng-show=\"event.okDressCodeTags.length > 0 || event.notOkDressCodeTags.length > 0\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">The Door</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix row\">\n                    <div class=\"col-xs-6\">\n                      <p class=\"bold\">What to wear:</p>\n                      <p class=\"dress-tag\" ng-repeat=\"tag in event.okDressCodeTags\">{{ tag.name }}</p>\n                    </div>\n                    <div class=\"col-xs-6\">\n                      <p class=\"bold\">What not to wear:</p>\n                      <p class=\"dress-tag\" ng-repeat=\"tag in event.notOkDressCodeTags\">{{ tag.name }}</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Crowd -->\n            <div class=\"box\" ng-show=\"event.crowdTags.length > 0\">\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Crowd</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix\">\n                    <span ng-show=\"event.details.minAge\">{{ event.details.minAge }} + | </span>\n                    <span ng-repeat=\"tag in event.crowdTags\">{{tag.name}}{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <!-- Address -->\n            <div class=\"box last-child\" ng-show=\"event.venue.address.address\">\n              <iframe class=\"google-map\" ng-if=\"mapUrl\" ng-src=\"{{mapUrl}}\"></iframe>\n              <div class=\"clearfix row\">\n                <h4 class=\"section-title col-md-3 col-xs-12\">Directions</h4>\n                <div class=\"col-md-9 col-xs-12\">\n                  <div class=\"dark-info-text clearfix row\">\n                    <div class=\"col-md-6 col-xs-6\">\n                      <div>{{event.venue.address.address}},</div>\n                      <div>\n                        <span>{{event.venue.address.city}}</span>, <span>{{event.venue.address.state}}</span> <span>{{event.venue.address.zip}}</span>\n                      </div>\n                      <div>{{event.venue.address.address1}}</div>\n                      <br>\n                      <p class=\"get-directions\" ng-show=\"googleMapsDirectionsUrl\">\n                        <a ng-href=\"{{googleMapsDirectionsUrl}}\" target=\"_blank\">Get directions</a>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"events-list\">\n              <h4 ng-show=\"loadingEvents || events.length > 0\" class=\"section-title\">Upcoming Events at {{ event.venue.name }}</h4>\n              <a class=\"upcoming-event clearfix\" ng-repeat=\"upcoming in events | limitTo:6\" href=\"#\" ui-sref=\"app.event({ seoPathname: upcoming.seoPathname })\" ng-hide=\"upcoming.id === event.id\">\n                <img ng-src=\"{{ imgix(upcoming.image, 100, 100) }}\" />\n                <div class=\"details\">\n                  <p class=\"date margin-bottom-0\">{{ upcoming.date | localize | date:'EEE, MMMM d' }}</p>\n                  <p class=\"name\">{{ upcoming.name }}</p>\n                  <p class=\"description\">{{ upcoming.description | truncateString:80 }}</p>\n                </div>\n              </a>\n              <a ui-sref=\"app.venue.events({ name: event.venue.seoPathname })\" ng-show=\"events.length > 6\" class=\"see-more-events\">See More Events</a>\n            </div>\n          </div>\n          <div class=\"col-md-5 right-column\">\n            <div class=\"inventory-note\" ng-show=\"event.inventoryNote\" ng-bind-html=\"event.inventoryNote\">\n            </div>\n            <div id=\"inventory-list-widget-lg\" class=\"hidden-sm\" ng-if=\"event.id && !event.isMapWidgetEnabled\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"event-video\" class=\"event-video hidden-sm hidden-xs\" ng-show=\"event.details.youtube\">\n    <div class=\"container\">\n      <div class=\"row clearfix\">\n        <div class=\"col-md-offset-1 left\">\n          <h4 class=\"section-title\">Watch</h4>\n        </div>\n        <div class=\"col-md-7 col-sm-12 video-wrapper\">\n          <iframe width=\"100%\" height=\"100%\" ng-src=\"{{ event.details.youtube }}\" frameborder=\"0\" allowfullscreen></iframe>\n        </div>\n      </div>\n    </div>\n  </div>\n  <rich-event-card event=\"event\" inventory=\"\"></rich-event-card>\n  <div id=\"guestlist-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\" role=\"document\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n          <h4 class=\"modal-title\">\n            Get on the Guest List\n          </h4>\n        </div>\n        <div class=\"modal-body\" id=\"guestlist-widget\">\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"reservation-request-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\">\n    <div class=\"modal-dialog\" role=\"document\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n          <h4 class=\"modal-title\">\n            Request Reservation\n          </h4>\n        </div>\n        <div class=\"modal-body\" id=\"reservation-request-widget\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "<div id=\"faq\">\n  <div id=\"faq-content\">\n    <div class=\"container\">\n      <div class=\"col-sm-12\">\n        <div class=\"faq-mobile-header visible-mobile visible-xs-block\">\n          <h1>Frequently Asked Questions</h1>\n          <ol>\n            <li ng-repeat=\"faqGroup in faqGroups\">\n              <a href=\"#\" ng-click=\"scrollTo(faqGroup.slug)\">{{ faqGroup.header }}</a>\n            </li>\n          </ol>\n        </div>\n      </div>\n      <div class=\"col-sm-8\">\n        <div class=\"faq-section\" ng-repeat=\"faqGroup in faqGroups\" id=\"{{ faqGroup.slug }}\">\n          <div class=\"faq-section-header\">\n            <h3 class=\"center\">{{ faqGroup.header }}</h3>\n            <div class=\"green-line green-line-thin\">\n            </div>\n          </div>\n          <div class=\"question-list\">\n            <div class=\"question col-md-12\" id=\"{{ question.slug }}\" ng-repeat=\"question in faqGroup.questions\">\n              <div class=\"question-border clickable\" ng-click=\"select(question.slug)\" ng-class=\"{ 'selected' : selectedSlug === question.slug }\">\n                <h4>{{ question.question }}</h4>\n                <p ng-bind-html=\"question.answer\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-4 hidden-xs\">\n        <div class=\"faq-side-nav\" id=\"scrollspy-header\" afix=\"\" offset-top=\"1\" offset-top-tablet=\"1\" offset-top-mobile-small=\"1\">\n          <h1>Frequently Asked Questions</h1>\n          <ol>\n            <li ng-repeat=\"faqGroup in faqGroups\">\n              <a href=\"#{{ faqGroup.slug}}\" du-smooth-scroll du-scrollspy>{{ faqGroup.header }}</a>\n            </li>\n          </ol>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"faq-contact\">\n    <p class=\"center\">\n      <img src=\"https://assets.tablelist.com/www-2/images/logo_small.png\" align=\"Tablelist\">\n    </p>\n    <h2>Contact Tablelist</h2>\n    <p>Contact a concierge at <strong>(617)-340-8791</strong>, through the “Talk to Us” widget on tablelist.com or Email us at <a href=\"mailto:hello@tablelist.com?subject=Tablelist FAQ\">hello@tablelist.com</a> for anything you may need!</p>\n  </div>\n</div>\n";

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<div id=\"forgot-password\" class=\"container\">\n\t<div class=\"forgot-password-inner\">\n\t\t<div class=\"forgot-form\" ng-hide=\"emailSent\">\n\t\t\t<h1>Forgot Password?</h1>\n\t\t\t<p class=\"description\">To get your new password, enter your email address below. We'll send you a link to create a new password.</p>\n\t\t\t<form name=\"forgotForm\" ng-submit=\"sendEmail(forgotForm)\" novalidate>\n\t\t\t\t<input type=\"email\" name=\"email\" ng-model=\"email\" class=\"form-control\" placeholder=\"Enter Email Address\" ng-class=\"{ 'has-errors': forgotForm.email.$invalid && submitted }\" required>\n\t\t\t\t<p class=\"error\" ng-show=\"error\">{{ error }}</p>\n\t\t\t\t<button type=\"submit\" class=\"btn btn-primary\">Submit</button>\n\t\t\t</form>\n\t\t</div>\n\t\t<div ng-show=\"emailSent\">\n\t\t\t<h1>Password Reset</h1>\n\t\t\t<p class=\"description\">We've sent an email to <strong>{{email}}</strong>, with instructions on how to reset your Tablelist password. If you don't see the email in 5 minutes, check your spam folder or try again. If you still can't access your\n\t\t\t\taccount, please contact <a href=\"mailto:support@tablelist.com\">support@tablelist.com</a>.</p>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<div id=\"home\">\n  <div class=\"hero-banner\">\n    <div class=\"inner\">\n      <div class=\"container\">\n        <h1 class=\"main-header\">\n          <span class=\"top-text animated fadeInUp\">Making nightlife</span>\n          <span class=\"mid-text animated fadeInUp\">simple</span>\n        </h1>\n        <h2 class=\"sub-header animated fadeInUp\">\n          The #1 app for bottle service, tickets and guestlist.\n        </h2>\n        <button class=\"btn btn-primary btn-browse-mobile visible-xs\" ng-click=\"browseCity()\">Discover Nightlife</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"section-cities clearfix\" id=\"cities\">\n    <h2 class=\"top-header center\">Discover Nightlife in Your City</h2>\n    <p class=\"description center\">Instant access to your favorite nightclubs, lounges, bars and parties nationwide.</p>\n    <!-- FIRST ROW ON DESKTOP -->\n    <div class=\"row first-row\">\n      <div class=\"col-md-3 col-sm-6 col-xs-12\" style=\"padding:0;\">\n        <div class=\"city-wrapper half first\">\n          <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-foxwoods.jpg')\" ui-sref=\"app.browse.city({city:'fox'})\">\n            <div class=\"overlay\"></div>\n            <div class=\"content\">\n              <h2 class=\"name\">Foxwoods</h2>\n              <button class=\"btn btn-tertiary\">Browse Now</button>\n            </div>\n          </div>\n        </div>\n        <div class=\"city-wrapper half\">\n          <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-philly.jpg')\" ui-sref=\"app.browse.city({city:'philly'})\">\n            <div class=\"overlay\"></div>\n            <div class=\"content\">\n              <h2 class=\"name\">Philadelphia</h2>\n              <button class=\"btn btn-tertiary\">Browse Now</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper col-md-6 col-sm-6 col-xs-12\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-nyc.jpg')\" ui-sref=\"app.browse.city({city:'nyc'})\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">New York City</h2>\n            <button class=\"btn btn-tertiary\">Browse Now</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-3 col-sm-6 col-xs-12\" style=\"padding:0;\">\n        <div class=\"city-wrapper half first\">\n          <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-lasvegas.jpg')\" ui-sref=\"app.browse.city({city:'vegas'})\">\n            <div class=\"overlay\"></div>\n            <div class=\"content\">\n              <h2 class=\"name\">Las Vegas</h2>\n              <button class=\"btn btn-tertiary\">Browse Now</button>\n            </div>\n          </div>\n        </div>\n        <div class=\"city-wrapper half\">\n          <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-sanfran.jpg'); background-position: left center;\" ui-sref=\"app.browse.city({city:'sf'})\">\n            <div class=\"overlay\"></div>\n            <div class=\"content\">\n              <h2 class=\"name\">San Francisco</h2>\n              <button class=\"btn btn-tertiary\">Browse Now</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- SECOND ROW ON DESKTOP -->\n    <div class=\"row second-row\">\n      <div class=\"city-wrapper col-md-4 col-sm-6 col-xs-12\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-miami-v3.jpg'); background-position: right center;\" ui-sref=\"app.browse.city({city:'miami'})\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Miami</h2>\n            <button class=\"btn btn-tertiary\">Browse Now</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper col-md-4 col-sm-6 col-xs-12\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-boston.jpg')\" ui-sref=\"app.browse.city({city:'bos'})\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Boston</h2>\n            <button class=\"btn btn-tertiary\">Browse Now</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper col-md-4 col-sm-6 col-xs-12\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-washington.jpg')\" ui-sref=\"app.browse.city({city:'dc'})\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Washington D.C.</h2>\n            <button class=\"btn btn-tertiary\">Browse Now</button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- MOBILE CITIES -->\n    <div class=\"row mobile-row\">\n      <div class=\"city-wrapper clickable col-md-4 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'nyc'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-nyc.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">New York City</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-6 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'bos'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-boston.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Boston</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-4 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'vegas'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-lasvegas.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Las Vegas</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-4 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'miami'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-miami-v3.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Miami</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-4 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'dc'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-washington.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Washington D.C.</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-3 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'fox'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-foxwoods.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Foxwoods</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-3 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'philly'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-philly.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">Philadelphia</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-3 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'sf'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-sanfran.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">San Francisco</h2>\n          </div>\n        </div>\n      </div>\n      <div class=\"city-wrapper clickable col-md-3 col-sm-6 col-xs-12\" ui-sref=\"app.browse.city({city:'hamptons'})\">\n        <div class=\"city\" style=\"background-image: url('https://assets.tablelist.com/www/images/city-hamptons.jpg')\">\n          <div class=\"overlay\"></div>\n          <div class=\"content\">\n            <h2 class=\"name\">The Hamptons</h2>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- <div class=\"membership-section\" ng-click=\"goToMembership()\">\n    <div class=\"cover\"></div>\n    <div class=\"container\">\n      <div class=\"col-sm-7\">\n        <p class=\"introducing\">INTRODUCING</p>\n        <h1>Tablelist Platinum</h1>\n        <p class=\"description\">Receive complementary entry, tickets to top acts, and member only benefits to the hottest nightclubs and lounges weekly.</p>\n        <div class=\"link btn btn-primary button clickable\">\n          <span ng-hide=\"isSubscribed()\">Learn More</span>\n          <span ng-show=\"isSubscribed()\">SEE PERKS</span>\n        </div>\n      </div>\n    </div>\n  </div> -->\n  <!-- <div class=\"value-props-section\">\n    <div class=\"row\">\n      <div class=\"col-sm-4\">\n        <div class=\"image\">\n          <img ng-src=\"https://assets.tablelist.com/www/images/value-discover-amazing-nightlife-v1.1.jpg\" />\n        </div>\n        <div class=\"text center\">\n          <h2>Discover Amazing Nightlife</h2>\n          <p>With Tablelist, you always know what’s happening at the best venues and events, and you’re always invited.</p>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"image\">\n          <img ng-src=\"https://s3.amazonaws.com/tablelist-images/homepage-pic2.jpg\" />\n        </div>\n        <div class=\"text center\">\n          <h2>VIP Treatment</h2>\n          <p>No question too big or too small, just ask! From our transparent booking process, all the way to last call, our concierge staff has your back.</p>\n        </div>\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"image\">\n          <img ng-src=\"https://assets.tablelist.com/www/images/value-no-hassle-bottleservice-reservation.jpg\" />\n        </div>\n        <div class=\"text center\">\n          <h2>Hassle-free Reservations</h2>\n          <p>Party like a VIP from the moment you book. Skip the line, party at exclusive events, and enjoy the night on your own terms.</p>\n        </div>\n      </div>\n    </div>\n  </div> -->\n</div>\n";

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "<section id=\"legal\" class=\"container-fluid\">\n\n  <h1> LEGAL </h1>\n\n  <div class=\"row\">\n    <div class=\"col-sm-offset-3 col-sm-6\">\n      <ui-view></ui-view>\n    </div>\n  </div>\n\n</section>\n\n\n";

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"title\">Privacy Policy</h2>\nUpdated 5/20/2020\n\n<article>\n  <p>\n    This privacy policy (this “Policy”) explains how Tablelist, Inc.\n    (“Tablelist” or “we”) collects, uses, processes, stores, and discloses\n    Personal Data (as defined below) in connection with your access to or our\n    provision of Tablelist’s websites, applications, and other online services\n    (collectively, our “Sites”). This Policy applies to consumer users\n    (individually referred to as “you”) of our Sites.\n  </p>\n  <p>\n    Other third parties, including without limitation, such venues at which you\n    make reservations or from which you purchase tickets through our Sites, and\n    social networks that you use in connection with our Sites, may also collect,\n    use, and share information about you. This Policy does not cover such third\n    parties or their services but does cover our disclosure of your Personal\n    Data to our service providers or the venues with whom we engage in\n    connection with providing the services. For information about third-party\n    privacy practices, please consult with them directly.\n  </p>\n\n  <h2>INFORMATION WE COLLECT</h2>\n  <p>\n    We collect information about you in various ways when you use our Sites. We\n    use this information to, among other things, provide the functionality and\n    improve the quality of our Sites, personalize your experience, directly\n    market our Sites and other service or product offerings to you, communicate\n    with you regarding our Sites and other service or product offerings, ensure\n    the safety and security of the Sites, and monitor for fraudulent or other\n    illegal activity. For example, we may collect your name, email address,\n    postal address, phone number (including your mobile phone number), billing\n    and payment information, survey responses, demographics, primary dining\n    city, current and prior reservation details, favorite venues, special venue\n    requests, passwords, birthday, contact information of people you add to, or\n    notify of, your venue reservations through our Sites, and other information\n    you provide on our Sites. If you use our mobile application, either to make\n    reservations or to pay a venue, we may also collect your mobile device ID,\n    your precise location data, and the venue search locations you select. For\n    certain services on our Sites, credit or debit card account information are\n    required, as further described in the section called “Payment Card\n    Information” below. We may also obtain information from other sources, such\n    as third-party websites, applications, and services (each, a “Third-Party\n    Platform”), through which you connect with our Sites and combine that with\n    information we collect on our Sites. The foregoing information, as well as\n    information such as your name, identification number, location data, or an\n    online identifier, and information specific to your physical, physiological,\n    genetic, mental, economic, cultural, or social identity, is referred to in\n    this Policy as “Personal Data”.\n  </p>\n  <p>\n    When you visit our Sites, some information is automatically collected. For\n    example, when you visit our Sites, we may automatically collect your\n    location, computer operating system, Internet Protocol (IP) address, access\n    times, browser type and language, and the website you visited before our\n    Sites. We also collect information about your usage and activity on our\n    Sites using certain technologies, such as:\n  </p>\n  <p>\n    Cookies. We may automatically collect information using “cookies” and\n    similar technology. Cookies are small data files that may have unique\n    identifiers and reside, among other places, on your computer or mobile\n    device, in emails we send to you, and on our web pages. Among other things,\n    cookies help us improve our Sites and your experience. We use cookies to see\n    which areas and features of our Sites are popular and to count visits to our\n    Sites. We may access information contained in cookies placed on your device\n    by a Third-Party Platform as permitted by the terms of your agreement and\n    privacy settings with such Third-Party Platform. We may share this\n    information with the Third-Party Platform for its use as permitted by the\n    terms of your agreement and privacy settings with such Third-Party Platform.\n  </p>\n  <p>\n    Web Beacons. We may collect information using web beacons. Web beacons are\n    electronic images that may be used on our Sites or in our emails. We use web\n    beacons to deliver cookies, count visits, understand usage and campaign\n    effectiveness, and tell whether you open an email and act upon it.\n  </p>\n  <p>\n    Do-Not-Track Signals. We currently do not employ technology that recognizes\n    “do-not-track” signals from your browser. We may engage third parties, such\n    as marketing or analytics partners, who may collect information about your\n    online activities over time and across different websites when you use our\n    Sites.\n  </p>\n  <p>\n    Location-Based Services. We may use location-based services in order to\n    locate you so that we may verify your location, deliver you relevant content\n    based on your location, and share your location with the venues and service\n    providers as part of the location-based services we offer.\n  </p>\n  <h2>HOW WE USE INFORMATION WE COLLECT</h2>\n  <p>\n    We use Personal Data collected through our Sites for the purposes described\n    in this Policy. For example, we may use your information to:\n  </p>\n  <ol>\n    <li>\n      make and change your reservations and to process your orders made through\n      our Sites;\n    </li>\n    <li>\n      offer you, or provide you with, products and services through our Sites;\n    </li>\n    <li>operate and improve our Sites, products, and services;</li>\n    <li>\n      understand you and your preferences to enhance, personalize, and customize\n      your experience and enjoyment using our Sites, products, and services,\n      such as understanding your reservation or ticket purchase history to make\n      recommendations about other venues or events you may like. In connection\n      with such collection we may use automated processing techniques, in\n      combination with manual decision making, to make certain determinations\n      about you and your preferences. If you have any questions pertaining to\n      our use of automated processing techniques, please contact us at\n      hello@tablelist.co\n    </li>\n    <li>process and deliver contest entries and rewards;</li>\n    <li>display relevant advertising;</li>\n    <li>display relevant advertising;</li>\n    <li>\n      send you information relating to our products and services, including\n      reservation confirmations, receipts, technical notices, updates, security\n      alerts, and support and administrative messages;\n    </li>\n    <li>\n      communicate with you about contests, offers, promotions, rewards, upcoming\n      events, and other news about products and services offered by Tablelist,\n      our subsidiaries, and affiliates; venues; and our other selected partners;\n    </li>\n    <li>\n      link or combine with other Personal Data we get from third parties to help\n      understand your needs and provide you with better service;\n    </li>\n    <li>authenticate your credit or debit card account information; and</li>\n    <li>\n      protect, investigate, and deter against fraudulent, unauthorized, or\n      illegal activity.\n    </li>\n  </ol>\n  <p>\n    By providing your mobile phone number, you expressly consent to receive\n    direct dial calls, autodialed and prerecorded message calls, and text\n    messages from us relating to our products and services at that number.\n  </p>\n  <h2>HOW WE SHARE INFORMATION</h2>\n  <ol>\n    <li>\n      Information Shared With Venues. When you make a venue reservation or\n      purchase tickets through our Sites, portions of your Personal Data is\n      provided to us and to the venues at which you choose to make a reservation\n      or purchase tickets. When you make a venue reservation through our Sites\n      and make a payment to a venue through our Sites, we may also share with\n      the venues additional information, such as information about your\n      preferences and history or information that we collect via Third-Party\n      Platforms. You also have the option of indicating special preferences or\n      providing comments about your reservation that Tablelist will pass on to\n      that venue. We may share with venues summary reports of feedback from\n      users. Information you choose to share with a venue when you make a\n      reservation and/or pay a venue through our Sites may be used by the venue\n      for its own purposes. Tablelist does not control the privacy practices of\n      venues. Please contact the venue directly for more information about its\n      privacy practices.\n    </li>\n    <li>\n      Payment Card Information. To use certain services on our Sites, we require\n      credit or debit card account information. By submitting your credit or\n      debit card account information through our Sites, you expressly consent to\n      the sharing of your information with venues, third-party payment\n      processors, and other third-party service providers that we engage to\n      provide services to and operate the Sites and monitor and maintain the\n      Sites (including but not limited to vendors who provide fraud detection\n      services to us and other third parties).\n    </li>\n    <li>\n      For information about the security of your credit or debit card account\n      information, see Section called “Security of Your Personal Data” below.\n    </li>\n    <li>\n      Information You Share Socially. Our Sites may allow you to connect and\n      share your actions, comments, content, and information publicly or with\n      friends. Our Sites may also allow you to connect with us on, share on, and\n      use Third-Party Platforms, including those on which Tablelist has a\n      presence.\n    </li>\n  </ol>\n  <p>\n    Please be mindful of your personal privacy needs and the privacy needs of\n    others as you choose whom to connect with and what to share and make public.\n    We cannot control the privacy or security of information you choose to make\n    public or share with others. Tablelist also does not control the privacy\n    practices of Third-Party Platforms. Please contact those sites and services\n    directly if you want to learn about their privacy practices.\n  </p>\n  <p>\n    Sharing with Others. We do not share your Personal Data with third parties\n    other than as described above and as follows:\n  </p>\n  <ol>\n    <li>\n      We may share Personal Data when you authorize us to share your information\n      with other third parties (such as the venues at which you make\n      reservations through our Sites) for their own marketing purposes, which\n      are subject to the separate privacy policies of such third parties.\n    </li>\n    <li>\n      We may share Personal Data with affiliates, third-party vendors,\n      consultants, and other service providers who work for us. Such third-party\n      vendors may include vendors who provide fraud detection services to us and\n      other third parties.\n    </li>\n    <li>\n      We may share your credit or debit card account information with third\n      parties as described in the section called “Payment Card Information”\n      above.\n    </li>\n    <li>\n      We may share aggregate statistical data for the improvement of services\n      offered by our Sites.\n    </li>\n    <li>\n      We share Personal Data with third parties who provide services to us, such\n      as data collection, reporting, ad response measurement, and site\n      analytics, as well as assistance with delivery of relevant marketing\n      messages and advertisements. These third parties may view, edit, or set\n      their own cookies. We and our third-party service providers, advertisers,\n      and/or partners may also place web beacons for these third parties. The\n      use of these technologies by these third parties is subject to their own\n      privacy policies and is not covered by this Policy. You should read those\n      policies to see how they treat your Personal Data.\n    </li>\n    <li>\n      We may disclose your Personal Data (i) to comply with laws and to respond\n      to lawful requests and legal process, (ii) to protect the rights and\n      property of Tablelist, our agents and customers, and others, including to\n      enforce our agreements, policies, and terms of use, and (iii) in an\n      emergency to protect the personal safety of Tablelist, its customers, or\n      any person.\n    </li>\n    <li>\n      We may disclose or transfer your Personal Data to a third party if we\n      sell, transfer, divest, or disclose all or a portion of our business or\n      assets to another company in connection with or during negotiation of any\n      merger, financing, acquisition, bankruptcy, dissolution, transaction, or\n      proceeding.\n    </li>\n    <li>\n      We may also share aggregated or de-identified information with third\n      parties in our discretion.\n    </li>\n  </ol>\n  <h2>SECURITY OF YOUR PERSONAL DATA</h2>\n  <p>\n    Tablelist employs appropriate technical and organizational measures to help\n    protect your Personal Data in an effort to prevent loss, misuse,\n    unauthorized access, disclosure, alteration, and destruction. When your\n    credit or debit card account information is being transmitted to our Sites\n    or through our Sites, it will be protected by encryption technology, such as\n    Secure Sockets Layer (SSL).\n  </p>\n  <p>\n     To be clear, Tablelist does not itself store your credit or debit card\n    account information, and we do not have direct control over or\n    responsibility for your credit or debit card account information. Our\n    contracts with third parties that receive your credit or debit card account\n    information require them to keep it secure and confidential and to use such\n    information solely to provide the services for which we engage them.\n  </p>\n  <p>\n    Nonetheless, we cannot guarantee that transmissions of your credit or debit\n    card account information or Personal Data will always be secure or that\n    unauthorized third parties will never be able to defeat the security\n    measures taken by Tablelist or our third-party service providers. We assume\n    no liability or responsibility for disclosure of your information due to\n    errors in transmission, unauthorized third-party access, or other causes\n    beyond our control. You play an important role in keeping your Personal Data\n    secure. You should not share your user name, password, or other security\n    information for your Tablelist account with anyone. If we receive\n    instructions using your user name and password, we will consider that you\n    have authorized the instructions. You should contact us at the address below\n    if you think that your account has been used by someone else or if you think\n    an unauthorized account has been opened in your name.\n  </p>\n  <h2>YOUR INFORMATION CHOICES AND CHANGES</h2>\n  <p>\n    You may opt out of receiving promotional emails from Tablelist by following\n    the instructions in those emails. If you opt out, we may still send you\n    non-promotional emails, such as emails about your Tablelist account or\n    transactions or our ongoing business relations. You may also send requests\n    about your contact preferences or changes to your information, including\n    requests to opt out of sharing your Personal Data with third parties, or\n    requests to update, change, or alter any Personal Data or other information\n    that we have about you, to our contact information below. We make changes as\n    soon as we can. If we cannot make the changes you want, we will let you know\n    and explain why.\n  </p>\n  <ol>\n    <li>\n      Cookie choices. Most web browsers are set to accept cookies by default. If\n      you prefer, you can usually choose to set your browser to remove cookies\n      and to reject cookies. If you choose to remove cookies or reject cookies,\n      this could affect your ability to use certain features or services of our\n      Sites.\n    </li>\n    <li>\n      Application location choices. Most mobile devices allow you to turn off\n      location services. For more information about how to do this, please\n      contact your mobile service carrier or your device manufacturer. If you\n      choose to turn off location services, this could affect certain features\n      or services of our Sites.\n    </li>\n    <li>\n      Deleting your Personal Data. You have the right to request, at any time,\n      Tablelist to delete or erase your account or any information contained in\n      your account, or any other Personal Data that you have provided to us or\n      that we have obtained from or about you.\n    </li>\n  </ol>\n  <h2>CONTACTING TABLELIST</h2>\n  <p>\n    For questions about accessing, changing, updating, or deleting your Personal\n    Data or other information, please  contact customer support by texting\n    617-340-8791 or send an email to hello@tablelist.com.\n  </p>\n  <p>\n    For questions or opinions on this Policy, please contact Tablelist via email\n    at hello@tablelist.com or by postal mail at: Tablelist, Attn: Legal\n    Department, 101 Federal Street, Suite 1900., Boston, MA 02110.\n  </p>\n  <h2>NOTICE TO CALIFORNIA RESIDENTS</h2>\n  <p>\n    Your California Privacy Rights (As Provided by California Civil Code Section\n    1798.83) A California resident who has provided personal information to a\n    business with whom he/she has established a business relationship for\n    personal, family, or household purposes (a “California Customer”) may\n    request information about whether the business has disclosed personal\n    information to any third parties for the third parties’ direct marketing\n    purposes, subject to certain exceptions. In general, again, subject to\n    certain exceptions, if the business has made such a disclosure of personal\n    information, upon receipt of a request by a California Customer, the\n    business is required to provide a list of all third parties to whom it\n    disclosed personal information in the preceding calendar year, as well as a\n    list of the categories of personal information that were disclosed. One of\n    the exceptions allows Tablelist to provide California Customers a cost-free\n    means to opt out of these disclosures instead of providing such list. Any\n    customer may request to opt out of these disclosures by contacting Tablelist\n    as described above. California Customers may also request further\n    information about our compliance with this law by contacting us at our\n    address above.\n  </p>\n  <h2>NOTICE TO RESIDENTS OF THE EUROPEAN UNION AND THE UNITED KINGDOM</h2>\n  <p>\n    If you are a resident of the European Union (“EU”) or the United Kingdom\n    (“UK”), you may have additional rights, as detailed in this section. To\n    process your Personal Data, we rely on the following legal bases: (i)\n    pursuant to your consent, which is provided by acknowledging your agreement\n    with our Terms of Service and this Privacy Policy when you sign up for our\n    Sites (note that such consent is affirmatively given by clicking the\n    applicable check boxes; we will never presume that you have provided\n    consent); (ii) to perform the contract we have with you to provide the\n    Sites; (iii) for compliance with legal obligations to which we are or to\n    which we may become subject (including tax obligations, and requests from\n    law enforcement agencies or other competent authorities with jurisdiction\n    over us and our Sites); and (iv) for the purposes of our legitimate\n    interests in providing the Sites to you, making suggestions to you regarding\n    service offerings, venues, and other offerings, monitoring the Sites for\n    fraud or misuse, and ensuring the functionality of our Sites.\n  </p>\n  <p>\n    To the extent that you have provided consent for us to process certain of\n    your Personal Data, you may withdraw your consent at any time. To withdraw\n    your consent, please follow the contact instructions set forth under the\n    Section of this Privacy Policy titled “Contact”. You may also contact us at\n    any time to request that we cease some or all of the processing of your\n    Personal Data, whether or not such processing was the result of your\n    specific consent or some other identified legal basis. It is your choice\n    whether you share Personal Data with us, and it is your choice whether you\n    revoke consent at any time or otherwise request us to cease processing your\n    information. There is no legal consequence to you if your refrain from\n    providing or otherwise revoke consent to our processing of your Personal\n    Data. However, please note that our ability to provide the Sites and other\n    services to you may be impacted if you do not share certain Personal Data\n    with us in connection with your use of the Sites or other services.\n  </p>\n  <p>\n    You may request that we confirm whether or not we are processing your\n    Personal Data, and you may request access at any time to your Personal Data\n    over which we have control. You may also request information about our\n    processing of Personal Data, including the type of Personal Data processed\n    and the reasons for such processing. There are no costs to you associated\n    with these requests; however we may charge reasonable fees for\n    administrative costs for excessive or repetitive requests. You may request\n    that we change, alter, amend, or update your Personal Data and you may\n    request that we refrain from processing certain information if it is\n    inaccurate or unlawfully held. You may request a copy of your Personal Data\n    for transfer to another entity. You may also, at any time, request that we\n    delete or erase your Personal Data, unless we are required by applicable law\n    to retain such information or have other legitimate grounds for continuing\n    to process your Personal Data. You may also object at any time to our use of\n    your Personal Data to provide direct marketing. To exercise any of the\n    rights described above, please follow the contact instructions under the\n    Section of this Privacy Policy titled “Contact”.\n  </p>\n  <h2>CHANGES TO THIS POLICY</h2>\n  <p>\n    Tablelist may update or revise this Policy from time to time. If we make any\n    changes to this Policy, we will post the modified version to our website and\n    will change the “Last Updated” date above. If required by law, we will also\n    contact you. You are free to decide whether or not to accept a modified\n    version of this Policy, but accepting this Policy, as modified, is required\n    for you to continue using our Sites after we post the modified Policy. If\n    you do not agree to the terms of this Policy or any modified version of this\n    Policy, your sole recourse is to terminate your use of our Sites.\n  </p>\n</article>\n";

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "<div id=\"booking-receipt\" class=\"row clearfix\">\n  <div class=\"loading-indicator\" ng-show=\"loading\">\n    <i class=\"fa fa-gear fa-spin\"></i>\n  </div>\n  <div class=\"container error\" ng-show=\"error && !loading\">\n    <h1>Order Details</h1>\n    <p class=\"alert alert-danger\"><strong>Whoops.</strong> We couldn’t find your booking.</p>\n    <p>Please try again with a different account. If you have any questions, please contact your <a href=\"/concierge\">Tablelist concierge</a>.</p>\n  </div>\n  <div class=\"content\" ng-hide=\"error || loading\">\n    <div class=\"booking-header row\">\n      <div class=\"col-sm-12 back-button\">\n        <div ng-show=\"status.isTicket\">\n          <a ui-sref=\"app.me.tickets\"><i class=\"fa fa-long-arrow-left\"></i> Back to your Tickets</a>\n        </div>\n        <div ng-hide=\"status.isTicket\">\n          <a ui-sref=\"app.me.bookings\"><i class=\"fa fa-long-arrow-left\"></i> Back to your Tables</a>\n        </div>\n      </div>\n      <div class=\"col-sm-8\">\n        <h1>Order Details</h1>\n        <h2>Reserved for {{ booking.date | localize | date:'EEEE, MMMM, dd'}}<span style=\"padding: 0 15px;\">|</span>Order #{{ booking.id }}</h2>\n      </div>\n      <div class=\"col-sm-4\">\n        <a ng-show=\"status.hasTickets\" href=\"{{ ticketPDF }}\" target=\"_blank\" class=\"btn btn-default print-receipt\">Print Receipt <i class=\"fa fa-file-pdf-o\"></i></a>\n      </div>\n    </div>\n    <booking-status booking=\"booking\"></booking-status>\n    <div class=\"booking-details row\">\n      <div class=\"col-sm-3\">\n        <p class=\"column-header\">Support Details</p>\n        <p class=\"venue-name\">{{ booking.venue.name }}</p>\n        <p>{{ booking.venue.location.address.address }}, {{ booking.venue.location.address.city }}, {{ booking.venue.location.address.state }}, {{ booking.venue.location.address.zip }}</p>\n        <div ng-show=\"booking.notes.user\">\n          <br>\n          <p class=\"column-header\">Notes</p>\n          <p>{{ booking.notes.user }}</p>\n        </div>\n      </div>\n      <div class=\"col-sm-3\">\n        <p class=\"column-header\">Payment Method</p>\n        <p>{{ bookingUser.paymentStatus }}</p>\n        <p><img ng-src=\"{{paymentProfile.imageUrl}}\" width=\"35\" /> ***** {{ paymentProfile.last4 }}</p>\n      </div>\n      <div class=\"col-sm-6\">\n        <p class=\"column-header\">Order Summary</p>\n        <div class=\"\" ng-if=\"booking.inventoryDescription\" ng-bind-html=\"booking.inventoryDescription\">\n        </div>\n        <booking-items booking=\"booking\"></booking-items>\n      </div>\n    </div>\n    <div class=\"row\">\n      <booking-card booking=\"booking\" is-receipt=\"'true'\"></booking-card>\n    </div>\n    <div class=\"clearfix\">\n      <booking-guests booking=\"booking\"></booking-guests>\n    </div>\n    <div class=\"ticket-options clearfix row\" ng-show=\"status.hasTickets\">\n      <div class=\"download-links clearfix col-xs-12\">\n        <p>Take your tickets on the go:</p>\n        <a class=\"apple\" href=\"https://itunes.apple.com/app/tablelist/id634444177?mt=8\" target=\"_blank\" title=\"Download for iOS\">\n          <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_apple.png\" />\n        </a>\n        <a class=\"android\" href=\"https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod\" target=\"_blank\" title=\"Download for Android\">\n          <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/assets/download_android.png\" />\n        </a>\n      </div>\n    </div>\n    <div class=\"package-tickets row\" ng-show=\"packageTickets.length > 0\">\n      <h3 ng-show=\"status.isTable\">This Tablelist Package comes with the following tickets.</h3>\n      <h4>Please have the QR codes available to scan at the door</h4>\n      <br>\n      <div class=\"package-ticket col-xs-12 col-sm-6 col-md-4\" ng-repeat=\"ticket in packageTickets\">\n        <p>Ticket for <strong>{{ ticket.name }}</strong></p>\n        <img ng-src=\"{{ ticket.qrCode }}\" />\n        <hr>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div id=\"reset-password\" class=\"container full-page-landing\" style=\"margin-bottom:100px;\">\n  <div class=\"password-reset transparent-background col-md-8 col-md-offset-2\">\n    <h1>Reset your Tablelist Password</h1>\n    <p class=\"white\" style=\"padding-bottom: 15px;\">To reset the password for your Tablelist App Account, please enter and confirm your new password</p>\n    <form name=\"resetPasswordForm\" role=\"form\" ng-submit=\"reset()\" class=\"tl-form\">\n      <div class=\"form-group\">\n        <input type=\"password\" class=\"form-control\" id=\"password1\" placeholder=\"Password (6 or more characters)\" ng-model=\"password1\" ng-minlength=\"6\" required>\n      </div>\n      <div class=\"form-group\">\n        <input type=\"password\" class=\"form-control\" id=\"password2\" placeholder=\"Confirm Password\" ng-model=\"password2\" ng-minlength=\"6\" required>\n      </div>\n      <div class=\"alert info\" ng-show=\"infoMessage\">\n        {{infoMessage}}\n      </div>\n      <div class=\"alert success\" ng-show=\"successMessage\">\n        {{successMessage}}\n      </div>\n      <div class=\"alert error\" ng-show=\"errorMessage\">\n        {{errorMessage}}\n      </div>\n      <p class=\"center\">\n        <button type=\"submit\" ng-disabled=\"buttonDisable || resetPasswordForm.$invalid || resetPasswordForm.$pristine\" class=\"btn btn-primary\" ng-hide=\"isReset\">Reset Password</button>\n      </p>\n      <div class=\"form-group\">\n        <a class=\"btn btn-success btn-block\" ui-sref=\"app.login\" ng-show=\"isReset\">Login to Tablelist</a>\n      </div>\n    </form>\n  </div>\n</div>\n";

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "<div id=\"search\" class=\"clearfix\">\n  <div class=\"search-bar-wrapper\">\n    <search-bar guests-min=\"{{ form.guestsMin }}\" guests-max=\"{{ form.guestsMax }}\" date=\"{{ form.date }}\" price-min=\"{{ form.priceMin }}\" price-max=\"{{ form.priceMax }}\" city-id=\"{{ form.cityId }}\" theme=\"gray\"></search-bar>\n  </div>\n  <div class=\"filter-bar\">\n    <div class=\"container\">\n      <div class=\"btn\" ng-click=\"limitToType('tickets')\" ng-class=\"{ 'disable' : limitTo !== 'tickets' }\"><i class=\"fa fa-ticket\"></i>Tickets</div>\n      <div class=\"btn\" ng-click=\"limitToType('tables')\" ng-class=\"{ 'disable' : limitTo !== 'tables' }\"><i class=\"fa fa-glass\"></i>Tables/Packages</div>\n      <div class=\"show-only\">Show Only: </div>\n    </div>\n  </div>\n  <div class=\"loading-wrapper\" ng-if=\"loading\">\n    <loading></loading>\n  </div>\n  <div class=\"search-results empty\" ng-show=\"inventorySummaries.length < 1 && !loading\">\n    Sorry, we couldn't find any options that matched your search.\n  </div>\n  <div class=\"search-results container\" ng-show=\"inventorySummaries.length && !loading\">\n    <div class=\"result clearfix row\" ng-repeat=\"summary in inventorySummaries\" ng-hide=\"venueInventoryOptions.length < 1\">\n      <!-- VENUE -->\n      <div class=\"col-sm-4 col-md-3 clearfix venue-image-wrapper\" ng-class=\"{ 'event' : summary.event }\">\n        <a ui-sref=\"app.venue({ seoPathname: summary.venue.seoPathname })\" target=\"_blank\" class=\"venue-image\" style=\"background: url('{{ summary.venue.primaryImage.filename }}?w=400&fm=jpg&q=50&dpr=2');\" ng-hide=\"summary.event\"></a>\n        <a ui-sref=\"app.event({ seoPathname: summary.event.seoPathname })\" target=\"_blank\" class=\"venue-image\" style=\"background: url('{{ summary.event.primaryImage.filename }}?w=400&fm=jpg&q=50&dpr=2');\" ng-show=\"summary.event\"></a>\n      </div>\n      <!-- VENUE or EVENT -->\n      <div class=\"col-sm-8 col-md-4\">\n        <a class=\"venue-name\" ng-hide=\"summary.event\" href=\"#\" ui-sref=\"app.venue({ seoPathname: summary.venue.seoPathname })\" target=\"_blank\">{{:: summary.venue.name }}</a>\n        <a class=\"venue-name\" ng-show=\"summary.event\" href=\"#\" ui-sref=\"app.event({ seoPathname: summary.event.seoPathname })\" target=\"_blank\">{{:: summary.event.name }} @ {{:: summary.venue.name }}</a>\n        <div class=\"venue-rating\" ng-hide=\"summary.venue.rating.ratingAverage < 1\">\n          <venue-rating rating-average=\"summary.venue.rating.ratingAverage\"></venue-rating>\n          <span> ({{:: summary.venue.rating.ratingCount }})</span>\n        </div>\n        <div class=\"venue-type\">\n          <span>{{:: summary.venue.type }}</span>\n          <span ng-show=\"summary.venue.subtype\">| {{:: summary.venue.subtype }}</span>\n          <span class=\"\" ng-show=\"summary.venue.location.neighborhood\"> in {{:: summary.venue.location.neighborhood }}</span>\n        </div>\n        <div class=\"venue-description-wrapper\">\n          <div class=\"venue-description\">{{:: summary.description }}</div>\n        </div>\n        <a class=\"venue-read-more\" ng-hide=\"summary.event\" href=\"#\" ui-sref=\"app.venue({ seoPathname: summary.venue.seoPathname })\" target=\"_blank\">Read More</a>\n        <a class=\"event-read-more\" ng-show=\"summary.event\" href=\"#\" ui-sref=\"app.event({ seoPathname: summary.event.seoPathname })\" target=\"_blank\">Read More</a>\n      </div>\n      <!-- OPTIONS -->\n      <div class=\"col-sm-12 col-md-5 clearfix\">\n        <div class=\"inventory-list\">\n          <div class=\"inventory clickable\" ng-repeat=\"inventory in venueInventoryOptions = (summary.inventory | filter: filterInventory | orderBy: 'price')\" ng-class=\"{ 'sold-out' : inventory.quantity < 1, 'platinum' : inventory.membershipLevel > 25 }\"\n            ng-click=\"buyInventory(inventory, summary.venue)\">\n\n            <div class=\"col-xs-6 col-md-7 col-lg-8 left-column\" ng-hide=\"inventory.buying\">\n              <h1 ng-hide=\"inventory.enable\">Not Enabled</h1>\n\n              <div class=\"inventory-type-icon\">\n                <i class=\"fa fa-ticket\" ng-show=\"inventory.type === 'COVER'\"></i>\n                <i class=\"fa fa-ticket\" ng-show=\"inventory.type === 'TICKET'\"></i>\n                <i class=\"fa fa-glass\" ng-show=\"inventory.type === 'TABLE'\"></i>\n                <i class=\"fa fa-cubes\" ng-show=\"inventory.type === 'PACKAGE'\"></i>\n              </div>\n\n              <p class=\"strong\">{{:: inventory.type }}<span ng-show=\"inventory.location\" class=\"inventory-location\">| {{:: inventory.location }}</span></p>\n\n              <p ng-hide=\"inventory.buying || inventory.type == 'COVER' || inventory.type == 'TICKET'\">\n                <span>for <span ng-show=\"inventory.guests > 1\">up to</span> {{:: inventory.guests }} guest<span ng-show=\"inventory.guests > 1\">s</span></span>\n              </p>\n\n              <p ng-show=\"inventory.type == 'COVER'\">\n                <span>for one guest</span>\n              </p>\n\n              <p ng-show=\"inventory.type == 'TICKET'\">\n                <span>General Admission</span>\n              </p>\n            </div>\n\n            <div class=\"col-xs-6 col-md-5 col-lg-4 right-column\" ng-hide=\"inventory.buying || inventory.type == 'COVER' || inventory.type == 'TICKET'\">\n              <p class=\"strong price\">{{:: inventory.price | tlCurrency:'$' }}</p>\n              <p ng-hide=\"inventory.pricePerGuest < 1\">{{:: inventory.pricePerGuest | tlCurrency:'$' }}/guest</p>\n            </div>\n\n            <div class=\"col-xs-6 col-md-5 col-lg-4 right-column\" ng-show=\"!inventory.buying && (inventory.type == 'COVER' || inventory.type == 'TICKET')\">\n              <p class=\"strong price\">{{:: inventory.price | tlCurrency:'$' }} each</p>\n            </div>\n\n            <div class=\"col-xs-12 inventory-buying-spinner\" ng-show=\"inventory.buying\">\n              <i class=\"fa fa-cog fa-spin\"></i>\n            </div>\n\n            <div class=\"col-xs-12 sold-out-banner\" ng-show=\"inventory.quantity < 1\">\n              <h3>SOLD OUT</h3>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<div id=\"signup\" class=\"clearfix\">\n  <div class=\"hero\" ng-show=\"promo && promo.referral\">\n    <img class=\"img-circle\" ng-src=\"{{ promo.imageUrl }}\" height=\"150\" width=\"150\" />\n    <h1>{{promo.name}} gave you ${{referralGiveCredit}} in Tablelist Credit.</h1>\n    <div class=\"button-container\">\n      <button class=\"btn\" type=\"button\" ng-click=\"scrollTo('form-title')\">CLAIM YOUR ${{referralGiveCredit}} CREDIT</button>\n    </div>\n  </div>\n  <div class=\"container\">\n    <h1 class=\"sign-up-title\" id=\"form-title\">{{ titleText }}</h1>\n    <p class=\"sign-up-description\" ng-hide=\"loginConfig.currentState == 'completeProfile' || loginConfig.currentState == 'existingUser'\">The instant way to book a VIP table, tickets, and more at your favorite nightclubs and lounges.</p>\n    <p class=\"sign-up-description\" ng-show=\"loginConfig.currentState == 'completeProfile'\">OMG, the last step. You’re on your way to the best night ever.</p>\n    <login config=\"loginConfig\" input=\"input\"></login>\n  </div>\n</div>\n";

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "<div id=\"table-service\">\n  <div id=\"table-service-hero\">\n    <h1 class=\"center\">What is Table Service?</h1>\n    <p class=\"center\">.... also known as bottle service, is a premium way of experiencing nightlife with less hassle.</p>\n  </div>\n  <div id=\"table-service-content\">\n    <div class=\"table-service-section\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-md-7\">\n            <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/images/tableservice_choices.jpg\" alt=\"Booking through Tablelist on Web and Mobile\">\n          </div>\n          <div class=\"col-md-5\">\n            <h3 class=\"margin-top-2em\">The choice is yours</h3>\n            <p>Tablelist provides a simple and transparent process that will upgrade your night with the tap of a button.</p>\n            <p>Browse through the variety of venues and events that we offer in your city. Have something else in mind? Request a custom table.</p>\n            <a href=\"#\" class=\"btn btn-default btn-default-green uppercase\" ng-click=\"browseVenues()\">Browse Our Venues</a>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"table-service-section personalize\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-md-6\">\n            <h3 class=\"margin-top-2em\">Personalize Your Table</h3>\n            <p>Questions along the way? No problem!</p>\n            <a href=\"#\" class=\"btn btn-default btn-default-green uppercase\" ng-click=\"browseVenues()\">Book Your Table</a>\n            <a href=\"#\" class=\"btn btn-default btn-default-green uppercase\" ui-sref=\"appfaq\">Browse our FAQ's</a>\n          </div>\n          <div class=\"col-md-6\">\n            <img class=\"img-responsive\" src=\"https://assets.tablelist.com/www-2/images/tableservice_personalize.jpg\" alt=\"Booking through Tablelist on Web and Mobile\">\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"table-service-section\" style=\"background-color: #fff;\">\n      <div class=\"container\">\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user1.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Jack S.</h3>\n            <p>Storyville</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>Close to if not THE best night I've had in almost 6 months</p>\n          </div>\n        </div>\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user2.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Patrick L.</h3>\n            <p>Storyville</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>Had a blast! Great venue, great bottle service, and easy booking through the Tablelist App - 5 stars!</p>\n          </div>\n        </div>\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user3.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Joseph F.</h3>\n            <p>Bagatelle</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>My friends and I had an awesome night. Our Tablelist concierge helped us pick a venue and plan our night. Everyone had a great time. Awesome app :)</p>\n          </div>\n        </div>\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user4.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Whitney G.</h3>\n            <p>Tunnel</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>Everything was flawless. I was very impressed by the level of detail and how friendly everyone was. It was a night I’ll never forget!!</p>\n          </div>\n        </div>\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user5.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Carlos P.</h3>\n            <p>Shrine</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>I had a great birthday night out! We were right next to the bar and had plenty of space to dance and easy access to the dance floor. It was so easy to use Tablelist and I will definitely will use it again for my home town of Boston!</p>\n          </div>\n        </div>\n        <div class=\"review col-sm-4\">\n          <div class=\"col-sm-3\"><img src=\"https://assets.tablelist.com/www-2/images/tableservice_review_user6.jpg\" class=\"img-responsive\" /></div>\n          <div class=\"col-sm-9\">\n            <h3>Kirsten M.</h3>\n            <p>Gem</p>\n          </div>\n          <div class=\"col-sm-12\">\n            <p>The service was phenomenal. Even when there was a slight confusion, Tablelist helped resolve it instantly. My friends and I can't stop talking about how fun it was.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"table-service-contact\">\n    <div class=\"row\">\n      <p class=\"center\">\n        <img src=\"https://assets.tablelist.com/www-2/images/logo_small.png\" alt=\"Tablelist\">\n      </p>\n      <h2 class=\"center\">Experience a better night out</h2>\n      <p class=\"center\">\n        <br>\n        <a href=\"#\" class=\"btn-dark btn-xlg uppercase\" ui-sref=\"app.signup\">Sign up for Free</a>\n      </p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "<div id=\"terms\" class='container'>\n  <div class='col-sm-10 col-sm-offset-1'>\n    <h1>Tablelist Terms of Use</h1>\n    <h4>\n      PLEASE READ THESE TERMS OF SERVICE CAREFULLY. BY ACCESSING OR USING THE TABLELIST APPLICATION AND ANY SERVICES PROVIDED BY US, YOU AGREE TO BE BOUND BY THE TERMS AND CONDITIONS DESCRIBED HEREIN AND ALL TERMS INCORPORATED BY REFERENCE. IF YOU DO\n      NOT AGREE TO ALL OF THESE TERMS AND CONDITIONS, PLEASE IMMEDIATELY LEAVE THE TABLELIST APPLICATION AND DO NOT USE THE TABLELIST APPLICATION OR ANY SERVICES PROVIDED BY US.\n    </h4>\n    <p>\n      These terms of service (the “Terms”) apply to your access and use of the iOS application, the Android application, the mobile web application and the website (“Site”) located at tablelist.com (collectively, the “Application”) provided by\n      Tablelist (“Tablelist”, “we”, “our” or “us”) and any feature, content, tools and services accessible by means of the Application. The Application and such services are collectively referred to as the “Service.” The Terms do not alter in any way\n      the terms or conditions of any other agreement you may have with Tablelist for the Service (or any part thereof). If you are using the Service on behalf of an entity, you represent and warrant that you are authorized to accept the Terms on such\n      entity’s behalf, and that such entity agrees to indemnify you and Tablelist for violations of the Terms.\n    </p>\n    <p>\n      The Service permits users to reserve tables and bottle service at participating nightclubs and venues, purchase tickets to certain events, and make reservations for appointment times and products at participating cannabis retailers.\n    </p>\n    <p>\n      We reserve the right to change or modify any of the terms and conditions contained in the Terms or any policy or guideline of the Service, at any time and in our sole discretion. Any changes or modifications will be effective immediately upon\n      the posting of such revisions on our website located at https://www.tablelist.com (the “Site”) or when such revisions are made available via the Service, and you waive any right you may have to receive specific notice of such changes or\n      modifications; provided, however, that to the extent such changes or modifications relate to our use, processing, storage, or disclosure of Personal Data (as defined in the Privacy Policy), we will obtain any consent required by applicable law.\n      Your continued use of the Service (or any portion thereof) following the posting of changes or modifications will confirm your acceptance of such changes or modifications. Therefore, you should frequently review the Terms and applicable\n      policies from time-to-time to understand the terms and conditions that apply to your use of the Service. If you do not agree to the amended Terms, you must leave the Application and stop using the Service.\n    </p>\n    <p>\n      If you have any questions regarding the use of the Service, please email us at hello@tablelist.com.\n    </p>\n  </div>\n</div>\n";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<div id=\"venue\">\n  <div class=\"back-btn-wrapper container\" ng-if=\"showBackBtn\">\n    <a href=\"#\" ui-sref=\"app.curatedList({ id : backId })\">\n      <img src=\"https://assets.tablelist.com/www/assets/arrow.svg\">\n      <span ng-if=\"backName\">Back to {{ backName }}</span>\n      <span ng-if=\"!backName\">Back</span>\n    </a>\n  </div>\n  <div class=\"venue-header\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"column col-sm-6 venue-image-wrap\">\n          <loading-dots class=\"img-loading\" ng-if=\"!venue || !venue.primaryImage\"></loading-dots>\n          <div class=\"venue-image\" ng-if=\"venue && venue.primaryImage\" ng-style=\"{ 'background-image' : 'url(' + venueImage(venue.primaryImage.filename) + ')' }\">\n          </div>\n          <div class=\"venue-thumbnails\">\n            <img class=\"thumbnail\" ng-repeat=\"image in venue.images | limitTo: 5\" ng-src=\"{{ imgix(image.filename, 100, 70) }}\" ng-click=\"goToImage($index);\" ng-class=\"{'active' : image.id === venue.primaryImage.id}\">\n          </div>\n        </div>\n        <div class=\"column col-sm-6 venue-details\">\n          <div class=\"venue-info clearfix\">\n            <ul class=\"venue-types clearfix\">\n              <li ng-show=\"venue.venueType\">{{ venue.venueType }}</li>\n              <li ng-show=\"venue.venueSubType\">\n                <span><i class=\"fa fa-circle\"></i> &nbsp;&nbsp;{{ venue.venueSubType }}</span>\n              </li>\n              <li ng-if=\"venue.details.minAge\">\n                <span><i class=\"fa fa-circle\"></i> &nbsp;&nbsp;{{ venue.details.minAge }}+</span>\n              </li>\n            </ul>\n            <h1 class=\"name\">{{ venue.name }}</h1>\n            <ul class=\"venue-hours-and-rating clearfix\">\n              <li ng-show=\"venue.rating && venue.rating.ratingAverage !== 0\">\n                <venue-rating rating-average=\"venue.rating.ratingAverage\"></venue-rating>\n                <!-- &nbsp;{{ venue.rating.ratingAverage | decimal }}&nbsp;({{ venue.rating.ratingCount }}) -->\n              </li>\n              <li ng-show=\"openSentence\">\n                <span><i class=\"fa fa-clock-o\"></i> {{ openSentence }}</span>\n              </li>\n            </ul>\n            <hr>\n            <ul class=\"venue-address clearfix\">\n              <li ng-show=\"venue.location.address.city\">{{ venue.location.address.city }}</li>\n              <li ng-show=\"venue.location.neighborhood\">\n                <span><i class=\"fa fa-circle\"></i> &nbsp;&nbsp;{{ venue.location.neighborhood }}</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"venue-nav-menu\">\n    <div class=\"container clearfix\">\n      <div class=\"col-xs-5 col-sm-6 left\">\n        <ul class=\"nav-items\">\n          <li ng-class=\"{ active: isVenueState() }\">\n            <a ng-click=\"goToAbout()\">About</a>\n          </li>\n          <li ng-class=\"{ active: isEventsState() }\" ng-if=\"loadingEvents || events.length > 0\">\n            <a ng-click=\"goToEvents()\">Events <span class=\"badge\">{{ totalEvents }}</span></a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"venue-content clearfix\">\n    <div id=\"venue-about-section\" class=\"venue-about clearfix\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-md-7 left-column\" id=\"description\" ng-class=\"{ 'full-width': isEventsState() }\">\n            <div class=\"visible-sm visible-xs\" ng-hide=\"isEventsState()\">\n              <div id=\"inventory-list-widget-xs\">\n              </div>\n            </div>\n            <div ui-view></div>\n            <div ng-if=\"isVenueState()\">\n              <div class=\"box events-preview\" ng-show=\"loadingEvents || events.length > 0\">\n                <h4 ng-show=\"loadingEvents || events.length > 0\" class=\"section-title\">Upcoming Events</h4>\n                <event-list-card event=\"event\" ng-repeat=\"event in events\"></event-list-card>\n                <event-list-card event=\"event\" placeholder=\"true\" ng-repeat=\"event in [1,2]\" ng-show=\"loadingEvents\"></event-list-card>\n                <a href=\"#\" ng-click=\"goToEvents()\" ng-show=\"totalEvents > 2\" class=\"see-more-events\">See all Events ({{ totalEvents }})</a>\n              </div>\n              <div class=\"box long-description\" ng-show=\"venue.details.description\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Description</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <p class=\"small-font\" ng-bind-html=\"venue.details.description\"></p>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"curatedLists.length > 0\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Featured In:</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <span ng-repeat=\"list in curatedLists\"><a href=\"#\" class=\"link\" ui-sref=\"app.curatedList({ id : list.id })\">{{list.title}}</a>{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box more-info\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">More info</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <!-- Hours -->\n                    <div class=\"clearfix row\">\n                      <div class=\"col-md-4 col-sm-6 col-xs-12\">\n                        <p class=\"bold\">Contact</p>\n                        <p class=\"small-font\"><a href=\"tel:{{venue.phone}}\">{{venue.phone | phoneNumber }}</a></p>\n\n                        <br>\n                        <p class=\"bold\">Links</p>\n                        <p class=\"small-font\"><a target=\"_blank\" ng-href=\"{{ generateLink(venue.website) }}\"><i class=\"fa fa-link\"></i>Website</a></p>\n                        <p class=\"small-font\" ng-show=\"venue.details.social.facebook\"><a target=\"_blank\" href=\"{{ generateLink(venue.details.social.facebook) }}\"><i class=\"fa fa-facebook\"></i>Facebook</a></p>\n                        <p class=\"small-font\" ng-show=\"venue.details.social.twitter\"><a target=\"_blank\" href=\"{{ generateLink(venue.details.social.twitter) }}\"><i class=\"fa fa-twitter\"></i>Twitter</a></p>\n                        <p class=\"small-font\" ng-show=\"venue.details.social.instagram\"><a target=\"_blank\" href=\"{{ generateLink(venue.details.social.instagram) }}\"><i class=\"fa fa-instagram\"></i>Instagram</a></p>\n                      </div>\n                      <div class=\"col-md-8 col-sm-6 col-xs-12 hours\">\n                        <p class=\"bold\">Hours</p>\n                        <div class=\"clearfix row\" ng-repeat=\"day in venue.schedule\" ng-hide=\"!day.hours || !day.hours.length\">\n                          <div class=\"col-md-4 col-xs-4\">\n                            <p class=\"small-font hidden-xs\">{{ getDayName(day.day) }}</p>\n                            <p class=\"small-font visible-xs\">{{ getDayNameShort(day.day) }}</p>\n                          </div>\n                          <div class=\"col-md-8 col-xs-8\">\n                            <div ng-repeat=\"hourSet in day.hours\" ng-show=\"day.hours && day.hours.length\">\n                              <p class=\"small-font\">{{hourSet.start | utc | date: 'h:mm a'}} - {{hourSet.end | utc | date: 'h:mm a'}}</p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.okDressCodeTags.length > 0 || venue.notOkDressCodeTags.length > 0\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">\n                    The door\n                  </h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <div class=\"clearfix row\">\n                      <p class=\"bold col-md-6 col-xs-6\">What to wear:</p>\n                      <p class=\"bold col-md-6 col-xs-6\">What not to wear:</p>\n                      <div class=\"col-md-6 col-xs-6\">\n                        <p ng-repeat=\"tag in venue.okDressCodeTags\">\n                          <a href=\"#\">\n                            {{ tag.name }}\n                          </a>\n                        </p>\n                      </div>\n                      <div class=\"col-md-6 col-xs-6\">\n                        <p ng-repeat=\"tag in venue.notOkDressCodeTags\">\n                          <del>\n                            <a href=\"#\">\n                              {{ tag.name }}\n                            </a>\n                          </del>\n                        </p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.musicTags && venue.musicTags.length\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Music Type</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <span ng-repeat=\"tag in venue.musicTags\">{{tag.name}}{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.details.minAge\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Age</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <div class=\"dark-info-text clearfix\">\n                      <span>{{ venue.details.minAge }}+</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.crowdTags && venue.crowdTags.length\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Crowd</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <span ng-repeat=\"tag in venue.crowdTags\">{{tag.name}}{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.busyNightTags && venue.busyNightTags.length\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Busy Nights</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <span ng-repeat=\"tag in venue.busyNightTags\">{{ tag.name}}{{$last ? '' : ', '}}</span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.featuresTags.length > 1\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">\n                    Features\n                  </h4>\n                  <div class=\"col-md-9 col-xs-12 clearfix\">\n                    <ul class=\"tag-list\">\n                      <li ng-repeat=\"tag in venue.featuresTags\">\n                        <span class=\"name\">{{ tag.name }}</span>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.noiseLevelTags.length > 0\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">\n                    Noise level\n                  </h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <p class=\"\" ng-repeat=\"tag in venue.noiseLevelTags\">{{ tag.name }}</p>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box\" ng-show=\"venue.goodForTags.length > 0\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">\n                    Good for\n                  </h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <div class=\"clearfix row\">\n                      <div class=\"col-md-6 col-xs-6\">\n                        <p class=\"bold\" ng-repeat='tag in venue.goodForTags'>{{ tag.name }}</p>\n                      </div>\n                      <div class=\"col-md-6 col-xs-6\">\n                        <p>Birthday or Special Event coming up? We can help plan your night</p>\n                        <a href=\"/concierge?message=Hello%2C+I+would+like+help+planning+a+special+event+at+{{ venue.name }}\" class=\"link\">Talk to a Tablelist Concierge</a>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box no-border\" ng-show=\"venue.address.address\">\n                <iframe id=\"google-map\" ng-if=\"mapUrl\" ng-src=\"{{mapUrl}}\"></iframe>\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">Directions</h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <div class=\"clearfix row\">\n                      <div class=\"col-md-6 col-xs-6\">\n                        <p ng-show=\"venue.address.address\">{{venue.address.address}},</p>\n                        <p ng-show=\"venue.address.city\" class=\"\"><span>{{venue.address.city}}</span>, <span>{{venue.address.state}}</span> <span>{{venue.address.zip}}</span></p>\n                        <p ng-show=\"venue.address.address1\">{{venue.address.address1}}</p>\n                        <br>\n                        <p class=\"get-directions\">\n                          <a ng-href=\"{{googleMapsDirectionsUrl}}\" target=\"_blank\">Get directions</a>\n                        </p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"box no-border\" ng-show=\"venue.noiseLevelTags.length > 0\">\n                <div class=\"clearfix row\">\n                  <h4 class=\"section-title col-md-3 col-xs-12\">\n                    More Information\n                  </h4>\n                  <div class=\"col-md-9 col-xs-12\">\n                    <p class=\"small-info-text\" ng-repeat=\"page in venueInfo\">\n                      <a href=\"#\" ui-sref=\"app.venue.info({seoPathname: venue.seoPathname, page: page.key})\">{{ venue.name }} {{ page.title }}</a>\n                    </p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-md-5 right-column hidden-sm\" ng-hide=\"isEventsState()\">\n            <div id=\"inventory-list-widget-lg\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <rich-venue-card venue=\"venue\"></rich-venue-card>\n</div>\n";

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box venue-events no-border\">\n  <h4 ng-show=\"loadingEvents || events.length > 0\" class=\"section-title\">\n    Upcoming Events\n  </h4>\n  <event-list-card event=\"event\" ng-repeat=\"event in events\" ng-hide=\"loadingEvents\"></event-list-card>\n  <event-list-card event=\"event\" placeholder=\"true\" ng-repeat=\"event in [1,2,3,4]\" ng-show=\"loadingEvents\"></event-list-card>\n  <p ng-show=\"!loadingEvents && events.length < 1\">No upcoming events.</p>\n  <div class=\"pagination\">\n    <button class=\"btn btn-link prev\" ng-click=\"previousEventPage()\" ng-disabled=\"eventPageNumber === 1\">\n      <i class=\"icon ion-ios-arrow-back\"></i> Previous\n    </button>\n    <button class=\"btn btn-link next\" ng-click=\"nextEventPage()\" ng-disabled=\"events.length < eventPageSize\">\n      Next <i class=\"icon ion-ios-arrow-forward\"></i>\n    </button>\n  </div>\n  <a ui-sref=\"app.venue({ seoPathname: venue.seoPathname })\" href=\"#\" class=\"see-more-events\">Back to About</a>\n</div>\n";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box venue-seo-info active\">\n  <h4 class=\"section-title\">Additional Info</h4>\n  <ul>\n    <li ng-class=\"{ 'active' : $state.includes('app.venue.info', { page: page.key}) }\" ng-repeat=\"page in venueInfo\">\n      <a href=\"#\" ui-sref=\"app.venue.info({ seoPathname: venue.seoPathname, page: page.key })\">{{ venue.name }} {{ page.title }}</a>\n    </li>\n  </ul>\n</div>\n\n<div class=\"box venue-seo-info no-border\" ng-class=\"{ 'active' : !loading }\">\n  <h4 class=\"section-title\">{{ page.title }} at {{ venue.name }}</h4>\n  <div ng-bind-html=\"page.text\"></div>\n</div>\n";

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<footer id=\"footer\" class=\"clearfix\">\n  <div class=\"footer-cells container-fluid\">\n    <div class=\"row\">\n      <a href=\"\" ui-sref=\"app.home\" active-class=\"active\" class=\"footer-cell col-lg-2 col-sm-12 col-xs-12 col-lg-offset-1 logo-cell\">\n        <svg class=\"logo\" xmlns=\"http://www.w3.org/2000/svg\" width=\"402\" height=\"45\" viewBox=\"0 0 402 45\">\n          <g fill=\"#FFF\" fill-rule=\"nonzero\">\n            <path d=\"M0 0v17.874h17V45h17V17.87l34 .004V45h17V17.874h17V0zM126.16 13.869H114V8h31v5.869h-12.16V41h-6.68zM167.267 8h-6.992L145 41h6.95l2.519-5.553h19L176.07 41H183L167.267 8zm-10.28 21.936l6.846-14.99 7.034 14.99h-13.88zM218.911 26.03c-.725-1.436-1.827-2.604-3.307-3.505 1.287-1.575 1.932-3.413 1.932-5.51 0-1.282-.25-2.475-.75-3.58-.5-1.104-1.263-2.057-2.29-2.86-1.027-.803-2.318-1.433-3.873-1.89C209.07 8.23 207.245 8 205.15 8H188v33h19.614c2.11 0 3.94-.235 5.496-.707 1.552-.472 2.84-1.148 3.86-2.027a8.167 8.167 0 0 0 2.28-3.177c.5-1.239.75-2.626.75-4.16 0-1.83-.363-3.462-1.089-4.9zm-24.4-12.14h10.803c1.753 0 3.084.328 3.996.982.91.654 1.365 1.58 1.365 2.776 0 1.154-.458 2.181-1.376 3.082a20.975 20.975 0 0 0-1.642-.063H194.51V13.89zm17.262 20.12c-.91.777-2.241 1.163-3.993 1.163h-13.27v-8.91h13.27c1.752 0 3.083.394 3.993 1.182.911.788 1.366 1.886 1.366 3.294.001 1.408-.454 2.498-1.366 3.272zM227 8h6.723v27.13H253V41h-26zM259 8h27.564v5.869h-21v6.587h18.598v5.51h-18.597v9.186H287V41h-28zM294 8h6.722v27.13H320V41h-26zM325 8h7v33h-7zM354.378 22.355c7.644 1.7 11.622 4.203 11.622 9.728 0 6.232-5.321 9.917-12.916 9.917-5.526 0-10.744-1.747-15.084-5.29l3.822-4.155c3.462 2.738 6.923 4.298 11.417 4.298 3.927 0 6.407-1.653 6.407-4.203 0-2.409-1.448-3.684-8.163-5.1-7.697-1.7-12.038-3.778-12.038-9.917 0-5.761 5.167-9.633 12.348-9.633 5.269 0 9.453 1.463 13.122 4.156l-3.411 4.391c-3.254-2.219-6.509-3.4-9.815-3.4-3.72 0-5.89 1.747-5.89 3.968.002 2.595 1.655 3.729 8.579 5.24zM383.16 13.869H371V8h31v5.869h-12.16V41h-6.68z\" />\n          </g>\n        </svg>\n      </a>\n      <div class=\"footer-cell col-lg-2 col-sm-4 col-xs-12 link-cell link-cell-offset\">\n        <h3 class=\"link-cell-header\">\n          Cities\n        </h3>\n        <ul>\n          <li>\n            <a href=\"/nyc/discover/\">New York City</a>\n          </li>\n          <li>\n            <a href=\"/bos/discover/\">Boston</a>\n          </li>\n          <li>\n            <a href=\"/miami/discover/\">Miami</a>\n          </li>\n          <li>\n            <a href=\"/vegas/discover/\">Las Vegas</a>\n          </li>\n          <li>\n            <a href=\"/philly/discover/\">Philadelphia</a>\n          </li>\n          <li>\n            <a href=\"/dc/discover/\">Washington</a>\n          </li>\n          <li>\n            <a href=\"/sanfrancisco/discover/\">San Francisco</a>\n          </li>\n          <li>\n            <a href=\"/foxwoods/discover/\">Foxwoods</a>\n          </li>\n        </ul>\n      </div>\n      <div class=\"footer-cell col-lg-2 col-sm-4 col-xs-12 link-cell\">\n        <h3 class=\"link-cell-header\">\n          Help\n        </h3>\n        <ul>\n          <li>\n            <a href=\"#\" ui-sref=\"app.tableservice\">What is table service?</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"app.concierge\">Talk to a concierge</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"app.about\">About Tablelist</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"app.faq\">FAQ</a>\n          </li>\n          <li>\n            <a href=\"https://www.tablelistpro.com/\" target=\"_blank\">TablelistPro</a>\n          </li>\n          <li>\n            <a href=\"http://blog.tablelist.com\" target=\"_blank\">Tablelist Blog</a>\n          </li>\n        </ul>\n      </div>\n      <div class=\"footer-cell col-lg-2 col-sm-4 col-xs-12 link-cell link-cell-offset\">\n        <h3 class=\"link-cell-header\">\n          My Account\n        </h3>\n        <ul>\n          <!-- <li>\n            <a href=\"#\" ui-sref=\"app.membership.landing\">Membership</a>\n          </li> -->\n          <li>\n            <a href=\"#\" ui-sref=\"app.me.profile\">My profile</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"app.me.bookings\">My bookings</a>\n          </li>\n        </ul>\n      </div>\n      <div class=\"footer-cell col-lg-2 col-sm-4 col-xs-12 social-link-cell\">\n        <h3 class=\"link-cell-header\">\n          Party With Us\n        </h3>\n        <div class=\"row links\">\n          <div class=\"link col-sm-3 col-xs-6\">\n            <a href=\"https://www.instagram.com/Tablelist\" target=\"_blank\">\n              <i class=\"icon ion-social-instagram\"></i>\n            </a>\n          </div>\n          <div class=\"link col-sm-3 col-xs-6\">\n            <a href=\"https://twitter.com/Tablelist\" target=\"_blank\">\n              <i class=\"icon ion-social-twitter\"></i>\n            </a>\n          </div>\n          <div class=\"link col-sm-3 col-xs-6\">\n            <a href=\"https://www.facebook.com/Tablelist\" target=\"_blank\">\n              <i class=\"icon ion-social-facebook\"></i>\n            </a>\n          </div>\n          <!-- <div class=\"link col-sm-3 col-xs-6\">\n            <a href=\"https://www.linkedin.com/company/Tablelist\" target=\"_blank\">\n              <i class=\"icon ion-social-linkedin\"></i>\n            </a>\n          </div> -->\n        </div>\n        <div class=\"hours-wrapper\">\n          Text Us @ <a href=\"tel:617-340-8791\">617-340-8791</a>\n          <br />\n          <br />\n          <div class=\"hours\">\n            <ul>\n              <li>\n                <span class=\"range\">M-W</span><span class=\"hours\">10am-10pm</span>\n              </li>\n              <li>\n                <span class=\"range\">Th</span><span class=\"hours\">10am-12am</span>\n              </li>\n              <li>\n                <span class=\"range\">Fr</span><span class=\"hours\">10am-2am</span>\n              </li>\n              <li>\n                <span class=\"range\">Sat</span><span class=\"hours\">12pm-2am</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"copyright\">\n    <h4>\n      Copyright {{ (currentDate).getFullYear() }} by Tablelist Inc.\n    </h4>\n  </div>\n  <div class=\"bottom-links center\">\n    <ul>\n      <li>\n        <a href=\"#\" ui-sref=\"app.legal.privacy\">Privacy Policy</a>\n      </li>\n      <li>\n        <a href=\"#\" ui-sref=\"app.terms\">Terms</a>\n      </li>\n    </ul>\n  </div>\n</footer>\n";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<div id=\"header\">\n  <!-- <div id=\"membership-banner\" class=\"membership-banner\" ng-if=\"showMembershipBanner\">\n    <a class=\"close-btn\" href=\"#\" ng-click=\"hideMembershipBanner($event)\">\n      <i class=\"icon ion-close\"></i>\n    </a>\n    <div class=\"container center\">\n      <div class=\"middle-text\">\n        <div class=\"intro\">Introducing</div>\n        <div class=\"diamond\">\n          <svg width=\"34px\" height=\"33px\" viewBox=\"0 0 22 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n            <defs>\n              <filter x=\"-20.0%\" y=\"-22.2%\" width=\"140.0%\" height=\"144.4%\" filterUnits=\"objectBoundingBox\" id=\"filter-1\">\n                <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n                <feGaussianBlur stdDeviation=\"0.5\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"></feGaussianBlur>\n                <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"></feColorMatrix>\n                <feMerge>\n                  <feMergeNode in=\"shadowMatrixOuter1\"></feMergeNode>\n                  <feMergeNode in=\"SourceGraphic\"></feMergeNode>\n                </feMerge>\n              </filter>\n              <path d=\"M8.37876381,4.07509885 C8.44396736,4.06184309 8.48665952,4.06681393 8.50684157,4.0900115 C8.52702362,4.11320907 8.53090473,4.14966185 8.518485,4.19937094 C8.50606528,4.24908002 8.48044998,4.30873003 8.44163835,4.37832274 C8.40282671,4.44791546 8.35625344,4.52082102 8.30191715,4.59704162 C8.24758086,4.67326221 8.18858805,4.75196708 8.12493697,4.83315859 C8.06128588,4.91435009 7.99841197,4.98974107 7.93631335,5.05933379 C7.93320842,5.06264773 7.92001266,5.08667342 7.89672568,5.1314116 C7.8734387,5.17614977 7.84549474,5.23082895 7.81289296,5.29545075 C7.78029119,5.36007256 7.74536124,5.42966424 7.70810206,5.50422786 C7.67084289,5.57879149 7.63824161,5.64755469 7.61029723,5.71051953 C7.58235285,5.77348437 7.56294732,5.82567812 7.55208006,5.86710236 C7.5412128,5.9085266 7.54354147,5.92923841 7.55906612,5.92923841 C7.59632529,5.92592447 7.66463275,5.87621613 7.76399054,5.7801119 C7.86334834,5.68400767 7.98055772,5.56470766 8.11562222,5.42220829 C8.25068672,5.27970891 8.39661629,5.12644153 8.5534153,4.96240156 C8.71021432,4.79836158 8.86312988,4.64757962 9.01216657,4.51005116 C9.16120325,4.37252269 9.30092305,4.2615074 9.43133016,4.17700196 C9.56173726,4.09249652 9.66730333,4.05687221 9.74803153,4.07012796 C9.80392029,4.08006978 9.83264047,4.12646423 9.83419294,4.2093127 C9.83574541,4.29216118 9.8209972,4.3932348 9.78994789,4.5125366 C9.75889858,4.6318384 9.71931131,4.75942313 9.67118488,4.89529463 C9.62305845,5.03116613 9.57803762,5.15543697 9.53612105,5.2681109 C9.49420448,5.38078482 9.46237942,5.47440219 9.4406449,5.54896582 C9.41891039,5.62352944 9.41891039,5.65749681 9.4406449,5.65086893 C9.46237942,5.64755499 9.50507158,5.61110221 9.56872267,5.54150949 C9.63237375,5.47191677 9.70921964,5.38824107 9.79926264,5.29047987 C9.88930564,5.19271867 9.98866194,5.08998811 10.0973345,4.98228509 C10.2060071,4.87458208 10.3154543,4.77930776 10.4256793,4.69645929 C10.5359044,4.61361082 10.6430229,4.55230387 10.7470381,4.5125366 C10.8510533,4.47276933 10.9434236,4.47276933 11.0241518,4.5125366 C11.0552011,4.52579235 11.0629633,4.57467222 11.0474387,4.65917766 C11.031914,4.74368311 11.0055225,4.84475673 10.9682633,4.96240156 C10.9310041,5.08004639 10.8898644,5.20597418 10.8448429,5.34018871 C10.7998214,5.47440323 10.7648915,5.59784561 10.740052,5.71051953 C10.7152126,5.82319345 10.7074504,5.9176393 10.7167652,5.99385989 C10.72608,6.07008049 10.7664435,6.10819021 10.8378569,6.10819021 C10.9185851,6.11150415 11.0156127,6.07670831 11.1289427,6.00380166 C11.2422727,5.930895 11.3594821,5.83893458 11.4805744,5.72791762 C11.6016667,5.61690067 11.7227572,5.49677218 11.8438495,5.36752857 C11.9649418,5.23828495 12.074389,5.11732799 12.1721943,5.00465407 C12.2699996,4.89198014 12.3515028,4.79587736 12.4167064,4.71634282 C12.4819099,4.63680829 12.520721,4.59372773 12.5331407,4.58709985 C12.567295,4.56721622 12.5960151,4.56307386 12.6193021,4.57467264 C12.6425891,4.58627143 12.6542324,4.61526796 12.6542324,4.6616631 C12.6542324,4.6782328 12.6231836,4.73125503 12.561085,4.82073138 C12.4989863,4.91020773 12.4174831,5.01708066 12.3165729,5.14135337 C12.2156626,5.26562608 12.1000057,5.39818164 11.9695986,5.53902405 C11.8391915,5.67986645 11.7049052,5.80910813 11.5667358,5.92675296 C11.4285663,6.0443978 11.2919514,6.14132906 11.1568869,6.21754965 C11.0218224,6.29377025 10.8999557,6.33022303 10.7912831,6.32690909 C10.6950303,6.32359515 10.6212893,6.29956945 10.5700579,6.25483128 C10.5188265,6.2100931 10.4846728,6.15210004 10.4675957,6.08085035 C10.4505186,6.00960067 10.4458613,5.92923885 10.4536236,5.8397625 C10.4613859,5.75028615 10.4761341,5.6591542 10.4978686,5.56636391 C10.5196031,5.47357362 10.543666,5.38244166 10.5700579,5.29296531 C10.5964498,5.20348896 10.6189602,5.12395562 10.6375898,5.0543629 C10.6562194,4.98477019 10.6678627,4.92926254 10.6725201,4.88783831 C10.6771775,4.84641407 10.6686391,4.82570226 10.6469046,4.82570226 C10.6189602,4.82570226 10.5731631,4.85387032 10.5095121,4.91020728 C10.445861,4.96654424 10.3736724,5.03613592 10.2929442,5.11898439 C10.212216,5.20183286 10.1252792,5.2904794 10.0321313,5.38492666 C9.93898337,5.47937392 9.84583684,5.56719198 9.75268891,5.64838349 C9.65954098,5.72957499 9.57027555,5.79585277 9.48488995,5.84721883 C9.39950435,5.89858488 9.3242109,5.92095363 9.25900735,5.91432575 C9.1938038,5.90769788 9.15887385,5.86875968 9.15421645,5.79750999 C9.14955905,5.7262603 9.16042615,5.63927071 9.18681806,5.53653861 C9.21320998,5.4338065 9.24891615,5.32444816 9.29393765,5.20846029 C9.33895915,5.09247243 9.37854642,4.98477103 9.41270066,4.88535286 C9.4468549,4.7859347 9.46936532,4.70308747 9.48023257,4.63680869 C9.49109983,4.57052991 9.47790407,4.53739102 9.4406449,4.53739102 C9.36923149,4.53739102 9.27918984,4.58212852 9.17051726,4.67160487 C9.06184467,4.76108122 8.94463528,4.87126804 8.81888558,5.00216863 C8.69313587,5.13306921 8.5619545,5.27473798 8.42533754,5.42717917 C8.28872058,5.57962036 8.15831543,5.71963218 8.03411819,5.84721883 C7.90992095,5.97480548 7.794264,6.07670757 7.68714388,6.15292816 C7.58002377,6.22914876 7.49386322,6.25897376 7.42865967,6.24240407 C7.34793146,6.22252043 7.29281977,6.18275376 7.26332292,6.12310286 C7.23382608,6.06345196 7.22451142,5.99303182 7.23537868,5.91184031 C7.24624594,5.83064881 7.27108502,5.7411738 7.30989665,5.6434126 C7.34870829,5.5456514 7.39528156,5.44623473 7.44961785,5.34515959 C7.50395414,5.24408445 7.56217073,5.14466778 7.62426935,5.04690658 C7.68636797,4.94914538 7.74380833,4.86049884 7.79659216,4.78096431 C7.82764147,4.73125523 7.86722874,4.6691198 7.91535517,4.59455618 C7.9634816,4.51999255 8.01393598,4.44543004 8.0667198,4.37086642 C8.11950363,4.29630279 8.17306289,4.23085348 8.22739918,4.17451652 C8.28173547,4.11817956 8.33218984,4.08504066 8.37876381,4.07509885 Z\"\n                id=\"path-2\"></path>\n              <filter x=\"-15.2%\" y=\"-36.5%\" width=\"130.4%\" height=\"173.0%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\">\n                <feGaussianBlur stdDeviation=\"0.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur>\n                <feOffset dx=\"0\" dy=\"0\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset>\n                <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n                <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n              </filter>\n            </defs>\n            <g id=\"Marketing-assets\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n              <g id=\"TLmembership-instagram3\" transform=\"translate(-211.000000, -617.000000)\">\n                <g id=\"Group-2\" transform=\"translate(212.000000, 578.000000)\">\n                  <g id=\"Group\" transform=\"translate(0.000000, 39.000000)\">\n                    <g id=\"Group-12\" filter=\"url(#filter-1)\">\n                      <g id=\"Group-8\">\n                        <polygon id=\"Path\" fill=\"#99BADD\" points=\"3.98223064 7.3668526 15.4510549 7.3668526 9.71664275 17.1359397\"></polygon>\n                        <polygon id=\"Path\" fill=\"#D7E6F7\" transform=\"translate(9.716643, 3.683426) scale(1, -1) translate(-9.716643, -3.683426) \" points=\"3.98223064 0 15.4510549 0 9.71664275 7.3668526\"></polygon>\n                        <polygon id=\"Path-2\" fill=\"#B8D3F1\" points=\"9.71664275 0 4.77867676 0 3.98223064 7.3668526\"></polygon>\n                        <polygon id=\"Path-2\" fill=\"#B8D3F1\" transform=\"translate(12.583849, 3.683426) scale(-1, 1) translate(-12.583849, -3.683426) \" points=\"15.4510549 0 10.5130889 0 9.71664275 7.3668526\"></polygon>\n                        <polygon id=\"Path-3\" fill=\"#7D9ABA\" points=\"9.71664275 17.1359397 0 7.3668526 3.98223064 7.3668526\"></polygon>\n                        <polygon id=\"Path-3\" fill=\"#7D9ABA\" transform=\"translate(14.574964, 12.251396) scale(-1, 1) translate(-14.574964, -12.251396) \" points=\"19.4332855 17.1359397 9.71664275 7.3668526 13.6988734 7.3668526\"></polygon>\n                        <polygon id=\"Path-4\" fill=\"#99BADD\" points=\"15.4510549 7.3668526 19.4332855 7.3668526 14.6546087 0\"></polygon>\n                        <polygon id=\"Path-4\" fill=\"#99BADD\" transform=\"translate(2.389338, 3.683426) scale(-1, 1) translate(-2.389338, -3.683426) \" points=\"0.796446127 7.3668526 4.77867676 7.3668526 0 0\"></polygon>\n                      </g>\n                      <g id=\"m\" fill-rule=\"nonzero\">\n                        <use fill=\"#7D9ABA\" xlink:href=\"#path-2\"></use>\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-3)\" xlink:href=\"#path-2\"></use>\n                        <use stroke=\"#7D9ABA\" stroke-width=\"0.648780488\" xlink:href=\"#path-2\"></use>\n                      </g>\n                    </g>\n                  </g>\n                </g>\n              </g>\n            </g>\n          </svg>\n          Diamond Membership\n        </div>\n      </div>\n      <div class=\"cta\">\n        <button class=\"btn btn-primary\" ng-click=\"goToMembership()\">\n          Sign Up Now\n        </button>\n      </div>\n    </div>\n  </div> -->\n  <!-- <div id=\"nye-banner\" class=\"nye-banner\" ng-if=\"showNYEBanner && !isCheckoutPage\">\n    <a class=\"close-btn\" href=\"#\" ng-click=\"hideNYEBanner($event)\">\n      <i class=\"icon ion-close\"></i>\n    </a>\n    <div class=\"container\">\n      <div class=\"top-text center\">\n        Need help planning <strong>New Year's Eve</strong>?\n        <a href=\"https://tablelist-forms.typeform.com/to/c66NJZ\" target=\"_blank\">\n          Take our survey, and a Tablelist concierge will be in touch!\n        </a>\n      </div>\n    </div>\n  </div> -->\n  <div class=\"main-navbar navbar navbar-inverse\" ng-show=\"!partner.hideHeader\">\n    <div class=\"container-fluid\">\n      <div class=\"navbar-header\">\n        <a id=\"logo\" href=\"{{ partner.logoLink }}\" class=\"navbar-brand logo\">\n          <img ng-src=\"{{ partner.logo }}\">\n        </a>\n      </div>\n      <!-- DISCOVER NAV -->\n      <ul class=\"nav navbar-nav discover-nav hidden-xs\" ng-hide=\"isCheckoutPage()\">\n        <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.browse') }\">\n          <a href=\"#\" class=\"book-table-link\" ui-sref=\"app.browse.city({ city: defaultCitySlug })\">\n            Discover\n          </a>\n        </li>\n      </ul>\n      <!-- MORE NAV -->\n      <ul class=\"nav navbar-nav more-nav visible-lg\" ng-hide=\"isCheckoutPage()\">\n        <!-- <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.membership') }\">\n          <a href=\"#\" ui-sref=\"app.membership.landing\">Membership</a>\n        </li> -->\n        <li class=\"menu-item partners\">\n          <a href=\"https://www.tablelistpro.com/?utm_source=www.tablelist.com&utm_medium=referral&utm_campaign=forbusinessestablelist\">For Businesses</a>\n        </li>\n      </ul>\n      <!-- HAMBURGER NAV -->\n      <ul class=\"nav navbar-nav hamburger-nav hidden-lg pull-right\" ng-hide=\"isCheckoutPage()\">\n        <li class=\"menu-item\">\n          <a href=\"#\" ng-click=\"toggleOverlayMenu()\">\n            <i class=\"fa fa-bars\"></i>\n          </a>\n        </li>\n      </ul>\n      <!-- LOGIN NAV -->\n      <ul class=\"nav navbar-nav login-nav pull-right hidden-xs\">\n        <li class=\"menu-item\" ng-hide=\"isLoggedIn() || isCheckoutPage()\">\n          <a href=\"#\" ui-sref=\"app.login\">Log in</a>\n        </li>\n        <li class=\"menu-item\" ng-hide=\"isLoggedIn() || isCheckoutPage()\">\n          <a href=\"#\" ui-sref=\"app.signup\">Sign up</a>\n        </li>\n        <li class=\"menu-item dropdown\" ng-show=\"isLoggedIn()\">\n          <a href=\"#\" class=\"dropdown-toggle dropdown-toggle-desktop hidden-xs\" ui-sref=\"app.me.profile\">\n            <div class=\"clearfix\">\n              <div class=\"col-md-2 hidden-md image-container\">\n                <img class=\"img-circle\" ng-src=\"{{ currentUserImageUrl() }}\" />\n              </div>\n              <div class=\"col-md-12 col-lg-10 hidden-sm hidden-xs name-credit-container\">\n                <div class=\"name\">{{ currentUser.name }}</div>\n                <div class=\"credit\" ng-show=\"currentUser.location.preferred.displayName\">\n                  <span>{{ currentUser.location.preferred.displayName || \"Select your city\" }}</span>\n                </div>\n              </div>\n            </div>\n          </a>\n          <a href='#' class=\"visible-xs\">\n            <img class=\"img-circle\" ng-src=\"{{ currentUserImageUrl() }}\" ui-sref=\"app.me.profile\" height=\"20px\" />\n          </a>\n        </li>\n      </ul>\n      <!-- SEARCH BAR NAV -->\n      <ul class=\"nav navbar-nav search-bar-nav pull-right\" ng-hide=\"isCheckoutPage()\">\n        <search></search>\n      </ul>\n      <!-- SEARCH BUTTON NAV -->\n      <ul class=\"login-nav nav navbar-nav search-button-nav pull-right hidden-lg hidden-md\">\n        <li>\n          <a href=\"#\" ng-click=\"openSearchModal()\">\n            <i class=\"icon ion-ios-search-strong\"></i>\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- Mobile Nav -->\n  <div class=\"mobile-nav\" ng-class=\"{ 'overlay-hidden': showOverlayMenu.hidden, 'overlay-hiding': showOverlayMenu.hiding }\">\n    <div class=\"menu-wrapper\">\n      <div class=\"ul-container\">\n        <ul class=\"main-nav\">\n          <li>\n            <a href=\"#\" ng-click=\"browseCity()\">Discover</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"app.membership.landing\">Membership</a>\n          </li>\n          <li>\n            <a href=\"https://www.tablelistpro.com/?utm_source=www.tablelist.com&utm_medium=referral&utm_campaign=forbusinessestablelist\">For Businesses</a>\n          </li>\n          <li>\n            <a href=\"#\" ui-sref=\"appdownload\">Download</a>\n          </li>\n        </ul>\n        <ul class=\"sub-nav\" ng-show=\"currentUser\">\n          <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.profile') }\">\n            <a href=\"#\" ui-sref=\"app.me.profile\">My Account</a>\n          </li>\n          <li class=\"menu-item\">\n            <a href=\"#\" ui-sref=\"app.me.tickets\" ng-class=\"{ active: $state.includes('app.me.tickets') }\">Your Tickets</a>\n            <span>/</span>\n            <a href=\"#\" ui-sref=\"app.me.bookings\" ng-class=\"{ active: $state.includes('app.me.bookings') }\">Tables</a>\n          </li>\n          <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.reviews') }\">\n            <a href=\"#\" ui-sref=\"app.me.reviews\">Reviews\n              <div class=\"count\" ng-show=\"pendingReviewCount > 0\">{{ pendingReviewCount }}</div>\n            </a>\n          <li class=\"menu-item\" ng-class=\"{ active: $state.includes('app.me.favorites') }\">\n            <a href=\"#\" ui-sref=\"app.me.favorites\">Favorites </a>\n          </li>\n        </ul>\n        <ul class=\"sub-nav secondary\">\n          <li ng-hide=\"isLoggedIn() || isCheckoutPage()\">\n            <a href=\"#\" ui-sref=\"app.login\">Log in</a>\n          </li>\n          <li ng-hide=\"isLoggedIn() || isCheckoutPage()\">\n            <a href=\"#\" ui-sref=\"app.signup\">Sign up</a>\n          </li>\n          <li ng-show=\"isLoggedIn()\">\n            <a href=\"#\" ng-click=\"logout()\">Logout</a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "<div class=\"booking-card-directive\">\n  <div class=\"booking-card-header\" ng-hide=\"isReceipt\">\n    <div class=\"header-cell col-sm-2 col-xs-6\">\n      <p class=\"title\">PURCHASE DATE</p>\n      <p>{{booking.created | localize | date:'EEEE, MMM dd'}}</p>\n    </div>\n    <div class=\"header-cell col-sm-2 col-xs-6\">\n      <p class=\"title\" ng-show=\"status.isUpcoming || status.isTable\">YOU WILL PAY</p>\n      <p class=\"title\" ng-hide=\"status.isUpcoming || status.isTable\">YOU PAID</p>\n      <p>{{ status._users.bookingUser.amount | currency:'$' }}</p>\n    </div>\n    <div class=\"header-cell col-sm-2 col-xs-12\">\n      <p class=\"title\">PRIMARY BOOKER</p>\n      <p>{{ booking.primaryUser.name }}</p>\n    </div>\n    <div class=\"header-cell col-sm-3 col-xs-12\">\n      <p class=\"title\">STATUS</p>\n      <p>{{ statusText }}</p>\n    </div>\n    <div class=\"header-cell col-sm-3 col-xs-12 status\">\n      <img ng-if=\"booking.inventoryMembershipLevel >= 50\" class=\"diamond\" src=\"https://assets.tablelist.com/www-2/tablelist/tl-membership-diamond@3x.png\" />\n      <div class=\"text\">\n        <p class=\"title\">Order #{{ booking.id }}</p>\n        <p>\n          <span class=\"link\" ui-sref=\"appreceipt({booking : booking.id })\">Order Details</span>\n          <span ng-show=\"status.hasTickets\"> | <a class=\"link\" target=\"_blank\" href=\"{{ receiptPDF }}\">View My Ticket</a></span>\n        </p>\n      </div>\n    </div>\n  </div>\n  <div class=\"booking-card-body\">\n    <div class=\"col-md-3 col-sm-2 image-wrapper\">\n      <img class=\"venue-image\" ng-if=\"booking.event.images[0]\" ng-src=\"{{ booking.event.images[0].small }}\" />\n      <img class=\"venue-image\" ng-if=\"!booking.event.images[0]\" ng-src=\"{{ booking.venue.primaryImage.small }}\" />\n    </div>\n    <div class=\"col-md-6 col-sm-6\">\n      <h2 class=\"name clickable\" ui-sref=\"appreceipt({booking : booking.id })\">{{ booking.name }} @ {{booking.venue.name}} <span ng-if=\"booking.event.name\">for {{booking.event.name}}</span></h2>\n      <p><a href=\"{{ directMapUrl }}\" target=\"_blank\" class=\"address\">{{ booking.venue.location.address.address }}, {{ booking.venue.location.address.city }}, {{ booking.venue.location.address.state }}, {{ booking.venue.location.address.zip }}</a></p>\n      <p><img src=\"https://assets.tablelist.com/www/icons/icon-clock.png\" class=\"icon\" alt=\"Clock Icon\">{{booking.date | localize | date:'EEEE MMM dd, yyyy'}} <span ng-show=\"booking.arrivalTime\">- {{booking.arrivalTime | localize | date:'h:mm a' }}</span></p>\n      <p ng-show=\"status.isTicket\">\n        <span ng-show=\"booking.quantity > 0\"><i class=\"fa fa-ticket\"></i>{{ booking.quantity }} Ticket<span ng-show=\"booking.quantity > 1\">s</span></span>\n      </p>\n      <p ng-show=\"status.hasTickets\">\n        <span ng-show=\"booking.inventoryIncluded.quantity > 0\"><i class=\"fa fa-ticket\"></i>{{ booking.inventoryIncluded.quantity }} Ticket<span ng-show=\"booking.inventoryIncluded.quantity > 1\">s</span></span>\n      </p>\n      <p ng-hide=\"status.isUpcoming || status.isTicket\"><img src=\"https://assets.tablelist.com/www/icons/icon-group.png\" class=\"icon\" alt=\"Users Icon\">{{ booking.guests }} Guest<span ng-show=\"booking.guests > 1\">s</span> Max</p>\n      <div class=\"favorite-venue\" ng-hide=\"status.isUpcoming || status.isTicket\" ng-if=\"booking.venue\">\n        <div class=\"btn btn-primary\" style=\"max-width: 200px; margin-right: 10px; margin-bottom: 0px;\" ui-sref=\"app.me.review({ reviewId: review.id })\" ng-show=\"review && review.pending\">Leave Review</div>\n      </div>\n      <a class=\"btn btn-primary print-ticket-button\" ng-show=\"status.hasTickets\" target=\"_blank\" href=\"{{ receiptPDF }}\">View My Tickets</a>\n    </div>\n    <div class=\"col-md-3 col-sm-4 actions\">\n      <div class=\"btn btn-default\" ng-click=\"bookNow(booking.venue)\" ng-show=\"review\">Book Here Again</div>\n      <div class=\"btn btn-default\" ng-click=\"shareEvent(booking)\">Share with Friends</div>\n      <div class=\"btn btn-default\" ng-click=\"contactSupport()\">Contact Support</div>\n      <div class=\"btn btn-default\" ng-click=\"cancelReservation()\" ng-show=\"status.isUpcoming && status.isTable\">Cancel Reservation</div>\n    </div>\n    <div class=\"col-md-9 col-sm-12 col-xs-12 review-content\" ng-if=\"review && !review.pending\">\n      <div class=\"review-comments\" ng-if=\"review.comment\">\n        <h4>You Wrote: </h4>\n        <p ng-bind-html=\"::sanitizeNewlines(review.comment)\"></p>\n      </div>\n      <div class=\"review-ratings\">\n        <h4>You Rated: </h4>\n        <div ng-repeat=\"question in review.questions\">\n          <span ng-bind=\"question.title\"></span>\n          <div>\n            <span class=\"fa fa-star\" ng-class=\"{ 'filled' : question.rating >= i  }\" ng-repeat=\"i in [1,2,3,4,5]\"></span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "<div id=\"booking-guests\">\n  <p>Guest List</p>\n  <div class=\"guest row\" ng-repeat=\"user in booking.users\" ng-class=\"{confirmed: user.status === 'CONFIRMED', declined: user.status === 'FAILED', pending : user.status === 'PENDING'}\">\n    <img class=\"profile-pic\" ng-src=\"{{user.imageUrl}}\" />\n    <div class=\"profile-status-icon\" ng-show=\"user.status === 'CONFIRMED'\" class=\"status-icon\" style=\"background-image: url('https://assets.tablelist.com/www/assets/status-check.png')\"></div>\n    <div class=\"profile-status-icon\" ng-hide=\"user.status === 'CONFIRMED'\" class=\"status-icon\" style=\"background-image: url('https://assets.tablelist.com/www/assets/status-cross.png')\"></div>\n    <div class=\"user-status\" ng-switch=\"user.status\">\n      <div ng-switch-when=\"CONFIRMED\" class=\"user-status-text\">\n        <span ng-show=\"user.user.id !== currentUser.id\"><strong>{{user.name}}</strong> is going</span>\n        <span ng-show=\"user.user.id === currentUser.id\"><strong>You</strong> are going</span>\n      </div>\n      <div ng-switch-when=\"PENDING\">\n        <strong>{{ user.name }}</strong> is pending...\n      </div>\n      <div class=\"user-status-payment\">{{ user.amount | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }} - <span class=\"small\">Payment {{ user.paymentStatus }}</span> </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div id=\"booking-items\">\n  <div class=\"clearfix row item\" ng-show=\"booking.inventoryType === 'TICKET' || booking.inventoryType === 'COVER'\">\n    <div class=\"col-xs-8 item-details\" ng-if=\"booking.quantity > 1\">\n      {{booking.quantity}} x {{ booking.location }} <span class=\"light\">({{booking.price / booking.quantity | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode}} each)</span>\n    </div>\n    <div class=\"col-xs-8 item-details\" ng-if=\"booking.quantity < 2\">\n      <strong>{{ booking.location }}</strong>\n    </div>\n    <div class=\"col-xs-4 price item-price\">\n      {{booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}\n    </div>\n  </div>\n  <div class=\"clearfix row\" ng-show=\"booking.inventoryType !== 'TICKET' && booking.inventoryType !== 'COVER'\">\n    <p class=\"col-xs-8\" ng-if=\"booking.payment !== 'ADVANCE_DEPOSIT'\">Subtotal</p>\n    <p class=\"col-xs-8\" ng-if=\"booking.payment === 'ADVANCE_DEPOSIT'\">Deposit</p>\n    <p class=\"col-xs-4 price\">{{booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode}}</p>\n  </div>\n  <div class=\"horizontal-divider\" ng-hide=\"fees.length < 1 && !booking.credit\"></div>\n  <div class=\"clearfix row\" ng-show=\"booking.tax > 0\">\n    <p class=\"col-xs-8\">Tax <span>{{booking.taxPercent | percentage}}</span></p>\n    <p class=\"col-xs-4 price\">{{booking.tax | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode}}</p>\n  </div>\n  <!-- TIP -->\n  <div class=\"clearfix row\" ng-show=\"booking.tip > 0\">\n    <p class=\"col-xs-8\">Service Charge <span>{{booking.tipPercent | percentage}}</span></p>\n    <p class=\"col-xs-4 price\">{{booking.tip | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode}}</p>\n  </div>\n  <!-- FEES -->\n  <div class=\"clearfix row\" ng-repeat=\"fee in booking.fees\">\n    <p class=\"col-xs-8\">\n      {{fee.name}}\n      <span ng-if=\"fee.type === 'PERCENT'\">{{ fee.amount | percentage }}</span>\n    </p>\n    <p class=\"col-xs-4 price\">{{fee.value | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode}}</p>\n  </div>\n\n  <div class=\"clearfix row credit\" ng-repeat=\"discount in booking.discounts\">\n    <div class=\"col-xs-8\">{{discount.name}}</div>\n    <div class=\"col-xs-4 price\">-{{discount.value | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</div>\n  </div>\n\n  <div class=\"clearfix row credit row\" ng-show=\"booking.credit\">\n    <div class=\"col-xs-8\">Tablelist Credit</div>\n    <div class=\"col-xs-4 price\">- {{booking.credit | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</div>\n  </div>\n  <div class=\"horizontal-divider\"></div>\n  <div class=\"clearfix row total\">\n    <span class=\"col-xs-8 price-label\">Total</span>\n    <span class=\"col-xs-4 price\">{{booking.total | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</span>\n  </div>\n  <!-- <div class=\"clearfix row due-on-arrival\" ng-show=\"booking.payment === 'ADVANCE_DEPOSIT' || booking.payment === 'VENUE' || booking.payment === 'NONE'\">\n    <div class=\"col-xs-8\">Estimated balance due at the venue</div>\n    <div class=\"col-xs-4 price\">{{booking.dueOnArrival | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</div>\n  </div> -->\n</div>\n";

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<!-- OPEN, PENDING, CANCELLED, REFUNDED, VOIDED bookings -->\n<div id=\"booking-status\" ng-class=\"{ 'payment-failed': paymentPlanFailed }\">\n\n  <!-- Booking Complete -->\n  <section class=\"booking-status-complete\" ng-show=\"booking.status === 'COMPLETE_PENDING' || booking.status === 'COMPLETE' || booking.status === 'PROCESS_PENDING' || booking.status === 'PROCESSED'\">\n    <h3>Thank you for your purchase!</h3>\n  </section>\n\n  <!-- Remaining Guests -->\n  <section class=\"booking-status-guests\" ng-show=\"booking.status === 'WAITING'\">\n    <h4 ng-hide=\"booking.display.remaining == 'Your table is full'\">{{ booking.display.remaining }} to join before your {{ booking.inventoryType.toLowerCase() }} is booked.</h4>\n    <h4 ng-show=\"booking.display.remaining == 'Your table is full'\">{{ booking.display.remaining }}. Waiting on payment details...</h4>\n  </section>\n\n  <section ng-show=\"bookingUser.status === 'CONFIRMED'\">\n    <div class=\"alert alert-danger\" ng-show=\"leaveError\">\n      {{leaveError}}\n    </div>\n\n  </section>\n\n  <!-- Errors -->\n  <section class=\"booking-status-state\" ng-hide=\"booking.status === 'WAITING' || booking.status === 'COMPLETE_PENDING' || booking.status === 'COMPLETE' || booking.status === 'PROCESS_PENDING' || booking.status === 'PROCESSED'\">\n    <div class=\"alert alert-danger\" ng-show=\"booking.status ==='OPEN_PENDING'\">\n      <div class=\"icon\">\n        <i class=\"failed fa fa-info-circle\"></i>\n      </div>\n      <p>Looks like there was an issue with your booking.</p>\n      <p>Please contact us at 617-340-8791 to resolve the issue.</p>\n    </div>\n    <div class=\"alert alert-info\" ng-show=\"booking.status ==='OPEN'\">\n      <p>Your booking has not been completed yet.</p>\n      <p>Click <a href=\"#\" ui-sref=\"appcheckout({ bookingId : booking.id })\">here</a> to complete your booking.</p>\n    </div>\n    <div class=\"alert alert-warning\" ng-show=\"booking.status ==='CANCEL_PENDING' || booking.status ==='CANCELLED'\">\n      <p>Your booking has been cancelled.</p>\n    </div>\n    <div class=\"alert alert-warning\" ng-show=\"booking.status ==='VOID_PENDING' || booking.status ==='VOIDED'\">\n      <p>Your booking has been voided.</p>\n    </div>\n    <div class=\"alert alert-warning\" ng-show=\"booking.status ==='EXPIRE_PENDING' || booking.status ==='EXPIRED'\">\n      <p>Your booking has expired.</p>\n      <p>Click <a href=\"#\" ui-sref=\"app.venue({ seoPathname: booking.venue.seoPathname })\">here</a> to book again.</p>\n    </div>\n  </section>\n\n  <!-- Payment Information -->\n  <section class=\"booking-status-payment\" ng-hide=\"booking.status ==='CANCEL_PENDING' || booking.status ==='CANCELLED'\">\n    <span ng-show=\"bookingUser.paymentStatus ==='CONFIRMED'\">You're on the list! Your card has been approved. <br> A confirmation e-mail has been sent to your e-mail address.</span>\n    <span ng-show=\"bookingUser.paymentStatus ==='PENDING'\">Your card has not been processed yet.</span>\n\n    <div ng-show=\"bookingUser.paymentStatus ==='FAILED'\" class=\"payment-options\">\n\n      <p>Your card has been declined. Please try again.</p>\n\n      <div ng-show=\"bookingUser.paymentStatus ==='FAILED'\" class=\"payment-options\">\n\n        <p>Your card has been declined. Please try again.</p>\n\n        <br>\n\n        <payment-profile payment-profile=\"paymentProfile\"></payment-profile>\n\n        <br>\n\n        <div class=\"btn btn-block btn-primary\" ng-class=\"{disabled: !paymentProfile}\" ng-click=\"confirmJoin()\">\n          Retry | {{ bookingUser.amount | currency:'$'}}\n        </div>\n\n        <br>\n\n        <div class=\"alert alert-danger\" ng-show=\"error\">\n          <p ng-repeat=\"e in error.errors\">{{e.message}}</p>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n";

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "<div id=\"checkout-preview-directive\">\n  <div class=\"checkout-preview-content\" ng-class=\"{ 'isLoaded' : fadeIn }\">\n    <div class=\"venue-image-wrapper\">\n      <img class=\"venue-image \" ng-src=\"{{ booking.venue.primaryImage.filename }}?w=420\">\n    </div>\n    <div class=\"profile-pic\">\n      <img ng-src=\"{{ imgix(profileImg()) }}\" />\n    </div>\n    <h3 class=\"checkout-preview-header\">{{ booking.name }}</h3>\n    <p class=\"header\">\n      {{ booking.date | date : 'EEE, MMM dd, yyyy' : 'UTC' }}\n    </p>\n    <p class=\"header\">\n      {{ booking.location }}\n    </p>\n    <div class=\"section-header\" ng-if=\"inventory.description\">\n      Order Summary\n    </div>\n    <div class=\"list-item list-item-order-summary clearfix row\" ng-if=\"inventory.description\">\n      <div ng-bind-html=\"inventory.description\"></div>\n    </div>\n    <div class=\"item-list\">\n      <div class=\"list-item clearfix row\" ng-if=\"booking.inventoryType === 'TABLE'\" ng-repeat=\"item in booking.items\" ng-class=\"{ 'last-child' : $last }\">\n        <div class=\"list-item-icon quantity\">{{item.quantity}}</div>\n        <div class=\"list-item-info\">\n          <div class=\"name\">{{item.item.name}}</div>\n          <div class=\"unit-details\">\n            {{item.item.type}} -\n            <span class=\"number-display\">{{item.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</span>\n          </div>\n        </div>\n        <div class=\"price number-display\">{{item.price * item.quantity | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</div>\n      </div>\n      <div class=\"list-item clearfix row not-table\" ng-if=\"booking.inventoryType !== 'TABLE'\" ng-class=\"{ 'last-child' : $last }\">\n        <div class=\"list-item-icon quantity\">{{ booking.quantity }}</div>\n        <div class=\"list-item-info\">\n          <div class=\"name\">{{:: getInventoryName(booking.inventoryType, booking.quantity) }}</div>\n        </div>\n        <div class=\"price number-display\">{{ booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</div>\n      </div>\n      <div class=\"list-item clearfix row reservation\" ng-if=\"booking.reservation && booking.inventoryType === 'TABLE' && booking.skipItems == true\" ng-class=\"{ 'last-child' : $last }\">\n        <div class=\"list-item-icon quantity\">{{ booking.inventoryType.slice(0, 1) + booking.inventoryType.slice(1, booking.inventoryType.length).toLowerCase() }}</div>\n        <div class=\"price number-display\">{{ booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode  }}</div>\n      </div>\n    </div>\n    <div class=\"section-header\">Location and Time</div>\n    <div class=\"location list-item clearfix row\">\n      <i class=\"list-item-icon fa fa-map-marker\"></i>\n      <div>\n        <div class=\"venue-name\">{{booking.venue.name}}</div>\n        <div class=\"location-details\">{{booking.venue.location.address.city}}<span ng-show=\"booking.venue.location.address.neighborhood\">| {{booking.venue.location.address.neighborhood}}</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"time list-item clearfix row\">\n      <i class=\"list-item-icon fa fa-clock-o\"></i>\n      <div>\n        <div class=\"date\">{{booking.date | date: 'longDate' : 'UTC' }}</div>\n        <div class=\"time-details\">\n          <span ng-show=\"booking.arrivalTime\">{{booking.arrivalTime | date: 'shortTime' : 'UTC'}} |</span>\n          <span ng-show=\"booking.inventoryType !== 'TICKET'\">{{booking.guests}} Guest<span ng-show=\"booking.guests > 1\">s</span></span>\n          <span ng-show=\"booking.inventoryType === 'TICKET'\">{{booking.quantity}} Guest<span ng-show=\"booking.quantity > 1\">s</span></span>\n        </div>\n      </div>\n    </div>\n    <div class=\"section-header\" style=\"border-top: none;\">Payment</div>\n\n    <!-- Promo -->\n    <div class=\"add-promo clearfix\" ng-show=\"isLoggedIn()\">\n\n      <a href=\"#\" ng-click=\"showRedeemCode = !showRedeemCode\" ng-hide=\"successMsg\">\n        Have a promo or referral code?\n        <i class=\"fa fa-chevron-down\" ng-show=\"!showRedeemCode\"></i>\n        <i class=\"fa fa-chevron-up\" ng-show=\"showRedeemCode\"></i>\n      </a>\n\n      <div class=\"success-message\" ng-show=\"successMsg\"><strong>Redeemed!</strong> {{ successMsg }}</div>\n\n      <div class=\"show-redeem-code\" slide-down=\"showRedeemCode\" ng-hide=\"successMsg\">\n        <form name=\"promoCodeForm\" class=\"form-inline\" role=\"form\" novalidate>\n          <div class=\"form-group\" ng-class=\"{ 'has-errors': submittedCode && promoCodeForm.promoCode.$invalid }\">\n            <div class=\"input-group\">\n              <input type=\"text\" class=\"form-control\" name=\"promoCode\" ng-model=\"promoCode\" placeholder=\"12345\" required>\n              <div class=\"btn-submit input-group-addon clickable\" ng-click=\"addDiscount()\">\n                <span ng-hide=\"loading\">Redeem</span>\n                <span ng-show=\"loading\"><i class=\"fa fa-spinner fa-spin\"></i></span>\n              </div>\n            </div>\n          </div>\n        </form>\n        <div class=\"error-message\">{{errorMsg}}</div>\n      </div>\n      <div class=\"cover\" ng-hide=\"hasCompletedMissingInfoSection\"></div>\n    </div>\n    <div class=\"receipt clearfix\">\n      <div class=\"clearfix\" ng-show=\"booking.payment !== 'ADVANCE_DEPOSIT'\">\n        <p class=\"pull-left\">Subtotal</p>\n        <p class=\"pull-right number-display\">{{booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix\" ng-show=\"booking.payment === 'ADVANCE_DEPOSIT'\">\n        <p class=\"pull-left\">Deposit</p>\n        <p class=\"pull-right number-display\">{{booking.price | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix\" ng-show=\"booking.tax !== 0\">\n        <p class=\"pull-left\">Tax <span ng-show=\"tax\">{{tax | percentage}}</span></p>\n        <p class=\"pull-right number-display\">{{booking.tax | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix\" ng-show=\"booking.tip !== 0\">\n        <p class=\"pull-left\">Service charge <span ng-show=\"tip\">{{tip}}%</span></p>\n        <p class=\"pull-right number-display\">{{booking.tip | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix\" ng-repeat=\"fee in booking.fees\">\n        <p class=\"pull-left\">\n          {{fee.name}}\n          <span ng-if=\"fee.type === 'PERCENT'\">({{ fee.amount | percentage }})</span>\n        </p>\n        <p class=\"pull-right number-display\">{{fee.value | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix credit clickable\" ng-repeat=\"discount in booking.discounts\" ng-click=\"removeDiscount(discount.id)\">\n        <p class=\"pull-left\">{{discount.name}}</p>\n        <p class=\"pull-right number-display\">-{{discount.value | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix credit\" ng-show=\"booking.credit\">\n        <p class=\"pull-left\">Credit</p>\n        <p class=\"pull-right number-display\">-{{booking.credit | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix total\">\n        <p class=\"pull-left\" ng-show=\"booking.payment === 'VENUE'\">Due at Venue</p>\n        <p class=\"pull-left\" ng-show=\"booking.payment === 'ADVANCE' || booking.payment === 'ADVANCE_DEPOSIT'\">Total</p>\n        <p class=\"pull-left\" ng-show=\"booking.payment === 'NONE' && booking.inventoryType !== 'PACKAGE'\">Due at Venue</p>\n        <p class=\"pull-right number-display\">{{booking.totalWithCredit | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix due-at-venue\" ng-show=\"booking.payment === 'ADVANCE_DEPOSIT'\">\n        <p class=\"pull-left\">Estimated balance due at the venue</p>\n        <p class=\"pull-right number-display\">{{booking.dueOnArrival | venueCurrency : booking.venue.currencyCode : booking.venue.languageCode }}</p>\n      </div>\n      <div class=\"clearfix due-at-venue\" ng-show=\"booking.payment === 'VENUE'\">\n        <p class=\"pull-left\">This is an estimate of what you will have to pay at the venue.</p>\n      </div>\n      <div class=\"clearfix due-at-venue\" ng-show=\"booking.payment === 'NONE' && booking.inventoryType !== 'PACKAGE'\">\n        <p class=\"pull-left\">This is an estimate of what you will have to pay at the venue.</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "<form name=\"completeProfileForm\" id=\"login-form\" ng-submit=\"submit(user)\" class=\"tl-form completeProfileForm\" novalidate>\n  <div class=\"form-group name row\" ng-show=\"requiredKeys.firstName || requiredKeys.lastName\">\n    <div class=\"col-xs-6\" ng-if=\"requiredKeys.firstName\">\n      <label for=\"firstName\">First Name</label>\n      <input class=\"form-control\" type=\"text\" name=\"firstName\" ng-model=\"user.firstName\" ng-minlength=\"2\" required>\n    </div>\n    <div class=\"col-xs-6\" ng-if=\"requiredKeys.firstName\">\n      <label for=\"lastName\">Last Name</label>\n      <input class=\"form-control\" type=\"text\" name=\"lastName\" ng-model=\"user.lastName\" ng-minlength=\"2\" required>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-if=\"requiredKeys.email\">\n    <label for=\"email\">E-mail Address</label>\n    <input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"user.email\">\n  </div>\n  <div class=\"form-group\" ng-if=\"requiredKeys.phone\">\n    <label for=\"phone\">Phone Number</label>\n    <input class=\"form-control\" type=\"text\" name=\"phone\" ng-model=\"user.phone\" phone-number ng-minlength=\"14\">\n  </div>\n  <div class=\"clearfix\" ng-show=\"errorMsg\">\n    <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n  </div>\n  <button class=\"btn btn-block btn-animated-no-icon icon-center\" type=\"submit\" tabindex=\"3\" ng-bs-animated-button=\"\" is-submitting=\"completeProfileSubmitting\" result=\"completeProfileResult\" options=\"completeProfileBtnOptions\" ng-disabled=\"completeProfileForm.$invalid\"></button>\n</form>\n<!-- <p class=\"legal\">By signing up you agree to our <br /><a target=\"_blank\" href=\"/terms\">Terms and Service</a> &amp; <a href=\"/legal/privacy\" target=\"_blank\">Privacy Policy</a></p> -->\n";

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<div class=\"concierge\">\n  <div class=\"talk-to-us\">\n    <button class=\"btn btn-primary\" ng-click=\"show()\">\n      <i class=\"icon ion-ios-chatbubble-outline\"></i>\n      <span class=\"text\">Need Help?</span>\n    </button>\n    <label ng-if=\"unreadMessages() > 0\">{{ unreadMessages() }}</label>\n  </div>\n  <div class=\"widget\" ng-class=\"{ visible : visible }\">\n    <div class=\"top-bar\">\n      Tablelist Concierge\n      <button ng-click=\"hide()\">\n        <i class=\"icon ion-close\"></i>\n      </button>\n    </div>\n    <div class=\"content\">\n      <concierge-signup ng-if=\"state() === STATE.SIGNUP\"></concierge-signup>\n      <concierge-chat ng-if=\"state() === STATE.CHAT\"></concierge-chat>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "<div class=\"concierge-chat\">\n  <div class=\"message-list\">\n    <div ng-repeat=\"message in getMessages() | orderBy:'created'\" class=\"message clearfix\" ng-class=\"{internal: isInternalMessage(message), admin: isAgentMessage(message), user: isUserMessage(message)}\">\n      <div class=\"message-info\" ng-if=\"isUserMessage(message)\">\n        <span class=\"from-name\">{{ getMessageName(message) }}</span>\n        <span class=\"time\">{{ message.created | date : 'short' }}</span>\n      </div>\n      <div class=\"message-info\" ng-if=\"isAgentMessage(message)\">\n        <span class=\"time\">{{ message.created | date : 'short' }}</span>\n        <span class=\"from-name\">{{ getMessageName(message) }}</span>\n      </div>\n      <div class=\"arrow-up\"></div>\n      <div class=\"message-text text\" ng-bind-html=\"getMessageText(message)\"></div>\n      <div class=\"message-links\">\n        <a ng-if=\"mediaUrl(message)\" ng-href=\"{{ mediaUrl(message) }}\" data-toggle=\"tooltip\" title=\"Image\" target=\"__blank\"><i class=\"fa fa-picture-o\"></i></a>\n        <a ng-if=\"bookingUrl(message)\" ng-href=\"{{ bookingUrl(message) }}\" data-toggle=\"tooltip\" title=\"Booking\"><i class=\"fa fa-book\"></i></a>\n        <a ng-if=\"eventUrl(message)\" ng-href=\"{{ eventUrl(message) }}\" data-toggle=\"tooltip\" title=\"Event\"><i class=\"fa fa-calendar-o\"></i></a>\n        <a ng-if=\"venueUrl(message)\" ng-href=\"{{ venueUrl(message) }}\" data-toggle=\"tooltip\" title=\"Venue\"><i class=\"fa fa-glass\"></i></a>\n        <a ng-if=\"cityUrl(message)\" ng-href=\"{{ mediaUrl(message) }}\" data-toggle=\"tooltip\" title=\"City\"><i class=\"fa fa-map-marker\"></i></a>\n      </div>\n    </div>\n    <div ng-if=\"showConciergeDescription()\" class=\"concierge-description\">\n      Hang tight, your concierge will be with you shortly\n    </div>\n    <div ng-if=\"showIntroDescription()\" class=\"concierge-description\">\n      <br><br>\n      <strong>Welcome to Tablelist Concierge</strong>\n      <br><br>\n      Contact your Tablelist Concierge 24/7 to book a table, plan your night or if you have any questions or concerns.\n    </div>\n    <div ng-if=\"loading\" class=\"loading-messages\">\n      <i class=\"fa fa-refresh fa-spin\"></i>\n    </div>\n  </div>\n  <div class=\"message-form\">\n    <div class=\"message-text\">\n      <textarea ng-model=\"messageText\" ng-enter=\"sendMessage(messageText)\" ng-class=\"{ sending: isSending }\" maxlength=\"{{ maxTextLength() }}\" rows=\"4\" placeholder=\"Enter message...\" ng-class=\"{ internal: internal }\"></textarea>\n    </div>\n    <div class=\"message-send\">\n      <div class=\"send-button btn btn-primary pull-right\" ng-disabled=\"!canSendMessage()\" ng-click=\"sendMessage(messageText)\">Send</div>\n      <div class=\"vtsp pull-right\"></div>\n      <div class=\"img-upload pull-right\">\n        <button ng-hide=\"image\" class=\"btn btn-default\" ng-disabled=\"uploading\">\n          <i ng-hide=\"uploading\" class=\"fa fa-picture-o\"></i>\n          <i ng-if=\"uploading\" class=\"fa fa-refresh fa-spin\"></i>\n        </button>\n        <input id=\"input-img-upload\" type=\"file\" name=\"file\" onchange=\"angular.element(this).scope().uploadImage(this.files)\" />\n        <i ng-if=\"image\" class=\"fa fa-times remove-img\" ng-click=\"removeImage()\"></i>\n        <img ng-if=\"image\" ng-src=\"{{ image.original }}\" />\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<div class=\"concierge-signup\">\n  <div class=\"concierge-signup-container\">\n    <div class=\"intro\" ng-show=\"intro\">\n      <p>Contact Tablelist concierge with any questions or concerns.</p>\n      <hr>\n      <label>Introduce yourself</label>\n      <button class=\"btn btn-default\" ng-click=\"begin()\">Name, Phone</button>\n    </div>\n    <div class=\"signup\" ng-if=\"!intro\">\n      <div class=\"container-fluid\">\n        <div class=\"row\">\n          <div class=\"col-xs-6\">\n            <label>First name</label>\n            <input ng-model=\"form.firstName\" class=\"form-control\" type=\"text\" auto-focus />\n          </div>\n          <div class=\"col-xs-6\">\n            <label>Last name</label>\n            <input ng-model=\"form.lastName\" class=\"form-control\" type=\"text\" />\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <label>Phone number</label>\n            <input ng-model=\"form.phone\" class=\"form-control\" type=\"text\" phone-number />\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <label>E-mail Address</label>\n            <input ng-model=\"form.email\" class=\"form-control\" type=\"text\" />\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <label>Password</label>\n            <input ng-model=\"form.password\" class=\"form-control\" type=\"password\" placeholder=\"Must be atleast 6 characters\" />\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"signin\">\n      or <a href=\"#\" ng-click=\"signIn()\">Log in with my Tablelist Account</a>\n    </div>\n    <div class=\"reason\">\n      <label>Reason for visiting Tablelist</label>\n      <div class=\"dropdown\">\n        <button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">\n          {{ selectedReason }}\n          <span class=\"caret pull-right\"></span>\n        </button>\n        <ul class=\"dropdown-menu\" aria-labelledby=\"dropdownMenu1\">\n          <li ng-repeat=\"reason in reasons\" ng-click=\"selectReason(reason)\"><a>{{ reason }}</a></li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"message\">\n      <label>Your message</label>\n      <textarea ng-model=\"message\" rows=\"5\" placeholder=\"Compose your message...\"></textarea>\n    </div>\n  </div>\n  <div class=\"start-talking\">\n    <label class=\"error-message\" ng-show=\"errorMessage\">{{ errorMessage }}</label>\n    <button class=\"btn btn-primary\" ng-click=\"startTalking()\"><i ng-show=\"loading\" class=\"fa fa-refresh fa-spin pull-left\"></i>Start Talking</button>\n  </div>\n</div>\n";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "<div id=\"contact-options\">\n  <textarea class=\"form-control\" rows=\"3\" ng-model=\"message\"></textarea>\n  <button class=\"btn btn-primary\" ng-click=\"chat()\" ng-hide=\"isMobile\">\n    <i class=\"fa fa-comment\"></i>\n    <span>Chat Concierge</span>\n  </button>\n  <button class=\"btn btn-primary\" ng-click=\"sms()\" ng-show=\"isMobile\">\n    <i class=\"fa fa-mobile\"></i>\n    <span>Text Concierge</span>\n  </button>\n  <button class=\"btn btn-default\" ng-click=\"email()\">\n    <i class=\"fa fa-envelope-o\"></i>\n    <span>E-mail Concierge</span>\n  </button>\n  <p>Questions or Comments? Contact support at <br><a href=\"mailto:hello@tablelist.com\">hello@tablelist.com</a> or text <a href=\"sms:6173408791\">(617)-340-8791</a></p>\n</div>\n";

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<div id=\"contact-us\">\n\tCan't find what you're looking for? We can help. <a href=\"#\" ng-click=\"concierge()\">Contact a Tablelist concierge</a>, or text us at (617)-340-8791\n</div>\n";

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "<div class=\"cookie-banner\" ng-class=\"{ 'visible' : visible }\">\n\t<div class=\"container\">\n\t\t<p class=\"text\">\n\t\t\tThis website uses cookies to provide you with a great user experience.\n\t\t\tBy closing this banner, dismissing this banner, by clicking on a link or button on this website, or by continuing to browse this website, <a href=\"#\" ui-sref=\"app.legal.privacy\">you accept our use of cookies.</a>\n\t\t</p>\n\t\t<button class=\"btn btn-default btn-cta\" ng-click=\"acceptCookies($event)\">OK</button>\n\t</div>\n</div>\n";

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "<div class=\"countdown row\">\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownDays }}</p>\n\t\t<p class=\"metric\">Days</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownHours }}</p>\n\t\t<p class=\"metric\">Hours</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownMinutes }}</p>\n\t\t<p class=\"metric\">Mins</p>\n\t</div>\n\t<div class=\"col-xs-3\">\n\t\t<p class=\"amount\">{{ countdownSeconds }}</p>\n\t\t<p class=\"metric\">Secs</p>\n\t</div>\n</div>\n";

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<div class=\"\" ng-show=\"loading\" style=\"margin-bottom: 20px;\">\n  Loading....\n</div>\n<div class=\"credit-card-preview\" ng-show=\"card && !loading\">\n  <p class=\"card-info\"> <span class=\"uppercase\">{{ card.cardType }}</span> ending in {{ card.last4 }}</p>\n  <p class=\"card-info\">Exp. {{ card.expirationMonth }}/{{ card.expirationYear }}</p>\n  <div class=\"remove-link\" ng-click=\"editCreditCard()\">Delete Card?</div>\n</div>\n<div class=\"credit-card-preview\" ng-show=\"!card && !loading\">\n  No Credit Cards to Show\n</div>\n";

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "<div class=\"curated-list-card col-md-4 col-sm-6 placeholder\" ng-show=\"placeholder\">\n  <a class=\"curated-list\">\n    <div class=\"background\"></div>\n    <div class=\"details\">\n      <p class=\"title\"></p>\n    </div>\n  </a>\n</div>\n<div class=\"curated-list-card col-md-4 col-sm-6\" ng-hide=\"placeholder\">\n  <div class=\"curated-list\">\n    <a class=\"curated-list-image\" ui-sref=\"app.curatedList({ id : list.id })\" ng-style=\"{'background-image':'url({{ getBackgroundImage(list) }})'}\">\n      <div class=\"item-count\" ng-show=\"list.itemCount > 1\">\n        {{ list.itemCount }} items, {{ list.followCount }} followers\n      </div>\n    </a>\n    <div class=\"curated-list-details\">\n      <a ui-sref=\"app.curatedList({ id : list.id })\">\n        <p class=\"title\">{{ list.title | truncateString:maxTitleLength }}</p>\n      </a>\n      <p class=\"stats\"><span ng-show=\"list.authorName\">By {{ list.authorName }}</span></p>\n      <p class=\"description\">{{ list.description | truncateString:maxDescriptionLength }}</p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "<!-- Loading / Placeholder -->\n<div class=\"curated-list-event-card placeholder\" ng-show=\"placeholder\">\n  <div class=\"item-wrapper clearfix\">\n    <div class=\"image pull-left\"></div>\n    <div class=\"item\">\n      <div class=\"details\">\n        <h3>...</h3>\n        <p>...</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Curated List Card -->\n<div class=\"curated-list-event-card\" ng-hide=\"placeholder\">\n  <div class=\"item-wrapper clearfix\" ng-click=\"goToItem(item);\">\n    <div class=\"image pull-left\">\n      <img ng-src=\"{{ imgix(item.imageUrl) }}\">\n    </div>\n    <div class=\"item pull-right\">\n      <div class=\"details\">\n        <h3 class=\"event-name\">\n          {{ item.title }}\n        </h3>\n        <p class=\"event-date\">\n          {{ eventDateString(item.event) }} <strong>{{ item.venue.name }}</strong>\n        </p>\n        <p class=\"event-time\">Doors open at {{ item.event.dateStart | utc | date:'h:mma' }}</p>\n        <p class=\"event-description\">{{ item.description }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<div class=\"curated-list-item-card col-md-4 col-sm-6 placeholder\" ng-show=\"placeholder\">\n  <div class=\"item-wrapper\">\n    <div class=\"item\">\n      <div class=\"image\"></div>\n      <div class=\"details\">\n        <h3>...</h3>\n        <p>...</p>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"curated-list-item-card col-md-4 col-sm-6\" ng-hide=\"placeholder\">\n  <div class=\"item-wrapper\" ng-click=\"goToItem(item);\">\n    <div class=\"item\">\n      <div class=\"image\" style=\"background-image: url( '{{ imgix(item.imageUrl) }}')\"></div>\n      <div class=\"details\">\n        <h3>{{ item.title }}</h3>\n        <p>{{ item.description }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-4 col-xs-6 event-card-directive\" ng-if=\"!placeholder\">\n  <div ng-class=\"{ 'featured' : event.special }\" ng-if=\"!placeholder\">\n    <a class=\"event-image\" href=\"#\" ui-sref=\"app.event({ seoPathname: event.seoPathname })\" style=\"background-image: url('{{imgix(event.primaryImage)}}')\" effect=\"fadeIn\" event=\"eventsLoaded\"></a>\n    <div class=\"event-info\">\n      <div class=\"row clearfix\">\n        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n          <a class=\"name\" href=\"#\" ui-sref=\"app.event({ seoPathname: event.seoPathname })\">{{ event.name }}</a>\n          <p class=\"date\">{{ opensAt(event) }} @ {{ event.venue.name }}</p>\n        </div>\n        <!-- <div class=\"col-md-4 col-sm-4 col-xs-4 rate-and-fav clearfix\">\n          <button class=\"btn favorite pull-right\" type=\"button\" ng-click=\"favoriteEvent(event)\" ng-class=\"{ favorited : isFavorited }\" ng-disabled=\"disableFavoriting\">\n            <span class=\"fa fa-heart\"></span>\n            <span>{{ event.favoriteCount }}</span>\n          </button>\n        </div> -->\n      </div>\n    </div>\n  </div>\n  <rich-event-card event=\"event\"></rich-event-card>\n</div>\n<div class=\"col-md-4 col-xs-6 event-card-directive placeholder\" ng-if=\"placeholder\">\n  <div ng-class=\"{ 'featured' : event.special }\">\n    <div class=\"event-image\">\n    </div>\n    <div class=\"event-info\">\n      <div class=\"row clearfix\">\n        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n          <div class=\"placeholder-name loadingpulse\"></div>\n          <div class=\"placeholder-date loadingpulse\"></div>\n        </div>\n        <!-- <div class=\"col-md-4 col-sm-4 col-xs-4 rate-and-fav clearfix\">\n          <button class=\"btn favorite pull-right\" type=\"button\">\n            <span class=\"fa fa-heart\"></span><span>0</span>\n          </button>\n        </div> -->\n      </div>\n    </div>\n  </div>\n  <rich-event-card event=\"event\"></rich-event-card>\n</div>\n";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "<div class=\"event-list-card-directive\" ng-class=\"{ 'featured' : event.special, 'compact' : compact }\" ng-if=\"!placeholder\">\n  <div class=\"event-flyer\" ui-sref=\"app.event({ seoPathname: event.seoPathname })\" style=\"background-image: url('{{ imageUrl }}')\">\n  </div>\n  <div class=\"event-info\">\n    <!-- <div class=\"rate-and-fav clearfix\">\n      <button class=\"btn favorite pull-right\" type=\"button\" ng-click=\"favoriteEvent(event)\" ng-class=\"{ favorited : isFavorited }\" ng-disabled=\"disableFavoriting\">\n        <span class=\"fa fa-heart\"></span>\n        <span>{{ event.favoriteCount }}</span>\n      </button>\n    </div> -->\n    <p class=\"date\">{{ date | moment:'ddd, MMM DD' }}</p>\n    <a class=\"name\" href=\"#\" ui-sref=\"app.event({ seoPathname: event.seoPathname })\">{{ event.name }}</a>\n    <p class=\"details\">{{ event.description | truncateString:maxDescriptionLength }}</p>\n  </div>\n  <rich-event-card event=\"event\"></rich-event-card>\n</div>\n<div class=\"event-list-card-directive placeholder\" ng-class=\"{ 'featured' : event.special, 'compact' : compact }\" ng-if=\"placeholder\">\n  <div class=\"event-flyer\">\n    <div class=\"image\"></div>\n  </div>\n  <div class=\"event-info\">\n    <!-- <div class=\"rate-and-fav clearfix\">\n      <button class=\"btn favorite pull-right\" type=\"button\" ng-click=\"favoriteEvent(event)\" ng-class=\"{ favorited : isFavorited }\" ng-disabled=\"disableFavoriting\">\n        <span class=\"fa fa-heart\"></span>\n        <span>0</span>\n      </button>\n    </div> -->\n    <p class=\"date\">...</p>\n    <a class=\"name\" href=\"#\">...</a>\n    <p class=\"details\">...</p>\n  </div>\n  <rich-event-card event=\"event\"></rich-event-card>\n</div>\n";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "<div class=\"favorite-toggle-directive\">\n  <a href=\"#\" class=\"favorite pull-right\" ng-click=\"favorite(type, id)\" ng-disabled=\"loading\" ng-show=\"!isFavorited && !loading\">\n    <i class=\"fa fa-heart\"></i>\n  </a>\n  <a href=\"#\" class=\"favorite pull-right favorited\" ng-click=\"favorite(type, id)\" ng-disabled=\"loading\" ng-show=\"isFavorited && !loading\">\n    <i class=\"fa fa-heart\"></i>\n  </a>\n  <a href=\"#\" class=\"favorite pull-right\" ng-show=\"loading\">\n    <i class=\"fa fa-spin fa-circle-o-notch\"></i>\n  </a>\n</div>\n";

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "<span class=\"inventory-icon\">\n  <span class=\"inventory-type-icon\">\n    <i class=\"fa fa-ticket\" ng-show=\"type === 'COVER'\"></i>\n    <i class=\"fa fa-ticket\" ng-show=\"type === 'TICKET'\"></i>\n    <i class=\"fa fa-glass\" ng-show=\"type === 'TABLE'\"></i>\n    <i class=\"fa fa-cubes\" ng-show=\"type === 'PACKAGE'\"></i>\n  </span>\n  <i class=\"fa fa-plus\" ng-show=\"type === 'UNKNOWN'\"></i>\n</span>\n";

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "<div class=\"inventory-list-item\">\n  <!-- SOLD OUT TIERS -->\n  <div class=\"inner sold-out\" ng-repeat=\"tier in getSoldOutTiers()\" ng-if=\"inventory.tier && inventory.tier.levels\">\n    <div class=\"columns\">\n      <div class=\"col column-left\">\n        <p class=\"name ellipsize\">\n          {{ tier.name }}\n        </p>\n        <p class=\"price\">\n          {{ (tier.price || 0).toFixed(2) | venueCurrency : venue.currencyCode : venue.languageCode }}\n        </p>\n      </div>\n      <div class=\"col column-right clearfix\">\n        <p class=\"sold-out-label price\">\n          Sold Out\n        </p>\n      </div>\n    </div>\n  </div>\n  <!-- INVENTORY -->\n  <a href=\"#\" class=\"inner\" title=\"{{ inventory.name }}\" ng-click=\"onInventoryClicked($event)\" :class=\"{ 'sold-out' : inventory.quantityLeft < 1 }\">\n    <div class=\"columns\">\n      <div class=\"col column-left\">\n        <p class=\"name ellipsize\">\n          <span class=\"membership\" ng-show=\"inventory.membershipLevel >= 50\">\n            <img src=\"https://assets.tablelist.com/www-2/tablelist/tl-membership-diamond@3x.png\" />\n          </span>\n          {{ inventory.name }}\n        </p>\n        <p class=\"guests ellipsize\" ng-if=\"inventory.guests > 1\">1 - {{ inventory.guests }} guests</p>\n        <p class=\"guests ellipsize\" ng-if=\"inventory.guests === 1\">1 guest</p>\n      </div>\n      <div class=\"col column-right\">\n        <p class=\"sold-out-label price\" ng-show=\"inventory.quantityLeft < 1\">\n          Sold Out\n        </p>\n        <div class=\"available-pricing pull-right\" ng-if=\"inventory.quantityLeft > 0\">\n          <div class=\"cell clearfix\">\n            <div class=\"pull-left price-cell\">\n              <p class=\"price number-display\">{{ (inventory.price || 0).toFixed(2) | venueCurrency : venue.currencyCode : venue.languageCode }}</p>\n              <p class=\"price-label\">\n                Subtotal\n              </p>\n            </div>\n            <div class=\"pull-right btn-cell\">\n              <button class=\"btn btn-primary btn-sm\">\n                Book\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </a>\n</div>\n";

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<div id=\"login-form\" class=\"row\" ng-class=\"{ 'compact' : config.compactLayout || isMobile() }\">\n  <div class=\"col-sm-6 col facebook\">\n    <login-facebook config=\"config\" callback=\"done\">\n    </login-facebook>\n  </div>\n  <div class=\"col-sm-6 col email\">\n    <login-email config=\"config\" callback=\"done\">\n    </login-email>\n  </div>\n</div>\n";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "<form name=\"newUserForm\" ng-submit=\"create(user)\" class=\"tl-form\" novalidate ng-show=\"config.currentState == 'newUser'\">\n  <div class=\"form-group name row\">\n    <div class=\"col-xs-6\">\n      <label for=\"firstName\">First Name</label>\n      <input class=\"form-control\" type=\"text\" name=\"firstName\" ng-model=\"user.firstName\" ng-minlength=\"2\" required>\n    </div>\n    <div class=\"col-xs-6\">\n      <label for=\"lastName\">Last Name</label>\n      <input class=\"form-control\" type=\"text\" name=\"lastName\" ng-model=\"user.lastName\" ng-minlength=\"2\" required>\n    </div>\n  </div>\n  <div class=\"form-group\">\n    <label for=\"email\">E-mail</label>\n    <input class=\"form-control\" type=\"email\" name=\"email\" ng-model=\"user.email\" required>\n  </div>\n  <div class=\"form-group\">\n    <label for=\"password\">Password</label>\n    <input class=\"form-control\" type=\"password\" name=\"password\" placeholder=\"Atleast 6 characters\" ng-model=\"user.password\" ng-minlength=\"6\" required>\n  </div>\n  <div class=\"form-group\" ng-show=\"config.promo\">\n    <label for=\"promo\">Promo Code</label>\n    <input class=\"form-control\" type=\"promo\" name=\"promo\" ng-model=\"user.promo\" ng-init=\"user.promo = config.promo\">\n  </div>\n  <div class=\"clearfix\" ng-show=\"errorMsg\">\n    <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n  </div>\n  <p class=\"center\">\n    <button class=\"login btn btn-block btn-primary icon-center\" ng-disabled=\"!newUserForm.$valid\" type=\"submit\" ng-bs-animated-button=\"\" is-submitting=\"signUpSubmitting\" result=\"signUpResult\" options=\"signUpBtnOptions\">\n    </button>\n  </p>\n  <div class=\"switch\">\n    <p>Already have an account? <a href=\"#\" ng-click=\"changeState('existingUser');\">Log In.</a></p>\n  </div>\n</form>\n<form name=\"userForm\" ng-submit=\"login(user)\" class=\"tl-form\" novalidate ng-show=\"config.currentState == 'existingUser'\">\n  <div>\n    <div class=\"form-group\">\n      <label for=\"email\">E-mail</label>\n      <input class=\"form-control\" type=\"email\" tabindex=\"1\" name=\"email\" ng-model=\"user.email\" required>\n    </div>\n    <div class=\"form-group\">\n      <label for=\"password\">Password</label>\n      <input class=\"form-control\" type=\"password\" tabindex=\"2\" name=\"password\" placeholder=\"Atleast 6 characters\" ng-model=\"user.password\" ng-minlength=\"6\" required>\n    </div>\n  </div>\n  <div class=\"clearfix\" ng-show=\"errorMsg\">\n    <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n  </div>\n  <button class=\"btn btn-block btn-animated-no-icon icon-center\" type=\"submit\" tabindex=\"3\" ng-bs-animated-button=\"\" is-submitting=\"loginSubmitting\" result=\"loginResult\" options=\"loginBtnOptions\" ng-disabled=\"!userForm.$valid\"></button>\n  <div class=\"switch\">\n    <p>Don't have an account? <a href=\"#\" ng-click=\"changeState('newUser');\">Sign Up</a></p>\n    <div class=\"horizontal-divider\"></div>\n    <p><a href=\"/forgot-password\">Forgot password?</a></p>\n  </div>\n</form>\n";

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<div id=\"facebook-login\" ng-hide=\"config.currentState == 'completeProfile'\">\n\t<button class=\"btn-block icon-center\" ng-click=\"facebook()\" ng-bs-animated-button=\"\" is-submitting=\"loginFbSubmitting\" result=\"loginFbResult\" options=\"loginFbBtnOptions\"></button>\n\t<p class=\"error\" ng-show=\"facebookError\">{{ facebookError }}</p>\n\t<div class=\"or-container\">\n\t\t<div class=\"or\" ng-show=\"config.compactLayout\">OR</div>\n\t</div>\n</div>\n";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-md-4 col-xs-6 membership-card-directive {{ type }}\" ng-show=\"showAd()\">\n  <div class=\"background\">\n    <div class=\"message\">\n      <h2>More than just <br> nightclubs.</h2>\n      <p>Introducing Tablelist Membership</p>\n      <a class=\"btn btn-primary\" ng-click=\"goToMembership()\">Learn More</a>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "<div id=\"payment-profile-directive\">\n  <div class=\"loading-wrapper center\" ng-show=\"loading\">\n    <loading></loading>\n  </div>\n  <div class=\"payment-profile-view payment-profile-existing\" ng-if=\"!loading\" ng-class=\"{ 'show-me' : !showAddPayment }\">\n    <div class=\"payment-profile-details clickable selected\" ng-if=\"!showPaymentProfilesList && paymentProfile\">\n      <i class=\"icon fa fa-credit-card left-icon\"></i>\n      <p class=\"card-details\">\n        <span class=\"bold\">{{paymentProfile.cardType}}</span>\n        <span class=\"details\">ending with {{paymentProfile.last4}}</span>\n        <a href=\"#\" class=\"remove-btn\" ng-click=\"deletePaymentProfile(paymentProfile, $event)\">\n          <i class=\"icon fa fa-remove\"></i>\n        </a>\n        <i class=\"fa fa-check-square-o right-icon active\"></i>\n      </p>\n    </div>\n    <div class=\"payment-profile-details clickable list-item\" ng-repeat=\"profile in paymentProfiles\" ng-if=\"showPaymentProfilesList\" ng-click=\"selectProfile(profile)\">\n      <i class=\"icon fa fa-credit-card left-icon\"></i>\n      <img ng-src=\"{{::profile.imageUrl}}\">\n      <p class=\"card-details\">\n        <span class=\"bold\">{{::profile.cardType}}</span>\n        <span class=\"details\">ending with {{::profile.last4}}</span>\n        <a href=\"#\" class=\"remove-btn\" ng-click=\"deletePaymentProfile(profile, $event)\">\n          <i class=\"icon fa fa-remove\"></i>\n        </a>\n        <i class=\"fa fa-check-square-o right-icon\" ng-class=\"{ 'active' : profile.id == paymentProfile.id }\"></i>\n      </p>\n    </div>\n    <!-- SELECT ACTIVE CARD -->\n    <div class=\"payment-profile-details clickable\" ng-click=\"showList($event)\" ng-show=\"!showPaymentProfilesList && paymentProfiles.length > 1\">\n      <i class=\"icon fa fa-credit-card left-icon\"></i>\n      <p class=\"card-details\">\n        <span class=\"details\">Select a different card</span>\n      </p>\n    </div>\n    <!-- ADD NEW CARD -->\n    <div class=\"payment-profile-details last clickable\" ng-click=\"addProfile()\">\n      <i class=\"icon fa fa-plus-circle left-icon\"></i>\n      <p class=\"card-details\">\n        <span class=\"details\">Add a payment method</span>\n      </p>\n    </div>\n    <div class=\"payment-profile-next row\" ng-show=\"paymentProfile && paymentProfile.id && !showAddPayment && callback\">\n      <div class=\"col-sm-12\">\n        <button class=\"submit btn btn-primary\" ng-click=\"callback(paymentProfile)\">\n          <span>Continue</span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"payment-profile-view payment-profile-edit\" ng-if=\"!loading\" ng-class=\"{ 'show-me' : showAddPayment }\">\n    <br>\n    <form id=\"checkout-form\" name=\"ccForm\" ng-submit=\"addNewCard(ccForm, card)\" novalidate>\n      <div class=\"form-group\" ng-class=\"{ 'has-errors' : submitted && ccForm.cardNumber.$invalid }\">\n        <label>\n          Credit Card Number\n        </label>\n        <div class=\"icon-field\">\n          <input type=\"text\" placeholder=\"XXXX-XXXX-XXXX-XXXX\" class=\"form-control\" id=\"cardNumber\" cc-number cc-eager-type cc-format=\"true\" name=\"cardNumber\" ng-model=\"card.ccNumber\" required>\n          <i class=\"icon-right fa fa-credit-card\"></i>\n        </div>\n      </div>\n      <div class=\"clearfix row\">\n        <div class=\"col-xs-8\">\n          <div class=\"row\" cc-exp>\n            <div class=\"col-xs-6 form-group\" ng-class=\"{ 'has-errors' : submitted && ccForm.ccExpMonth.$invalid }\">\n              <label>Month</label>\n              <div class=\"icon-field\">\n                <input placeholder=\"MM\" type=\"text\" class=\"form-control\" cc-exp-month name=\"ccExpMonth\" ng-model=\"card.ccExpMonth\" required>\n              </div>\n            </div>\n            <div class=\"col-xs-6 form-group\" ng-class=\"{ 'has-errors' : submitted && ccForm.ccExpYear.$invalid }\">\n              <label>Year</label>\n              <div class=\"icon-field\">\n                <input placeholder=\"YY\" type=\"text\" class=\"form-control\" cc-exp-year name=\"ccExpYear\" ng-model=\"card.ccExpYear\" required>\n                <i class=\"icon-right fa fa-calendar\"></i>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-4 form-group\" ng-class=\"{ 'has-errors' : submitted && ccCvc.ccExpYear.$invalid }\">\n          <label>CVV</label>\n          <div class=\"icon-field\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"123\" id=\"cvc\" cc-cvc cc-type=\"ccForm.ccNumber.$ccType\" name=\"ccCvc\" ng-model=\"card.ccCvc\" required>\n            <i class=\"icon-right fa fa-lock\"></i>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-xs-12 form-group\" ng-class=\"{ 'has-errors' : submitted && ccCvc.postalCode.$invalid }\">\n          <label>Postal Code</label>\n          <input class=\"form-control\" placeholder=\"12345\" type=\"text\" name=\"postalCode\" ng-model=\"card.postalCode\" x-autocompletetype=\"postal-code\" required>\n        </div>\n      </div>\n      <div class=\"alert alert-danger\" ng-show=\"formErrors.length > 0\">\n        <p>We had a problem with your credit card.</p>\n        <ul>\n          <li ng-repeat=\"error in formErrors\">{{ error }}</li>\n        </ul>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <button type=\"submit\" class=\"submit btn btn-default\" ng-hide=\"savingPayment\">\n            <span ng-hide=\"saving\">Save Card</span>\n            <span ng-show=\"saving\"><i class=\"fa fa-spin fa-spinner\"></i></span>\n          </button>\n        </div>\n        <div class=\"col-sm-12 center\" style=\"margin-bottom: 20px;\">\n          <a href=\"#\" class=\"link cancel no-select\" ng-hide=\"paymentProfiles.length < 1\" ng-click=\"hideAddPayment($event);\">Cancel</a>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n";

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navbar\" id=\"promo-bar\" ng-show=\"showPromoBar()\" ng-class=\"promo.src\">\n  <div class=\"row\">\n    <div class=\"col-sm-3 col-sm-push-9\">\n      <a class=\"cta\" ng-show=\"promo.link\" href=\"{{ promo.link.url }}\">{{ promo.link.text }}</a>\n      <div class=\"close\" ng-click=\"dismissed = true\"><i class=\"fa fa-close\"></i></div>\n    </div>\n    <div class=\"col-sm-9 col-sm-pull-3\">\n      <h3 ng-bind-html=\"promo.message\"></h3>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "<div id=\"referral-block\" class=\"container\">\n  <p class=\"tagline\">EARN MONEY FOR TABLE AND PACKAGE RESERVATIONS</p>\n  <p class=\"description\">Get ${{referralGiveCredit}} for every friend you invite.</p>\n  <p class=\"learn-more\"><a href=\"#\" ui-sref=\"appearnCredit\">Learn More</a></p>\n  <input ng-value=\"currentUser.referralCode\" class=\"referral-code\" />\n  <p class=\"lead-small\">We'll include a special referral link when you share Tablelist on Facebook or Twitter.</p>\n  <share-bar></share-bar>\n</div>\n";

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "<script ng-bind-html=\"richJson()\", type=\"application/ld+json\">\n";

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "<script ng-bind-html=\"richJson()\", type=\"application/ld+json\">\n";

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "<div id=\"search-directive\" ng-class=\"{ 'modal-mode' : modal }\">\n  <div class=\"search-bar input-group\">\n    <span class=\"input-group-addon\">\n      <i class=\"icon ion-ios-search-strong\"></i>\n    </span>\n    <input type=\"text\" class=\"form-control\" placeholder=\"Search\" ng-model=\"input\" ng-change=\"search(input)\" ng-keyup=\"keyup($event)\">\n    <i class=\"clear\" ng-class=\"{ 'active' : input.length > 0 && !fetching }\" ng-click=\"clear()\">+</i>\n  </div>\n  <div class=\"search-results\" ng-class=\"{ 'active' : input.length > 0 && !fetching }\">\n    <div class=\"search-result\" ng-repeat=\"result in results track by $index\" ng-click=\"select(result)\" ng-mouseover=\"hover($index)\" ng-class=\"{ 'focus' : focus == $index}\">\n      <p ng-bind-html=\"result.highlightName\"></p>\n      <p class=\"small\" ng-show=\"result.highlightPerformers\" ng-bind-html=\"result.highlightPerformers\"></p>\n      <p class=\"small\" ng-show=\"result.venue\">\n        Venue\n        <span ng-show=\"result.venue.location.neighborhood\"> - {{ result.venue.location.neighborhood }}</span>\n        <span ng-show=\"result.venue.location.address.city\"> - {{ result.venue.location.address.city }}</span>\n      </p>\n      <p class=\"small\" ng-show=\"result.event\">\n        Event\n        <span ng-show=\"result.event.date\"> - on {{ result.event.date | localize | date:'EEE, MM/dd' }}</span>\n        <span ng-show=\"result.event.venue.name\"> at {{ result.event.venue.name }}</span>\n        <span ng-show=\"result.event.venue.location.address.city\"> in {{ result.event.venue.location.address.city }}</span>\n      </p>\n      <p class=\"small\" ng-show=\"result.curatedList\">\n        Tablelist Picks | {{ cities[result.curatedList.city].displayName }}\n      </p>\n    </div>\n    <div class=\"search-result empty\" ng-if='input && !fetching && results.length < 1' ng-class=\"{ 'active' : input && !fetching && results.length < 1 }\">\n      <p>Sorry, we could find anything that matched your search criteria.</p>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "<div class=\"selected-inventory animated-fast fadeInUp\">\n  <div class=\"tops-btns clearfix\">\n    <a class=\"back-link btn btn-default pull-left\" href=\"#\" ng-click=\"back($event)\">\n      <i class=\"icon ion-ios-arrow-back\"></i>\n    </a>\n    <div class=\"pull-right\">\n      <div>\n        <form action=\"{{ bookingUrl }}\" method=\"post\" target=\"_parent\" ng-submit=\"bookingFormSubmitted()\">\n          <button class=\"btn btn-primary btn-spinner\" type=\"submit\">\n            <i class=\"icon spin\" :class=\"{ 'spin' : submittingBookingForm }\" ng-if=\"submittingBookingForm\"></i>\n            {{ submittingBookingForm ? '' : 'Checkout' }}\n          </button>\n        </form>\n      </div>\n    </div>\n  </div>\n  <div class=\"quantity clearfix\" ng-if=\"inventory.type === 'TICKET'\">\n    <form data-vv-scope=\"checkoutForm\">\n      <div class=\"form-group\" :class=\"{ 'has-errors' : ticketQuantityError }\">\n        <label class=\"\">\n          How many?\n        </label>\n        <select class=\"form-control\" ng-model=\"inventoryForm.inventoryQuantity\" name=\"ticketQuantity\" ng-change=\"getBookingUrl()\">\n          <option ng-repeat=\"num in getTicketSelectorQuantity()\" ng-value=\"num\">\n            {{ num }}\n          </option>\n        </select>\n      </div>\n    </form>\n  </div>\n  <div class=\"inner row\">\n    <div class=\"col column-left\">\n      <p class=\"name\">{{ inventory.name }}</p>\n      <p class=\"guests\" ng-if=\"inventory.guests > 1\">1 - {{ inventory.guests }} guests</p>\n      <p class=\"guests\" ng-if=\"inventory.guests === 1\">1 guest</p>\n    </div>\n    <div class=\"col column-right\">\n      <p class=\"sold-out-label price\" ng-show=\"inventory.quantityLeft < 1\">\n        Sold Out\n      </p>\n      <div class=\"available-pricing pull-right\" ng-if=\"inventory.quantityLeft > 0\">\n        <div class=\"cell cell-left\" ng-class=\"{ 'has-right-cell' : inventory.paymentType === 'ADVANCE_DEPOSIT' }\">\n          <p class=\"price number-display\">\n            {{ (inventory.price || 0).toFixed(2) | venueCurrency : venue.currencyCode : venue.languageCode }}\n          </p>\n          <p class=\"price-label\">\n            Subtotal\n          </p>\n        </div>\n        <div class=\"cell cell-right deposit\" ng-if=\"inventory.paymentType === 'ADVANCE_DEPOSIT'\">\n          <p class=\"price number-display\">\n            {{ (inventory.depositAmount || 0).toFixed(2) | venueCurrency : venue.currencyCode : venue.languageCode }}\n          </p>\n          <p class=\"price-label\">\n            Deposit due\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"description\" ng-bind-html=\"inventoryDescription\">\n  </div>\n</div>\n";

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row share-bar\">\n  <div class=\"options\">\n    <div class=\"option\">\n      <a class=\"btn btn-facebook\" href=\"{{ facebookLink }}\" target=\"_blank\">\n        <i class=\"fa fa-facebook-square\"></i>\n      </a>\n    </div>\n    <div class=\"option\">\n      <a class=\"btn btn-twitter\" href=\"{{ twitterLink }}\" target=\"_blank\">\n        <i class=\"fa fa-twitter\"></i>\n      </a>\n    </div>\n    <div class=\"option\">\n      <a class=\"btn btn-email\" href=\"{{ emailLink }}\">\n        <i class=\"fa fa-envelope\"></i>\n      </a>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "<meta name=\"apple-itunes-app\" content=\"app-id={{ appId() }}, app-argument={{ appArgument() }}\">\n";

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "<div id=\"sms-download\">\n  <form class=\"phone-form tl-form form-horizontal\" name=\"form\" role=\"form\" novalidate>\n    <div class=\"form-group\" ng-class=\"{ 'has-errors' : submitted && form.phone.$invalid }\">\n      <div class=\"input-group\">\n        <input class=\"form-control\" type=\"text\" placeholder=\"Phone number\" name=\"phone\" ng-model=\"phone\" tabindex=\"1\" required phone-number ng-minlength=\"14\" />\n        <button class=\"input-group-addon btn btn-secondary btn-animated-no-icon\" type=\"submit\" ng-click=\"sendSMS(form)\" tabindex=\"2\" ng-bs-animated-button=\"\" is-submitting=\"isSending\" result=\"sendResult\" options=\"buttonOptions\"></button>\n      </div>\n    </div>\n  </form>\n  <div class=\"download-links\">\n    <a class=\"android\" href=\"https://play.google.com/store/apps/details?id=com.tablelistapp.android.prod\" target=\"_blank\" title=\"Download for Android\">\n      <i class=\"fa fa-android\"></i><span>Google Play</span>\n    </a>\n    <a class=\"apple\" href=\"https://itunes.apple.com/app/tablelist/id634444177?mt=8\" target=\"_blank\" title=\"Download for iOS\">\n      <i class=\"fa fa-apple\"></i><span>App Store</span>\n    </a>\n  </div>\n</div>\n";

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "<div ui-sref=\"app.venue({ seoPathname: venue.seoPathname })\" class=\"col-md-4 col-xs-6 venue-card\" ng-class=\"{ 'placeholder' : placeholder }\">\n  <div class=\"venue-card-inner\" ng-class=\"{ 'featured' : venue.featured }\" ng-if=\"!placeholder\">\n    <div class=\"venue-image\">\n      <span style=\"background-image: url('{{ imgix(venue.primaryImage) }}')\" effect=\"fadeIn\" event=\"venuesLoaded\"></span>\n    </div>\n    <div class=\"venue-info clearfix\">\n      <a class=\"name\" href=\"#\" ui-sref=\"app.venue({ seoPathname: venue.seoPathname })\">{{ venue.name }}</a>\n      <p class=\"type\"><span>{{ venue.type.name }}</span><span><i class=\"fa fa-circle\" ng-show=\"venue.subtype.name\"></i>{{ venue.subtype.name }}</span></p>\n      <!-- <div class=\"rate-and-fav clearfix\">\n        <p class=\"rating pull-left\" ng-hide=\"venue.rating.ratingCount === 0\">\n          <venue-rating rating-average=\"venue.rating.ratingAverage\"></venue-rating>&nbsp;{{ venue.rating.ratingCount }} Reviews\n        </p>\n        <p class=\"rating pull-left\" ng-show=\"venue.rating.ratingCount === 0\">\n          Be the first to review\n        </p>\n        <button class=\"btn favorite pull-right\" type=\"button\" ng-click=\"favoriteVenue(venue)\" ng-class=\"{ favorited : isFavorited }\" ng-disabled=\"disableFavoriting\" analytics-on=\"click\" analytics-category=\"button\" analytics-label=\"{{ isFavorited ? 'Un-Favorite Venue' : 'Favorite Venue' }}\"\n          analytics-value=\"{{ isFavorited ? 'un-favorited' : 'favorited' }}\">\n          <span class=\"fa fa-heart\"></span>\n          <span ng-hide=\"!venue.favoriteCount\">{{ venue.favoriteCount }}</span>\n        </button>\n      </div> -->\n    </div>\n    <rich-venue-card venue=\"venue\"></rich-venue-card>\n  </div>\n  <div class=\"venue-card-inner\" ng-class=\"{ 'featured' : venue.featured }\" ng-if=\"placeholder\">\n    <div ng-class=\"{ 'featured' : venue.featured }\">\n      <div class=\"venue-image\">\n      </div>\n      <div class=\"venue-info clearfix\">\n        <div class=\"placeholder-name loadingpulse\"></div>\n        <div class=\"placeholder-type loadingpulse\"></div>\n        <!-- <div class=\"rate-and-fav clearfix\">\n          <button class=\"btn favorite pull-right\" type=\"button\">\n            <span class=\"fa fa-heart\"></span>\n            <span class=\"\">0</span>\n          </button>\n        </div> -->\n      </div>\n    </div>\n    <rich-venue-card venue=\"venue\"></rich-venue-card>\n  </div>\n</div>\n";

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "<div id=\"venue-book\">\n  <a class=\"close\" href=\"#\" ng-click=\"cancel($event)\">\n    <i class=\"fa fa-times\"></i>\n  </a>\n  <div class=\"venue-book-widget\">\n    <div id=\"inventory-list-modal-widget\">\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Complete Your Profile</h2>\n</div>\n\n<div class=\"modal-body\">\n  <complete-profile callback=\"done\" config=\"config\"></complete-profile>\n</div>\n";

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmation-modal\">\n  <div class=\"modal-header capitalize\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">\n      <i class=\"ion-close\"></i>\n    </button>\n    <h3 class=\"modal-title\">\n      {{ modalHeader || 'Confirm' }}\n    </h3>\n  </div>\n  <div class=\"modal-body\" ng-bind-html=\"modalMessageHtml\">\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"close($event)\" ng-hide=\"hideCancelBtn\">\n      {{ cancelBtnTxt || 'Cancel' }}\n    </button>\n    <button type=\"button\" class=\"btn confirm-delete {{ confirmingBtnClass || 'btn-danger' }}\" ng-click=\"confirm($event)\" ng-disabled=\"saving\">\n      <span ng-show=\"saving\">{{ confirmingBtnTxt || 'Confirming' }}</span>\n      <span ng-show=\"!saving\">{{ confirmBtnTxt || 'Confirm' }}</span>\n    </button>\n  </div>\n</div>\n";

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Contact Tablelist Concierge</h2>\n</div>\n<div class=\"modal-body\" id=\"contact-support-modal\">\n  <contact-options message=\"message\"></contact-options>\n</div>\n";

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "<div class=\"close\" ng-click=\"cancel()\">+</div>\n\n<h2>Invite Friends</h2>\n\n<p>Send a friend Tablelist credit from web or mobile. After they sign up and book their first table or table package you get credit to.\n\n<img ng-src=\"https://assets.tablelist.com/www/assets/earn-credit-device-preview.jpg\" alt=\"You can find your referral code from your account on the website, and mobile apps.\"/>\n\n<p class=\"small\">Send invites from our iOS, Android, and web platforms.*</p>";

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Cities</h2>\n</div>\n<div class=\"modal-body\" ng-show=\"loading\">\n  <div class=\"loading gray\"></div>\n</div>\n<div class=\"modal-body\" ng-hide=\"loading\">\n  <form class=\"account-form tl-form form-horizontal\" name=\"selectCityForm\" role=\"form\" novalidate>\n    <div class=\"form-group\" ng-class=\"{ 'has-errors' : submitted && selectCityForm.promoCode.$invalid }\">\n      <label class=\"control-label\">CURRENT CITY</label>\n      <select class=\"form-control\" ng-model=\"selectedCityId\">\n        <option ng-repeat=\"city in cities\" value=\"{{city.id}}\">{{ city.displayName }}</option>\n      </select>\n    </div>\n    <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"setCity(selectedCityId)\">SAVE</button>\n    <br>\n    <div class=\"clearfix account-error\" ng-show=\"errorMsg\">\n      <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n    </div>\n    <div class=\"clearfix account-error\" ng-show=\"successMsg\">\n      <div class=\"alert alert-success\">{{ successMsg }}</div>\n    </div>\n  </form>\n</div>\n";

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Contact Information</h2>\n</div>\n<div class=\"modal-body\">\n  <form name=\"userForm\" class=\"account-form tl-form form-horizontal\" role=\"form\" novalidate>\n    <div class=\"form-group\">\n      <label class=\"control-label\">EMAIL ADDRESS</label>\n      <input class=\"form-control\" type=\"text\" name=\"email\" ng-model=\"user.email\" required>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"control-label\">PHONE NUMBER</label>\n      <input class=\"form-control\" placeholder=\"e.g. (617)-555-1234\" type=\"text\" name=\"phone\" ng-model=\"user.phone\" phone-number>\n    </div>\n    <p class=\"center\">\n      <button class=\"btn btn-animated-no-icon\" type=\"submit\" ng-hide=\"loading\" ng-click=\"saveUser()\" ng-bs-animated-button=\"\" is-submitting=\"isUpdatingUser\" result=\"updateUserResult\" options=\"updateUserBtnOptions\"></button>\n    </p>\n  </form>\n</div>\n";

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Edit Payment Options</h2>\n</div>\n<div class=\"modal-body\">\n  <payment-profile payment-profile=\"paymentProfile\"></payment-profile>\n</div>\n";

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "<div class=\"edit-membership-modal\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n    <h2 class=\"modal-title\">Edit Membership</h2>\n  </div>\n\n  <p class=\"alert alert-danger\" ng-show=\"error\">{{ error }}</p>\n  <p class=\"alert alert-success\" ng-show=\"success\">{{ success }}</p>\n\n  <div class=\"modal-body modal-loading\" ng-show=\"loading\">\n    <i class=\"fa fa-circle-o-notch fa-spin\"></i>\n  </div>\n\n  <!-- No Membership -->\n  <div class=\"modal-body\" ng-if=\"!membership && !loading\">\n    <p>Learn more about Tablelist Membership</p>\n    <button class=\"btn btn-secondary\" ui-sref=\"app.membership.landing\">About Membership</button>\n  </div>\n\n  <!-- Active Membership (ACTIVE, FREE_TRIAL, CANCEL_PENDING) -->\n  <div class=\"modal-body\" ng-if=\"membership.active && !loading\">\n    <p>{{ membership.statusDescription }}</p>\n    <p>Update the credit card used for your Tablelist Membership:</p>\n    <br>\n    <payment-profile payment-profile=\"paymentProfile\"></payment-profile>\n    <button class=\"btn btn-primary\" ng-click=\"save(membership, paymentProfile)\" ng-disabled=\"!paymentProfile.id\">Apply Changes</button>\n  </div>\n\n  <!-- Inactive Membership -->\n  <div class=\"modal-body\" ng-if=\"!membership.active && !loading\" ng-switch on=\"membership.status\">\n    <!-- PAST DUE -->\n    <div ng-switch-when=\"PAST_DUE\">\n      <p><strong>Status: </strong>PAST DUE</p>\n      <p>{{ membership.statusDescription }}</p>\n      <p>To maintain your access to Tablelist membership benefits, please update your credit card:</p>\n      <payment-profile payment-profile=\"paymentProfile\"></payment-profile>\n      <button class=\"btn btn-primary\" ng-click=\"save(membership, paymentProfile)\">Apply Changes</button>\n    </div>\n\n    <!-- CANCELLED -->\n    <div ng-switch-when=\"CANCELLED\">\n      <p><strong>Status: </strong>CANCELLED</p>\n      <p>{{ membership.statusDescription }}</p>\n      <button class=\"btn btn-secondary\" ui-sref=\"app.membership.landing\">Start Membership</button>\n    </div>\n\n    <!-- ELSE -->\n    <div ng-switch-default>\n      <p>Unable to edit membership</p>\n      <br>\n      <button class=\"btn btn-secondary\" ui-sref=\"app.me.profile\">Back to my Account</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Edit Profile</h2>\n</div>\n<div class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <label class=\"control-label\">YOUR AVATAR</label>\n    </div>\n    <div class=\"col-sm-5 col-xs-12\">\n      <img class=\"profile-picture\" ng-src=\"{{ $root.currentUser.imageUrl }}\" height=\"150\" width=\"150\" />\n    </div>\n    <div class=\"col-sm-7 col-xs-12\">\n      <br>\n      <img-upload file-selected=\"updateProfilePic\">\n        <button class=\"btn change-avatar\" type=\"submit\" ng-hide=\"loading\" ng-click=\"selectImage()\" data-ng-bs-animated-button=\"\" ng-disabled data-is-submitting=\"isSubmittingProfilePic\" data-result=\"profilePicResult\" data-options=\"profilePicBtnOptions\"></button>\n      </img-upload>\n    </div>\n  </div>\n  <br>\n  <form name=\"userForm\" class=\"account-form tl-form form-horizontal\" role=\"form\" novalidate>\n    <div class=\"form-group\">\n      <label class=\"control-label\">NAME</label>\n      <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"user.name\" required>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"control-label\">BIRTHDAY</label>\n      <input class=\"form-control\" type=\"date\" id=\"birthday\" name=\"input\" ng-model=\"birthday\" required />\n    </div>\n    <label class=\"control-label\">GENDER</label>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" name=\"gender\" ng-model=\"selectedGender\" value=\"male\" ng-change=\"user.gender = 'male'\">Male\n      </label>\n    </div>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" name=\"gender\" ng-model=\"selectedGender\" value=\"female\" ng-change=\"user.gender = 'female'\">Female\n      </label>\n    </div>\n    <div class=\"radio\">\n      <label>\n        <input type=\"radio\" name=\"gender\" ng-model=\"selectedGender\" value=\"custom\" ng-change=\"user.gender = ''\">More Options\n      </label>\n    </div>\n    <div class=\"form-group\" ng-show=\"selectedGender == 'custom'\">\n      <label class=\"control-label\">ENTER GENDER</label>\n      <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"user.gender\" required>\n    </div>\n    <br>\n    <p class=\"center\">\n      <button class=\"btn btn-animated-no-icon\" type=\"submit\" ng-hide=\"loading\" ng-click=\"saveUser()\" ng-bs-animated-button=\"\" is-submitting=\"isUpdatingUser\" result=\"updateUserResult\" options=\"updateUserBtnOptions\"></button>\n    </p>\n  </form>\n</div>\n";

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Enter Promo Code</h2>\n</div>\n<div class=\"modal-body\">\n  <div class=\"clearfix account-error\" ng-show=\"errorMsg\">\n    <div class=\"alert alert-danger\">{{ errorMsg }}</div>\n  </div>\n  <div class=\"clearfix account-error\" ng-show=\"successMsg\">\n    <div class=\"alert alert-success\">{{ successMsg }}</div>\n  </div>\n  <form class=\"account-form tl-form form-horizontal\" name=\"promoCodeForm\" role=\"form\" novalidate>\n    <div class=\"form-group\" ng-class=\"{ 'has-errors' : submitted && promoCodeForm.promoCode.$invalid }\">\n      <label class=\"control-label\">Promo Code:</label>\n      <input class=\"small form-control\" type=\"text\" placeholder=\"Enter your promo code\" name=\"promoCode\" ng-model=\"form.promoCode\" value=\"user.referralCode\" tabindex=\"1\" required>\n    </div>\n    <button class=\"btn btn-animated-no-icon\" type=\"submit\" ng-click=\"redeemPromoCode(promoCodeForm)\" tabindex=\"2\" ng-bs-animated-button=\"\" is-submitting=\"isRedeemingPromo\" result=\"redeemPromoResult\" options=\"redeemPromoBtnOptions\"></button>\n  </form>\n</div>\n";

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n    <h2 class=\"modal-title\">Change Password</h2>\n</div>\n<div class=\"modal-body\">\n\n    <div ng-hide=\"emailSent\">\n      <p class=\"description\">To change your password, please confirm your email address. We'll send you a link to create a new password.</p>\n      <form name=\"forgotForm\" ng-submit=\"sendEmail(forgotForm)\" novalidate>\n        <input type=\"email\" name=\"email\" ng-model=\"email\" class=\"form-control\" placeholder=\"Enter Email Address\" ng-class=\"{ 'has-errors': forgotForm.email.$invalid && submitted }\" required>\n        <br>\n        <p class=\"error\" ng-show=\"error\">{{ error }}</p>\n        <button type=\"submit\" class=\"btn btn-primary\">Reset Password</button>\n      </form>\n      <br>\n    </div>\n    <div ng-show=\"emailSent\">\n      <p class=\"description\">We've sent an email to <strong>{{email}}</strong>, with instructions on how to reset your Tablelist password. If you don't see the email in 5 minutes, check your spam folder or try again. If you still can't access your account, please contact <a href=\"mailto:support@tablelist.com\">support@tablelist.com</a>.</p>\n    </div>\n</div>\n";

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "<div class=\"membership-modal-body\">\n  <div class=\"clearfix visible-xs\">\n    <a class=\"pull-left close\" href=\"#\" ng-click=\"cancel()\">\n      <i class=\"fa fa-times\"></i>\n    </a>\n  </div>\n  <div class=\"header\">\n    <h5>YOUR NIGHT OUT JUST GOT BETTER</h5>\n    <h1>Tablelist Platinum</h1>\n    <p>Receive complimentary entry, tickets to top acts, and members-only benefits to the hottest nightclubs and lounges weekly.</p>\n    <a ui-sref=\"app.membership.start\" class=\"btn btn-primary\">GET STARTED</a>\n    <a class=\"sign-in\" ui-sref=\"app.login\">Already a Member? Log in</a>\n  </div>\n</div>\n";

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\" data-ng-hide=\"hideClose\">&times;</button>\n  <p class=\"modal-title\">{{config.title}}</p>\n</div>\n<div class=\"modal-body\">\n  <login config=\"config\" input=\"input\" ng-hide=\"loginComplete\"></login>\n</div>\n";

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search-modal-body\">\n  <div class=\"clearfix visible-xs\">\n    <a class=\"pull-left close\" href=\"#\" ng-click=\"cancel()\">\n      <i class=\"fa fa-times\"></i>\n    </a>\n  </div>\n  <div class=\"content\">\n    <search modal=\"true\" callback=\"cancel\"></search>\n  </div>\n</div>\n";

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Share</h2>\n</div>\n\n<div class=\"modal-body\">\n  <p class=\"center\">{{ shareBarConfig.message }}</p>\n  <share-bar config=\"shareBarConfig\"></share-bar>\n</div>\n";

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button>\n  <h2 class=\"modal-title\">Terms &amp; Conditions</h2>\n</div>\n<div class=\"modal-body terms-modal-body\" ng-bind-html=\"terms\">\n</div>\n";

/***/ }),
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 237,
	"./af.js": 237,
	"./ar": 241,
	"./ar-ma": 238,
	"./ar-ma.js": 238,
	"./ar-sa": 239,
	"./ar-sa.js": 239,
	"./ar-tn": 240,
	"./ar-tn.js": 240,
	"./ar.js": 241,
	"./az": 242,
	"./az.js": 242,
	"./be": 243,
	"./be.js": 243,
	"./bg": 244,
	"./bg.js": 244,
	"./bn": 245,
	"./bn.js": 245,
	"./bo": 246,
	"./bo.js": 246,
	"./br": 247,
	"./br.js": 247,
	"./bs": 248,
	"./bs.js": 248,
	"./ca": 249,
	"./ca.js": 249,
	"./cs": 250,
	"./cs.js": 250,
	"./cv": 251,
	"./cv.js": 251,
	"./cy": 252,
	"./cy.js": 252,
	"./da": 253,
	"./da.js": 253,
	"./de": 255,
	"./de-at": 254,
	"./de-at.js": 254,
	"./de.js": 255,
	"./el": 256,
	"./el.js": 256,
	"./en-au": 257,
	"./en-au.js": 257,
	"./en-ca": 258,
	"./en-ca.js": 258,
	"./en-gb": 259,
	"./en-gb.js": 259,
	"./eo": 260,
	"./eo.js": 260,
	"./es": 261,
	"./es.js": 261,
	"./et": 262,
	"./et.js": 262,
	"./eu": 263,
	"./eu.js": 263,
	"./fa": 264,
	"./fa.js": 264,
	"./fi": 265,
	"./fi.js": 265,
	"./fo": 266,
	"./fo.js": 266,
	"./fr": 268,
	"./fr-ca": 267,
	"./fr-ca.js": 267,
	"./fr.js": 268,
	"./fy": 269,
	"./fy.js": 269,
	"./gl": 270,
	"./gl.js": 270,
	"./he": 271,
	"./he.js": 271,
	"./hi": 272,
	"./hi.js": 272,
	"./hr": 273,
	"./hr.js": 273,
	"./hu": 274,
	"./hu.js": 274,
	"./hy-am": 275,
	"./hy-am.js": 275,
	"./id": 276,
	"./id.js": 276,
	"./is": 277,
	"./is.js": 277,
	"./it": 278,
	"./it.js": 278,
	"./ja": 279,
	"./ja.js": 279,
	"./jv": 280,
	"./jv.js": 280,
	"./ka": 281,
	"./ka.js": 281,
	"./km": 282,
	"./km.js": 282,
	"./ko": 283,
	"./ko.js": 283,
	"./lb": 284,
	"./lb.js": 284,
	"./lt": 285,
	"./lt.js": 285,
	"./lv": 286,
	"./lv.js": 286,
	"./me": 287,
	"./me.js": 287,
	"./mk": 288,
	"./mk.js": 288,
	"./ml": 289,
	"./ml.js": 289,
	"./mr": 290,
	"./mr.js": 290,
	"./ms": 292,
	"./ms-my": 291,
	"./ms-my.js": 291,
	"./ms.js": 292,
	"./my": 293,
	"./my.js": 293,
	"./nb": 294,
	"./nb.js": 294,
	"./ne": 295,
	"./ne.js": 295,
	"./nl": 296,
	"./nl.js": 296,
	"./nn": 297,
	"./nn.js": 297,
	"./pl": 298,
	"./pl.js": 298,
	"./pt": 300,
	"./pt-br": 299,
	"./pt-br.js": 299,
	"./pt.js": 300,
	"./ro": 301,
	"./ro.js": 301,
	"./ru": 302,
	"./ru.js": 302,
	"./si": 303,
	"./si.js": 303,
	"./sk": 304,
	"./sk.js": 304,
	"./sl": 305,
	"./sl.js": 305,
	"./sq": 306,
	"./sq.js": 306,
	"./sr": 308,
	"./sr-cyrl": 307,
	"./sr-cyrl.js": 307,
	"./sr.js": 308,
	"./sv": 309,
	"./sv.js": 309,
	"./ta": 310,
	"./ta.js": 310,
	"./th": 311,
	"./th.js": 311,
	"./tl-ph": 312,
	"./tl-ph.js": 312,
	"./tr": 313,
	"./tr.js": 313,
	"./tzl": 314,
	"./tzl.js": 314,
	"./tzm": 316,
	"./tzm-latn": 315,
	"./tzm-latn.js": 315,
	"./tzm.js": 316,
	"./uk": 317,
	"./uk.js": 317,
	"./uz": 318,
	"./uz.js": 318,
	"./vi": 319,
	"./vi.js": 319,
	"./zh-cn": 320,
	"./zh-cn.js": 320,
	"./zh-tw": 321,
	"./zh-tw.js": 321
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1017;

/***/ }),
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325);
module.exports = __webpack_require__(324);


/***/ })
],[1031]);


// WEBPACK FOOTER //
// app.3dd48a6.js